/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "../i18n/de.json":
/***/ (function(module, exports) {

module.exports = {"GDPR":{"ContactPreferences":{"Header":"Du hast es in der Hand %{name}","Description":"Bist du noch happy mit den Infos, die du von uns bekommst? Wenn nicht, kannst du sie einfach in deinen Kontakteinstellungen bearbeiten.","Channels":"Verschickt per E-Mail, SMS oder beides","EditButton":"Einstellungen bearbeiten","KeepButton":"Weiterhin erhalten","LoginButton":"Einstellungen bearbeiten","OptOutButton":"Abmelden","PrivacyLink":"Datenschutzrichtlinie","Terms":"Allgemeinen Geschäftsbedingungen","Deadline":{"Header":"Das Gesetzt hat sich geändert","Description":"Deshalb hast du in letzter Zeit keine Mails mehr von uns bekommen. Wenn du wieder auf dem Laufenden sein willst, meld dich neu an und sag uns, welche News du wirklich lesen willst.","KeepButton":"Für News anmelden","OptOutButton":"Keine News mehr erhalten"}},"GreetingButton":"Inhalte auswählen","GreetingButtonError":"Nochmal versuchen","Greeting":"Was willst du von uns erfahren?","GreetingLabel":"Hi %{name}. %{greeting}","GreetingLabelError":"Oopsie! Da ist wohl was schiefgelaufen. Versuch's bitte nochmal.","InConfirmationBody":"Erledigt! Und denk dran: Diese Infos kannst du jederzeit in deinen Kontakteinstellungen bearbeiten.","InConfirmationHeading":"Geschafft!","OutConfirmationBody":"Du wurdest jetzt erfolgreich abgemeldet. Es kann allerdings bis zu 7 Tage dauern bis die Änderung in Kraft tritt. Sehnsucht nach uns? Du kannst dich in den Kontakteinstellung jederzeit wieder anmelden.","OutConfirmationHeading":"Oh, schade!","PreferencesButton":"Kontakteinstellungen bearbeiten","ShoppingButton":"Jetzt shoppen"},"MyAccountLinks":{"ContactPreferences":"Kontakteinstellungen","Greeting":"Hallo %{name}","MyAccount":"Mein Konto","MyOrders":"Meine Bestellungen","ReturnsInformation":"Informationen zur Rücksendung","ReturnsInformationLink":"kundenservice/kundenbetreuung/hilfe/?help=/app/topiclanding/p/90","SignInLabel":"Anmelden","SignOutLabel":"Abmelden","SignUpLabel":"Registrieren","SignUpLink":"/register","Welcome":"Willkommen"},"MiscBar":{"Marketplace":"Marketplace","Help":"Hilfe und FAQ","HelpLink":"kundenservice/kundenbetreuung/hilfe/"},"Header":{"HomeAlt":"Zurück zur Startseite","WomenFloor":"DAMEN","MenFloor":"HERREN"},"LegalBar":{"Privacy":"Datenschutz und Cookies","PrivacyLink":"datenschutz/","Terms":"AGB","TermsLink":"allgemeine-geschaftsbedingungen/","Accessibility":"Barrierefreiheit","AccessibilityLink":"barrierefreiheit/"},"SidePanel":{"NavigationLabel":"Hauptmenü","CloseNavigationLabel":"Hauptmenü schließen"},"SearchBar":{"Label":"Nach Artikeln, Marken und Inspiration suchen","RecentSearches":"Zuletzt gesucht","ClearRecentSearchesLabel":"Letzte Suchanfragen löschen","ClearRecentSearchesText":"Löschen","Placeholder":"Suche"},"Burger":{"OpenNavigationLabel":"Hauptmenü öffnen"},"Icon":{"Search":"Suche","Close":"Schließen","MyAccount":"Mein Konto","SavedItems":"Gespeichert","Bag":"Tasche"},"Bag":{"Link":"bag"},"MiniBag":{"Name":"Name","Price":"Preis","Color":"Farbe","Quantity":"Anzahl","Qty":"Anz.","Size":"Größe","RRP":"UVP","ItemCount":"%{smart_count} Artikel |||| %{smart_count} Artikel","MyBag":"Meine Tasche","Footer":{"BagLinks":{"Bag":{"Text":"Tasche Anzeigen"},"Checkout":{"Text":"Kasse"}},"DeliveryProposition":{"Title":"Kostenloser Versand Weltweit*","Description":"Mehr Infos ","LinkText":"hier","DeliveryInformationLink":"kundenservice/lieferung/"},"MaximumItemsMessage":"Hier können nur 20 Artikel angezeigt werden.","ViewBagMessage":{"PartOne":"Bitte klicke auf ","Link":"meine Tasche anzeigen","PartTwo":", um alle Artikel zu sehen."}},"reservationMessage":"Der Artikel liegt in deiner Tasche und ist für 60 Minuten reserviert.","subscriptionConfirmationMessage":"Der Artikel liegt in deiner Tasche.","voucherConfirmationMessage":"Der Artikel liegt in deiner Tasche.","ErrorMessage":{"firstLine":"Oopsie! Es ist ein Problem aufgetreten.","secondLine":"Bitte versuche es später noch einmal."},"DismissNotificationBtnText":"Meldung ignorieren","DeleteBagItemText":"Artikel löschen","SubTotal":"Zwischensumme","ItemDeleted":"Artikel gelöscht"},"SavedItems":{"Link":"saved-items"},"CountrySelectorButton":{"Heading":"Einkaufen aus","ChangeCountry":"Land auswählen","ChangeButton":"Ändern","LocationText":"Du bist in"},"CookieDisclaimer":{"summary":"ASOS verwendet Cookies.","readMore":"Mehr Infos zu unseren Cookie-Richtlinien.","link":"entdecken/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"},"Errors":{"SomethingDoesntLookRight":"Hoppla! Irgend etwas scheint nicht korrekt zu sein."},"UnsupportedBrowserMessage":{"Header":"Browser-Unterstützung","Details":"Für ein optimales Nutzererlebnis bei ASOS empfehlen wir die Verwendung der neuesten Versionen von Chrome, Firefox, Safari oder Internet Explorer."}}

/***/ }),

/***/ "../i18n/en-au.json":
/***/ (function(module, exports) {

module.exports = {"SearchBar":{"RecentSearches":"Recent searches"},"CookieDisclaimer":{"link":"discover/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"},"MiniBag":{"Footer":{"DeliveryProposition":{"Title":"Free Shipping Worldwide*","Description":"More info ","LinkText":"here","DeliveryInformationLink":"customer-service/delivery/"}}}}

/***/ }),

/***/ "../i18n/en-us.json":
/***/ (function(module, exports) {

module.exports = {"MiniBag":{"Color":"Color","MyBag":"My Cart","Footer":{"BagLinks":{"Bag":{"Text":"View Cart"}},"DeliveryProposition":{"Title":"Free Shipping Worldwide*","Description":"More info ","LinkText":"here","DeliveryInformationLink":"customer-service/delivery/"}}},"SearchBar":{"RecentSearches":"Recent searches"},"Icon":{"Bag":"Cart"},"CookieDisclaimer":{"link":"discover/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"}}

/***/ }),

/***/ "../i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"GDPR":{"ContactPreferences":{"Header":"Time’s running out %{name}","Description":"Let us know if you're happy with the content below or edit in your preferences.","Channels":"Sent by email, text or both","EditButton":"Edit preferences","KeepButton":"Keep sending me this","LoginButton":"Sign in and edit","OptOutButton":"Opt me out","PrivacyLink":"Privacy Policy","Terms":"Terms & Conditions","Deadline":{"Header":"The law has changed","Description":"Which is why you may not have heard from us lately. If you don't want to miss out, tell us what you want to hear about below.","KeepButton":"Opt me back in","OptOutButton":"Keep me opted out"}},"GreetingButton":"Choose my options","GreetingButtonError":"Retry","Greeting":"What would you like to hear about from us?","GreetingLabel":"Hi %{name}. %{greeting}","GreetingLabelError":"Oops! Looks like we're facing some issues. Please try again.","InConfirmationBody":"Great! You can change these anytime in your contact preferences.","InConfirmationHeading":"Youʼre all done","OutConfirmationBody":"No worries. You can opt back in anytime by going to your preferences.","OutConfirmationHeading":"Oh, that's a shame","PreferencesButton":"Change my preferences","ShoppingButton":"Get shopping"},"MyAccountLinks":{"ContactPreferences":"Contact Preferences","Greeting":"Hi %{name}","MyAccount":"My Account","MyOrders":"My Orders","ReturnsInformation":"Returns Information","ReturnsInformationLink":"customer-service/customer-care/help/?help=/app/topiclanding/p/90","SignInLabel":"Sign In","SignOutLabel":"Sign Out","SignUpLabel":"Join","SignUpLink":"/register","Welcome":"Welcome"},"MiscBar":{"Marketplace":"Marketplace","Help":"Help & FAQs","HelpLink":"customer-service/customer-care/help/"},"Header":{"HomeAlt":"Back to the Home Page","WomenFloor":"WOMEN","MenFloor":"MEN"},"LegalBar":{"Privacy":"Privacy & Cookies","PrivacyLink":"privacy-policy/","Terms":"Ts&Cs","TermsLink":"terms-and-conditions/","Accessibility":"Accessibility","AccessibilityLink":"accessibility/"},"SidePanel":{"NavigationLabel":"Navigation menu","CloseNavigationLabel":"Close navigation menu"},"SearchBar":{"Label":"Search for items, brands and inspiration","RecentSearches":"Recent Searches","ClearRecentSearchesLabel":"Clear recent searches","ClearRecentSearchesText":"Clear","Placeholder":"Search for items, brands and inspiration"},"Burger":{"OpenNavigationLabel":"Open navigation menu"},"Icon":{"Search":"Search","Close":"Close","MyAccount":"My Account","SavedItems":"Saved Items","Bag":"Bag"},"Bag":{"Link":"bag"},"MiniBag":{"Name":"Name","Price":"Price","Color":"Colour","Quantity":"Quantity","Qty":"Qty","Size":"Size","RRP":"RRP","ItemCount":"%{smart_count} item |||| %{smart_count} items","MyBag":"My Bag","Footer":{"BagLinks":{"Bag":{"Text":"View Bag"},"Checkout":{"Text":"Checkout"}},"DeliveryProposition":{"Title":"Free Delivery Worldwide*","Description":"More info ","LinkText":"here","DeliveryInformationLink":"customer-service/delivery/"},"MaximumItemsMessage":"We can only show you 20 items here.","ViewBagMessage":{"PartOne":"Please ","Link":"view your bag","PartTwo":" to see everything."}},"reservationMessage":"It's in the bag - We'll hold it for an hour","subscriptionConfirmationMessage":"It's in the bag.","voucherConfirmationMessage":"It's in the bag.","ErrorMessage":{"firstLine":"Oops! We're having issues.","secondLine":"Please try again later."},"DismissNotificationBtnText":"Dismiss this message","DeleteBagItemText":"Delete this item","SubTotal":"Sub-total","ItemDeleted":"Item deleted"},"SavedItems":{"Link":"saved-items"},"CountrySelectorButton":{"Heading":"Shopping from:","ChangeCountry":"Choose Country","ChangeButton":"Change","LocationText":"You're in"},"CookieDisclaimer":{"summary":"ASOS uses cookies.","readMore":"About our cookie policy.","link":"discover/marketing-terms-and-conditions/privacy-policy-cookies/"},"Errors":{"SomethingDoesntLookRight":"Oops! Something doesn't look right."},"UnsupportedBrowserMessage":{"Header":"your browser is not supported","Details":"To use ASOS, we recommend using the latest versions of Chrome, Firefox, Safari or Internet Explorer"}}

/***/ }),

/***/ "../i18n/es.json":
/***/ (function(module, exports) {

module.exports = {"GDPR":{"ContactPreferences":{"Header":"Tú decides %{name}","Description":"Si no quieres que te sigamos informando acerca del contenido especificado a continuación, puedes modificarlo en tus preferencias.","Channels":"Eviar por email, SMS o ambos","EditButton":"Registrarme y modificar","KeepButton":"Quiero seguir recibiendo acerca de esto","LoginButton":"Registrarme y modificar","OptOutButton":"Dejar de recibir emails","PrivacyLink":"Política de privacidad","Terms":"Términos y condiciones","Deadline":{"Header":"La ley ha cambiado","Description":"Lo que explica por qué llevas un tiempo sin tener noticias nuestras...Si quieres que volvamos a la carga, dinos acerca de qué quieres que te informemos a continuación.","KeepButton":"Volver a unirme","OptOutButton":"De momento no, gracias"}},"GreetingButton":"Seleccionar mis opciones","GreetingButtonError":"Volver a intentar","Greeting":"¿Acerca de qué quieres que te informemos?","GreetingLabel":"Hola %{name}. %{greeting}","GreetingLabelError":"¡Ups! Parece que ha habido un problema. Inténtalo otra vez.","InConfirmationBody":"¡Perfecto! Y recuerda que puedes modificar esta información en tus preferencias de contacto cuando te apetezca.","InConfirmationHeading":"¡Ya has terminado!","OutConfirmationBody":"No te preocupes. Ya te hemos dado de baja y el proceso se completará en los próximos siete días. Y, si quieres volver a suscribirte, solo tienes que ajustar tus preferencias.","OutConfirmationHeading":"¡Qué pena…!","PreferencesButton":"Ajustar mis preferencias","ShoppingButton":"Ver ahora"},"MyAccountLinks":{"ContactPreferences":"Preferencias de contacto","Greeting":"Hola %{name}","MyAccount":"Mi cuenta","MyOrders":"Mis pedidos","ReturnsInformation":"Información de devoluciones","ReturnsInformationLink":"atencion-cliente/asistencia-al-cliente/ayuda/?help=/app/topiclanding/p/90","SignInLabel":"Acceder","SignOutLabel":"Salir","SignUpLabel":"Regístrate","SignUpLink":"/register","Welcome":"Bienvenido"},"MiscBar":{"Marketplace":"Marketplace","Help":"Ayuda y Preguntas frecuentes","HelpLink":"atencion-cliente/asistencia-al-cliente/ayuda/"},"Header":{"HomeAlt":"Volver a Página de Inicio","WomenFloor":"MUJER","MenFloor":"HOMBRE"},"LegalBar":{"Privacy":"Privacidad y cookies","PrivacyLink":"privacidad/","Terms":"Términos y condiciones","TermsLink":"terminos-y-condiciones/","Accessibility":"Accesibilidad","AccessibilityLink":"accesibilidad/"},"SidePanel":{"NavigationLabel":"Menú de navegación","CloseNavigationLabel":"Cerrar menú de navegación"},"SearchBar":{"Label":"Buscar artículos, marcas e inspiración","RecentSearches":"Búsquedas recientes","ClearRecentSearchesLabel":"Limpiar búsquedas recientes","ClearRecentSearchesText":"Borrar","Placeholder":"Buscar"},"Burger":{"OpenNavigationLabel":"Abrir menú de navegación"},"Icon":{"Search":"Buscar","Close":"Cerrar","MyAccount":"Mi cuenta","SavedItems":"Guardado","Bag":"Bolsa"},"Bag":{"Link":"bag"},"MiniBag":{"Name":"Nombre","Price":"Precio","Color":"Color","Quantity":"Cantidad","Qty":"Cant.","Size":"Talla","RRP":"RRP","ItemCount":"%{smart_count} artículo |||| %{smart_count} artículos","MyBag":"Mi bolsa","Footer":{"BagLinks":{"Bag":{"Text":"Ver Bolsa"},"Checkout":{"Text":"Pagar Ahora"}},"DeliveryProposition":{"Title":"Envío Y Devoluciones Gratis*","Description":"Más información ","LinkText":"aquí","DeliveryInformationLink":"atencion-cliente/envios/"},"MaximumItemsMessage":"Solo podemos mostrar 20 artículos.","ViewBagMessage":{"PartOne":"Por favor, ","Link":"consulta tu bolsa","PartTwo":" para ver todo."}},"reservationMessage":"Está en tu bolsa, ¡te lo guardamos durante una hora!","subscriptionConfirmationMessage":"Está en tu bolsa.","voucherConfirmationMessage":"Está en tu bolsa.","ErrorMessage":{"firstLine":"¡Ups! Tenemos problemas en estos momentos.","secondLine":"Inténtalo de nuevo más tarde."},"DismissNotificationBtnText":"Ignorar este mensaje","DeleteBagItemText":"Eliminar este artículo","SubTotal":"Subtotal","ItemDeleted":"Artículo eliminado"},"SavedItems":{"Link":"saved-items"},"CountrySelectorButton":{"Heading":"Compras desde","ChangeCountry":"Elige un país","ChangeButton":"Cambiar","LocationText":"Estás en"},"CookieDisclaimer":{"summary":"ASOS usa cookies.","readMore":"Más sobre nuestra política de cookies.","link":"descubre/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"},"Errors":{"SomethingDoesntLookRight":"¡Ups! Parece que algo no va bien."},"UnsupportedBrowserMessage":{"Header":"Compatibilidad con navegadores","Details":"Para utilizar ASOS, recomendamos utilizar las últimas versiones de Chrome, Firefox, Safari o Internet Explorer."}}

/***/ }),

/***/ "../i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"GDPR":{"ContactPreferences":{"Header":"C'est comme vous voulez %{name}","Description":"Dites-nous si notre contenu vous convient ou modifiez vos préférences.","Channels":"A recevoir par email, texto ou les deux","EditButton":"Modifier vos préférences","KeepButton":"Continuer de recevoir les infos","LoginButton":"Sʼincrire et modifier","OptOutButton":"Se désabonner","PrivacyLink":"Politique de confidentialité","Terms":"Modalités","Deadline":{"Header":"La loi change","Description":"Ce qui explique pourquoi vous n'avez pas eu de nos nouvelles récemment. Si vous voulez être sûr de ne rien manquer, confirmez les news que vous avez envie de recevoir.","KeepButton":"Je me réabonne","OptOutButton":"Je préfère ne pas me réabonner"}},"GreetingButton":"Choisir vos options","GreetingButtonError":"Réessayer","Greeting":"Quelles infos voulez-vous recevoir ?","GreetingLabel":"Salut %{name}. %{greeting}","GreetingLabelError":"Oups ! Il semblerait qu'il y ait un problème. Veuillez réessayer.","InConfirmationBody":"Vous pouvez les modifier dans vos préférences de contact à tout moment.","InConfirmationHeading":"C'est fait !","OutConfirmationBody":"Ne vous inquiétez pas. Maintenant que vous vous êtes désabonné, nous avons besoin de 7 jours pour que cela prenne effet. Vous pouvez vous réabonner à nouveau en modifiant vos préférences.","OutConfirmationHeading":"Dommage !","PreferencesButton":"Modifier mes préférences","ShoppingButton":"Shoppez"},"MyAccountLinks":{"ContactPreferences":"Préférences de contact","Greeting":"Salut %{name}","MyAccount":"Mon compte","MyOrders":"Mes commandes","ReturnsInformation":"Information sur les retours","ReturnsInformationLink":"service-client/assistance/aide/?help=/app/topiclanding/p/90","SignInLabel":"Connexion","SignOutLabel":"Déconnexion","SignUpLabel":"Créer un compte","SignUpLink":"/register","Welcome":"Bienvenue"},"MiscBar":{"Marketplace":"Marketplace","Help":"Aide et FAQ","HelpLink":"service-client/assistance/aide/"},"Header":{"HomeAlt":"Retour à la page d'accueil","WomenFloor":"FEMME","MenFloor":"HOMME"},"LegalBar":{"Privacy":"Confidentialité et cookies","PrivacyLink":"confidentialite/","Terms":"Conditions générales","TermsLink":"conditions-generales/","Accessibility":"Accessibilité","AccessibilityLink":"accessibilite/"},"SidePanel":{"NavigationLabel":"Menu de navigation","CloseNavigationLabel":"Fermer le menu de navigation"},"SearchBar":{"Label":"Rechercher des articles, des marques et de l'inspiration","RecentSearches":"Recherches récentes","ClearRecentSearchesLabel":"Supprimer les dernières recherches","ClearRecentSearchesText":"Effacer","Placeholder":"Rechercher"},"Burger":{"OpenNavigationLabel":"Ouvrir le menu de navigation"},"Icon":{"Search":"Rechercher","Close":"Fermer","MyAccount":"Mon compte","SavedItems":"Articles Sauvegardés","Bag":"Panier"},"Bag":{"Link":"bag"},"MiniBag":{"Name":"Nom","Price":"Prix","Color":"Couleur","Quantity":"Quantité","Qty":"Qté","Size":"Taille","RRP":"PVC","ItemCount":"%{smart_count} article |||| %{smart_count} articles","MyBag":"Mon panier","Footer":{"BagLinks":{"Bag":{"Text":"Voir Panier"},"Checkout":{"Text":"Payer"}},"DeliveryProposition":{"Title":"Livraison Et Retour Gratuits*","Description":"Plus d'informations ","LinkText":"ici","DeliveryInformationLink":"service-client/livraison/"},"MaximumItemsMessage":"Nous ne pouvons vous montrer que 20 articles ici.","ViewBagMessage":{"PartOne":"Veuillez ","Link":"consulter votre panier","PartTwo":" pour tout voir."}},"reservationMessage":"C'est dans votre panier. On vous le garde pendant une heure!","subscriptionConfirmationMessage":"C'est dans votre panier.","voucherConfirmationMessage":"C'est dans votre panier.","ErrorMessage":{"firstLine":"Oups ! Nous avons quelques difficultés.","secondLine":"Veuillez réessayer plus tard."},"DismissNotificationBtnText":"Supprimer ce message","DeleteBagItemText":"Supprimer cet article","SubTotal":"Sous-total","ItemDeleted":"Article supprimé"},"SavedItems":{"Link":"saved-items"},"CountrySelectorButton":{"Heading":"Sélectionnez le pays","ChangeCountry":"Sélectionner le pays","ChangeButton":"Changer","LocationText":"Vous êtes en"},"CookieDisclaimer":{"summary":"ASOS utilise des cookies.","readMore":"En savoir plus sur notre politique de cookies.","link":"decouvrez/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"},"Errors":{"SomethingDoesntLookRight":"Nous sommes désolés, nous rencontrons des problèmes."},"UnsupportedBrowserMessage":{"Header":"Support navigateur","Details":"Pour utiliser ASOS, nous vous conseillons les dernières versions de Chrome, Firefox, Safari ou Internet Explorer."}}

/***/ }),

/***/ "../i18n/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__("../node_modules/babel-runtime/helpers/slicedToArray.js");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _merge = __webpack_require__("../node_modules/lodash/merge.js");

var _merge2 = _interopRequireDefault(_merge);

var _de = __webpack_require__("../i18n/de.json");

var _de2 = _interopRequireDefault(_de);

var _enAu = __webpack_require__("../i18n/en-au.json");

var _enAu2 = _interopRequireDefault(_enAu);

var _enUs = __webpack_require__("../i18n/en-us.json");

var _enUs2 = _interopRequireDefault(_enUs);

var _en = __webpack_require__("../i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _es = __webpack_require__("../i18n/es.json");

var _es2 = _interopRequireDefault(_es);

var _fr = __webpack_require__("../i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

var _it = __webpack_require__("../i18n/it.json");

var _it2 = _interopRequireDefault(_it);

var _nlNl = __webpack_require__("../i18n/nl-nl.json");

var _nlNl2 = _interopRequireDefault(_nlNl);

var _ru = __webpack_require__("../i18n/ru.json");

var _ru2 = _interopRequireDefault(_ru);

var _svSe = __webpack_require__("../i18n/sv-se.json");

var _svSe2 = _interopRequireDefault(_svSe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locales = {
  de: _de2.default,
  "en-au": _enAu2.default,
  "en-us": _enUs2.default,
  en: _en2.default,
  es: _es2.default,
  fr: _fr2.default,
  it: _it2.default,
  "nl-nl": _nlNl2.default,
  ru: _ru2.default,
  "sv-se": _svSe2.default
};

var getLanguageBundle = function getLanguageBundle(bundle) {
  return locales[bundle] || {};
};

exports.default = function (languageCode) {
  var _languageCode$split = languageCode.split("-"),
      _languageCode$split2 = (0, _slicedToArray3.default)(_languageCode$split, 1),
      lang = _languageCode$split2[0];

  return (0, _merge2.default)({}, getLanguageBundle(lang), getLanguageBundle(languageCode.toLowerCase()));
};

/***/ }),

/***/ "../i18n/it.json":
/***/ (function(module, exports) {

module.exports = {"GDPR":{"ContactPreferences":{"Header":"Sei tu che decidi %{name}","Description":"Sei soddisfatto delle notizie che ricevi da noi? Altrimenti seleziona le tue preferenze qui sotto.","Channels":"Invio tramite email, SMS o entrambi","EditButton":"Modifica le preferenze","KeepButton":"Voglio continuare a ricevere le email di ASOS","LoginButton":"Registrati e modifica","OptOutButton":"Cancella l'iscrizione","PrivacyLink":"Politica sulla privacy","Terms":"Termini e Condizioni","Deadline":{"Header":"La legge è cambiata","Description":"Motivo per il quale potresti non aver ricevuto nostre notizie ultimamente. Se non vuoi perdere le nostre novità, modifica le tue preferenze adesso.","KeepButton":"Rieccomi","OptOutButton":"Non per il momento, grazie"}},"GreetingButton":"Scegli le opzioni","GreetingButtonError":"Riprova","Greeting":"Quali notizie vorresti ricevere da noi?","GreetingLabel":"Ciao, %{name}. %{greeting}","GreetingLabelError":"Ops! C’è stato un problema. Per favore, prova di nuovo.","InConfirmationBody":"Ben fatto! Se cambi idea puoi modificare le tue preferenze quando vuoi.","InConfirmationHeading":"Fatto!","OutConfirmationBody":"Non preoccuparti, puoi iscriverti di nuovo modificando le tue preferenze.","OutConfirmationHeading":"Oh no, che peccato!","PreferencesButton":"Modifica le preferenze","ShoppingButton":"Inizia lo shopping"},"MyAccountLinks":{"ContactPreferences":"Preferenze di contatto","Greeting":"Ciao %{name}","MyAccount":"Il mio account","MyOrders":"I miei ordini","ReturnsInformation":"Informazioni sui resi","ReturnsInformationLink":"assistenza-clienti/servizio-clienti/aiuto/?help=/app/topiclanding/p/90","SignInLabel":"Accedi","SignOutLabel":"Esci","SignUpLabel":"Registrati","SignUpLink":"/register","Welcome":"Benvenuto"},"MiscBar":{"Marketplace":"Marketplace","Help":"Assistenza e domande frequenti","HelpLink":"assistenza-clienti/servizio-clienti/aiuto/"},"Header":{"HomeAlt":"Torna alla Homepage","WomenFloor":"DONNA","MenFloor":"UOMO"},"LegalBar":{"Privacy":"Privacy e Cookie","PrivacyLink":"privacy/","Terms":"Termini e condizioni","TermsLink":"termini-e-condizioni/","Accessibility":"Accessibilità","AccessibilityLink":"accessibilita/"},"SidePanel":{"NavigationLabel":"Menu di navigazione","CloseNavigationLabel":"Chiudi menu di navigazione"},"SearchBar":{"Label":"Cerca articoli, brand e ispirazione","RecentSearches":"Ricerche recenti","ClearRecentSearchesLabel":"Cancella ricerche recenti","ClearRecentSearchesText":"Azzera","Placeholder":"Cerca"},"Burger":{"OpenNavigationLabel":"Apri menu di navigazione"},"Icon":{"Search":"Cerca","Close":"Chiudi","MyAccount":"Il mio account","SavedItems":"Prodotti Salvati","Bag":"Carrello"},"Bag":{"Link":"bag"},"MiniBag":{"Name":"Nome","Price":"Prezzo","Color":"Colore","Quantity":"Quantità","Qty":"Qtà","Size":"Taglia","RRP":"Prezzo originale","ItemCount":"%{smart_count} prodotto |||| %{smart_count} prodotti","MyBag":"Il mio carrello","Footer":{"BagLinks":{"Bag":{"Text":"Visualizza Carrello"},"Checkout":{"Text":"Acquista Ora"}},"DeliveryProposition":{"Title":"Spedizione E Resi Gratis*","Description":"Più info ","LinkText":"qui","DeliveryInformationLink":"assistenza-clienti/consegna/"},"MaximumItemsMessage":"Qui possiamo mostrarti solo 20 articoli.","ViewBagMessage":{"PartOne":"","Link":"Visualizza il carrello","PartTwo":" per vedere tutto."}},"reservationMessage":"È nel tuo carrello! Lo terremo per un'ora.","subscriptionConfirmationMessage":"È nel tuo carrello!","voucherConfirmationMessage":"È nel tuo carrello!","ErrorMessage":{"firstLine":"Ops! Si sono verificati dei problemi.","secondLine":"Riprova più tardi."},"DismissNotificationBtnText":"Rimuovi questo messaggio","DeleteBagItemText":"Elimina prodotto","SubTotal":"Subtotale","ItemDeleted":"Prodotto eliminato"},"SavedItems":{"Link":"saved-items"},"CountrySelectorButton":{"Heading":"Acquista da","ChangeCountry":"Scegli il Paese","ChangeButton":"Modifica","LocationText":"Ti trovi in"},"CookieDisclaimer":{"summary":"ASOS utilizza cookie.","readMore":"Leggi l'informativa sui cookie.","link":"scopri/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"},"Errors":{"SomethingDoesntLookRight":"Spiacenti, si sono verificati dei problemi."},"UnsupportedBrowserMessage":{"Header":"Browser supportati","Details":"Per utilizzare ASOS, ti consigliamo di utilizzare l'ultima versione di Firefox, Safari o Internet Explorer."}}

/***/ }),

/***/ "../i18n/nl-nl.json":
/***/ (function(module, exports) {

module.exports = {"GDPR":{"ContactPreferences":{"Header":"Jij hebt de controle","Description":"Laat ons weten of je tevreden bent met de onderstaande inhoud of wijzig het in je voorkeuren","Channels":"Verzonden via e-mail, SMS of allebei","EditButton":"Wijzig voorkeuren","KeepButton":"Blijf me dit sturen","LoginButton":"Log in en wijzig","OptOutButton":"Meld me af","PrivacyLink":"Privacybeleid","Terms":"Algemene voorwaarden","Deadline":{"Header":"The law has changed","Description":"Which is why you may not have heard from us lately. If you don't want to miss out, tell us what you want to hear about below.","KeepButton":"Opt me back in","OptOutButton":"Keep me opted out"}},"GreetingButton":"Mijn opties kiezen","GreetingButtonError":"Opnieuw proberen","Greeting":"Waar wil je graag over horen van ons?","GreetingLabel":"Hallo %{name}. %{greeting}","GreetingLabelError":"Oeps! Het lijkt erop dat we wat problemen hebben. Probeer het opnieuw.","InConfirmationBody":"Geweldig! Je kunt deze op ieder moment veranderen in je contactvoorkeuren.","InConfirmationHeading":"Je bent helemaal klaar","OutConfirmationBody":"Geen zorgen. Je kunt je op ieder moment weer aanmelden door naar je voorkeuren te gaan.","OutConfirmationHeading":"Oh, dat is jammer","PreferencesButton":"Verander mijn voorkeuren","ShoppingButton":"Begin met winkelen"},"MyAccountLinks":{"ContactPreferences":"Contactvoorkeuren","Greeting":"Hallo %{name}","MyAccount":"Mijn account","MyOrders":"Mijn bestellingen","ReturnsInformation":"Informatie over retourneren","ReturnsInformationLink":"klantenservice/klantendienst/hulp/?help=/app/topiclanding/p/90","SignInLabel":"Inloggen","SignOutLabel":"Uitloggen","SignUpLabel":"Meld je aan","SignUpLink":"/register","Welcome":"Welkom"},"MiscBar":{"Marketplace":"Marketplace","Help":"Hulp en FAQs","HelpLink":"klantenservice/klantendienst/hulp/"},"Header":{"HomeAlt":"Terug naar de homepage","WomenFloor":"DAMES","MenFloor":"HEREN"},"LegalBar":{"Privacy":"Privacy & Cookies","PrivacyLink":"privacy-policy/","Terms":"Algemene Voorwaarden","TermsLink":"terms-and-conditions/","Accessibility":"Toegankelijkheid","AccessibilityLink":"accessibility/"},"SidePanel":{"NavigationLabel":"Navigatiemenu","CloseNavigationLabel":"Sluit navigatiemenu"},"SearchBar":{"Label":"Zoek artikelen, merken en inspiratie","RecentSearches":"Recente zoekopdrachten","ClearRecentSearchesLabel":"Recente zoekopdrachten verwijderen","ClearRecentSearchesText":"Verwijderen","Placeholder":"Zoek artikelen, merken en inspiratie"},"Burger":{"OpenNavigationLabel":"Open navigatiemenu"},"Icon":{"Search":"Zoeken","Close":"Sluiten","MyAccount":"Mijn account","SavedItems":"Favorieten","Bag":"Winkelmandje"},"Bag":{"Link":"bag"},"MiniBag":{"Name":"Naam","Price":"Prijs","Color":"Kleur","Quantity":"Aantal","Qty":"Aantal","Size":"Maat","RRP":"Adviesprijs","ItemCount":"%{smart_count} item |||| %{smart_count} artikelen","MyBag":"Mijn winkelmandje","Footer":{"BagLinks":{"Bag":{"Text":"WINKELMANDJE BEKIJKEN"},"Checkout":{"Text":"BETALEN"}},"DeliveryProposition":{"Title":"Gratis bezorging wereldwijd*","Description":"","LinkText":"Meer informatie","DeliveryInformationLink":"customer-service/delivery/"},"MaximumItemsMessage":"Wij kunnen je hier slechts 20 artikelen laten zien.","ViewBagMessage":{"PartOne":"","Link":"Bekijk je winkelmandje","PartTwo":" om alles te zien."}},"reservationMessage":"Het zit in je winkelmandje - we houden het een uur voor je vast!","subscriptionConfirmationMessage":"Het zit in je winkelmandje!","voucherConfirmationMessage":"Het zit in je winkelmandje!","ErrorMessage":{"firstLine":"Oeps! We hebben technische problemen.","secondLine":"Probeer het later opnieuw."},"DismissNotificationBtnText":"Sluit deze boodschap","DeleteBagItemText":"Verwijder dit artikel","SubTotal":"Subtotaal","ItemDeleted":"Artikel verwijderd"},"SavedItems":{"Link":"saved-items"},"CountrySelectorButton":{"Heading":"Winkelen vanuit:","ChangeCountry":"Kies land","ChangeButton":"Verander","LocationText":"Je bent in"},"CookieDisclaimer":{"summary":"ASOS gebruikt cookies.","readMore":" Over ons cookiebeleid.","link":"ontdek/marketing-algemene-voorwaarden/privacyverklaring-cookies/"},"Errors":{"SomethingDoesntLookRight":"Oeps! Er is iets verkeerd gegaan."},"UnsupportedBrowserMessage":{"Header":"Je browser wordt niet ondersteund","Details":"Om ASOS te gebruiken, adviseren wij om de meest recente versie van Chrome, Firefox, Safari of Internet Explorer te gebruiken."}}

/***/ }),

/***/ "../i18n/ru.json":
/***/ (function(module, exports) {

module.exports = {"GDPR":{"ContactPreferences":{"Header":"Выбор только за тобой %{name}","Description":"Дай нам, пожалуйста, знать, если тебя все устраивает, или перейди в настройки, чтобы внести изменения.","Channels":"По электронной почте, SMS или через оба канала","EditButton":"Редактировать","KeepButton":"Я хочу продолжать получать эту рассылку","LoginButton":"Войти в личный кабинет и поменять настройки","OptOutButton":"Я не хочу получать рассылку","PrivacyLink":"Политику конфиденциальности","Terms":"Правила и условия","Deadline":{"Header":"Законы меняются","Description":"Именно поэтому какое-то время тебе не приходили никакие письма от нас. Если не хочешь пропустить всё самое интересное, выбери из опций ниже.","KeepButton":"Подписаться на рассылку","OptOutButton":"Я не хочу получать рассылку"}},"GreetingButton":"Выбрать вариант","GreetingButtonError":"Повторить","Greeting":"Какие новости тебе бы хотелось от нас получать?","GreetingLabel":"Привет %{name}. %{greeting}","GreetingLabelError":"Упс! У нас небольшие технические сложности. Повтори попытку еще раз.","InConfirmationBody":"Ты можешь внести изменения в настройки в любой момент в разделе \"Контакты\".","InConfirmationHeading":"Готово!","OutConfirmationBody":"Не беспокойся. Теперь вы успешно отменили подписку – в течение семи дней это вступит в силу. Вы можете вернуться в любое время, перейдя к вашим предпочтениям","OutConfirmationHeading":"О, нет!","PreferencesButton":"Изменить мои настройки","ShoppingButton":"Начать шоппинг"},"MyAccountLinks":{"ContactPreferences":"Предпочтительные способы связи","Greeting":"Привет %{name}","MyAccount":"Личный кабинет","MyOrders":"Мои заказы","ReturnsInformation":"Информация о возвратах","ReturnsInformationLink":"customer-service/customer-care/help/?help=/app/topiclanding/p/90","SignInLabel":"Войти","SignOutLabel":"Выйти","SignUpLabel":"Регистрация","SignUpLink":"/register","Welcome":"Добро пожаловать"},"MiscBar":{"Marketplace":"Marketplace","Help":"Помощь и FAQ","HelpLink":"customer-service/customer-care/help/"},"Header":{"HomeAlt":"Назад на главную","WomenFloor":"ЖЕНСКОЕ","MenFloor":"МУЖСКОЕ"},"LegalBar":{"Privacy":"Конфиденциальность и cookie-файлы","PrivacyLink":"privacy-policy/","Terms":"Правила и условия","TermsLink":"terms-and-conditions/","Accessibility":"Доступность","AccessibilityLink":"accessibility/"},"SidePanel":{"NavigationLabel":"Навигационное меню","CloseNavigationLabel":"Закрыть навигационное меню"},"SearchBar":{"Label":"Поиск товаров, брендов и новостей из мира моды","RecentSearches":"Недавние запросы","ClearRecentSearchesLabel":"Очистить последние результаты поиска","ClearRecentSearchesText":"Очистить","Placeholder":"Искать"},"Burger":{"OpenNavigationLabel":"Открыть навигационное меню"},"Icon":{"Search":"Поиск","Close":"Закрыть","MyAccount":"Личный кабинет","SavedItems":"Отложено","Bag":"Корзина"},"Bag":{"Link":"bag"},"MiniBag":{"Name":"Имя","Price":"Цена","Color":"Цвет","Quantity":"Количество","Qty":"Кол-во","Size":"Размер","RRP":"Розничная цена","ItemCount":"%{smart_count} товар |||| %{smart_count} товаров","MyBag":"Моя корзина","Footer":{"BagLinks":{"Bag":{"Text":"Просмотреть Корзину"},"Checkout":{"Text":"Оформить Заказ"}},"DeliveryProposition":{"Title":"Бесплатная Доставка По Всему Миру*","Description":"Подробнее ","LinkText":"здесь","DeliveryInformationLink":"customer-service/delivery/"},"MaximumItemsMessage":"Здесь отображается только 20 товаров.","ViewBagMessage":{"PartOne":"Пожалуйста, ","Link":"зайдите в вашу корзину","PartTwo":", чтобы просмотреть все товары."}},"reservationMessage":"Ваш товар в будет находится в корзине в течение часа.","subscriptionConfirmationMessage":"Ваш товар в будет находится в корзине","voucherConfirmationMessage":"Ваш товар в будет находится в корзине","ErrorMessage":{"firstLine":"Ой, произошла ошибка.","secondLine":"Пожалуйста, повторите попытку позже."},"DismissNotificationBtnText":"Пропустить это сообщение","DeleteBagItemText":"Удалить этот товар","SubTotal":"Всего","ItemDeleted":"Товар удален"},"SavedItems":{"Link":"saved-items"},"CountrySelectorButton":{"Heading":"Шоппинг в","ChangeCountry":"Выберите страну","ChangeButton":"Изменить","LocationText":"Страна:"},"CookieDisclaimer":{"summary":"ASOS использует cookies.","readMore":"Правила использования.","link":"discover/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"},"Errors":{"SomethingDoesntLookRight":"Извините, у нас возникли некоторые проблемы."},"UnsupportedBrowserMessage":{"Header":"Поддержка браузера","Details":"Для ASOS мы рекомендуем использовать последние версии Chrome, Firefox, Safari или Internet Explorer."}}

/***/ }),

/***/ "../i18n/sv-se.json":
/***/ (function(module, exports) {

module.exports = {"GDPR":{"ContactPreferences":{"Header":"Du bestämmer","Description":"Tala om för oss om du gillar innehållet nedan eller ange dina preferenser.","Channels":"Skickat via e-post, SMS eller både och.","EditButton":"Redigera preferenser","KeepButton":"Skicka mer av detta","LoginButton":"Logga in och redigera","OptOutButton":"Avanmäl mig","PrivacyLink":"Sekretesspolicy","Terms":"Användarvillkor","Deadline":{"Header":"The law has changed","Description":"Which is why you may not have heard from us lately. If you don't want to miss out, tell us what you want to hear about below.","KeepButton":"Opt me back in","OptOutButton":"Keep me opted out"}},"GreetingButton":"Välj mina alternativ","GreetingButtonError":"Försök igen","Greeting":"Vad vill du höra om från oss?","GreetingLabel":"Hej, %{name}. %{greeting}","GreetingLabelError":"Hoppsan! Det verkar som om vi har problem. Vänligen försök igen.","InConfirmationBody":"Utmärkt! Du kan ändra detta när som helst i dina kontaktpreferenser.","InConfirmationHeading":"Nu är du färdig","OutConfirmationBody":"Oroa dig inte. Du kan anmäla dig igen när som helst genom att gå till dina preferenser.","OutConfirmationHeading":"Åh, det var synd","PreferencesButton":"Ändra mina preferenser","ShoppingButton":"Börja shoppa"},"MyAccountLinks":{"ContactPreferences":"Kontaktinställningar","Greeting":"Hej %{name}","MyAccount":"Mitt konto","MyOrders":"Mina beställningar","ReturnsInformation":"Information om returer","ReturnsInformationLink":"customer-service/customer-care/help/?help=/app/topiclanding/p/90","SignInLabel":"Logga in","SignOutLabel":"Logga ut","SignUpLabel":"Registrera dig","SignUpLink":"/register","Welcome":"Välkommen"},"MiscBar":{"Marketplace":"Marketplace","Help":"Hjälp och vanliga frågor","HelpLink":"customer-service/customer-care/help/"},"Header":{"HomeAlt":"Tillbaka till startsidan","WomenFloor":"KVINNA","MenFloor":"MAN"},"LegalBar":{"Privacy":"Sekretess och cookies","PrivacyLink":"privacy-policy/","Terms":"Användarvillkor","TermsLink":"terms-and-conditions/","Accessibility":"Tillgänglighet","AccessibilityLink":"accessibility/"},"SidePanel":{"NavigationLabel":"Navigeringsmeny","CloseNavigationLabel":"Stäng navigeringsmenyn"},"SearchBar":{"Label":"Sök efter artiklar, varumärken och inspiration","RecentSearches":"Senaste sökningarna","ClearRecentSearchesLabel":"Rensa senaste sökningarna","ClearRecentSearchesText":"Rensa","Placeholder":"Sök efter artiklar, varumärken och inspiration"},"Burger":{"OpenNavigationLabel":"Öppna navigeringsmenyn"},"Icon":{"Search":"Sök","Close":"Stäng","MyAccount":"Mitt konto","SavedItems":"Sparade artiklar","Bag":"Varukorg"},"Bag":{"Link":"bag"},"MiniBag":{"Name":"Namn","Price":"Pris","Color":"Färg","Quantity":"Antal","Qty":"Antal","Size":"Storlek","RRP":"Rekommenderat försäljningspris","ItemCount":"%{smart_count} item |||| %{smart_count} artiklar","MyBag":"Min varukorg","Footer":{"BagLinks":{"Bag":{"Text":"VISA VARUKORG"},"Checkout":{"Text":"GÅ TILL KASSAN"}},"DeliveryProposition":{"Title":"Kostnadsfri leverans över hela världen*","Description":"","LinkText":"Mer information här","DeliveryInformationLink":"customer-service/delivery/"},"MaximumItemsMessage":"Vi kan endast visa dig 20 artiklar här.","ViewBagMessage":{"PartOne":"","Link":"Visa din varukorg","PartTwo":" om du vill se allt."}},"reservationMessage":"Den ligger i varukorgen – vi reserverar den åt dig i en timme!","subscriptionConfirmationMessage":"Den ligger i varukorgen!","voucherConfirmationMessage":"Den ligger i varukorgen!","ErrorMessage":{"firstLine":"Hoppsan! Vi har problem.","secondLine":"Försök igen senare."},"DismissNotificationBtnText":"Avvisa det här meddelandet","DeleteBagItemText":"Ta bort den här artikeln","SubTotal":"Delsumma","ItemDeleted":"Artikeln har tagits bort"},"SavedItems":{"Link":"saved-items"},"CountrySelectorButton":{"Heading":"Shoppar från:","ChangeCountry":"Välj land","ChangeButton":"Ändra","LocationText":"Du befinner dig i"},"CookieDisclaimer":{"summary":"ASOS använder cookies.","readMore":"Om vår cookiepolicy.","link":"upptack/marknadsforing-allmanna-villkor/integritetspolicy-cookies/"},"Errors":{"SomethingDoesntLookRight":"Hoppsan! Något blev fel."},"UnsupportedBrowserMessage":{"Header":"din webbläsare stöds inte","Details":"Om du vill besöka ASOS rekommenderar vi att du använder den senaste versionen av Chrome, Firefox, Safari eller Internet Explorer"}}

/***/ }),

/***/ "../i18n/utilities/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSocialLinks = exports.getLanguage = undefined;

var _get = __webpack_require__("./helpers/get.js");

var _get2 = _interopRequireDefault(_get);

var _socialLinks = __webpack_require__("../i18n/utilities/socialLinks.json");

var _socialLinks2 = _interopRequireDefault(_socialLinks);

var _lowerEntries2 = __webpack_require__("./helpers/lowerEntries.js");

var _lowerEntries3 = _interopRequireDefault(_lowerEntries2);

var _constants = __webpack_require__("./template/state/modules/layout/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLanguage = exports.getLanguage = function getLanguage(languageCode) {
  return languageCode.split("-")[0];
};

var getSocialLinks = exports.getSocialLinks = function getSocialLinks(params) {
  var _lowerEntries = (0, _lowerEntries3.default)(params),
      floor = _lowerEntries.floor,
      storeCode = _lowerEntries.storeCode;

  if (!floor || !storeCode) {
    throw new Error("cannot retrieve social networks without storeCode and floor");
  }

  var defaultedFloor = floor === _constants.DEFAULT ? _constants.FEMALE : floor;
  var linksPath = storeCode + "." + defaultedFloor;

  return (0, _get2.default)(_socialLinks2.default, linksPath);
};

/***/ }),

/***/ "../i18n/utilities/socialLinks.json":
/***/ (function(module, exports) {

module.exports = {"com":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"}},"row":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"}},"roe":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"}},"fr":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos_fr/","Snapchat":"https://www.snapchat.com/add/asosfashion"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos_fr/","Snapchat":"https://www.snapchat.com/add/asosfashion"}},"us":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos_us/","Snapchat":"https://www.snapchat.com/add/asosfashion"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos_us/","Snapchat":"https://www.snapchat.com/add/asosfashion"}},"au":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos_au/","Snapchat":"https://www.snapchat.com/add/asosfashion"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos_au/","Snapchat":"https://www.snapchat.com/add/asosfashion"}},"de":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos_de/","Snapchat":"https://www.snapchat.com/add/asosfashion"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"http://www.instagram.com/asos_de/","Snapchat":"https://www.snapchat.com/add/asosfashion"}},"it":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"http://www.instagram.com/asos_it/"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"http://www.instagram.com/asos_it/"}},"es":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"http://www.instagram.com/asos_es/"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"http://www.instagram.com/asos_es/"}},"ru":{"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"http://www.instagram.com/asos_ru/","Vk":"https://vk.com/asos"},"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"http://www.instagram.com/asos_ru/","Vk":"https://vk.com/asos"}},"nl":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"}},"se":{"women":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"},"men":{"Facebook":"https://www.facebook.com/ASOS/","Instagram":"https://www.instagram.com/asos/","Snapchat":"https://www.snapchat.com/add/asosfashion"}}}

/***/ }),

/***/ "../node_modules/agentkeepalive/browser.js":
/***/ (function(module, exports) {

module.exports = noop;
module.exports.HttpsAgent = noop;

// Noop function for browser since native api's don't use agents.
function noop () {}


/***/ }),

/***/ "../node_modules/asos-content-api-global-banner/dist/asos-content-api-global-banner.min.js":
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n(__webpack_require__("../node_modules/prop-types/index.js"),__webpack_require__("../node_modules/react/index.js"),__webpack_require__("../node_modules/base64url/index.js"),__webpack_require__("../node_modules/isomorphic-fetch/fetch-npm-browserify.js")):"function"==typeof define&&define.amd?define("asos-content-api-global-banner",["prop-types","react","base64url","isomorphic-fetch"],n):"object"==typeof exports?exports["asos-content-api-global-banner"]=n(require("prop-types"),require("react"),require("base64url"),require("isomorphic-fetch")):t["asos-content-api-global-banner"]=n(t["prop-types"],t.react,t.base64url,t["isomorphic-fetch"])}(this,function(t,n,e,o){return function(t){var n={};function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t["default"]}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=17)}([function(t,n){t.exports=__webpack_require__("../node_modules/prop-types/index.js")},function(t,n){t.exports=__webpack_require__("../node_modules/react/index.js")},function(t,n){t.exports=function(t){var n=[];return n.toString=function(){return this.map(function(n){var e=function(t,n){var e=t[1]||"",o=t[3];if(!o)return e;if(n&&"function"==typeof btoa){var r=(a=o,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),l=o.sources.map(function(t){return"/*# sourceURL="+o.sourceRoot+t+" */"});return[e].concat(l).concat([r]).join("\n")}var a;return[e].join("\n")}(n,t);return n[2]?"@media "+n[2]+"{"+e+"}":e}).join("")},n.i=function(t,e){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},r=0;r<this.length;r++){var l=this[r][0];"number"==typeof l&&(o[l]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&o[a[0]]||(e&&!a[2]?a[2]=e:e&&(a[2]="("+a[2]+") and ("+e+")"),n.push(a))}},n}},function(t,n,e){var o,r,l={},a=(o=function(){return window&&document&&document.all&&!window.atob},function(){return void 0===r&&(r=o.apply(this,arguments)),r}),i=function(t){var n={};return function(t){if("function"==typeof t)return t();if("undefined"==typeof n[t]){var e=function(t){return document.querySelector(t)}.call(this,t);if(window.HTMLIFrameElement&&e instanceof window.HTMLIFrameElement)try{e=e.contentDocument.head}catch(o){e=null}n[t]=e}return n[t]}}(),s=null,c=0,p=[],u=e(32);function f(t,n){for(var e=0;e<t.length;e++){var o=t[e],r=l[o.id];if(r){r.refs++;for(var a=0;a<r.parts.length;a++)r.parts[a](o.parts[a]);for(;a<o.parts.length;a++)r.parts.push(y(o.parts[a],n))}else{var i=[];for(a=0;a<o.parts.length;a++)i.push(y(o.parts[a],n));l[o.id]={id:o.id,refs:1,parts:i}}}}function d(t,n){for(var e=[],o={},r=0;r<t.length;r++){var l=t[r],a=n.base?l[0]+n.base:l[0],i={css:l[1],media:l[2],sourceMap:l[3]};o[a]?o[a].parts.push(i):e.push(o[a]={id:a,parts:[i]})}return e}function b(t,n){var e=i(t.insertInto);if(!e)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o=p[p.length-1];if("top"===t.insertAt)o?o.nextSibling?e.insertBefore(n,o.nextSibling):e.appendChild(n):e.insertBefore(n,e.firstChild),p.push(n);else if("bottom"===t.insertAt)e.appendChild(n);else{if("object"!=typeof t.insertAt||!t.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var r=i(t.insertInto+" "+t.insertAt.before);e.insertBefore(n,r)}}function C(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var n=p.indexOf(t);n>=0&&p.splice(n,1)}function h(t){var n=document.createElement("style");return t.attrs.type===undefined&&(t.attrs.type="text/css"),_(n,t.attrs),b(t,n),n}function _(t,n){Object.keys(n).forEach(function(e){t.setAttribute(e,n[e])})}function y(t,n){var e,o,r,l;if(n.transform&&t.css){if(!(l=n.transform(t.css)))return function(){};t.css=l}if(n.singleton){var a=c++;e=s||(s=h(n)),o=x.bind(null,e,a,!1),r=x.bind(null,e,a,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(e=function(t){var n=document.createElement("link");return t.attrs.type===undefined&&(t.attrs.type="text/css"),t.attrs.rel="stylesheet",_(n,t.attrs),b(t,n),n}(n),o=function(t,n,e){var o=e.css,r=e.sourceMap,l=n.convertToAbsoluteUrls===undefined&&r;(n.convertToAbsoluteUrls||l)&&(o=u(o));r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([o],{type:"text/css"}),i=t.href;t.href=URL.createObjectURL(a),i&&URL.revokeObjectURL(i)}.bind(null,e,n),r=function(){C(e),e.href&&URL.revokeObjectURL(e.href)}):(e=h(n),o=function(t,n){var e=n.css,o=n.media;o&&t.setAttribute("media",o);if(t.styleSheet)t.styleSheet.cssText=e;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(e))}}.bind(null,e),r=function(){C(e)});return o(t),function(n){if(n){if(n.css===t.css&&n.media===t.media&&n.sourceMap===t.sourceMap)return;o(t=n)}else r()}}t.exports=function(t,n){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");if("undefined"==typeof document)return null;(n=n||{}).attrs="object"==typeof n.attrs?n.attrs:{},n.singleton||"boolean"==typeof n.singleton||(n.singleton=a()),n.insertInto||(n.insertInto="head"),n.insertAt||(n.insertAt="bottom");var e=d(t,n);return f(e,n),function(t){for(var o=[],r=0;r<e.length;r++){var a=e[r];(i=l[a.id]).refs--,o.push(i)}t&&f(d(t,n),n);for(r=0;r<o.length;r++){var i;if(0===(i=o[r]).refs){for(var s=0;s<i.parts.length;s++)i.parts[s]();delete l[i.id]}}}};var P,g=(P=[],function(t,n){return P[t]=n,P.filter(Boolean).join("\n")});function x(t,n,e,o){var r=e?"":o.css;if(t.styleSheet)t.styleSheet.cssText=g(n,r);else{var l=document.createTextNode(r),a=t.childNodes;a[n]&&t.removeChild(a[n]),a.length?t.insertBefore(l,a[n]):t.appendChild(l)}}},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}();var r=function(){function t(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,t)}return o(t,[{key:"triggerNewrelicEvent",value:function(t,n){if("undefined"!=typeof window){var e=window.newrelic;e&&e.addPageAction(t,n)}}},{key:"triggerTargetEvent",value:function(t){if("undefined"!=typeof window){var n=new CustomEvent(t,{detail:{message:t,time:new Date},bubbles:!0,cancelable:!0});window.dispatchEvent(n)}}}]),t}();n["default"]=r},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.handleCtaRef=function(t,n){if(n.length>0){var e="ctaref",o=new RegExp("([?&])ctaref=.*?(&|$)","i"),r=-1!==t.indexOf("?")?"&":"?";return t.match(o)?t.replace(o,"$1ctaref="+n+"$2"):""+t+r+e+"="+n}return t}},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}();e(34);var r,l=e(33),a=(r=l)&&r.__esModule?r:{"default":r},i=e(18);var s=function(){function t(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,t),this.endpoint=i.ENDPOINT,this.locationParameters={},this.encodedUserContext={}}return o(t,[{key:"setContextParameters",value:function(n){this.encodedUserContext=t.objectToBase64({premier:n.subscriptions}),this.locationParameters={country:n.country,store:n.store,lang:n.lang}}},{key:"fetchContent",value:function(){return fetch(this.generateContentAPIURL(),{method:"GET",credentials:"same-origin"}).then(function(t){return 200===t.status?t.json():Promise.reject(t)}).then(function(t){return t})["catch"](function(t){return Promise.reject(t)})}},{key:"generateContentAPIURL",value:function(){var n=t.constructQueryString(this.locationParameters,this.encodedUserContext);return""+this.endpoint+n}}],[{key:"objectToBase64",value:function(t){return 0===Object.keys(t).length?null:a["default"].encode(JSON.stringify(t))}},{key:"constructQueryString",value:function(t,n){var e="/?";for(var o in t)e="/?"===e?""+e+o+"="+t[o]:e+"&"+o+"="+t[o];return n?e+"&context="+n:e}}]),t}();n["default"]=s},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}(),r=s(e(1)),l=s(e(0)),a=s(e(14)),i=s(e(16));function s(t){return t&&t.__esModule?t:{"default":t}}var c=function(t){function n(){return function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n),function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?t:n}(this,(n.__proto__||Object.getPrototypeOf(n)).apply(this,arguments))}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(t,n):t.__proto__=n)}(n,r["default"].PureComponent),o(n,[{key:"isMarketingUnits",value:function(t){return!!t.javascripts}},{key:"filterGlobalBannerFromContentAPI",value:function(t){for(var n=0;n<t.length;n++)if("GlobalBanner"===t[n].type)return t[n].data;return null}},{key:"render",value:function(){return this.isMarketingUnits(this.props.content)?r["default"].createElement(i["default"],{content:this.props.content}):r["default"].createElement(a["default"],{content:this.filterGlobalBannerFromContentAPI(this.props.content)})}}]),n}();c.propTypes={content:l["default"].oneOfType([l["default"].object,l["default"].array]).isRequired},n["default"]=c},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}();var r=function(){function t(n,e){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,t),this.storageType=n,this.storageTimeout=e}return o(t,[{key:"isAvailable",value:function(){try{var t=window[this.storageType],n="__storage_test__";return t.setItem(n,n),t.removeItem(n),!0}catch(e){return!1}}},{key:"getData",value:function(t){return this.isAvailable()?JSON.parse(window[this.storageType].getItem(t)):null}},{key:"getValidatedContent",value:function(t){var n=this.getData(t);return n&&(new Date).getTime()-n.timestamp<this.storageTimeout?n.content:null}},{key:"setData",value:function(t,n){var e={content:n,timestamp:(new Date).getTime()};this.isAvailable()&&window[this.storageType].setItem(t,JSON.stringify(e))}}]),t}();n["default"]=r},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=i(e(1)),r=i(e(0)),l=e(5),a=i(e(26));function i(t){return t&&t.__esModule?t:{"default":t}}var s=function(t){var n=t.data,e=t.contentColor,r=t.style,i=r===undefined?a["default"]:r;return o["default"].createElement("a",{href:(0,l.handleCtaRef)(n.url,n.ctaRef),className:i.button,target:n.target,style:{color:e,borderColor:e}},n.text)};s.propTypes={data:r["default"].shape({url:r["default"].string.isRequired,text:r["default"].string.isRequired,ctaRef:r["default"].string.isRequired,target:r["default"].string.isRequired}).isRequired,contentColor:r["default"].string.isRequired},n["default"]=s},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}(),r=c(e(1)),l=c(e(0)),a=c(e(27)),i=c(e(13)),s=c(e(12));function c(t){return t&&t.__esModule?t:{"default":t}}var p=function(t){function n(t){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n);var e=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?t:n}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return e.style=a["default"],e.state={tooltipVisible:!1},e}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(t,n):t.__proto__=n)}(n,r["default"].Component),o(n,[{key:"handleUnitHover",value:function(){var t=this;return function(){t.setState({tooltipVisible:!t.state.tooltipVisible})}}},{key:"render",value:function(){return r["default"].createElement("div",{className:this.style.column,style:{backgroundColor:this.props.data.backgroundColor}},r["default"].createElement(i["default"],{data:this.props.data,unitPosition:this.props.columnPosition,handleUnitHover:this.handleUnitHover(),fontSize:this.props.data.fontSize,contentColor:this.props.data.contentColor}),this.props.data.tooltip?r["default"].createElement(s["default"],{content:this.props.data.tooltip,tooltipPosition:this.props.columnPosition,isVisible:this.state.tooltipVisible}):null)}}]),n}();p.defaultProps={data:{tooltip:"",fontSize:"medium",backgroundColor:"#FFF",contentColor:"#000"}},p.propTypes={columnPosition:l["default"].string.isRequired,data:l["default"].shape({tooltip:l["default"].string,fontSize:l["default"].string,backgroundColor:l["default"].string,contentColor:l["default"].string}).isRequired},n["default"]=p},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=i(e(1)),r=i(e(0)),l=i(e(28)),a=i(e(19));function i(t){return t&&t.__esModule?t:{"default":t}}var s=function(t){var n=t.content,e=t.contentColor,r=t.fontSize,i=t.style,s=i===undefined?l["default"]:i;return o["default"].createElement("div",{className:s.content,style:{fontSize:a["default"][r],color:e}},o["default"].createElement("span",{className:s.copy,dangerouslySetInnerHTML:{__html:n}}))};s.propTypes={content:r["default"].string.isRequired,contentColor:r["default"].string.isRequired,fontSize:r["default"].string.isRequired},n["default"]=s},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}(),r=i(e(1)),l=i(e(0)),a=i(e(30));function i(t){return t&&t.__esModule?t:{"default":t}}var s=function(t){function n(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n);var t=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?t:n}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return t.style=a["default"],t.state={mouseOverTooltip:!1},t}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(t,n):t.__proto__=n)}(n,r["default"].Component),o(n,[{key:"createMarkup",value:function(){return{__html:this.props.content}}},{key:"mouseOverTooltip",value:function(){this.setState({mouseOverTooltip:!this.state.mouseOverTooltip})}},{key:"render",value:function(){var t=this;return this.state.mouseOverTooltip||this.props.isVisible?r["default"].createElement("div",{className:this.style["wrapper"+this.props.tooltipPosition],onMouseEnter:function(){return t.mouseOverTooltip()},onMouseLeave:function(){return t.mouseOverTooltip()}},r["default"].createElement("div",{className:this.style.tooltip,dangerouslySetInnerHTML:this.createMarkup()})):r["default"].createElement("div",{className:this.style["wrapper"+this.props.tooltipPosition]+" "+this.style.hidden},r["default"].createElement("div",{className:this.style.tooltip,dangerouslySetInnerHTML:this.createMarkup()}))}}]),n}();s.propTypes={content:l["default"].string.isRequired,tooltipPosition:l["default"].string.isRequired,isVisible:l["default"].bool.isRequired},n["default"]=s},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=c(e(1)),r=c(e(0)),l=e(5),a=c(e(31)),i=c(e(11)),s=c(e(9));function c(t){return t&&t.__esModule?t:{"default":t}}var p=function(t){var n=t.data,e=t.unitPosition,r=t.fontSize,c=t.contentColor,p=t.handleUnitHover,u=t.style,f=u===undefined?a["default"]:u;return n.link?o["default"].createElement("a",{className:f.unitLink+" "+f["unit"+e],href:(0,l.handleCtaRef)(n.link.url,n.link.ctaRef),target:n.link.target,onMouseEnter:function(){return p()},onMouseLeave:function(){return p()}},o["default"].createElement(i["default"],{content:n.content,contentColor:c,fontSize:r})):o["default"].createElement("div",{className:f.unit+" "+f["unit"+e],onMouseEnter:function(){return p()},onMouseLeave:function(){return p()}},n.buttons.length?o["default"].createElement(s["default"],{data:n.buttons[0],contentColor:c}):null,o["default"].createElement(i["default"],{content:n.content,contentColor:c,fontSize:r}),n.buttons.length?o["default"].createElement(s["default"],{data:n.buttons[1],contentColor:c}):null)};p.propTypes={data:r["default"].shape({content:r["default"].string.isRequired,contentColor:r["default"].string.isRequired,link:r["default"].object}).isRequired,unitPosition:r["default"].string.isRequired,fontSize:r["default"].string.isRequired,handleUnitHover:r["default"].func.isRequired},n["default"]=p},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}(),r=c(e(1)),l=c(e(0)),a=c(e(29)),i=c(e(10)),s=c(e(4));function c(t){return t&&t.__esModule?t:{"default":t}}var p=function(t){function n(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n);var t=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?t:n}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return t.eventManager=new s["default"],t}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(t,n):t.__proto__=n)}(n,r["default"].PureComponent),o(n,[{key:"getColumnPosition",value:function(t){return 1===this.props.content.columns.length?"Center":0===t?"Left":"Right"}},{key:"render",value:function(){var t=this;return this.props.content?(this.eventManager.triggerTargetEvent("globalBannerComplete"),r["default"].createElement("section",{id:"globalBannerComponent",className:this.props.style.globalBanner},this.props.content.columns.map(function(n,e){return r["default"].createElement(i["default"],{key:"column"+e,data:n,columnPosition:t.getColumnPosition(e)})}))):null}}]),n}();p.defaultProps={style:a["default"]},p.propTypes={content:l["default"].shape({columns:l["default"].arrayOf(l["default"].object).isRequired})},n["default"]=p},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}();var r=function(){function t(n){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,t),this.elements=n,this.stylesheet=document.createElement("style"),this.stylesheet.type="text/css",this.hasGeneratedStyles=!1}return o(t,[{key:"init",value:function(){for(var t=0;t<this.elements.length;t++){var n=this.elements[t],e="unit-btn_"+t;n.className+=" "+e,this.extractStyles(n,e)}this.hasGeneratedStyles&&document.head.appendChild(this.stylesheet)}},{key:"extractStyles",value:function(t,n){var e=t.getAttribute("data-color-primary"),o=t.getAttribute("data-color-secondary"),r="";-1!==t.className.indexOf("unit-btn_reverse")&&e&&o&&(r+=".global-banner ."+n+".unit-btn_reverse .unit-btn { background-color: "+o+"; border: solid 2px "+e+"; color: "+e+"; }",r+=".global-banner ."+n+".unit-btn_reverse .unit-btn:hover { background-color: "+e+"; border: solid 2px "+e+"; color: "+o+";}"),-1!==t.className.indexOf("unit-btn_glow")&&e&&o&&(r+=".global-banner ."+n+".unit-btn_glow .unit-btn { color: "+e+"; border: solid 2px "+e+"; box-shadow: 0 0 7px "+e+"; }",r+=".global-banner ."+n+".unit-btn_glow .unit-btn:hover { box-shadow: 0 0 7px "+o+"; animation: shop_"+n+" 2s linear forwards; }",r+="@keyframes shop_"+n+" { 2% {  border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 3%  { border-color: "+o+" ; box-shadow:none; } 5% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; }  6% { border-color: "+o+" box-shadow:none; } 7% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 9%  { border-color: "+o+" box-shadow:none; } 13% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 16% { border-color: "+o+" ; box-shadow:none; } 18% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 22% { border-color: "+o+" ; box-shadow:none; } 34% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 36% { border-color: "+o+" ; box-shadow:none; } 54% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 100% { border-color: "+e+" ; box-shadow:0 0 12px -1px "+e+" inset; } } ",r+="@-webkit-keyframes shop_"+n+" { 2% {  border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 3%  { border-color: "+o+" ; box-shadow:none; } 5% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; }  6% { border-color: "+o+" box-shadow:none; } 7% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 9%  { border-color: "+o+" box-shadow:none; } 13% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 16% { border-color: "+o+" ; box-shadow:none; } 18% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 22% { border-color: "+o+" ; box-shadow:none; } 34% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 36% { border-color: "+o+" ; box-shadow:none; } 54% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 100% { border-color: "+e+" ; box-shadow:0 0 12px -1px "+e+" inset; } } ",r+="@-moz-keyframes shop_"+n+" { 2% {  border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 3%  { border-color: "+o+" ; box-shadow:none; } 5% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; }  6% { border-color: "+o+" box-shadow:none; } 7% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 9%  { border-color: "+o+" box-shadow:none; } 13% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 16% { border-color: "+o+" ; box-shadow:none; } 18% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 22% { border-color: "+o+" ; box-shadow:none; } 34% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 36% { border-color: "+o+" ; box-shadow:none; } 54% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 100% { border-color: "+e+" ; box-shadow:0 0 12px -1px "+e+" inset; } } ",r+="@-o-keyframes shop_"+n+" { 2% {  border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 3%  { border-color: "+o+" ; box-shadow:none; } 5% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; }  6% { border-color: "+o+" box-shadow:none; } 7% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 9%  { border-color: "+o+" box-shadow:none; } 13% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 16% { border-color: "+o+" ; box-shadow:none; } 18% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 22% { border-color: "+o+" ; box-shadow:none; } 34% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 36% { border-color: "+o+" ; box-shadow:none; } 54% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 100% { border-color: "+e+" ; box-shadow:0 0 12px -1px "+e+" inset; } } ",r+="@-ms-keyframes shop_"+n+" { 2% {  border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 3%  { border-color: "+o+" ; box-shadow:none; } 5% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; }  6% { border-color: "+o+" box-shadow:none; } 7% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 9%  { border-color: "+o+" box-shadow:none; } 13% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 16% { border-color: "+o+" ; box-shadow:none; } 18% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 22% { border-color: "+o+" ; box-shadow:none; } 34% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 36% { border-color: "+o+" ; box-shadow:none; } 54% { border-color: "+e+" ; box-shadow: 0 0 12px -1px "+e+" inset; } 100% { border-color: "+e+" ; box-shadow:0 0 12px -1px "+e+" inset; } } "),-1===t.className.indexOf("unit-btn_fade")&&-1===t.className.indexOf("unit-btn_copyfade")||!e||(r+=".global-banner ."+n+" .unit-btn {background: none; border: solid 2px "+e+"; color: "+e+"; }"),r.length>0&&(this.hasGeneratedStyles=!0,this.stylesheet.appendChild(document.createTextNode(r)))}}]),t}();n["default"]=r},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}(),r=s(e(1)),l=s(e(0)),a=s(e(15)),i=s(e(4));function s(t){return t&&t.__esModule?t:{"default":t}}var c=function(t){function n(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n);var t=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?t:n}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return t.eventManager=new i["default"],t}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(t,n):t.__proto__=n)}(n,r["default"].PureComponent),o(n,[{key:"componentDidMount",value:function(){new a["default"](document.getElementsByClassName("unit-message")).init()}},{key:"createMarkup",value:function(t){return{__html:t}}},{key:"render",value:function(){return this.eventManager.triggerTargetEvent("globalBannerComplete"),r["default"].createElement("div",{id:"divGlobalBanner",dangerouslySetInnerHTML:this.createMarkup(this.props.content.content)})}}]),n}();c.propTypes={content:l["default"].oneOfType([l["default"].object,l["default"].array]).isRequired},n["default"]=c},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function t(t,n){for(var e=0;e<n.length;e++){var o=n[e];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(n,e,o){return e&&t(n.prototype,e),o&&t(n,o),n}}(),r=p(e(1)),l=p(e(0)),a=p(e(7)),i=p(e(6)),s=p(e(8)),c=p(e(4));function p(t){return t&&t.__esModule?t:{"default":t}}var u=function(t){function n(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n);var t=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?t:n}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return t.storage=new s["default"]("localStorage",3e5),t.eventManager=new c["default"],t.contentAPISDK=new i["default"],t.state={data:null},t}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(t,n):t.__proto__=n)}(n,r["default"].Component),o(n,[{key:"componentDidMount",value:function(){this.setPropsAsContentAPIParameters(this.props),this.getBannerData(this.props)}},{key:"componentWillReceiveProps",value:function(t){this.setPropsAsContentAPIParameters(t),this.getBannerData(t)}},{key:"componentDidUpdate",value:function(){}},{key:"getBannerData",value:function(t){var n=this,e=this.getDataFromStorage();e?this.setState({data:e}):this.getDataFromAPI().then(function(t){n.setState({data:t})})}},{key:"getDataFromStorage",value:function(){var t=this.generateStorageKey();return this.storage.getValidatedContent(t)}},{key:"generateStorageKey",value:function(){return"globalBanner-"+this.contentAPISDK.generateContentAPIURL()}},{key:"setPropsAsContentAPIParameters",value:function(t){this.contentAPISDK.setContextParameters({subscriptions:t.isPremier?"T":"F",country:t.browseCountry,store:t.store,lang:t.language})}},{key:"getDataFromAPI",value:function(){var t=this;return new Promise(function(n){t.contentAPISDK.fetchContent().then(function(e){t.storage.setData(t.generateStorageKey(),e),n(e)})["catch"](function(e){t.eventManager.triggerNewrelicEvent("globalBannerApiError",e),n(null)})})}},{key:"render",value:function(){return this.state.data?r["default"].createElement(a["default"],{content:this.state.data}):null}}]),n}();u.propTypes={store:l["default"].string.isRequired,language:l["default"].string.isRequired,isPremier:l["default"].bool.isRequired,browseCountry:l["default"].string.isRequired},n["default"]=u},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o="/api/fashion/contentapi/v1/components";n.ENDPOINT=o},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n["default"]={small:"13px",medium:"14px",large:"16px",xlarge:"18px"}},function(t,n,e){(n=t.exports=e(2)(!1)).push([t.i,".src-GlobalBannerContentAPI-Button-Button_button{height:30px;font-size:13px;font-weight:700;width:100px;border-radius:0;display:block;border:2px solid #fff;box-sizing:border-box;line-height:26px;text-decoration:none;color:#fff;margin:9px 0;cursor:pointer;opacity:1;transition:opacity .8s ease}.src-GlobalBannerContentAPI-Button-Button_button:hover{opacity:.5;transition:opacity .8s ease}",""]),n.locals={button:"src-GlobalBannerContentAPI-Button-Button_button"}},function(t,n,e){(n=t.exports=e(2)(!1)).push([t.i,".src-GlobalBannerContentAPI-Column-Column_column{width:50%;background:#fff;text-align:center;line-height:15px;height:100%;float:left;box-sizing:border-box;position:relative}.src-GlobalBannerContentAPI-Column-Column_column:first-child{border-right:1px solid #ddd}.src-GlobalBannerContentAPI-Column-Column_column:only-child{border-right:none;width:100%}",""]),n.locals={column:"src-GlobalBannerContentAPI-Column-Column_column"}},function(t,n,e){(n=t.exports=e(2)(!1)).push([t.i,'.src-GlobalBannerContentAPI-Content-Content_content{display:table-cell;vertical-align:middle;margin:auto;width:100%;height:100%;box-sizing:border-box}.src-GlobalBannerContentAPI-Content-Content_content a,.src-GlobalBannerContentAPI-Content-Content_content abbr,.src-GlobalBannerContentAPI-Content-Content_content address,.src-GlobalBannerContentAPI-Content-Content_content article,.src-GlobalBannerContentAPI-Content-Content_content aside,.src-GlobalBannerContentAPI-Content-Content_content audio,.src-GlobalBannerContentAPI-Content-Content_content b,.src-GlobalBannerContentAPI-Content-Content_content big,.src-GlobalBannerContentAPI-Content-Content_content blockquote,.src-GlobalBannerContentAPI-Content-Content_content canvas,.src-GlobalBannerContentAPI-Content-Content_content caption,.src-GlobalBannerContentAPI-Content-Content_content center,.src-GlobalBannerContentAPI-Content-Content_content dd,.src-GlobalBannerContentAPI-Content-Content_content del,.src-GlobalBannerContentAPI-Content-Content_content details,.src-GlobalBannerContentAPI-Content-Content_content dfn,.src-GlobalBannerContentAPI-Content-Content_content dl,.src-GlobalBannerContentAPI-Content-Content_content dt,.src-GlobalBannerContentAPI-Content-Content_content em,.src-GlobalBannerContentAPI-Content-Content_content embed,.src-GlobalBannerContentAPI-Content-Content_content fieldset,.src-GlobalBannerContentAPI-Content-Content_content figcaption,.src-GlobalBannerContentAPI-Content-Content_content figure,.src-GlobalBannerContentAPI-Content-Content_content footer,.src-GlobalBannerContentAPI-Content-Content_content form,.src-GlobalBannerContentAPI-Content-Content_content h1,.src-GlobalBannerContentAPI-Content-Content_content h2,.src-GlobalBannerContentAPI-Content-Content_content h3,.src-GlobalBannerContentAPI-Content-Content_content h4,.src-GlobalBannerContentAPI-Content-Content_content h5,.src-GlobalBannerContentAPI-Content-Content_content h6,.src-GlobalBannerContentAPI-Content-Content_content header,.src-GlobalBannerContentAPI-Content-Content_content hgroup,.src-GlobalBannerContentAPI-Content-Content_content i,.src-GlobalBannerContentAPI-Content-Content_content img,.src-GlobalBannerContentAPI-Content-Content_content label,.src-GlobalBannerContentAPI-Content-Content_content legend,.src-GlobalBannerContentAPI-Content-Content_content li,.src-GlobalBannerContentAPI-Content-Content_content mark,.src-GlobalBannerContentAPI-Content-Content_content menu,.src-GlobalBannerContentAPI-Content-Content_content nav,.src-GlobalBannerContentAPI-Content-Content_content ol,.src-GlobalBannerContentAPI-Content-Content_content output,.src-GlobalBannerContentAPI-Content-Content_content p,.src-GlobalBannerContentAPI-Content-Content_content pre,.src-GlobalBannerContentAPI-Content-Content_content q,.src-GlobalBannerContentAPI-Content-Content_content ruby,.src-GlobalBannerContentAPI-Content-Content_content s,.src-GlobalBannerContentAPI-Content-Content_content samp,.src-GlobalBannerContentAPI-Content-Content_content section,.src-GlobalBannerContentAPI-Content-Content_content small,.src-GlobalBannerContentAPI-Content-Content_content strike,.src-GlobalBannerContentAPI-Content-Content_content strong,.src-GlobalBannerContentAPI-Content-Content_content summary,.src-GlobalBannerContentAPI-Content-Content_content sup,.src-GlobalBannerContentAPI-Content-Content_content table,.src-GlobalBannerContentAPI-Content-Content_content tbody,.src-GlobalBannerContentAPI-Content-Content_content td,.src-GlobalBannerContentAPI-Content-Content_content tfoot,.src-GlobalBannerContentAPI-Content-Content_content th,.src-GlobalBannerContentAPI-Content-Content_content thead,.src-GlobalBannerContentAPI-Content-Content_content tr,.src-GlobalBannerContentAPI-Content-Content_content tt,.src-GlobalBannerContentAPI-Content-Content_content u,.src-GlobalBannerContentAPI-Content-Content_content ul,.src-GlobalBannerContentAPI-Content-Content_content var,.src-GlobalBannerContentAPI-Content-Content_content video{margin:0;padding:0;border:0;vertical-align:baseline}.src-GlobalBannerContentAPI-Content-Content_content article,.src-GlobalBannerContentAPI-Content-Content_content aside,.src-GlobalBannerContentAPI-Content-Content_content details,.src-GlobalBannerContentAPI-Content-Content_content figcaption,.src-GlobalBannerContentAPI-Content-Content_content figure,.src-GlobalBannerContentAPI-Content-Content_content footer,.src-GlobalBannerContentAPI-Content-Content_content header,.src-GlobalBannerContentAPI-Content-Content_content hgroup,.src-GlobalBannerContentAPI-Content-Content_content menu,.src-GlobalBannerContentAPI-Content-Content_content nav,.src-GlobalBannerContentAPI-Content-Content_content section{display:block}.src-GlobalBannerContentAPI-Content-Content_content ol,.src-GlobalBannerContentAPI-Content-Content_content ul{list-style:none}.src-GlobalBannerContentAPI-Content-Content_content blockquote,.src-GlobalBannerContentAPI-Content-Content_content q{quotes:none}.src-GlobalBannerContentAPI-Content-Content_content blockquote:after,.src-GlobalBannerContentAPI-Content-Content_content blockquote:before,.src-GlobalBannerContentAPI-Content-Content_content q:after,.src-GlobalBannerContentAPI-Content-Content_content q:before{content:""}.src-GlobalBannerContentAPI-Content-Content_content a{color:inherit;text-decoration:underline}.src-GlobalBannerContentAPI-Content-Content_content table{border-collapse:collapse;border-spacing:0}.src-GlobalBannerContentAPI-Content-Content_copy{text-align:center;max-width:661px;width:100%;display:inline-block;letter-spacing:.5px;vertical-align:middle;margin:auto;box-sizing:border-box}.src-GlobalBannerContentAPI-Content-Content_copy strong{font-weight:700;letter-spacing:2px}',""]),n.locals={content:"src-GlobalBannerContentAPI-Content-Content_content",copy:"src-GlobalBannerContentAPI-Content-Content_copy"}},function(t,n,e){(n=t.exports=e(2)(!1)).push([t.i,".src-GlobalBannerContentAPI-GlobalBannerContentAPI_globalBanner{display:none}@media (min-width:768px){.src-GlobalBannerContentAPI-GlobalBannerContentAPI_globalBanner{width:100%;height:50px;min-height:50px;margin:0 auto;font-family:Futura-pt,Futura STD,Arial,Verdana,sans-serif;font-size:13px;letter-spacing:1px;display:block;position:relative;background-color:#fff;box-sizing:border-box;border-bottom:1px solid #ddd}.src-GlobalBannerContentAPI-GlobalBannerContentAPI_globalBanner:after{content:none}}",""]),n.locals={globalBanner:"src-GlobalBannerContentAPI-GlobalBannerContentAPI_globalBanner"}},function(t,n,e){(n=t.exports=e(2)(!1)).push([t.i,'.src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperCenter,.src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperLeft,.src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperRight{position:absolute;top:50px;padding:0 16px;max-width:646px;width:100%;box-sizing:border-box;transition-property:opacity,visiblity;transition-delay:.2s;transition-duration:1s;transition-timing-function:ease;opacity:1;visibility:visible;z-index:100}.src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperCenter{max-width:100%;width:1366px;padding:0 16px}.src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperLeft{right:0;margin:0}.src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperRight{left:0;margin:0}.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip{font-size:12px;letter-spacing:.5px;line-height:14px;background:#f2f2f2;padding:8px;text-align:center;box-shadow:3px 3px 0 hsla(0,0%,41%,.5);text-transform:none;box-sizing:border-box}.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip:before{content:"";width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #f2f2f2;position:absolute;top:-5px;margin:0 auto;left:0;right:0}.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip a,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip abbr,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip address,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip article,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip aside,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip audio,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip b,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip big,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip blockquote,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip canvas,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip caption,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip center,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip dd,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip del,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip details,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip dfn,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip dl,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip dt,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip em,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip embed,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip fieldset,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip figcaption,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip figure,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip footer,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip form,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip h1,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip h2,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip h3,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip h4,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip h5,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip h6,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip header,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip hgroup,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip i,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip img,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip label,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip legend,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip li,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip mark,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip menu,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip nav,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip ol,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip output,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip p,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip pre,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip q,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip ruby,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip s,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip samp,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip section,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip small,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip strike,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip strong,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip summary,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip sup,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip table,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip tbody,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip td,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip tfoot,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip th,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip thead,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip tr,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip tt,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip u,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip ul,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip var,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip video{margin:0;padding:0;border:0;vertical-align:baseline}.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip article,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip aside,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip details,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip figcaption,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip figure,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip footer,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip header,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip hgroup,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip menu,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip nav,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip section{display:block}.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip ol,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip ul{list-style:none}.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip blockquote,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip q{quotes:none}.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip blockquote:after,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip blockquote:before,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip q:after,.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip q:before{content:""}.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip a{color:inherit;text-decoration:underline}.src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip table{border-collapse:collapse;border-spacing:0}.src-GlobalBannerContentAPI-Tooltip-Tooltip_hidden{opacity:0;transition:opacity .4s,visibility .4s;visibility:hidden}@media (min-width:1366px){.src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperCenter{max-width:1366px;margin-left:-683px;left:50%;width:1366px;padding:0 32px}}',""]),n.locals={wrapperCenter:"src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperCenter",wrapperLeft:"src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperLeft",wrapperRight:"src-GlobalBannerContentAPI-Tooltip-Tooltip_wrapperRight",tooltip:"src-GlobalBannerContentAPI-Tooltip-Tooltip_tooltip",hidden:"src-GlobalBannerContentAPI-Tooltip-Tooltip_hidden"}},function(t,n,e){(n=t.exports=e(2)(!1)).push([t.i,".src-GlobalBannerContentAPI-Unit-Unit_unit,.src-GlobalBannerContentAPI-Unit-Unit_unitLink{padding:0 16px;box-sizing:border-box;text-align:center;width:100%;height:49px;display:table;position:relative;line-height:15px}.src-GlobalBannerContentAPI-Unit-Unit_unit{cursor:default}.src-GlobalBannerContentAPI-Unit-Unit_unitLink{cursor:pointer;opacity:1;transition:opacity .8s ease}.src-GlobalBannerContentAPI-Unit-Unit_unitLink:hover{opacity:.5;transition:opacity .8s ease}@media (min-width:1366px){.src-GlobalBannerContentAPI-Unit-Unit_unitLeft{width:661px;right:0;position:absolute}.src-GlobalBannerContentAPI-Unit-Unit_unitRight{width:661px;left:0;position:absolute}.src-GlobalBannerContentAPI-Unit-Unit_unitCenter{width:1366px;position:static;margin:0 auto;padding:0 32px}}",""]),n.locals={unit:"src-GlobalBannerContentAPI-Unit-Unit_unit",unitLink:"src-GlobalBannerContentAPI-Unit-Unit_unitLink",unitLeft:"src-GlobalBannerContentAPI-Unit-Unit_unitLeft",unitRight:"src-GlobalBannerContentAPI-Unit-Unit_unitRight",unitCenter:"src-GlobalBannerContentAPI-Unit-Unit_unitCenter"}},function(t,n,e){var o=e(20);"string"==typeof o&&(o=[[t.i,o,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;e(3)(o,r);o.locals&&(t.exports=o.locals)},function(t,n,e){var o=e(21);"string"==typeof o&&(o=[[t.i,o,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;e(3)(o,r);o.locals&&(t.exports=o.locals)},function(t,n,e){var o=e(22);"string"==typeof o&&(o=[[t.i,o,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;e(3)(o,r);o.locals&&(t.exports=o.locals)},function(t,n,e){var o=e(23);"string"==typeof o&&(o=[[t.i,o,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;e(3)(o,r);o.locals&&(t.exports=o.locals)},function(t,n,e){var o=e(24);"string"==typeof o&&(o=[[t.i,o,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;e(3)(o,r);o.locals&&(t.exports=o.locals)},function(t,n,e){var o=e(25);"string"==typeof o&&(o=[[t.i,o,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;e(3)(o,r);o.locals&&(t.exports=o.locals)},function(t,n){t.exports=function(t){var n="undefined"!=typeof window&&window.location;if(!n)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var e=n.protocol+"//"+n.host,o=e+n.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,n){var r,l=n.trim().replace(/^"(.*)"$/,function(t,n){return n}).replace(/^'(.*)'$/,function(t,n){return n});return/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(l)?t:(r=0===l.indexOf("//")?l:0===l.indexOf("/")?e+l:o+l.replace(/^\.\//,""),"url("+JSON.stringify(r)+")")})}},function(t,n){t.exports=__webpack_require__("../node_modules/base64url/index.js")},function(t,n){t.exports=__webpack_require__("../node_modules/isomorphic-fetch/fetch-npm-browserify.js")}])});

/***/ }),

/***/ "../node_modules/asos-site-chrome-store-presentation/lib/module/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/map.js
var map = __webpack_require__("../node_modules/babel-runtime/core-js/map.js");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ../node_modules/debug/src/browser.js
var browser = __webpack_require__("../node_modules/debug/src/browser.js");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/errors/index.js
var errors = {
  StoreServiceError: "StoreServiceError",
  StoreFormatError: "StoreFormatError",
  StoreNotFoundError: "StoreNotFoundError",
  CacheError: "CacheError",
  InvalidArgumentError: "InvalidArgumentError"
};

var storeServiceError = function storeServiceError(message, e) {
  return {
    type: errors.StoreServiceError,
    message: message,
    raw: e
  };
};

var storeFormatError = function storeFormatError(message) {
  return {
    type: errors.StoreFormatError,
    message: message
  };
};

var storeNotFoundError = function storeNotFoundError(message) {
  return {
    type: errors.StoreNotFoundError,
    message: message
  };
};

var cacheError = function cacheError(message) {
  return {
    type: errors.CacheError,
    message: message
  };
};

var invalidArgumentError = function invalidArgumentError(message) {
  return {
    type: errors.InvalidArgumentError,
    message: message
  };
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/cache/index.js




var cacheFactory = {
  create: function create() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        expiryMs = _ref.expiryMs;

    if (typeof expiryMs !== "number") {
      throw cacheError("Invalid argument: Cache expiry (argument name: expiryMs) must be a number");
    }

    var logger = browser_default()("asos-site-chrome-store-presentation:cache");
    var storage = new map_default.a();

    return {
      set: function set(key, value) {
        storage.set(key, {
          value: value,
          expiry: Date.now() + expiryMs
        });
        return value;
      },
      hasKey: function hasKey(key) {
        return storage.has(key);
      },
      hasExpired: function hasExpired(key) {
        var entry = storage.get(key);
        return entry && entry.expiry < Date.now();
      },
      get: function get(key) {
        if (!this.hasKey(key)) {
          logger("Key missing: " + key);
          return null;
        }
        var entry = storage.get(key);
        if (this.hasExpired(key)) {
          logger("Key expired: " + key);
        }
        return entry.value;
      }
    };
  }
};

/* harmony default export */ var factories_cache = (cacheFactory);
// EXTERNAL MODULE: ../node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("../node_modules/babel-runtime/core-js/object/assign.js");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ../node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__("../node_modules/isomorphic-fetch/fetch-npm-browserify.js");
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/wrappedFetch/index.js



var handleError = function () {
  var _ref2 = asyncToGenerator_default()(regenerator_default.a.mark(function _callee2(response, url) {
    var information, errorResponse, status;
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            information = void 0, errorResponse = void 0, status = void 0;
            _context2.prev = 1;

            status = response.status;
            _context2.next = 5;
            return response.json();

          case 5:
            information = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);

            errorResponse = _context2.t0;

          case 11:
            throw storeServiceError("Failed to fetch", {
              url: url,
              status: status,
              information: information,
              errorResponse: errorResponse
            });

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[1, 8]]);
  }));

  return function handleError(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/* global fetch */



/* harmony default export */ var utils_wrappedFetch = ((function () {
  var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(url) {
    var response;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            response = void 0;
            _context.prev = 1;
            _context.next = 4;
            return fetch(url);

          case 4:
            response = _context.sent;
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", handleError(response, url));

          case 10:
            if (!(response.status >= 400)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", handleError(response, url));

          case 12:
            return _context.abrupt("return", response);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 7]]);
  }));

  function wrappedFetch(_x) {
    return _ref.apply(this, arguments);
  }

  return wrappedFetch;
})());
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getVersionManifest/index.js






/*
 * @typedef {Object} SiteChromeVersion
 * @property {boolean} useCurrent
 * @property {string} current
 * @property {string} previous
 */

/*
 * @typedef {Object} VersionManifest
 * @property {string[]} permittedKeyStoreDataversions
 * @property {boolean} useCurrentKeyStoreDataversion
 * @property {{ current: string, previous: string }} keyStoreDataversion
 * @property {string[]} permittedSiteChromeVersions
 * @property {Object.<string, SiteChromeVersion>} siteChromeVersion
 */

/*
 * @returns {VersionManifest} versionManifest
 */
function getVersionManifest_getVersionManifest(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, cache, versionManifestEndpoint, warn, response, json;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              cache = params.cache, versionManifestEndpoint = params.versionManifestEndpoint, warn = params.warn;

              if (!(cache.hasKey(versionManifestEndpoint) && !cache.hasExpired(versionManifestEndpoint))) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", cache.get(versionManifestEndpoint));

            case 4:
              _context.prev = 4;
              _context.next = 7;
              return utils_wrappedFetch(versionManifestEndpoint);

            case 7:
              response = _context.sent;
              _context.next = 10;
              return response.json();

            case 10:
              json = _context.sent;
              return _context.abrupt("return", cache.set(versionManifestEndpoint, json));

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);

              warn("Store presentation failed to fetch valid manifest from", versionManifestEndpoint, _context.t0);

              if (!cache.hasKey(versionManifestEndpoint)) {
                _context.next = 21;
                break;
              }

              warn("Store presentation forced to return a stale manifest cache", _context.t0);
              warn("Resetting the stale cache");

              return _context.abrupt("return", cache.set(versionManifestEndpoint, cache.get(versionManifestEndpoint)));

            case 21:
              throw storeServiceError("Could not obtain a valid manifest", _context.t0);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[4, 14]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/server/cookieReadingAndWriting.js
var oneYearInSeconds = 365 * 24 * 60 * 60;

var cookieReadingAndWriting_getCookieValue = function getCookieValue(req, cookieName) {
  return req.cookies[cookieName] || null;
};

var cookieReadingAndWriting_setCookieValue = function setCookieValue(res, cookieName, value) {
  var expiry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { maxAge: oneYearInSeconds };

  res.cookie(cookieName, value, expiry);
};

var findKeyValuePair = function findKeyValuePair(values, key) {
  return values ? values.split("&").filter(function (keyValue) {
    return keyValue.includes(key + "=");
  })[0] : null;
};

var concatenateKeyValuePairs = function concatenateKeyValuePairs(cookieValue, newKey, newValue) {
  if (cookieValue) {
    var keyValueInCookie = findKeyValuePair(cookieValue, newKey);
    if (keyValueInCookie) {
      return cookieValue.replace(keyValueInCookie, newKey + "=" + newValue);
    } else {
      return cookieValue + "&" + newKey + "=" + newValue;
    }
  }
  return newKey + "=" + newValue;
};

var setKeyedCookieValue = function setKeyedCookieValue(req, res, cookieName, key, value, expiry) {
  cookieReadingAndWriting_setCookieValue(res, cookieName, concatenateKeyValuePairs(cookieReadingAndWriting_getCookieValue(req, cookieName), key, value), expiry);
};

var getKeyedCookieValue = function getKeyedCookieValue(req, cookieName, key) {
  var keyValuePair = findKeyValuePair(cookieReadingAndWriting_getCookieValue(req, cookieName), key);
  return keyValuePair ? keyValuePair.split("=")[1] : null;
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/gender/index.js
var getGenderByFloorId = function getGenderByFloorId(floorId) {
  switch (Number(floorId)) {
    case 1000:
      return "women";
    case 1001:
      return "men";
    default:
      return "default";
  }
};

var getFloorIdByGender = function getFloorIdByGender(gender) {
  if (typeof gender !== "string") {
    return null;
  }
  switch (gender.toLowerCase()) {
    case "women":
      return 1000;
    case "men":
      return 1001;
    default:
      return null;
  }
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/cookiesMap.js
/* harmony default export */ var cookiesMap = ({
  BrowseCountryKey: "browseCountry",
  FloorCookieName: "floor",
  AsosCookieName: "asos",
  CurrencyCookieName: "currency",
  CurrencyIdKey: "currencyid",
  CurrencyLabelKey: "currencylabel",
  SizeSchemaKey: "sizeSchema",
  PreferredSiteKey: "PreferredSite",
  TopCatIdKey: "topcatid",
  WelcomeMessage: "welcomeMessageClosed",
  BrowseCurrencyKey: "browseCurrency",
  BrowseLanguageKey: "browseLanguage",
  BrowseSizeSchemaKey: "browseSizeSchema",
  StoreCodeKey: "storeCode",
  TemplateVersionKey: "siteChromeVersion",
  KeyStoreDataversionKey: "keyStoreDataversion",
  GeoCountryKey: "geocountry",
  AffiliateCookieName: "asosAffiliate",
  AffiliateKey: "affiliateId",
  WelcomeMatWrong: "welcomeMatWrong",
  WelcomeMatCorrect: "welcomeMatCorrect"
});
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/server/index.js





var oneHourInSeconds = 60 * 60;

var FloorCookieName = cookiesMap.FloorCookieName,
    AsosCookieName = cookiesMap.AsosCookieName,
    SizeSchemaKey = cookiesMap.SizeSchemaKey,
    PreferredSiteKey = cookiesMap.PreferredSiteKey,
    TopCatIdKey = cookiesMap.TopCatIdKey,
    BrowseCountryKey = cookiesMap.BrowseCountryKey,
    KeyStoreDataversionKey = cookiesMap.KeyStoreDataversionKey,
    TemplateVersionKey = cookiesMap.TemplateVersionKey,
    BrowseCurrencyKey = cookiesMap.BrowseCurrencyKey,
    BrowseSizeSchemaKey = cookiesMap.BrowseSizeSchemaKey,
    BrowseLanguageKey = cookiesMap.BrowseLanguageKey;


var server_getSizeSchema = function getSizeSchema(req) {
  return getKeyedCookieValue(req, AsosCookieName, SizeSchemaKey);
};

var server_setSizeSchema = function setSizeSchema(req, res, sizeSchema) {
  if (!sizeSchema) {
    throw invalidArgumentError("Invalid argument: sizeSchema cannot be empty");
  }
  setKeyedCookieValue(req, res, AsosCookieName, SizeSchemaKey, sizeSchema);
};

var server_getFloor = function getFloor(req) {
  return getGenderByFloorId(cookieReadingAndWriting_getCookieValue(req, FloorCookieName));
};

var server_setFloor = function setFloor(req, res, gender) {
  if (!gender) {
    throw invalidArgumentError("Invalid argument: gender cannot be empty");
  }
  var floorId = getFloorIdByGender(gender);
  if (floorId) {
    cookieReadingAndWriting_setCookieValue(res, FloorCookieName, floorId);
    setKeyedCookieValue(req, res, AsosCookieName, TopCatIdKey, floorId);
  }
};

var server_getPreferredSite = function getPreferredSite(req) {
  return getKeyedCookieValue(req, AsosCookieName, PreferredSiteKey);
};

var isFirstVisit = function isFirstVisit(req) {
  return !server_getPreferredSite(req);
};

var server_getBrowseCountry = function getBrowseCountry(req) {
  return cookieReadingAndWriting_getCookieValue(req, BrowseCountryKey);
};

var server_clearCookies = function clearCookies(res) {
  res.clearCookie(AsosCookieName);
  res.clearCookie(FloorCookieName);
};

var server_getKeyStoreDataversion = function getKeyStoreDataversion(req) {
  return cookieReadingAndWriting_getCookieValue(req, KeyStoreDataversionKey);
};

var server_setKeyStoreDataversion = function setKeyStoreDataversion(res, value) {
  return cookieReadingAndWriting_setCookieValue(res, KeyStoreDataversionKey, value, {
    maxAge: oneHourInSeconds
  });
};

var server_getTemplateVersion = function getTemplateVersion(req, storeCode) {
  return getKeyedCookieValue(req, TemplateVersionKey, storeCode);
};

var server_setTemplateVersion = function setTemplateVersion(req, res, storeCode, value) {
  return setKeyedCookieValue(req, res, TemplateVersionKey, storeCode, value, {
    maxAge: oneHourInSeconds
  });
};

var server_getBrowseCurrency = function getBrowseCurrency(req) {
  return [req.query[BrowseCurrencyKey] || null, cookieReadingAndWriting_getCookieValue(req, BrowseCurrencyKey)].find(function (currencyCode) {
    return currencyCode !== null;
  }) || null;
};

var server_getBrowseSizeSchema = function getBrowseSizeSchema(req) {
  return cookieReadingAndWriting_getCookieValue(req, BrowseSizeSchemaKey);
};

var server_getBrowseLanguage = function getBrowseLanguage(req) {
  return cookieReadingAndWriting_getCookieValue(req, BrowseLanguageKey);
};

/* harmony default export */ var server = ({
  getSizeSchema: server_getSizeSchema,
  setSizeSchema: server_setSizeSchema,
  getFloor: server_getFloor,
  setFloor: server_setFloor,
  getPreferredSite: server_getPreferredSite,
  isFirstVisit: isFirstVisit,
  clearCookies: server_clearCookies,
  getBrowseCurrency: server_getBrowseCurrency
});
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getKeyStoreDataversion/index.js





function getKeyStoreDataversion_getKeyStoreDataversion(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getVersionManifest, request, response, ksdvInCookie, _ref2, useCurrentKeyStoreDataversion, keyStoreDataversion, permittedKeyStoreDataversions, activeKeyStore;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getVersionManifest = params.getVersionManifest, request = params.request, response = params.response;
              ksdvInCookie = null;

              if (request) {
                ksdvInCookie = server_getKeyStoreDataversion(request);
              }

              _context.next = 6;
              return getVersionManifest();

            case 6:
              _ref2 = _context.sent;
              useCurrentKeyStoreDataversion = _ref2.useCurrentKeyStoreDataversion;
              keyStoreDataversion = _ref2.keyStoreDataversion;
              permittedKeyStoreDataversions = _ref2.permittedKeyStoreDataversions;

              if (!(ksdvInCookie && permittedKeyStoreDataversions.includes(ksdvInCookie))) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", ksdvInCookie);

            case 12:
              activeKeyStore = useCurrentKeyStoreDataversion ? keyStoreDataversion.current : keyStoreDataversion.previous;

              // If cookie is set but isnt permitted

              if (ksdvInCookie && response) {
                server_setKeyStoreDataversion(response, activeKeyStore);
              }

              return _context.abrupt("return", activeKeyStore);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getSiteChromeVersion/index.js






/*
 * @returns {string} siteChromeVersion
 */
function getSiteChromeVersion_getSiteChromeVersion(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountry, getVersionManifest, request, response, _ref2, storeCode, siteChromeVersionInCookie, _ref3, siteChromeVersion, permittedSiteChromeVersions, storesSiteChromeVersion, activeSiteChrome;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountry = params.getCountry, getVersionManifest = params.getVersionManifest, request = params.request, response = params.response;
              _context.next = 4;
              return getCountry({ request: request, response: response });

            case 4:
              _ref2 = _context.sent;
              storeCode = _ref2.storeCode;
              siteChromeVersionInCookie = server_getTemplateVersion(request, storeCode.toLowerCase());
              _context.next = 9;
              return getVersionManifest();

            case 9:
              _ref3 = _context.sent;
              siteChromeVersion = _ref3.siteChromeVersion;
              permittedSiteChromeVersions = _ref3.permittedSiteChromeVersions;

              if (siteChromeVersion) {
                _context.next = 14;
                break;
              }

              throw storeServiceError("Could not get valid version manifest");

            case 14:
              if (!(siteChromeVersionInCookie && permittedSiteChromeVersions.includes(siteChromeVersionInCookie))) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", siteChromeVersionInCookie);

            case 16:
              storesSiteChromeVersion = siteChromeVersion[storeCode] || siteChromeVersion[storeCode.toLowerCase()] || null;

              if (!(storesSiteChromeVersion === null)) {
                _context.next = 19;
                break;
              }

              throw storeServiceError("Could not match store in the version manifest");

            case 19:
              activeSiteChrome = storesSiteChromeVersion.useCurrent ? storesSiteChromeVersion.current : storesSiteChromeVersion.previous;

              // If cookie is set but isn't permitted

              if (siteChromeVersionInCookie && request && response) {
                server_setTemplateVersion(request, response, activeSiteChrome);
              }

              return _context.abrupt("return", activeSiteChrome);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getUseSiteChrome/index.js



/*
 * @returns {boolean} useSiteChrome
 */
function getUseSiteChrome(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getSiteChromeVersion, request, response, siteChromeVersion;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getSiteChromeVersion = params.getSiteChromeVersion, request = params.request, response = params.response;
              _context.next = 4;
              return getSiteChromeVersion({ request: request, response: response });

            case 4:
              siteChromeVersion = _context.sent;
              return _context.abrupt("return", !["1", "2"].includes(String(siteChromeVersion)));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getDefaultCountry/index.js
function getDefaultCountry(req, defaultCountries) {
  var com = defaultCountries.find(function (defaultCountry) {
    return defaultCountry.storeCode === "COM";
  });
  var xSiteUrn = req.get("X-SITE-URN") || com.url;

  var candidateCountries = defaultCountries.filter(function (defaultCountry) {
    return defaultCountry.url === xSiteUrn;
  });

  switch (candidateCountries.length) {
    case 0:
      return com;
    case 1:
      return candidateCountries[0];
    default:
      return candidateCountries.find(function (candidateCountry) {
        return candidateCountry.isXSiteUrnFallback;
      });
  }
}
// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("../node_modules/babel-runtime/helpers/typeof.js");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getBrowseCountry/index.js



var getBrowseCountry_getBrowseCountryFromQueryString = function getBrowseCountryFromQueryString(req) {
  return typeof_default()(req.query) === "object" && typeof req.query.browseCountry === "string" && req.query.browseCountry;
};

var getBrowseCountry_getBrowseCountryFromCookie = function getBrowseCountryFromCookie(req) {
  return req.cookies && server_getBrowseCountry(req);
};

function getBrowseCountry_getBrowseCountry(req) {
  return getBrowseCountry_getBrowseCountryFromQueryString(req) || getBrowseCountry_getBrowseCountryFromCookie(req) || "";
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getCountry/index.js






var lc = function lc(str) {
  return str && str.toLowerCase();
};

var getIsCountryValidForDomain = function getIsCountryValidForDomain(country, defaultCountry, defaultCountries) {
  var validStoreCodes = defaultCountries.filter(function (country) {
    return country.url === defaultCountry.url;
  }).map(function (country) {
    return country.storeCode;
  });

  return validStoreCodes.includes(country.storeCode);
};

/*
 * @returns {Country} country
 */
function getCountry_getCountry(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountryCollections, request, response, lang, _ref2, majorCountries, defaultCountries, defaultCountry, browseCountry, candidateCountry;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getCountryCollections({
                request: request,
                response: response,
                lang: lang
              });

            case 4:
              _ref2 = _context.sent;
              majorCountries = _ref2.majorCountries;
              defaultCountries = _ref2.defaultCountries;
              defaultCountry = getDefaultCountry(request, defaultCountries);
              browseCountry = lc(getBrowseCountry_getBrowseCountry(request));

              if (browseCountry) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", defaultCountry);

            case 11:
              candidateCountry = majorCountries.find(function (country) {
                return lc(country.countryCode) === browseCountry;
              });

              if (candidateCountry) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return", defaultCountry);

            case 14:
              if (getIsCountryValidForDomain(candidateCountry, defaultCountry, defaultCountries)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", defaultCountry);

            case 16:
              return _context.abrupt("return", candidateCountry);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/validate.js


function validate(storeApiEndpoint, versionManifestEndpoint, warn) {
  if (typeof warn !== "function") {
    throw storeServiceError("Invalid argument: warn (must be a function)");
  }

  if (typeof storeApiEndpoint !== "string" || storeApiEndpoint.length === 0) {
    throw storeServiceError("Invalid argument: StoreAPI endpoint (argument name: storeApiEndpoint) must be a string");
  }

  if (typeof versionManifestEndpoint !== "string" || versionManifestEndpoint.length === 0) {
    throw storeServiceError("Invalid argument: StoreAPI endpoint (argument name: versionManifestEndpoint) must be a string");
  }

  return true;
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getMajorCountries.js





/*
 * @returns {Country[]} majorCountries
 */
function getMajorCountries(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountryCollections, request, response, lang, _ref2, majorCountries;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getCountryCollections({
                request: request,
                response: response,
                lang: lang
              });

            case 4:
              _ref2 = _context.sent;
              majorCountries = _ref2.majorCountries;

              if (!majorCountries) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", majorCountries);

            case 10:
              throw storeServiceError("Major countries was not calculated correctly");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// EXTERNAL MODULE: ../node_modules/querystring-es3/index.js
var querystring_es3 = __webpack_require__("../node_modules/querystring-es3/index.js");
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);

// EXTERNAL MODULE: ../node_modules/url/url.js
var url_url = __webpack_require__("../node_modules/url/url.js");
var url_default = /*#__PURE__*/__webpack_require__.n(url_url);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/enrichMinorCountries/index.js


function enrichMinorCountries(countries) {
  var countryMap = countries.reduce(function (memo, next) {
    return assign_default()(memo, defineProperty_default()({}, next.country, next));
  }, {});

  return countries.map(function (country) {
    if (country.majorCountry === null) {
      return country;
    }

    return looseAssign(countryMap[country.majorCountry], country);
  });
}

function looseAssign(_ref, minor) {
  var store = _ref.store,
      siteUrl = _ref.siteUrl,
      siteId = _ref.siteId,
      languages = _ref.languages,
      currencies = _ref.currencies,
      sizeSchemas = _ref.sizeSchemas;

  return assign_default()(minor, {
    store: store,
    siteUrl: siteUrl,
    siteId: siteId,
    languages: languages,
    currencies: currencies,
    sizeSchemas: sizeSchemas
  });
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getPrimaryAttribute/index.js


var getPrimaryAttribute_getPrimary = function getPrimary(_ref) {
  var list = _ref.list,
      errorMessage = _ref.errorMessage;

  var primaryItem = list.find(function (item) {
    return item.isPrimary;
  });
  if (primaryItem) {
    return primaryItem;
  }
  throw storeFormatError(errorMessage);
};

var getPrimaryLanguage = function getPrimaryLanguage(store) {
  return getPrimaryAttribute_getPrimary({
    list: store.languages,
    errorMessage: "No primary language defined for " + store.country + " store"
  }).language;
};

var getPrimaryCurrency = function getPrimaryCurrency(store) {
  return getPrimaryAttribute_getPrimary({
    list: store.currencies,
    errorMessage: "No primary currency defined for " + store.country + " store"
  }).currency;
};

var getPrimarySizeSchema = function getPrimarySizeSchema(store) {
  return getPrimaryAttribute_getPrimary({
    list: store.sizeSchemas,
    errorMessage: "No primary size defined for " + store.country + " store"
  }).sizeSchema;
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/formatCountries/index.js


var formatCountries = function formatCountries(countries, keyStoreDataversion) {
  return countries.map(function (country) {
    return format(country, keyStoreDataversion);
  });
};

/*
 * @typedef {Object} Country
 * @property {string} siteId
 * @property {string} storeCode
 * @property {Object} defaultLanguage
 * @property {Object} defaultSizeSchema
 * @property {Object} defaultCurrency
 * @property {string} url
 * @property {string} countryCode
 * @property {string} imageUrl
 * @property {string} name
 * @property {string} majorCountry
 * @property {string} isDefaultCountry
 * @property {Object[]} currencies
 * @property {Object[]} languages
 * @property {Object[]} sizeSchemas
 * @property {string} keyStoreDataversion
 * @property {Object.<string, Country>} [keyStoreDataversionVariants]
 */

/*
 * @returns {Country} country
 */
function format(country, keyStoreDataversion) {
  return {
    siteId: country.siteId,
    storeCode: country.store,
    defaultLanguage: getPrimaryLanguage(country),
    defaultSizeSchema: getPrimarySizeSchema(country),
    defaultCurrency: getPrimaryCurrency(country),
    url: country.siteUrl,
    countryCode: country.country,
    imageUrl: country.imageUrl,
    name: country.name,
    majorCountry: country.majorCountry,
    isDefaultCountry: false,
    currencies: country.currencies,
    languages: country.languages,
    sizeSchemas: country.sizeSchemas,
    keyStoreDataversion: keyStoreDataversion
  };
}

/* harmony default export */ var utils_formatCountries = (formatCountries);
// EXTERNAL MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/storeToDefaultCountryMappings/storeToDefaultCountryMappings.json
var storeToDefaultCountryMappings_storeToDefaultCountryMappings = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/utils/storeToDefaultCountryMappings/storeToDefaultCountryMappings.json");
var storeToDefaultCountryMappings_default = /*#__PURE__*/__webpack_require__.n(storeToDefaultCountryMappings_storeToDefaultCountryMappings);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/storeToDefaultCountryMappings/index.js


function getStoreToDefaultCountryMappings() {
  storeToDefaultCountryMappings_default.a.forEach(function (storeToDefaultCountryMapping) {
    var defaultCountryCode = storeToDefaultCountryMapping.defaultCountryCode;

    var allMappingsWithThisDefaultCountryCode = storeToDefaultCountryMappings_default.a.filter(function (mapping) {
      return mapping.defaultCountryCode === defaultCountryCode;
    });

    var suchMappingsWithXSiteUrnFallback = allMappingsWithThisDefaultCountryCode.filter(function (mapping) {
      return mapping.isXSiteUrnFallback;
    });

    if (suchMappingsWithXSiteUrnFallback.length > 1) {
      throw "The defaultCountryCode '" + defaultCountryCode + "' has been assigned an 'isXSiteUrnFallback' of true more than once. Each defaultCountryCode can only have up to one xSiteUrnFallback.";
    }

    if (allMappingsWithThisDefaultCountryCode.length > 1 && suchMappingsWithXSiteUrnFallback.length === 0) {
      throw "The defaultCountryCode '" + defaultCountryCode + "' is mapped more than once, but none of these mappings has 'isXSiteUrnFallback' set as true. At least one of them must.";
    }
  });

  return storeToDefaultCountryMappings_default.a;
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getDefaultCountries/index.js



function getDefaultCountries(majorCountries) {
  var storeToDefaultCountryMappings = getStoreToDefaultCountryMappings();
  var stores = getUniqueStoresFromMajorCountries(majorCountries, storeToDefaultCountryMappings);

  var defaultCountries = stores.reduce(function (defaultCountries, store) {
    var storeToDefaultCountryMapping = storeToDefaultCountryMappings.find(function (mapping) {
      return mapping.storeCode === store.storeCode;
    });

    var majorCountry = majorCountries.find(function (country) {
      return country.countryCode === storeToDefaultCountryMapping.defaultCountryCode;
    });

    defaultCountries.push(assign_default()({}, majorCountry, { isDefaultCountry: true }, store, {
      isXSiteUrnFallback: storeToDefaultCountryMapping.isXSiteUrnFallback || false
    }));

    return defaultCountries;
  }, []);

  return defaultCountries;
}

var getUniqueStoresFromMajorCountries = function getUniqueStoresFromMajorCountries(majorCountries, storeToDefaultCountryMappings) {
  var mapped = storeToDefaultCountryMappings.map(function (_ref) {
    var storeCode = _ref.storeCode;

    var country = majorCountries.find(function (c) {
      return c.storeCode === storeCode;
    });

    if (!country) return null;

    return {
      storeCode: storeCode,
      storeId: country.siteId,
      url: country.url
    };
  });

  return mapped.filter(function (v) {
    return v;
  });
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/createCountryCollections/index.js


/*
 * @typedef {Object} CountryCollections
 * @property {Country[]} majorCountries
 * @property {Country[]} defaultCountries
 * @property {Country[]} countries
 */

/*
 * @retuns {CountryCollections} countryCollections
 */
function createCountryCollections(countries) {
  var isMajorCountry = function isMajorCountry(country) {
    return country.majorCountry === null;
  };
  var majorCountries = countries.filter(isMajorCountry);

  return {
    majorCountries: majorCountries,
    defaultCountries: getDefaultCountries(majorCountries),
    countries: countries
  };
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getCountryCollections.js











function getCountryCollections_getCountryCollections(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, cache, endpoint, getKeyStoreDataversion, warn, request, response, lang, keyStoreDataversion, queryParams, parsedEndpoint, _response, json;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              cache = params.cache, endpoint = params.endpoint, getKeyStoreDataversion = params.getKeyStoreDataversion, warn = params.warn, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getKeyStoreDataversion({
                request: request,
                response: response
              });

            case 4:
              keyStoreDataversion = _context.sent;
              queryParams = { keyStoreDataversion: keyStoreDataversion };


              if (lang) {
                assign_default()(queryParams, { lang: lang });
              }

              parsedEndpoint = Object(url_url["resolve"])(endpoint, "?" + Object(querystring_es3["stringify"])(queryParams));

              if (!(cache.hasKey(parsedEndpoint) && !cache.hasExpired(parsedEndpoint))) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", cache.get(parsedEndpoint));

            case 10:
              _context.prev = 10;
              _context.next = 13;
              return utils_wrappedFetch(parsedEndpoint);

            case 13:
              _response = _context.sent;
              _context.next = 16;
              return _response.json();

            case 16:
              json = _context.sent;
              return _context.abrupt("return", cache.set(parsedEndpoint, createCountryCollections(utils_formatCountries(enrichMinorCountries(json), keyStoreDataversion))));

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](10);

              warn("Store presentation failed to fetch fresh stores", _context.t0);

              if (!cache.hasKey(parsedEndpoint)) {
                _context.next = 27;
                break;
              }

              warn("Store presentation forced to return stale stores cache", _context.t0);
              warn("Resetting the stale cache");
              return _context.abrupt("return", cache.set(parsedEndpoint, cache.get(parsedEndpoint)));

            case 27:
              throw storeServiceError("Could not obtain stores", _context.t0);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[10, 20]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getCountries.js




/*
 * @returns {Country[]} countries
 */
function getCountries(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountryCollections, request, response, lang, _ref2, countries;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getCountryCollections({
                request: request,
                response: response,
                lang: lang
              });

            case 4:
              _ref2 = _context.sent;
              countries = _ref2.countries;

              if (!countries) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", countries);

            case 10:
              throw storeServiceError("Countries was not calculated correctly");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getDefaultCountries.js




/*
 * @returns {Country[]} defaultCountries
 */
function getDefaultCountries_getDefaultCountries(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountryCollections, request, response, lang, _ref2, defaultCountries;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getCountryCollections({
                request: request,
                response: response,
                lang: lang
              });

            case 4:
              _ref2 = _context.sent;
              defaultCountries = _ref2.defaultCountries;

              if (!defaultCountries) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", defaultCountries);

            case 10:
              throw storeServiceError("Default countries was not calculated correctly");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("../node_modules/babel-runtime/core-js/get-iterator.js");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getMajorCountriesWithKSDVVariants.js








/*
 * @returns {Country[]} majorCountries
 */
function getMajorCountriesWithKSDVVariants(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var _this = this;

      var params, getCountryCollections, getVersionManifest, getKeyStoreDataversion, request, response, lang, warn, _ref2, permittedKeyStoreDataversions, currentKSDV, countriesByKSDV, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ksdv, majorCountriesWithKSDV;

      return regenerator_default.a.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, getVersionManifest = params.getVersionManifest, getKeyStoreDataversion = params.getKeyStoreDataversion, request = params.request, response = params.response, lang = params.lang, warn = params.warn;
              _context2.prev = 2;
              _context2.next = 5;
              return getVersionManifest();

            case 5:
              _ref2 = _context2.sent;
              permittedKeyStoreDataversions = _ref2.permittedKeyStoreDataversions;
              _context2.next = 9;
              return getKeyStoreDataversion({ request: request, response: response });

            case 9:
              currentKSDV = _context2.sent;
              countriesByKSDV = {};
              _loop = regenerator_default.a.mark(function _loop(ksdv) {
                var _ref3, majorCountries;

                return regenerator_default.a.wrap(function _loop$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return getCountryCollections({
                          request: request,
                          response: response,
                          lang: lang,
                          getKeyStoreDataversion: function getKeyStoreDataversion() {
                            return promise_default.a.resolve(ksdv);
                          }
                        });

                      case 3:
                        _ref3 = _context.sent;
                        majorCountries = _ref3.majorCountries;


                        if (majorCountries && majorCountries.length) {
                          countriesByKSDV[ksdv] = majorCountries.slice();
                        }
                        _context.next = 11;
                        break;

                      case 8:
                        _context.prev = 8;
                        _context.t0 = _context["catch"](0);

                        warn("Get country collection failed for KSDV: " + ksdv);

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _loop, _this, [[0, 8]]);
              });
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context2.prev = 15;
              _iterator = get_iterator_default()(permittedKeyStoreDataversions);

            case 17:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context2.next = 23;
                break;
              }

              ksdv = _step.value;
              return _context2.delegateYield(_loop(ksdv), "t0", 20);

            case 20:
              _iteratorNormalCompletion = true;
              _context2.next = 17;
              break;

            case 23:
              _context2.next = 29;
              break;

            case 25:
              _context2.prev = 25;
              _context2.t1 = _context2["catch"](15);
              _didIteratorError = true;
              _iteratorError = _context2.t1;

            case 29:
              _context2.prev = 29;
              _context2.prev = 30;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 32:
              _context2.prev = 32;

              if (!_didIteratorError) {
                _context2.next = 35;
                break;
              }

              throw _iteratorError;

            case 35:
              return _context2.finish(32);

            case 36:
              return _context2.finish(29);

            case 37:
              majorCountriesWithKSDV = countriesByKSDV[currentKSDV] || [];

              delete countriesByKSDV[currentKSDV];

              majorCountriesWithKSDV.forEach(function (country) {
                country.keyStoreDataversionVariants = keys_default()(countriesByKSDV).reduce(function (acc, ksdv) {
                  var foundIndex = void 0;
                  var foundCountry = countriesByKSDV[ksdv].find(function (el, index) {
                    if (el.countryCode === country.countryCode) {
                      foundIndex = index;
                      return true;
                    }
                    return false;
                  });

                  if (foundCountry) {
                    acc[ksdv] = foundCountry;
                    countriesByKSDV[ksdv].splice(foundIndex, 1);
                  }

                  return acc;
                }, {});
              });

              return _context2.abrupt("return", majorCountriesWithKSDV);

            case 43:
              _context2.prev = 43;
              _context2.t2 = _context2["catch"](2);
              throw storeServiceError("Failed to getMajorCountriesWithKSDVVariants", _context2.t2);

            case 46:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee, this, [[2, 43], [15, 25, 29, 37], [30,, 32, 36]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getCurrency.js





/*
 * @param {Country} country
 *
 * @returns {Currency} currency
 */
var getDefaultCurrencyForCountry = function getDefaultCurrencyForCountry(country) {
  return country.currencies.find(function (currency) {
    return currency.isPrimary;
  });
};

/*
 * @param {string} browseCurrency
 * @param {Country} country
 *
 * @returns {Currency} currency
 */
var getCurrencyIfValid = function getCurrencyIfValid(browseCurrency, country) {
  return country.currencies.find(function (_ref) {
    var currency = _ref.currency;
    return browseCurrency === currency;
  });
};

/*
 * @typedef {Object} Currency
 * @property {string} currency
 * @property {string} symbol
 * @property {string} text
 * @property {boolean} isPrimary
 * @property {number} currencyId
 */

/*
 * @typedef {Object} GetCurrencyOptions
 * @property {Function} getCountry
 * @property {Object} request
 * @property {Object} response
 */

/*
 * @async
 * @callback CurriedGetCurrency
 * @param {GetCurrencyOptions} options
 */

/*
 * @param {GetCurrencyOptions} initialParams
 *
 * @returns {CurriedGetCurrency} curriedGetCurrency
 */
function getCurrency_getCurrency(initialParams) {
  return function () {
    var _ref2 = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var _Object$assign, request, response, getCountry, country, browseCurrency, validCurrency;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _Object$assign = assign_default()({}, initialParams, callParams), request = _Object$assign.request, response = _Object$assign.response, getCountry = _Object$assign.getCountry;
              _context.next = 3;
              return getCountry({ request: request, response: response });

            case 3:
              country = _context.sent;
              browseCurrency = server_getBrowseCurrency(request);
              validCurrency = getCurrencyIfValid(browseCurrency, country);
              return _context.abrupt("return", validCurrency || getDefaultCurrencyForCountry(country));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getLanguage.js





/*
 * @param {Country} country
 *
 * @returns {Language} language
 */
var getDefaultLanguageForCountry = function getDefaultLanguageForCountry(country) {
  return country.languages.find(function (language) {
    return language.isPrimary;
  });
};

/*
 * @param {string} browseLanguage
 * @param {Country} country
 *
 * @returns {Language} language
 */
var getLanguageIfValid = function getLanguageIfValid(browseLanguage, country) {
  return country.languages.find(function (_ref) {
    var language = _ref.language;
    return browseLanguage === language;
  });
};

/*
 * @typedef {Object} Language
 * @property {string} language
 * @property {string} name
 * @property {string} text
 * @property {string} languageShort
 * @property {boolean} isPrimary
 */

/*
 * @typedef {Object} GetLanguageOptions
 * @property {Function} getCountry
 * @property {Object} request
 * @property {Object} response
 */

/*
 * @async
 * @callback CurriedGetLanguage
 * @param {GetLanguageOptions} options
 */

/*
 * @param {GetLanguageOptions} initialParams
 *
 * @returns {CurriedGetLanguage} curriedGetLanguage
 */
function getLanguage(initialParams) {
  return function () {
    var _ref2 = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var _Object$assign, request, response, getCountry, country, browseLanguage, validLanguage;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _Object$assign = assign_default()({}, initialParams, callParams), request = _Object$assign.request, response = _Object$assign.response, getCountry = _Object$assign.getCountry;
              _context.next = 3;
              return getCountry({ request: request, response: response });

            case 3:
              country = _context.sent;
              browseLanguage = server_getBrowseLanguage(request);
              validLanguage = getLanguageIfValid(browseLanguage, country);
              return _context.abrupt("return", validLanguage || getDefaultLanguageForCountry(country));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getSizeSchema.js





/*
 * @param {Country} country
 *
 * @returns {SizeSchema} sizeSchema
 */
var getDefaultSizeSchemaForCountry = function getDefaultSizeSchemaForCountry(country) {
  return country.sizeSchemas.find(function (sizeSchema) {
    return sizeSchema.isPrimary;
  });
};

/*
 * @param {string} browseSizeSchema
 * @param {Country} country
 *
 * @returns {SizeSchema} sizeSchema
 */
var getSizeSchemaIfValid = function getSizeSchemaIfValid(browseSizeSchema, country) {
  return country.sizeSchemas.find(function (_ref) {
    var sizeSchema = _ref.sizeSchema;
    return browseSizeSchema === sizeSchema;
  });
};

/*
 * @typedef {Object} SizeSchema
 * @property {string} sizeSchema
 * @property {string} text
 * @property {boolean} isPrimary
 */

/*
 * @typedef {Object} GetSizeSchemaOptions
 * @property {Function} getCountry
 * @property {Object} request
 * @property {Object} response
 */

/*
 * @async
 * @callback CurriedGetSizeSchema
 * @param {GetSizeSchemaOptions} options
 */

/*
 * @param {GetSizeSchemaOptions} initialParams
 *
 * @returns {CurriedGetSizeSchema} curriedGetSizeSchema
 */
function getSizeSchema_getSizeSchema(initialParams) {
  return function () {
    var _ref2 = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var _Object$assign, request, response, getCountry, country, browseSizeSchema, validSizeSchema;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _Object$assign = assign_default()({}, initialParams, callParams), request = _Object$assign.request, response = _Object$assign.response, getCountry = _Object$assign.getCountry;
              _context.next = 3;
              return getCountry({ request: request, response: response });

            case 3:
              country = _context.sent;
              browseSizeSchema = server_getBrowseSizeSchema(request);
              validSizeSchema = getSizeSchemaIfValid(browseSizeSchema, country);
              return _context.abrupt("return", validSizeSchema || getDefaultSizeSchemaForCountry(country));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/index.js
















var fiveMinutes = 1000 * 60 * 5;

var storeFactory = {
  create: function create() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        storeApiEndpoint = _ref.storeApiEndpoint,
        _ref$storeExpiryMs = _ref.storeExpiryMs,
        storeExpiryMs = _ref$storeExpiryMs === undefined ? fiveMinutes : _ref$storeExpiryMs,
        versionManifestEndpoint = _ref.versionManifestEndpoint,
        _ref$versionManifestE = _ref.versionManifestExpiryMs,
        versionManifestExpiryMs = _ref$versionManifestE === undefined ? fiveMinutes : _ref$versionManifestE,
        warn = _ref.warn;

    validate(storeApiEndpoint, versionManifestEndpoint, warn);

    var storeCache = factories_cache.create({ expiryMs: storeExpiryMs });
    var versionManifestCache = factories_cache.create({
      expiryMs: versionManifestExpiryMs
    });

    /*
     * Needs no parameters
     * @returns {VersionManifest}
     */
    var curriedGetVersionManifest = getVersionManifest_getVersionManifest({
      cache: versionManifestCache,
      versionManifestEndpoint: versionManifestEndpoint,
      warn: warn
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @returns {string} keyStoreDataversion
     */
    var curriedGetKeyStoreDataversion = getKeyStoreDataversion_getKeyStoreDataversion({
      getVersionManifest: curriedGetVersionManifest
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @param {Object} cache,
     * @param {string} endpoint,
     * @param {Function} getKeyStoreDataversion
     * @returns {CountryCollections} countryCollections
     */
    var curriedGetCountryCollections = getCountryCollections_getCountryCollections({
      cache: storeCache,
      endpoint: storeApiEndpoint,
      getKeyStoreDataversion: curriedGetKeyStoreDataversion,
      warn: warn
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country[]} countries
     */
    var curriedGetCountries = getCountries({
      getCountryCollections: curriedGetCountryCollections
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country[]} majorCountries
     */
    var curriedGetMajorCountries = getMajorCountries({
      getCountryCollections: curriedGetCountryCollections
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country[]} defaultCountries
     */
    var curriedGetDefaultCountries = getDefaultCountries_getDefaultCountries({
      getCountryCollections: curriedGetCountryCollections
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country} country
     */
    var curriedGetCountry = getCountry_getCountry({
      getCountryCollections: curriedGetCountryCollections
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country[]} majorCountries
     */
    var curriedGetMajorCountriesWithKSDVVariants = getMajorCountriesWithKSDVVariants({
      getCountryCollections: curriedGetCountryCollections,
      getVersionManifest: curriedGetVersionManifest,
      getKeyStoreDataversion: curriedGetKeyStoreDataversion,
      warn: warn
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @returns {string} siteChromeVersion
     */
    var curriedGetSiteChromeVersion = getSiteChromeVersion_getSiteChromeVersion({
      getCountry: curriedGetCountry,
      getVersionManifest: curriedGetVersionManifest
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @returns {boolean} useSiteChrome
     */
    var curriedGetUseSiteChrome = getUseSiteChrome({
      getSiteChromeVersion: curriedGetSiteChromeVersion
    });

    /*
     * @param {Object} options
     * @param {Object} options.request
     * @param {Object} options.response
     */
    var curriedGetCurrency = getCurrency_getCurrency({
      getCountry: curriedGetCountry
    });

    /*
     * @param {Object} options
     * @param {Object} options.request
     * @param {Object} options.response
     */
    var curriedGetLanguage = getLanguage({
      getCountry: curriedGetCountry
    });

    /*
     * @param {Object} options
     * @param {Object} options.request
     * @param {Object} options.response
     */
    var curriedGetSizeSchema = getSizeSchema_getSizeSchema({
      getCountry: curriedGetCountry
    });

    return {
      getCountries: curriedGetCountries,
      getMajorCountries: curriedGetMajorCountries,
      getMajorCountriesWithKSDVVariants: curriedGetMajorCountriesWithKSDVVariants,
      getDefaultCountries: curriedGetDefaultCountries,
      getCountry: curriedGetCountry,
      getKeyStoreDataversion: curriedGetKeyStoreDataversion,
      getVersionManifest: curriedGetVersionManifest,
      getSiteChromeVersion: curriedGetSiteChromeVersion,
      getUseSiteChrome: curriedGetUseSiteChrome,
      getCurrency: curriedGetCurrency,
      getLanguage: curriedGetLanguage,
      getSizeSchema: curriedGetSizeSchema
    };
  }
};

/* harmony default export */ var factories_store = (storeFactory);
// EXTERNAL MODULE: delegated ../node_modules/js-cookie/src/js.cookie.js from dll-reference vendor
var js_cookiefrom_dll_reference_vendor = __webpack_require__("../node_modules/js-cookie/src/js.cookie.js");
var js_cookiefrom_dll_reference_vendor_default = /*#__PURE__*/__webpack_require__.n(js_cookiefrom_dll_reference_vendor);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/client/cookieReadingAndWriting.js


var oneYearInDays = 365;

var client_cookieReadingAndWriting_getCookieValue = function getCookieValue(cookieName) {
  return js_cookiefrom_dll_reference_vendor_default.a.get(cookieName) || undefined;
};

var client_cookieReadingAndWriting_setCookieValue = function setCookieValue(cookieName, value) {
  var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : oneYearInDays;

  var options = { expires: expires };
  js_cookiefrom_dll_reference_vendor_default.a.set(cookieName, value, options);
};

var cookieReadingAndWriting_findKeyValuePair = function findKeyValuePair(values, key) {
  return values ? values.split("&").filter(function (keyValue) {
    return keyValue.includes(key + "=");
  })[0] : null;
};

var cookieReadingAndWriting_concatenateKeyValuePairs = function concatenateKeyValuePairs(cookieValue, newKey, newValue) {
  if (cookieValue) {
    var keyValueInCookie = cookieReadingAndWriting_findKeyValuePair(cookieValue, newKey);
    if (keyValueInCookie) {
      return cookieValue.replace(keyValueInCookie, newKey + "=" + newValue);
    } else {
      return cookieValue + "&" + newKey + "=" + newValue;
    }
  }
  return newKey + "=" + newValue;
};

var cookieReadingAndWriting_setKeyedCookieValue = function setKeyedCookieValue(cookieName, key, value) {
  var expires = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : oneYearInDays;

  client_cookieReadingAndWriting_setCookieValue(cookieName, cookieReadingAndWriting_concatenateKeyValuePairs(client_cookieReadingAndWriting_getCookieValue(cookieName), key, value), expires);
};

var cookieReadingAndWriting_getKeyedCookieValue = function getKeyedCookieValue(cookieName, key) {
  var keyValuePair = cookieReadingAndWriting_findKeyValuePair(client_cookieReadingAndWriting_getCookieValue(cookieName), key);
  return keyValuePair ? keyValuePair.split("=")[1] : null;
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/client/index.js








var client_BrowseCountryKey = cookiesMap.BrowseCountryKey,
    client_FloorCookieName = cookiesMap.FloorCookieName,
    client_AsosCookieName = cookiesMap.AsosCookieName,
    CurrencyCookieName = cookiesMap.CurrencyCookieName,
    CurrencyIdKey = cookiesMap.CurrencyIdKey,
    CurrencyLabelKey = cookiesMap.CurrencyLabelKey,
    client_SizeSchemaKey = cookiesMap.SizeSchemaKey,
    client_PreferredSiteKey = cookiesMap.PreferredSiteKey,
    client_TopCatIdKey = cookiesMap.TopCatIdKey,
    WelcomeMessage = cookiesMap.WelcomeMessage,
    client_BrowseCurrencyKey = cookiesMap.BrowseCurrencyKey,
    client_BrowseLanguageKey = cookiesMap.BrowseLanguageKey,
    client_BrowseSizeSchemaKey = cookiesMap.BrowseSizeSchemaKey,
    StoreCodeKey = cookiesMap.StoreCodeKey,
    client_TemplateVersionKey = cookiesMap.TemplateVersionKey,
    GeoCountryKey = cookiesMap.GeoCountryKey,
    client_KeyStoreDataversionKey = cookiesMap.KeyStoreDataversionKey,
    AffiliateCookieName = cookiesMap.AffiliateCookieName,
    AffiliateKey = cookiesMap.AffiliateKey,
    WelcomeMatWrong = cookiesMap.WelcomeMatWrong,
    WelcomeMatCorrect = cookiesMap.WelcomeMatCorrect;


var defaultCurrency = -1;

var thirtyDays = 30;
var inOneHour = 1 / 24;
var oneWeek = 7;
var oneYear = 365;

var client_getBrowseCountry = function getBrowseCountry() {
  return client_cookieReadingAndWriting_getCookieValue(client_BrowseCountryKey);
};
var client_setBrowseCountry = function setBrowseCountry(country) {
  return client_cookieReadingAndWriting_setCookieValue(client_BrowseCountryKey, country);
};

var client_getCurrency = function getCurrency() {
  var currencyId = cookieReadingAndWriting_getKeyedCookieValue(client_AsosCookieName, CurrencyIdKey);
  var currencyLabel = cookieReadingAndWriting_getKeyedCookieValue(client_AsosCookieName, CurrencyLabelKey);

  return {
    currencyId: parseInt(currencyId) || defaultCurrency,
    currencyLabel: currencyLabel
  };
};

var client_setCurrency = function setCurrency(_ref) {
  var currencyCode = _ref.currencyCode,
      currencyId = _ref.currencyId;

  if (!currencyId || isNaN(currencyId)) throw invalidArgumentError("Invalid argument: currencyId needs to be a number");

  if (!currencyCode) throw invalidArgumentError("Invalid argument: currencyCode cannot be empty");

  cookieReadingAndWriting_setKeyedCookieValue(client_AsosCookieName, CurrencyIdKey, currencyId);
  cookieReadingAndWriting_setKeyedCookieValue(client_AsosCookieName, CurrencyLabelKey, currencyCode);

  // legacy cookie
  client_cookieReadingAndWriting_setCookieValue(CurrencyCookieName, currencyId);
};

var client_getSizeSchema = function getSizeSchema() {
  return cookieReadingAndWriting_getKeyedCookieValue(client_AsosCookieName, client_SizeSchemaKey);
};

var client_setSizeSchema = function setSizeSchema(sizeSchema) {
  if (!sizeSchema) {
    throw invalidArgumentError("Invalid argument: sizeSchema cannot be empty");
  }
  cookieReadingAndWriting_setKeyedCookieValue(client_AsosCookieName, client_SizeSchemaKey, sizeSchema);
};

var client_getFloor = function getFloor() {
  return getGenderByFloorId(client_cookieReadingAndWriting_getCookieValue(client_FloorCookieName));
};

var client_setFloor = function setFloor(gender) {
  if (!gender) {
    throw invalidArgumentError("Invalid argument: gender cannot be empty");
  }
  var floorId = getFloorIdByGender(gender);
  if (floorId) {
    client_cookieReadingAndWriting_setCookieValue(client_FloorCookieName, floorId);
    cookieReadingAndWriting_setKeyedCookieValue(client_AsosCookieName, client_TopCatIdKey, floorId);
  }
};

var client_getPreferredSite = function getPreferredSite() {
  return cookieReadingAndWriting_getKeyedCookieValue(client_AsosCookieName, client_PreferredSiteKey);
};

var client_isFirstVisit = function isFirstVisit() {
  return !client_getBrowseCountry();
};

var client_clearCookies = function clearCookies() {
  client_cookieReadingAndWriting_setCookieValue(client_AsosCookieName, "");
  js_cookiefrom_dll_reference_vendor_default.a.remove(client_FloorCookieName);
  js_cookiefrom_dll_reference_vendor_default.a.remove(WelcomeMessage);
  js_cookiefrom_dll_reference_vendor_default.a.remove(AffiliateCookieName);
};

var client_getWelcomeMessage = function getWelcomeMessage() {
  return client_cookieReadingAndWriting_getCookieValue(WelcomeMessage);
};

var client_setWelcomeMessage = function setWelcomeMessage(messageSeen) {
  return client_cookieReadingAndWriting_setCookieValue(WelcomeMessage, messageSeen);
};

var client_getWelcomeMatClosedForWrongCountry = function getWelcomeMatClosedForWrongCountry() {
  return client_cookieReadingAndWriting_getCookieValue(WelcomeMatWrong);
};

var client_setWelcomeMatClosedForWrongCountry = function setWelcomeMatClosedForWrongCountry(value) {
  return client_cookieReadingAndWriting_setCookieValue(WelcomeMatWrong, value, oneWeek);
};

var client_getWelcomeMatClosedForCorrectCountry = function getWelcomeMatClosedForCorrectCountry() {
  return client_cookieReadingAndWriting_getCookieValue(WelcomeMatCorrect);
};

var client_setWelcomeMatClosedForCorrectCountry = function setWelcomeMatClosedForCorrectCountry(value) {
  return client_cookieReadingAndWriting_setCookieValue(WelcomeMatCorrect, value, oneYear);
};

var client_setBrowseCurrency = function setBrowseCurrency(val) {
  return client_cookieReadingAndWriting_setCookieValue(client_BrowseCurrencyKey, val);
};
var client_setBrowseLanguage = function setBrowseLanguage(val) {
  return client_cookieReadingAndWriting_setCookieValue(client_BrowseLanguageKey, val);
};
var client_setBrowseSizeSchema = function setBrowseSizeSchema(val) {
  return client_cookieReadingAndWriting_setCookieValue(client_BrowseSizeSchemaKey, val);
};
var client_setStoreCode = function setStoreCode(val) {
  return client_cookieReadingAndWriting_setCookieValue(StoreCodeKey, val);
};
var client_setTemplateVersion = function setTemplateVersion(storeCode, val) {
  return cookieReadingAndWriting_setKeyedCookieValue(client_TemplateVersionKey, storeCode, val, inOneHour);
};

var client_setTemplateVersions = function setTemplateVersions(templateVersions) {
  var keyValuePairs = keys_default()(templateVersions).sort().map(function (storeCode) {
    return storeCode + "=" + templateVersions[storeCode];
  }).join("&");

  client_cookieReadingAndWriting_setCookieValue(client_TemplateVersionKey, keyValuePairs, inOneHour);
};

var client_setKeyStoreDataversion = function setKeyStoreDataversion(val) {
  return client_cookieReadingAndWriting_setCookieValue(client_KeyStoreDataversionKey, val, inOneHour);
};

var client_getBrowseCurrency = function getBrowseCurrency() {
  return client_cookieReadingAndWriting_getCookieValue(client_BrowseCurrencyKey);
};
var client_getBrowseLanguage = function getBrowseLanguage() {
  return client_cookieReadingAndWriting_getCookieValue(client_BrowseLanguageKey);
};
var client_getBrowseSizeSchema = function getBrowseSizeSchema() {
  return client_cookieReadingAndWriting_getCookieValue(client_BrowseSizeSchemaKey);
};
var client_getStoreCode = function getStoreCode() {
  return client_cookieReadingAndWriting_getCookieValue(StoreCodeKey);
};
var client_getTemplateVersion = function getTemplateVersion(storeCode) {
  return cookieReadingAndWriting_getKeyedCookieValue(client_TemplateVersionKey, storeCode);
};
var client_getKeyStoreDataversion = function getKeyStoreDataversion() {
  return client_cookieReadingAndWriting_getCookieValue(client_KeyStoreDataversionKey);
};

var client_getGeoCountry = function getGeoCountry() {
  return client_cookieReadingAndWriting_getCookieValue(GeoCountryKey);
};

var client_setAffiliateId = function setAffiliateId(val) {
  return cookieReadingAndWriting_setKeyedCookieValue(AffiliateCookieName, AffiliateKey, val, thirtyDays);
};
var client_getAffiliateId = function getAffiliateId() {
  return cookieReadingAndWriting_getKeyedCookieValue(AffiliateCookieName, AffiliateKey);
};

var client_initAsosCookie = function initAsosCookie() {
  if (!client_cookieReadingAndWriting_getCookieValue(client_AsosCookieName) && client_cookieReadingAndWriting_getCookieValue(client_AsosCookieName) !== "") {
    client_cookieReadingAndWriting_setCookieValue(client_AsosCookieName, "");
  }
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/dataPlatform/index.js
var MOBILE = "mobile";
var TABLET = "tablet";
var DESKTOP = "desktop";

var dataPlatform_isMobile = function isMobile(req) {
  return req.get("IsMobile") === "true";
};
var isTablet = function isTablet(req) {
  return req.get("IsTablet") === "true";
};
var isStopMobileSet = function isStopMobileSet(req) {
  return req.query.stop_mobi === "yes";
};
var getPlatform = function getPlatform(req) {
  switch (true) {
    case isTablet(req):
      return TABLET;
    case dataPlatform_isMobile(req):
      return MOBILE;
    default:
      return DESKTOP;
  }
};
// EXTERNAL MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores.json
var store_stores = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores.json");
var stores_default = /*#__PURE__*/__webpack_require__.n(store_stores);

// EXTERNAL MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores-prod.json
var stores_prod = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores-prod.json");
var stores_prod_default = /*#__PURE__*/__webpack_require__.n(stores_prod);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/index.js





var store_normalise = function normalise(_ref) {
  var storeCode = _ref.storeCode,
      _ref$gender = _ref.gender,
      gender = _ref$gender === undefined ? "default" : _ref$gender,
      isMobile = _ref.isMobile,
      environmentMode = _ref.environmentMode;
  return {
    storeCode: storeCode.toLowerCase(),
    platform: isMobile ? MOBILE : DESKTOP,
    gender: ["women", "men", "default", "secure"].includes(gender) ? gender : "default",
    storeUrls: environmentMode === "prod" ? stores_prod_default.a : stores_default.a
  };
};

var store_getStoreUrlByStoreCode = function getStoreUrlByStoreCode(options) {
  var _normalise = store_normalise(options),
      storeCode = _normalise.storeCode,
      platform = _normalise.platform,
      gender = _normalise.gender,
      storeUrls = _normalise.storeUrls;

  if (!storeUrls.hasOwnProperty(storeCode)) {
    throw storeServiceError("Invalid storeCode " + storeCode);
  }
  return storeUrls[storeCode][platform][gender];
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storePresentation", function() { return module_storePresentation; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getBrowseCountry", function() { return client_getBrowseCountry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setBrowseCountry", function() { return client_setBrowseCountry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getBrowseCurrency", function() { return client_getBrowseCurrency; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setBrowseCurrency", function() { return client_setBrowseCurrency; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getBrowseLanguage", function() { return client_getBrowseLanguage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setBrowseLanguage", function() { return client_setBrowseLanguage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getBrowseSizeSchema", function() { return client_getBrowseSizeSchema; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setBrowseSizeSchema", function() { return client_setBrowseSizeSchema; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getCurrency", function() { return client_getCurrency; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setCurrency", function() { return client_setCurrency; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getFloor", function() { return client_getFloor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setFloor", function() { return client_setFloor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getKeyStoreDataversion", function() { return client_getKeyStoreDataversion; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setKeyStoreDataversion", function() { return client_setKeyStoreDataversion; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getGeoCountry", function() { return client_getGeoCountry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getPreferredSite", function() { return client_getPreferredSite; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getSizeSchema", function() { return client_getSizeSchema; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setSizeSchema", function() { return client_setSizeSchema; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getStoreCode", function() { return client_getStoreCode; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setStoreCode", function() { return client_setStoreCode; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getTemplateVersion", function() { return client_getTemplateVersion; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setTemplateVersion", function() { return client_setTemplateVersion; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setTemplateVersions", function() { return client_setTemplateVersions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getWelcomeMessage", function() { return client_getWelcomeMessage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setWelcomeMessage", function() { return client_setWelcomeMessage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getWelcomeMatClosedForWrongCountry", function() { return client_getWelcomeMatClosedForWrongCountry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setWelcomeMatClosedForWrongCountry", function() { return client_setWelcomeMatClosedForWrongCountry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getWelcomeMatClosedForCorrectCountry", function() { return client_getWelcomeMatClosedForCorrectCountry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setWelcomeMatClosedForCorrectCountry", function() { return client_setWelcomeMatClosedForCorrectCountry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "clearCookies", function() { return client_clearCookies; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isFirstVisit", function() { return client_isFirstVisit; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setAffiliateId", function() { return client_setAffiliateId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getAffiliateId", function() { return client_getAffiliateId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "initAsosCookie", function() { return client_initAsosCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getGenderByFloorId", function() { return getGenderByFloorId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getFloorIdByGender", function() { return getFloorIdByGender; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isMobile", function() { return dataPlatform_isMobile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isTablet", function() { return isTablet; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isStopMobileSet", function() { return isStopMobileSet; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getPlatform", function() { return getPlatform; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getStoreUrlByStoreCode", function() { return store_getStoreUrlByStoreCode; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "errors", function() { return errors; });









var module_storePresentation = function storePresentation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      storeApiEndpoint = _ref.storeApiEndpoint,
      storeExpiryMs = _ref.storeExpiryMs,
      versionManifestEndpoint = _ref.versionManifestEndpoint,
      versionManifestExpiryMs = _ref.versionManifestExpiryMs,
      warn = _ref.warn;

  return {
    store: factories_store.create({
      storeApiEndpoint: storeApiEndpoint,
      storeExpiryMs: storeExpiryMs,
      versionManifestEndpoint: versionManifestEndpoint,
      versionManifestExpiryMs: versionManifestExpiryMs,
      warn: warn
    })
  };
};

/***/ }),

/***/ "../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores-prod.json":
/***/ (function(module, exports) {

module.exports = {"com":{"desktop":{"default":"http://www.asos.com","women":"http://www.asos.com/women","men":"http://www.asos.com/men","secure":"https://secure.asos.com"},"mobile":{"default":"http://m.asos.com","women":"http://m.asos.com/women","men":"http://m.asos.com/men","secure":"https://secure.asos.com"}},"row":{"desktop":{"default":"http://www.asos.com","women":"http://www.asos.com/women","men":"http://www.asos.com/men","secure":"https://secure.asos.com"},"mobile":{"default":"http://m.asos.com","women":"http://m.asos.com/women","men":"http://m.asos.com/men","secure":"https://secure.asos.com"}},"roe":{"desktop":{"default":"http://www.asos.com","women":"http://www.asos.com/women","men":"http://www.asos.com/men","secure":"https://secure.asos.com"},"mobile":{"default":"http://m.asos.com","women":"http://m.asos.com/women","men":"http://m.asos.com/men","secure":"https://secure.asos.com"}},"us":{"desktop":{"default":"http://us.asos.com","women":"http://us.asos.com/women","men":"http://us.asos.com/men","secure":"https://secure.asos.com/us"},"mobile":{"default":"http://m.asos.com/us","women":"http://m.asos.com/us/women","men":"http://m.asos.com/us/men","secure":"https://secure.asos.com/us"}},"fr":{"desktop":{"default":"http://www.asos.fr","women":"http://www.asos.fr/femme","men":"http://www.asos.fr/homme","secure":"https://secure.asos.com/fr"},"mobile":{"default":"http://m.asos.com/fr","women":"http://m.asos.com/fr/femme","men":"http://m.asos.com/fr/homme","secure":"https://secure.asos.com/fr"}},"de":{"desktop":{"default":"http://www.asos.de","women":"http://www.asos.de/damen","men":"http://www.asos.de/herren","secure":"https://secure.asos.com/de"},"mobile":{"default":"http://m.asos.com/de","women":"http://m.asos.com/de/damen","men":"http://m.asos.com/de/herren","secure":"https://secure.asos.com/de"}},"it":{"desktop":{"default":"http://www.asos.com/it","women":"http://www.asos.com/it/donna","men":"http://www.asos.com/it/uomo","secure":"https://secure.asos.com/it"},"mobile":{"default":"http://m.asos.com/it","women":"http://m.asos.com/it/donna","men":"http://m.asos.com/it/uomo","secure":"https://secure.asos.com/it"}},"es":{"desktop":{"default":"http://www.asos.com/es","women":"http://www.asos.com/es/mujer","men":"http://www.asos.com/es/hombre","secure":"https://secure.asos.com/es"},"mobile":{"default":"http://m.asos.com/es","women":"http://m.asos.com/es/mujer","men":"http://m.asos.com/es/hombre","secure":"https://secure.asos.com/es"}},"au":{"desktop":{"default":"http://www.asos.com/au","women":"http://www.asos.com/au/women","men":"http://www.asos.com/au/men","secure":"https://secure.asos.com/au"},"mobile":{"default":"http://m.asos.com/au","women":"http://m.asos.com/au/women","men":"http://m.asos.com/au/men","secure":"https://secure.asos.com/au"}},"ru":{"desktop":{"default":"http://www.asos.com/ru","women":"http://www.asos.com/ru/women","men":"http://www.asos.com/ru/men","secure":"https://secure.asos.com/ru"},"mobile":{"default":"http://m.asos.com/ru","women":"http://m.asos.com/ru/women","men":"http://m.asos.com/ru/men","secure":"https://secure.asos.com/ru"}},"se":{"desktop":{"default":"http://www.asos.com/se","women":"http://www.asos.com/se/kvinna","men":"http://www.asos.com/se/man","secure":"https://secure.asos.com/se"},"mobile":{"default":"http://m.asos.com/se","women":"http://m.asos.com/se/kvinna","men":"http://m.asos.com/se/man","secure":"https://secure.asos.com/se"}},"nl":{"desktop":{"default":"http://www.asos.com/nl","women":"http://www.asos.com/nl/dames","men":"http://www.asos.com/nl/heren","secure":"https://secure.asos.com/nl"},"mobile":{"default":"http://m.asos.com/nl","women":"http://m.asos.com/nl/dames","men":"http://m.asos.com/nl/heren","secure":"https://secure.asos.com/nl"}}}

/***/ }),

/***/ "../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores.json":
/***/ (function(module, exports) {

module.exports = {"com":{"desktop":{"default":"http://test.asosservices.com","women":"http://test.asosservices.com/women","men":"http://test.asosservices.com/men","secure":"https://secure.asosservices.com"},"mobile":{"default":"http://m.asosservices.com","women":"http://m.asosservices.com/women","men":"http://m.asosservices.com/men","secure":"https://secure.asosservices.com"}},"row":{"desktop":{"default":"http://test.asosservices.com","women":"http://test.asosservices.com/women","men":"http://test.asosservices.com/men","secure":"https://secure.asosservices.com"},"mobile":{"default":"http://m.asosservices.com","women":"http://m.asosservices.com/women","men":"http://m.asosservices.com/men","secure":"https://secure.asosservices.com"}},"roe":{"desktop":{"default":"http://test.asosservices.com","women":"http://test.asosservices.com/women","men":"http://test.asosservices.com/men","secure":"https://secure.asosservices.com"},"mobile":{"default":"http://m.asosservices.com","women":"http://m.asosservices.com/women","men":"http://m.asosservices.com/men","secure":"https://secure.asosservices.com"}},"us":{"desktop":{"default":"http://ustest.asosservices.com","women":"http://ustest.asosservices.com/women","men":"http://ustest.asosservices.com/men","secure":"https://secure.asosservices.com/us"},"mobile":{"default":"http://m.asosservices.com/us","women":"http://m.asosservices.com/us/women","men":"http://m.asosservices.com/us/men","secure":"https://secure.asosservices.com/us"}},"fr":{"desktop":{"default":"http://test.asosservices.fr","women":"http://test.asosservices.fr/femme","men":"http://test.asosservices.fr/homme","secure":"https://secure.asosservices.com/fr"},"mobile":{"default":"http://m.asosservices.com/fr","women":"http://m.asosservices.com/fr/femme","men":"http://m.asosservices.com/fr/homme","secure":"https://secure.asosservices.com/fr"}},"de":{"desktop":{"default":"http://test.asosservices.de","women":"http://test.asosservices.de/damen","men":"http://test.asosservices.de/herren","secure":"https://secure.asosservices.com/de"},"mobile":{"default":"http://m.asosservices.com/de","women":"http://m.asosservices.com/de/damen","men":"http://m.asosservices.com/de/herren","secure":"https://secure.asosservices.com/de"}},"it":{"desktop":{"default":"http://test.asosservices.com/it","women":"http://test.asosservices.com/it/donna","men":"http://test.asosservices.com/it/uomo","secure":"https://secure.asosservices.com/it"},"mobile":{"default":"http://m.asosservices.com/it","women":"http://m.asosservices.com/it/donna","men":"http://m.asosservices.com/it/uomo","secure":"https://secure.asosservices.com/it"}},"es":{"desktop":{"default":"http://test.asosservices.com/es","women":"http://test.asosservices.com/es/mujer","men":"http://test.asosservices.com/es/hombre","secure":"https://secure.asosservices.com/es"},"mobile":{"default":"http://m.asosservices.com/es","women":"http://m.asosservices.com/es/mujer","men":"http://m.asosservices.com/es/hombre","secure":"https://secure.asosservices.com/es"}},"au":{"desktop":{"default":"http://test.asosservices.com/au","women":"http://test.asosservices.com/au/women","men":"http://test.asosservices.com/au/men","secure":"https://secure.asosservices.com/au"},"mobile":{"default":"http://m.asosservices.com/au","women":"http://m.asosservices.com/au/women","men":"http://m.asosservices.com/au/men","secure":"https://secure.asosservices.com/au"}},"ru":{"desktop":{"default":"http://test.asosservices.com/ru","women":"http://test.asosservices.com/ru/women","men":"http://test.asosservices.com/ru/men","secure":"https://secure.asosservices.com/ru"},"mobile":{"default":"http://m.asosservices.com/ru","women":"http://m.asosservices.com/ru/women","men":"http://m.asosservices.com/ru/men","secure":"https://secure.asosservices.com/ru"}},"se":{"desktop":{"default":"http://test.asosservices.com/se","women":"http://test.asosservices.com/se/kvinna","men":"http://test.asosservices.com/se/man","secure":"https://secure.asosservices.com/se"},"mobile":{"default":"http://m.asosservices.com/se","women":"http://m.asosservices.com/se/kvinna","men":"http://m.asosservices.com/se/man","secure":"https://secure.asosservices.com/se"}},"nl":{"desktop":{"default":"http://test.asosservices.com/nl","women":"http://test.asosservices.com/nl/dames","men":"http://test.asosservices.com/nl/heren","secure":"https://secure.asosservices.com/nl"},"mobile":{"default":"http://m.asosservices.com/nl","women":"http://m.asosservices.com/nl/dames","men":"http://m.asosservices.com/nl/heren","secure":"https://secure.asosservices.com/nl"}}}

/***/ }),

/***/ "../node_modules/asos-site-chrome-store-presentation/lib/module/utils/storeToDefaultCountryMappings/storeToDefaultCountryMappings.json":
/***/ (function(module, exports) {

module.exports = [{"storeCode":"COM","defaultCountryCode":"GB","isXSiteUrnFallback":true},{"storeCode":"ROW","defaultCountryCode":"GB"},{"storeCode":"ROE","defaultCountryCode":"GB"},{"storeCode":"AU","defaultCountryCode":"AU"},{"storeCode":"IT","defaultCountryCode":"IT"},{"storeCode":"DE","defaultCountryCode":"DE"},{"storeCode":"FR","defaultCountryCode":"FR"},{"storeCode":"ES","defaultCountryCode":"ES"},{"storeCode":"RU","defaultCountryCode":"RU"},{"storeCode":"US","defaultCountryCode":"US"},{"storeCode":"SE","defaultCountryCode":"SE"},{"storeCode":"NL","defaultCountryCode":"NL"}]

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/array/from.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/get-iterator.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/is-iterable.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/json/stringify.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/map.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/map.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/number/is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/number/is-integer.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/create.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/define-property.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/get-own-property-descriptor.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/get-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/keys.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/set-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/values.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/promise.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/promise.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/symbol.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/symbol/index.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/symbol/iterator.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/asyncToGenerator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("../node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("../node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("../node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/get.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/inherits.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/set-prototype-of.js");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("../node_modules/babel-runtime/core-js/object/create.js");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("../node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/objectWithoutProperties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("../node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/slicedToArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__("../node_modules/babel-runtime/core-js/is-iterable.js");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("../node_modules/babel-runtime/core-js/get-iterator.js");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/toConsumableArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("../node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/typeof.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("../node_modules/babel-runtime/core-js/symbol/iterator.js");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("../node_modules/babel-runtime/core-js/symbol.js");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "../node_modules/babel-runtime/regenerator/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/regenerator-runtime/runtime-module.js");


/***/ }),

/***/ "../node_modules/base64-js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = ((uint8[i] << 16) & 0xFF0000) + ((uint8[i + 1] << 8) & 0xFF00) + (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),

/***/ "../node_modules/base64url/dist/base64url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
var pad_string_1 = __webpack_require__("../node_modules/base64url/dist/pad-string.js");
function encode(input, encoding) {
    if (encoding === void 0) { encoding = "utf8"; }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString("base64"));
    }
    return fromBase64(new Buffer(input, encoding).toString("base64"));
}
;
function decode(base64url, encoding) {
    if (encoding === void 0) { encoding = "utf8"; }
    return new Buffer(toBase64(base64url), "base64").toString(encoding);
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return pad_string_1.default(base64url)
        .replace(/\-/g, "+")
        .replace(/_/g, "/");
}
function fromBase64(base64) {
    return base64
        .replace(/=/g, "")
        .replace(/\+/g, "-")
        .replace(/\//g, "_");
}
function toBuffer(base64url) {
    return new Buffer(toBase64(base64url), "base64");
}
var base64url = encode;
base64url.encode = encode;
base64url.decode = decode;
base64url.toBase64 = toBase64;
base64url.fromBase64 = fromBase64;
base64url.toBuffer = toBuffer;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = base64url;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "../node_modules/base64url/dist/pad-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = new Buffer(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write("=", position++);
    }
    return buffer.toString();
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = padString;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "../node_modules/base64url/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/base64url/dist/base64url.js").default;
module.exports.default = module.exports;


/***/ }),

/***/ "../node_modules/buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("../node_modules/base64-js/index.js")
var ieee754 = __webpack_require__("../node_modules/ieee754/index.js")
var isArray = __webpack_require__("../node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/classnames/bind.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "../node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/classnames/index.js");

/***/ }),

/***/ "../node_modules/core-js/library/fn/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.array.from.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Array.from;


/***/ }),

/***/ "../node_modules/core-js/library/fn/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator.js");


/***/ }),

/***/ "../node_modules/core-js/library/fn/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/core.is-iterable.js");


/***/ }),

/***/ "../node_modules/core-js/library/fn/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "../node_modules/core-js/library/fn/map.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.map.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.map.to-json.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.map.of.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.map.from.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Map;


/***/ }),

/***/ "../node_modules/core-js/library/fn/number/is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.number.is-integer.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Number.isInteger;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.assign.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.create.js");
var $Object = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.define-property.js");
var $Object = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js");
var $Object = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.get-prototype-of.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.keys.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.keys;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.set-prototype-of.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es7.object.values.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.values;


/***/ }),

/***/ "../node_modules/core-js/library/fn/promise.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.promise.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.promise.finally.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.promise.try.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Promise;


/***/ }),

/***/ "../node_modules/core-js/library/fn/symbol/index.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.symbol.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.symbol.observable.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Symbol;


/***/ }),

/***/ "../node_modules/core-js/library/fn/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_wks-ext.js").f('iterator');


/***/ }),

/***/ "../node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_add-to-unscopables.js":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "../node_modules/core-js/library/modules/_an-instance.js":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-from-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/library/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/library/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var IObject = __webpack_require__("../node_modules/core-js/library/modules/_iobject.js");
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var toLength = __webpack_require__("../node_modules/core-js/library/modules/_to-length.js");
var asc = __webpack_require__("../node_modules/core-js/library/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var isArray = __webpack_require__("../node_modules/core-js/library/modules/_is-array.js");
var SPECIES = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("../node_modules/core-js/library/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("../node_modules/core-js/library/modules/_cof.js");
var TAG = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_collection-strong.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
var create = __webpack_require__("../node_modules/core-js/library/modules/_object-create.js");
var redefineAll = __webpack_require__("../node_modules/core-js/library/modules/_redefine-all.js");
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var anInstance = __webpack_require__("../node_modules/core-js/library/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");
var $iterDefine = __webpack_require__("../node_modules/core-js/library/modules/_iter-define.js");
var step = __webpack_require__("../node_modules/core-js/library/modules/_iter-step.js");
var setSpecies = __webpack_require__("../node_modules/core-js/library/modules/_set-species.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js");
var fastKey = __webpack_require__("../node_modules/core-js/library/modules/_meta.js").fastKey;
var validate = __webpack_require__("../node_modules/core-js/library/modules/_validate-collection.js");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_collection-to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("../node_modules/core-js/library/modules/_classof.js");
var from = __webpack_require__("../node_modules/core-js/library/modules/_array-from-iterable.js");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var meta = __webpack_require__("../node_modules/core-js/library/modules/_meta.js");
var fails = __webpack_require__("../node_modules/core-js/library/modules/_fails.js");
var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
var redefineAll = __webpack_require__("../node_modules/core-js/library/modules/_redefine-all.js");
var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");
var anInstance = __webpack_require__("../node_modules/core-js/library/modules/_an-instance.js");
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js");
var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
var each = __webpack_require__("../node_modules/core-js/library/modules/_array-methods.js")(0);
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.4' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "../node_modules/core-js/library/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("../node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "../node_modules/core-js/library/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_for-of.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var call = __webpack_require__("../node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../node_modules/core-js/library/modules/_is-array-iter.js");
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var toLength = __webpack_require__("../node_modules/core-js/library/modules/_to-length.js");
var getIterFn = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator-method.js");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "../node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("../node_modules/core-js/library/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/_invoke.js":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../node_modules/core-js/library/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../node_modules/core-js/library/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("../node_modules/core-js/library/modules/_object-create.js");
var descriptor = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("../node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../node_modules/core-js/library/modules/_library.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/library/modules/_redefine.js");
var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
var $iterCreate = __webpack_require__("../node_modules/core-js/library/modules/_iter-create.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("../node_modules/core-js/library/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_library.js":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("../node_modules/core-js/library/modules/_uid.js")('meta');
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var setDesc = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("../node_modules/core-js/library/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_microtask.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var macrotask = __webpack_require__("../node_modules/core-js/library/modules/_task.js").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("../node_modules/core-js/library/modules/_cof.js")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_new-promise-capability.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js");
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var IObject = __webpack_require__("../node_modules/core-js/library/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("../node_modules/core-js/library/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var dPs = __webpack_require__("../node_modules/core-js/library/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/library/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("../node_modules/core-js/library/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("../node_modules/core-js/library/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var getKeys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");

module.exports = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js");
var createDesc = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/library/modules/_to-primitive.js");
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/library/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var gOPN = __webpack_require__("../node_modules/core-js/library/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("../node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var IE_PROTO = __webpack_require__("../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../node_modules/core-js/library/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/library/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var fails = __webpack_require__("../node_modules/core-js/library/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var isEnum = __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_perform.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_promise-resolve.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var newPromiseCapability = __webpack_require__("../node_modules/core-js/library/modules/_new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_redefine-all.js":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-collection-from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-collection-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__("../node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js");
var SPECIES = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var TAG = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("../node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("../node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");
var SPECIES = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../node_modules/core-js/library/modules/_to-integer.js");
var defined = __webpack_require__("../node_modules/core-js/library/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_task.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var invoke = __webpack_require__("../node_modules/core-js/library/modules/_invoke.js");
var html = __webpack_require__("../node_modules/core-js/library/modules/_html.js");
var cel = __webpack_require__("../node_modules/core-js/library/modules/_dom-create.js");
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("../node_modules/core-js/library/modules/_cof.js")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../node_modules/core-js/library/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../node_modules/core-js/library/modules/_iobject.js");
var defined = __webpack_require__("../node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("../node_modules/core-js/library/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_validate-collection.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var LIBRARY = __webpack_require__("../node_modules/core-js/library/modules/_library.js");
var wksExt = __webpack_require__("../node_modules/core-js/library/modules/_wks-ext.js");
var defineProperty = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("../node_modules/core-js/library/modules/_wks.js");


/***/ }),

/***/ "../node_modules/core-js/library/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("../node_modules/core-js/library/modules/_shared.js")('wks');
var uid = __webpack_require__("../node_modules/core-js/library/modules/_uid.js");
var Symbol = __webpack_require__("../node_modules/core-js/library/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "../node_modules/core-js/library/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/core.get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var get = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator-method.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/core.is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var call = __webpack_require__("../node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../node_modules/core-js/library/modules/_is-array-iter.js");
var toLength = __webpack_require__("../node_modules/core-js/library/modules/_to-length.js");
var createProperty = __webpack_require__("../node_modules/core-js/library/modules/_create-property.js");
var getIterFn = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/library/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("../node_modules/core-js/library/modules/_add-to-unscopables.js");
var step = __webpack_require__("../node_modules/core-js/library/modules/_iter-step.js");
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("../node_modules/core-js/library/modules/_collection-strong.js");
var validate = __webpack_require__("../node_modules/core-js/library/modules/_validate-collection.js");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_collection.js")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.number.is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");

$export($export.S, 'Number', { isInteger: __webpack_require__("../node_modules/core-js/library/modules/_is-integer.js") });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("../node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.create.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("../node_modules/core-js/library/modules/_object-create.js") });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/library/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var $getOwnPropertyDescriptor = __webpack_require__("../node_modules/core-js/library/modules/_object-gopd.js").f;

__webpack_require__("../node_modules/core-js/library/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("../node_modules/core-js/library/modules/_object-gpo.js");

__webpack_require__("../node_modules/core-js/library/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var $keys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");

__webpack_require__("../node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("../node_modules/core-js/library/modules/_set-proto.js").set });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.to-string.js":
/***/ (function(module, exports) {



/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../node_modules/core-js/library/modules/_library.js");
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var classof = __webpack_require__("../node_modules/core-js/library/modules/_classof.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");
var anInstance = __webpack_require__("../node_modules/core-js/library/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");
var speciesConstructor = __webpack_require__("../node_modules/core-js/library/modules/_species-constructor.js");
var task = __webpack_require__("../node_modules/core-js/library/modules/_task.js").set;
var microtask = __webpack_require__("../node_modules/core-js/library/modules/_microtask.js")();
var newPromiseCapabilityModule = __webpack_require__("../node_modules/core-js/library/modules/_new-promise-capability.js");
var perform = __webpack_require__("../node_modules/core-js/library/modules/_perform.js");
var promiseResolve = __webpack_require__("../node_modules/core-js/library/modules/_promise-resolve.js");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("../node_modules/core-js/library/modules/_wks.js")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("../node_modules/core-js/library/modules/_redefine-all.js")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js")($Promise, PROMISE);
__webpack_require__("../node_modules/core-js/library/modules/_set-species.js")(PROMISE);
Wrapper = __webpack_require__("../node_modules/core-js/library/modules/_core.js")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("../node_modules/core-js/library/modules/_iter-detect.js")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("../node_modules/core-js/library/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("../node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/library/modules/_redefine.js");
var META = __webpack_require__("../node_modules/core-js/library/modules/_meta.js").KEY;
var $fails = __webpack_require__("../node_modules/core-js/library/modules/_fails.js");
var shared = __webpack_require__("../node_modules/core-js/library/modules/_shared.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js");
var uid = __webpack_require__("../node_modules/core-js/library/modules/_uid.js");
var wks = __webpack_require__("../node_modules/core-js/library/modules/_wks.js");
var wksExt = __webpack_require__("../node_modules/core-js/library/modules/_wks-ext.js");
var wksDefine = __webpack_require__("../node_modules/core-js/library/modules/_wks-define.js");
var enumKeys = __webpack_require__("../node_modules/core-js/library/modules/_enum-keys.js");
var isArray = __webpack_require__("../node_modules/core-js/library/modules/_is-array.js");
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/library/modules/_to-primitive.js");
var createDesc = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");
var _create = __webpack_require__("../node_modules/core-js/library/modules/_object-create.js");
var gOPNExt = __webpack_require__("../node_modules/core-js/library/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("../node_modules/core-js/library/modules/_object-gopd.js");
var $DP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var $keys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("../node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
  __webpack_require__("../node_modules/core-js/library/modules/_object-gops.js").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("../node_modules/core-js/library/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("../node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.map.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("../node_modules/core-js/library/modules/_set-collection-from.js")('Map');


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.map.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("../node_modules/core-js/library/modules/_set-collection-of.js")('Map');


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.map.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("../node_modules/core-js/library/modules/_collection-to-json.js")('Map') });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var $values = __webpack_require__("../node_modules/core-js/library/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.promise.finally.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var speciesConstructor = __webpack_require__("../node_modules/core-js/library/modules/_species-constructor.js");
var promiseResolve = __webpack_require__("../node_modules/core-js/library/modules/_promise-resolve.js");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.promise.try.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var newPromiseCapability = __webpack_require__("../node_modules/core-js/library/modules/_new-promise-capability.js");
var perform = __webpack_require__("../node_modules/core-js/library/modules/_perform.js");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.symbol.observable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/_wks-define.js")('observable');


/***/ }),

/***/ "../node_modules/core-js/library/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.array.iterator.js");
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
var TO_STRING_TAG = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "../node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("../node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_an-instance.js":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-copy-within.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-fill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var asc = __webpack_require__("../node_modules/core-js/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var isArray = __webpack_require__("../node_modules/core-js/modules/_is-array.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var invoke = __webpack_require__("../node_modules/core-js/modules/_invoke.js");
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
var TAG = __webpack_require__("../node_modules/core-js/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_collection-strong.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/modules/_for-of.js");
var $iterDefine = __webpack_require__("../node_modules/core-js/modules/_iter-define.js");
var step = __webpack_require__("../node_modules/core-js/modules/_iter-step.js");
var setSpecies = __webpack_require__("../node_modules/core-js/modules/_set-species.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var fastKey = __webpack_require__("../node_modules/core-js/modules/_meta.js").fastKey;
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_collection-weak.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
var getWeak = __webpack_require__("../node_modules/core-js/modules/_meta.js").getWeak;
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/modules/_for-of.js");
var createArrayMethod = __webpack_require__("../node_modules/core-js/modules/_array-methods.js");
var $has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),

/***/ "../node_modules/core-js/modules/_collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js");
var forOf = __webpack_require__("../node_modules/core-js/modules/_for-of.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var $iterDetect = __webpack_require__("../node_modules/core-js/modules/_iter-detect.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var inheritIfRequired = __webpack_require__("../node_modules/core-js/modules/_inherit-if-required.js");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.4' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "../node_modules/core-js/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("../node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "../node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "../node_modules/core-js/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "../node_modules/core-js/modules/_fails-is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_fix-re-wks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
var wks = __webpack_require__("../node_modules/core-js/modules/_wks.js");

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_flags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_for-of.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var call = __webpack_require__("../node_modules/core-js/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../node_modules/core-js/modules/_is-array-iter.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var getIterFn = __webpack_require__("../node_modules/core-js/modules/core.get-iterator-method.js");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "../node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "../node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("../node_modules/core-js/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "../node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../node_modules/core-js/modules/_inherit-if-required.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var setPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_set-proto.js").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_invoke.js":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
var descriptor = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("../node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
var $iterCreate = __webpack_require__("../node_modules/core-js/modules/_iter-create.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "../node_modules/core-js/modules/_library.js":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "../node_modules/core-js/modules/_math-expm1.js":
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),

/***/ "../node_modules/core-js/modules/_math-fround.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__("../node_modules/core-js/modules/_math-sign.js");
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_math-log1p.js":
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_math-sign.js":
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("../node_modules/core-js/modules/_uid.js")('meta');
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var setDesc = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "../node_modules/core-js/modules/_microtask.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var macrotask = __webpack_require__("../node_modules/core-js/modules/_task.js").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("../node_modules/core-js/modules/_cof.js")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_new-promise-capability.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "../node_modules/core-js/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var dPs = __webpack_require__("../node_modules/core-js/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("../node_modules/core-js/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("../node_modules/core-js/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");

module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var gOPN = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "../node_modules/core-js/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var isEnum = __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_own-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js");
var gOPS = __webpack_require__("../node_modules/core-js/modules/_object-gops.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var Reflect = __webpack_require__("../node_modules/core-js/modules/_global.js").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_perform.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_promise-resolve.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var newPromiseCapability = __webpack_require__("../node_modules/core-js/modules/_new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_redefine-all.js":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("../node_modules/core-js/modules/_uid.js")('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("../node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "../node_modules/core-js/modules/_same-value.js":
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("../node_modules/core-js/modules/_ctx.js")(Function.call, __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "../node_modules/core-js/modules/_set-species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "../node_modules/core-js/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var TAG = __webpack_require__("../node_modules/core-js/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "../node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "../node_modules/core-js/modules/_species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_string-context.js":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_string-pad.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var repeat = __webpack_require__("../node_modules/core-js/modules/_string-repeat.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_string-repeat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_task.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var invoke = __webpack_require__("../node_modules/core-js/modules/_invoke.js");
var html = __webpack_require__("../node_modules/core-js/modules/_html.js");
var cel = __webpack_require__("../node_modules/core-js/modules/_dom-create.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("../node_modules/core-js/modules/_cof.js")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-index.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "../node_modules/core-js/modules/_typed-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__("../node_modules/core-js/modules/_descriptors.js")) {
  var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
  var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
  var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
  var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
  var $typed = __webpack_require__("../node_modules/core-js/modules/_typed.js");
  var $buffer = __webpack_require__("../node_modules/core-js/modules/_typed-buffer.js");
  var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
  var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
  var propertyDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
  var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
  var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
  var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
  var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
  var toIndex = __webpack_require__("../node_modules/core-js/modules/_to-index.js");
  var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
  var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
  var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
  var classof = __webpack_require__("../node_modules/core-js/modules/_classof.js");
  var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
  var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
  var isArrayIter = __webpack_require__("../node_modules/core-js/modules/_is-array-iter.js");
  var create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
  var getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
  var gOPN = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f;
  var getIterFn = __webpack_require__("../node_modules/core-js/modules/core.get-iterator-method.js");
  var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
  var wks = __webpack_require__("../node_modules/core-js/modules/_wks.js");
  var createArrayMethod = __webpack_require__("../node_modules/core-js/modules/_array-methods.js");
  var createArrayIncludes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js");
  var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_species-constructor.js");
  var ArrayIterators = __webpack_require__("../node_modules/core-js/modules/es6.array.iterator.js");
  var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
  var $iterDetect = __webpack_require__("../node_modules/core-js/modules/_iter-detect.js");
  var setSpecies = __webpack_require__("../node_modules/core-js/modules/_set-species.js");
  var arrayFill = __webpack_require__("../node_modules/core-js/modules/_array-fill.js");
  var arrayCopyWithin = __webpack_require__("../node_modules/core-js/modules/_array-copy-within.js");
  var $DP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
  var $GOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ "../node_modules/core-js/modules/_typed-buffer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
var $typed = __webpack_require__("../node_modules/core-js/modules/_typed.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var toIndex = __webpack_require__("../node_modules/core-js/modules/_to-index.js");
var gOPN = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f;
var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var arrayFill = __webpack_require__("../node_modules/core-js/modules/_array-fill.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),

/***/ "../node_modules/core-js/modules/_typed.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),

/***/ "../node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_user-agent.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "../node_modules/core-js/modules/_validate-collection.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
var wksExt = __webpack_require__("../node_modules/core-js/modules/_wks-ext.js");
var defineProperty = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "../node_modules/core-js/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("../node_modules/core-js/modules/_wks.js");


/***/ }),

/***/ "../node_modules/core-js/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("../node_modules/core-js/modules/_shared.js")('wks');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var Symbol = __webpack_require__("../node_modules/core-js/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "../node_modules/core-js/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../node_modules/core-js/modules/_classof.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.copy-within.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.P, 'Array', { copyWithin: __webpack_require__("../node_modules/core-js/modules/_array-copy-within.js") });

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('copyWithin');


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.fill.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.P, 'Array', { fill: __webpack_require__("../node_modules/core-js/modules/_array-fill.js") });

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('fill');


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.find-index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.find.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var call = __webpack_require__("../node_modules/core-js/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../node_modules/core-js/modules/_is-array-iter.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var createProperty = __webpack_require__("../node_modules/core-js/modules/_create-property.js");
var getIterFn = __webpack_require__("../node_modules/core-js/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js");
var step = __webpack_require__("../node_modules/core-js/modules/_iter-step.js");
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("../node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var createProperty = __webpack_require__("../node_modules/core-js/modules/_create-property.js");

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.function.name.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("../node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("../node_modules/core-js/modules/_collection-strong.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("../node_modules/core-js/modules/_collection.js")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.acosh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var log1p = __webpack_require__("../node_modules/core-js/modules/_math-log1p.js");
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.asinh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.atanh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.cbrt.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var sign = __webpack_require__("../node_modules/core-js/modules/_math-sign.js");

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.clz32.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.cosh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.expm1.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $expm1 = __webpack_require__("../node_modules/core-js/modules/_math-expm1.js");

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.fround.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { fround: __webpack_require__("../node_modules/core-js/modules/_math-fround.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.hypot.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.imul.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.log10.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.log1p.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { log1p: __webpack_require__("../node_modules/core-js/modules/_math-log1p.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.log2.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.sign.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { sign: __webpack_require__("../node_modules/core-js/modules/_math-sign.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.sinh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var expm1 = __webpack_require__("../node_modules/core-js/modules/_math-expm1.js");
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.tanh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var expm1 = __webpack_require__("../node_modules/core-js/modules/_math-expm1.js");
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.trunc.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.epsilon.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.is-finite.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var _isFinite = __webpack_require__("../node_modules/core-js/modules/_global.js").isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { isInteger: __webpack_require__("../node_modules/core-js/modules/_is-integer.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.is-nan.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.is-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var isInteger = __webpack_require__("../node_modules/core-js/modules/_is-integer.js");
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.max-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.min-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("../node_modules/core-js/modules/_object-assign.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.freeze.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var $getOwnPropertyDescriptor = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f;

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('getOwnPropertyNames', function () {
  return __webpack_require__("../node_modules/core-js/modules/_object-gopn-ext.js").f;
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.is-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.is-frozen.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.is-sealed.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.is.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
$export($export.S, 'Object', { is: __webpack_require__("../node_modules/core-js/modules/_same-value.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.prevent-extensions.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.seal.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("../node_modules/core-js/modules/_set-proto.js").set });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var classof = __webpack_require__("../node_modules/core-js/modules/_classof.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/modules/_for-of.js");
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_species-constructor.js");
var task = __webpack_require__("../node_modules/core-js/modules/_task.js").set;
var microtask = __webpack_require__("../node_modules/core-js/modules/_microtask.js")();
var newPromiseCapabilityModule = __webpack_require__("../node_modules/core-js/modules/_new-promise-capability.js");
var perform = __webpack_require__("../node_modules/core-js/modules/_perform.js");
var promiseResolve = __webpack_require__("../node_modules/core-js/modules/_promise-resolve.js");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("../node_modules/core-js/modules/_wks.js")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js")($Promise, PROMISE);
__webpack_require__("../node_modules/core-js/modules/_set-species.js")(PROMISE);
Wrapper = __webpack_require__("../node_modules/core-js/modules/_core.js")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("../node_modules/core-js/modules/_iter-detect.js")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.apply.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var rApply = (__webpack_require__("../node_modules/core-js/modules/_global.js").Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.construct.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var bind = __webpack_require__("../node_modules/core-js/modules/_bind.js");
var rConstruct = (__webpack_require__("../node_modules/core-js/modules/_global.js").Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.delete-property.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f;
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var getProto = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.get.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.has.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.is-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.own-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Reflect', { ownKeys: __webpack_require__("../node_modules/core-js/modules/_own-keys.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.prevent-extensions.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var setProto = __webpack_require__("../node_modules/core-js/modules/_set-proto.js");

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.set.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.flags.js":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && /./g.flags != 'g') __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("../node_modules/core-js/modules/_flags.js")
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.match.js":
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.replace.js":
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.search.js":
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.split.js":
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js");
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.set.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("../node_modules/core-js/modules/_collection-strong.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("../node_modules/core-js/modules/_collection.js")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.code-point-at.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $at = __webpack_require__("../node_modules/core-js/modules/_string-at.js")(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.ends-with.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.from-code-point.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.includes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.raw.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.repeat.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__("../node_modules/core-js/modules/_string-repeat.js")
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.starts-with.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var META = __webpack_require__("../node_modules/core-js/modules/_meta.js").KEY;
var $fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var wks = __webpack_require__("../node_modules/core-js/modules/_wks.js");
var wksExt = __webpack_require__("../node_modules/core-js/modules/_wks-ext.js");
var wksDefine = __webpack_require__("../node_modules/core-js/modules/_wks-define.js");
var enumKeys = __webpack_require__("../node_modules/core-js/modules/_enum-keys.js");
var isArray = __webpack_require__("../node_modules/core-js/modules/_is-array.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
var _create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
var gOPNExt = __webpack_require__("../node_modules/core-js/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var $DP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f = $propertyIsEnumerable;
  __webpack_require__("../node_modules/core-js/modules/_object-gops.js").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("../node_modules/core-js/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("../node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.array-buffer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $typed = __webpack_require__("../node_modules/core-js/modules/_typed.js");
var buffer = __webpack_require__("../node_modules/core-js/modules/_typed-buffer.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var ArrayBuffer = __webpack_require__("../node_modules/core-js/modules/_global.js").ArrayBuffer;
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_species-constructor.js");
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__("../node_modules/core-js/modules/_set-species.js")(ARRAY_BUFFER);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.data-view.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
$export($export.G + $export.W + $export.F * !__webpack_require__("../node_modules/core-js/modules/_typed.js").ABV, {
  DataView: __webpack_require__("../node_modules/core-js/modules/_typed-buffer.js").DataView
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.float32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.float64-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.int16-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.int32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.int8-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.uint16-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.uint32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.uint8-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.uint8-clamped-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.weak-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(0);
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js");
var assign = __webpack_require__("../node_modules/core-js/modules/_object-assign.js");
var weak = __webpack_require__("../node_modules/core-js/modules/_collection-weak.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__("../node_modules/core-js/modules/_collection.js")(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),

/***/ "../node_modules/core-js/modules/es6.weak-set.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__("../node_modules/core-js/modules/_collection-weak.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__("../node_modules/core-js/modules/_collection.js")(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),

/***/ "../node_modules/core-js/modules/es7.array.includes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $includes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('includes');


/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $entries = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.get-own-property-descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var ownKeys = __webpack_require__("../node_modules/core-js/modules/_own-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var createProperty = __webpack_require__("../node_modules/core-js/modules/_create-property.js");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $values = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es7.string.pad-end.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $pad = __webpack_require__("../node_modules/core-js/modules/_string-pad.js");
var userAgent = __webpack_require__("../node_modules/core-js/modules/_user-agent.js");

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es7.string.pad-start.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $pad = __webpack_require__("../node_modules/core-js/modules/_string-pad.js");
var userAgent = __webpack_require__("../node_modules/core-js/modules/_user-agent.js");

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("../node_modules/core-js/modules/es6.array.iterator.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
var wks = __webpack_require__("../node_modules/core-js/modules/_wks.js");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "../node_modules/core-js/modules/web.immediate.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $task = __webpack_require__("../node_modules/core-js/modules/_task.js");
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),

/***/ "../node_modules/core-js/modules/web.timers.js":
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var userAgent = __webpack_require__("../node_modules/core-js/modules/_user-agent.js");
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),

/***/ "../node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("../node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "../node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("../node_modules/ms/index.js");

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ "../node_modules/define-properties/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__("../node_modules/object-keys/index.js");
var foreach = __webpack_require__("../node_modules/foreach/index.js");
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ "../node_modules/details-polyfill/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;void (function (root, factory) {
  if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if (typeof exports === 'object') module.exports = factory()
  else factory()
}(this, function () {
  var DETAILS = 'details'
  var SUMMARY = 'summary'

  var supported = checkSupport()
  if (supported) return

  // Add a classname
  document.documentElement.className += ' no-details'

  window.addEventListener('click', clickHandler)

  injectStyle('details-polyfill-style',
    'html.no-details ' + DETAILS + ':not([open]) > :not(' + SUMMARY + ') { display: none; }\n' +
    'html.no-details ' + DETAILS + ' > ' + SUMMARY + ':before { content: "\u25b6"; display: inline-block; font-size: .8em; width: 1.5em; }\n' +
    'html.no-details ' + DETAILS + '[open] > ' + SUMMARY + ':before { content: "\u25bc"; }')

  /*
   * Click handler for `<summary>` tags
   */

  function clickHandler (e) {
    if (e.target.nodeName.toLowerCase() === 'summary') {
      var details = e.target.parentNode
      if (!details) return

      if (details.getAttribute('open')) {
        details.open = false
        details.removeAttribute('open')
      } else {
        details.open = true
        details.setAttribute('open', 'open')
      }
    }
  }

  /*
   * Checks for support for `<details>`
   */

  function checkSupport () {
    var el = document.createElement(DETAILS)
    if (!('open' in el)) return false

    el.innerHTML = '<' + SUMMARY + '>a</' + SUMMARY + '>b'
    document.body.appendChild(el)

    var diff = el.offsetHeight
    el.open = true
    var result = (diff != el.offsetHeight)

    document.body.removeChild(el)
    return result
  }

  /*
   * Injects styles (idempotent)
   */

  function injectStyle (id, style) {
    if (document.getElementById(id)) return

    var el = document.createElement('style')
    el.id = id
    el.innerHTML = style

    document.getElementsByTagName('head')[0].appendChild(el)
  }
})); // eslint-disable-line semi


/***/ }),

/***/ "../node_modules/dom-helpers/class/addClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__("../node_modules/dom-helpers/class/hasClass.js");

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/dom-helpers/class/hasClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),

/***/ "../node_modules/dom-helpers/class/removeClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ "../node_modules/es-abstract/es5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__("../node_modules/es-abstract/helpers/isNaN.js");
var $isFinite = __webpack_require__("../node_modules/es-abstract/helpers/isFinite.js");

var sign = __webpack_require__("../node_modules/es-abstract/helpers/sign.js");
var mod = __webpack_require__("../node_modules/es-abstract/helpers/mod.js");

var IsCallable = __webpack_require__("../node_modules/is-callable/index.js");
var toPrimitive = __webpack_require__("../node_modules/es-to-primitive/es5.js");

var has = __webpack_require__("../node_modules/has/src/index.js");

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};
		// jscs:disable
		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}
		// jscs:enable
		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),

/***/ "../node_modules/es-abstract/helpers/isFinite.js":
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),

/***/ "../node_modules/es-abstract/helpers/isNaN.js":
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ "../node_modules/es-abstract/helpers/mod.js":
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),

/***/ "../node_modules/es-abstract/helpers/sign.js":
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),

/***/ "../node_modules/es-to-primitive/es5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__("../node_modules/es-to-primitive/helpers/isPrimitive.js");

var isCallable = __webpack_require__("../node_modules/is-callable/index.js");

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),

/***/ "../node_modules/es-to-primitive/helpers/isPrimitive.js":
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),

/***/ "../node_modules/fbemitter/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var fbemitter = {
  EventEmitter: __webpack_require__("../node_modules/fbemitter/lib/BaseEventEmitter.js"),
  EmitterSubscription : __webpack_require__("../node_modules/fbemitter/lib/EmitterSubscription.js")
};

module.exports = fbemitter;


/***/ }),

/***/ "../node_modules/fbemitter/lib/BaseEventEmitter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BaseEventEmitter
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EmitterSubscription = __webpack_require__("../node_modules/fbemitter/lib/EmitterSubscription.js");
var EventSubscriptionVendor = __webpack_require__("../node_modules/fbemitter/lib/EventSubscriptionVendor.js");

var emptyFunction = __webpack_require__("../node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("../node_modules/fbjs/lib/invariant.js");

/**
 * @class BaseEventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */

var BaseEventEmitter = (function () {
  /**
   * @constructor
   */

  function BaseEventEmitter() {
    _classCallCheck(this, BaseEventEmitter);

    this._subscriber = new EventSubscriptionVendor();
    this._currentSubscription = null;
  }

  /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
    return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
  };

  /**
   * Similar to addListener, except that the listener is removed after it is
   * invoked once.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke only once when the
   *   specified event is emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.once = function once(eventType, listener, context) {
    var emitter = this;
    return this.addListener(eventType, function () {
      emitter.removeCurrentListener();
      listener.apply(context, arguments);
    });
  };

  /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */

  BaseEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
    this._subscriber.removeAllSubscriptions(eventType);
  };

  /**
   * Provides an API that can be called during an eventing cycle to remove the
   * last listener that was invoked. This allows a developer to provide an event
   * object that can remove the listener (or listener map) during the
   * invocation.
   *
   * If it is called when not inside of an emitting cycle it will throw.
   *
   * @throws {Error} When called not during an eventing cycle
   *
   * @example
   *   var subscription = emitter.addListenerMap({
   *     someEvent: function(data, event) {
   *       console.log(data);
   *       emitter.removeCurrentListener();
   *     }
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   *   emitter.emit('someEvent', 'def'); // does not log anything
   */

  BaseEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
    !!!this._currentSubscription ?  false ? invariant(false, 'Not in an emitting cycle; there is no current subscription') : invariant(false) : undefined;
    this._subscriber.removeSubscription(this._currentSubscription);
  };

  /**
   * Returns an array of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @return {array}
   */

  BaseEventEmitter.prototype.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */{
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    return subscriptions ? subscriptions.filter(emptyFunction.thatReturnsTrue).map(function (subscription) {
      return subscription.listener;
    }) : [];
  };

  /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */

  BaseEventEmitter.prototype.emit = function emit(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    if (subscriptions) {
      var keys = Object.keys(subscriptions);
      for (var ii = 0; ii < keys.length; ii++) {
        var key = keys[ii];
        var subscription = subscriptions[key];
        // The subscription may have been removed during this event loop.
        if (subscription) {
          this._currentSubscription = subscription;
          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
        }
      }
      this._currentSubscription = null;
    }
  };

  /**
   * Provides a hook to override how the emitter emits an event to a specific
   * subscription. This allows you to set up logging and error boundaries
   * specific to your environment.
   *
   * @param {EmitterSubscription} subscription
   * @param {string} eventType
   * @param {*} Arbitrary arguments to be passed to each registered listener
   */

  BaseEventEmitter.prototype.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
    var args = Array.prototype.slice.call(arguments, 2);
    subscription.listener.apply(subscription.context, args);
  };

  return BaseEventEmitter;
})();

module.exports = BaseEventEmitter;

/***/ }),

/***/ "../node_modules/fbemitter/lib/EmitterSubscription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EmitterSubscription
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventSubscription = __webpack_require__("../node_modules/fbemitter/lib/EventSubscription.js");

/**
 * EmitterSubscription represents a subscription with listener and context data.
 */

var EmitterSubscription = (function (_EventSubscription) {
  _inherits(EmitterSubscription, _EventSubscription);

  /**
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  function EmitterSubscription(subscriber, listener, context) {
    _classCallCheck(this, EmitterSubscription);

    _EventSubscription.call(this, subscriber);
    this.listener = listener;
    this.context = context;
  }

  return EmitterSubscription;
})(EventSubscription);

module.exports = EmitterSubscription;

/***/ }),

/***/ "../node_modules/fbemitter/lib/EventSubscription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventSubscription
 * @typechecks
 */



/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EventSubscription = (function () {

  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */

  function EventSubscription(subscriber) {
    _classCallCheck(this, EventSubscription);

    this.subscriber = subscriber;
  }

  /**
   * Removes this subscription from the subscriber that controls it.
   */

  EventSubscription.prototype.remove = function remove() {
    if (this.subscriber) {
      this.subscriber.removeSubscription(this);
      this.subscriber = null;
    }
  };

  return EventSubscription;
})();

module.exports = EventSubscription;

/***/ }),

/***/ "../node_modules/fbemitter/lib/EventSubscriptionVendor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EventSubscriptionVendor
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var invariant = __webpack_require__("../node_modules/fbjs/lib/invariant.js");

/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */

var EventSubscriptionVendor = (function () {
  function EventSubscriptionVendor() {
    _classCallCheck(this, EventSubscriptionVendor);

    this._subscriptionsForType = {};
    this._currentSubscription = null;
  }

  /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */

  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
    !(subscription.subscriber === this) ?  false ? invariant(false, 'The subscriber of the subscription is incorrectly set.') : invariant(false) : undefined;
    if (!this._subscriptionsForType[eventType]) {
      this._subscriptionsForType[eventType] = [];
    }
    var key = this._subscriptionsForType[eventType].length;
    this._subscriptionsForType[eventType].push(subscription);
    subscription.eventType = eventType;
    subscription.key = key;
    return subscription;
  };

  /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */

  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
    if (eventType === undefined) {
      this._subscriptionsForType = {};
    } else {
      delete this._subscriptionsForType[eventType];
    }
  };

  /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */

  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
    var eventType = subscription.eventType;
    var key = subscription.key;

    var subscriptionsForType = this._subscriptionsForType[eventType];
    if (subscriptionsForType) {
      delete subscriptionsForType[key];
    }
  };

  /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @return {?array}
   */

  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
    return this._subscriptionsForType[eventType];
  };

  return EventSubscriptionVendor;
})();

module.exports = EventSubscriptionVendor;

/***/ }),

/***/ "../node_modules/fbjs/lib/emptyFunction.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/fbjs/lib/emptyFunction.js");

/***/ }),

/***/ "../node_modules/fbjs/lib/invariant.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/fbjs/lib/invariant.js");

/***/ }),

/***/ "../node_modules/for-each/index.js":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("../node_modules/is-function/index.js")

module.exports = forEach

var toString = Object.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty

function forEach(list, iterator, context) {
    if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function')
    }

    if (arguments.length < 3) {
        context = this
    }
    
    if (toString.call(list) === '[object Array]')
        forEachArray(list, iterator, context)
    else if (typeof list === 'string')
        forEachString(list, iterator, context)
    else
        forEachObject(list, iterator, context)
}

function forEachArray(array, iterator, context) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            iterator.call(context, array[i], i, array)
        }
    }
}

function forEachString(string, iterator, context) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        iterator.call(context, string.charAt(i), i, string)
    }
}

function forEachObject(object, iterator, context) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            iterator.call(context, object[k], k, object)
        }
    }
}


/***/ }),

/***/ "../node_modules/foreach/index.js":
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),

/***/ "../node_modules/function-bind/implementation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ "../node_modules/function-bind/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("../node_modules/function-bind/implementation.js");

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "../node_modules/has/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("../node_modules/function-bind/index.js");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ "../node_modules/ieee754/index.js":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "../node_modules/inobounce/inobounce.js":
/***/ (function(module, exports) {

/*! iNoBounce - v0.1.6
* https://github.com/lazd/iNoBounce/
* Copyright (c) 2013 Larry Davis <lazdnet@gmail.com>; Licensed BSD */
(function(global) {
	// Stores the Y position where the touch started
	var startY = 0;

	// Store enabled status
	var enabled = false;

	var supportsPassiveOption = false;
	try {
		var opts = Object.defineProperty({}, 'passive', {
			get: function() {
				supportsPassiveOption = true;
			}
		});
		window.addEventListener('test', null, opts);
	} catch (e) {}

	var handleTouchmove = function(evt) {
		// Get the element that was scrolled upon
		var el = evt.target;

		// Check all parent elements for scrollability
		while (el !== document.body && el !== document) {
			// Get some style properties
			var style = window.getComputedStyle(el);

			if (!style) {
				// If we've encountered an element we can't compute the style for, get out
				break;
			}

			// Ignore range input element
			if (el.nodeName === 'INPUT' && el.getAttribute('type') === 'range') {
				return;
			}

			var scrolling = style.getPropertyValue('-webkit-overflow-scrolling');
			var overflowY = style.getPropertyValue('overflow-y');
			var height = parseInt(style.getPropertyValue('height'), 10);

			// Determine if the element should scroll
			var isScrollable = scrolling === 'touch' && (overflowY === 'auto' || overflowY === 'scroll');
			var canScroll = el.scrollHeight > el.offsetHeight;

			if (isScrollable && canScroll) {
				// Get the current Y position of the touch
				var curY = evt.touches ? evt.touches[0].screenY : evt.screenY;

				// Determine if the user is trying to scroll past the top or bottom
				// In this case, the window will bounce, so we have to prevent scrolling completely
				var isAtTop = (startY <= curY && el.scrollTop === 0);
				var isAtBottom = (startY >= curY && el.scrollHeight - el.scrollTop === height);

				// Stop a bounce bug when at the bottom or top of the scrollable element
				if (isAtTop || isAtBottom) {
					evt.preventDefault();
				}

				// No need to continue up the DOM, we've done our job
				return;
			}

			// Test the next parent
			el = el.parentNode;
		}

		// Stop the bouncing -- no parents are scrollable
		evt.preventDefault();
	};

	var handleTouchstart = function(evt) {
		// Store the first Y position of the touch
		startY = evt.touches ? evt.touches[0].screenY : evt.screenY;
	};

	var enable = function() {
		// Listen to a couple key touch events
		window.addEventListener('touchstart', handleTouchstart, supportsPassiveOption ? { passive : false } : false);
		window.addEventListener('touchmove', handleTouchmove, supportsPassiveOption ? { passive : false } : false);
		enabled = true;
	};

	var disable = function() {
		// Stop listening
		window.removeEventListener('touchstart', handleTouchstart, false);
		window.removeEventListener('touchmove', handleTouchmove, false);
		enabled = false;
	};

	var isEnabled = function() {
		return enabled;
	};

	// Enable by default if the browser supports -webkit-overflow-scrolling
	// Test this by setting the property with JavaScript on an element that exists in the DOM
	// Then, see if the property is reflected in the computed style
	var testDiv = document.createElement('div');
	document.documentElement.appendChild(testDiv);
	testDiv.style.WebkitOverflowScrolling = 'touch';
	var scrollSupport = 'getComputedStyle' in window && window.getComputedStyle(testDiv)['-webkit-overflow-scrolling'] === 'touch';
	document.documentElement.removeChild(testDiv);

	if (scrollSupport) {
		enable();
	}

	// A module to support enabling/disabling iNoBounce
	var iNoBounce = {
		enable: enable,
		disable: disable,
		isEnabled: isEnabled
	};

	if (typeof module !== 'undefined' && module.exports) {
		// Node.js Support
		module.exports = iNoBounce;
	}
	if (typeof global.define === 'function') {
		// AMD Support
		(function(define) {
			define('iNoBounce', [], function() { return iNoBounce; });
		}(global.define));
	}
	else {
		// Browser support
		global.iNoBounce = iNoBounce;
	}
}(this));


/***/ }),

/***/ "../node_modules/is-callable/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),

/***/ "../node_modules/is-function/index.js":
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),

/***/ "../node_modules/isarray/index.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "../node_modules/isomorphic-fetch/fetch-npm-browserify.js":
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__("../node_modules/whatwg-fetch/fetch.js");
module.exports = self.fetch.bind(self);


/***/ }),

/***/ "../node_modules/js-cookie/src/js.cookie.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/js-cookie/src/js.cookie.js");

/***/ }),

/***/ "../node_modules/json-stringify-safe/stringify.js":
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),

/***/ "../node_modules/lodash-es/isPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/lodash-es/isPlainObject.js");

/***/ }),

/***/ "../node_modules/lodash.keys/index.js":
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "../node_modules/lodash/_SetCache.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("../node_modules/lodash/isArray.js");

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),

/***/ "../node_modules/lodash/_Stack.js":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("../node_modules/lodash/_listCacheClear.js"),
    listCacheDelete = __webpack_require__("../node_modules/lodash/_listCacheDelete.js"),
    listCacheGet = __webpack_require__("../node_modules/lodash/_listCacheGet.js"),
    listCacheHas = __webpack_require__("../node_modules/lodash/_listCacheHas.js"),
    listCacheSet = __webpack_require__("../node_modules/lodash/_listCacheSet.js");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "../node_modules/lodash/_Uint8Array.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("../node_modules/lodash/_root.js");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "../node_modules/lodash/_apply.js":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "../node_modules/lodash/_arrayMap.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "../node_modules/lodash/_arraySome.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "../node_modules/lodash/_assignMergeValue.js":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("../node_modules/lodash/_baseAssignValue.js"),
    eq = __webpack_require__("../node_modules/lodash/eq.js");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "../node_modules/lodash/_assignValue.js":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("../node_modules/lodash/_baseAssignValue.js"),
    eq = __webpack_require__("../node_modules/lodash/eq.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "../node_modules/lodash/_assocIndexOf.js":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("../node_modules/lodash/eq.js");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "../node_modules/lodash/_baseAssignValue.js":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("../node_modules/lodash/_defineProperty.js");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "../node_modules/lodash/_baseCreate.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/lodash/isObject.js");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "../node_modules/lodash/_baseFor.js":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("../node_modules/lodash/_createBaseFor.js");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "../node_modules/lodash/_baseGet.js":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("../node_modules/lodash/_castPath.js"),
    toKey = __webpack_require__("../node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "../node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "../node_modules/lodash/_baseHasIn.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "../node_modules/lodash/_baseIndexOf.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "../node_modules/lodash/_baseIsEqual.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("../node_modules/lodash/_baseIsEqualDeep.js"),
    isObjectLike = __webpack_require__("../node_modules/lodash/isObjectLike.js");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "../node_modules/lodash/_baseIsEqualDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("../node_modules/lodash/_Stack.js"),
    equalArrays = __webpack_require__("../node_modules/lodash/_equalArrays.js"),
    equalByTag = __webpack_require__("../node_modules/lodash/_equalByTag.js"),
    equalObjects = __webpack_require__("../node_modules/lodash/_equalObjects.js"),
    getTag = __webpack_require__("../node_modules/lodash/_getTag.js"),
    isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__("../node_modules/lodash/isBuffer.js"),
    isTypedArray = __webpack_require__("../node_modules/lodash/isTypedArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "../node_modules/lodash/_baseIsMatch.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("../node_modules/lodash/_Stack.js"),
    baseIsEqual = __webpack_require__("../node_modules/lodash/_baseIsEqual.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "../node_modules/lodash/_baseIteratee.js":
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__("../node_modules/lodash/_baseMatches.js"),
    baseMatchesProperty = __webpack_require__("../node_modules/lodash/_baseMatchesProperty.js"),
    identity = __webpack_require__("../node_modules/lodash/identity.js"),
    isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    property = __webpack_require__("../node_modules/lodash/property.js");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "../node_modules/lodash/_baseMap.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "../node_modules/lodash/_baseMatches.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("../node_modules/lodash/_baseIsMatch.js"),
    getMatchData = __webpack_require__("../node_modules/lodash/_getMatchData.js"),
    matchesStrictComparable = __webpack_require__("../node_modules/lodash/_matchesStrictComparable.js");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "../node_modules/lodash/_baseMatchesProperty.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("../node_modules/lodash/_baseIsEqual.js"),
    get = __webpack_require__("../node_modules/lodash/get.js"),
    hasIn = __webpack_require__("../node_modules/lodash/hasIn.js"),
    isKey = __webpack_require__("../node_modules/lodash/_isKey.js"),
    isStrictComparable = __webpack_require__("../node_modules/lodash/_isStrictComparable.js"),
    matchesStrictComparable = __webpack_require__("../node_modules/lodash/_matchesStrictComparable.js"),
    toKey = __webpack_require__("../node_modules/lodash/_toKey.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "../node_modules/lodash/_baseMerge.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("../node_modules/lodash/_Stack.js"),
    assignMergeValue = __webpack_require__("../node_modules/lodash/_assignMergeValue.js"),
    baseFor = __webpack_require__("../node_modules/lodash/_baseFor.js"),
    baseMergeDeep = __webpack_require__("../node_modules/lodash/_baseMergeDeep.js"),
    isObject = __webpack_require__("../node_modules/lodash/isObject.js"),
    keysIn = __webpack_require__("../node_modules/lodash/keysIn.js"),
    safeGet = __webpack_require__("../node_modules/lodash/_safeGet.js");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "../node_modules/lodash/_baseMergeDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__("../node_modules/lodash/_assignMergeValue.js"),
    cloneBuffer = __webpack_require__("../node_modules/lodash/_cloneBuffer.js"),
    cloneTypedArray = __webpack_require__("../node_modules/lodash/_cloneTypedArray.js"),
    copyArray = __webpack_require__("../node_modules/lodash/_copyArray.js"),
    initCloneObject = __webpack_require__("../node_modules/lodash/_initCloneObject.js"),
    isArguments = __webpack_require__("../node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    isArrayLikeObject = __webpack_require__("../node_modules/lodash/isArrayLikeObject.js"),
    isBuffer = __webpack_require__("../node_modules/lodash/isBuffer.js"),
    isFunction = __webpack_require__("../node_modules/lodash/isFunction.js"),
    isObject = __webpack_require__("../node_modules/lodash/isObject.js"),
    isPlainObject = __webpack_require__("../node_modules/lodash/isPlainObject.js"),
    isTypedArray = __webpack_require__("../node_modules/lodash/isTypedArray.js"),
    safeGet = __webpack_require__("../node_modules/lodash/_safeGet.js"),
    toPlainObject = __webpack_require__("../node_modules/lodash/toPlainObject.js");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "../node_modules/lodash/_baseOrderBy.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("../node_modules/lodash/_arrayMap.js"),
    baseIteratee = __webpack_require__("../node_modules/lodash/_baseIteratee.js"),
    baseMap = __webpack_require__("../node_modules/lodash/_baseMap.js"),
    baseSortBy = __webpack_require__("../node_modules/lodash/_baseSortBy.js"),
    baseUnary = __webpack_require__("../node_modules/lodash/_baseUnary.js"),
    compareMultiple = __webpack_require__("../node_modules/lodash/_compareMultiple.js"),
    identity = __webpack_require__("../node_modules/lodash/identity.js");

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ "../node_modules/lodash/_baseProperty.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "../node_modules/lodash/_basePropertyDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("../node_modules/lodash/_baseGet.js");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "../node_modules/lodash/_baseRest.js":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("../node_modules/lodash/identity.js"),
    overRest = __webpack_require__("../node_modules/lodash/_overRest.js"),
    setToString = __webpack_require__("../node_modules/lodash/_setToString.js");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "../node_modules/lodash/_baseSortBy.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ "../node_modules/lodash/_baseUnary.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "../node_modules/lodash/_cacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("../node_modules/lodash/_baseIndexOf.js");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "../node_modules/lodash/_castPath.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    isKey = __webpack_require__("../node_modules/lodash/_isKey.js"),
    stringToPath = __webpack_require__("../node_modules/lodash/_stringToPath.js"),
    toString = __webpack_require__("../node_modules/lodash/toString.js");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "../node_modules/lodash/_cloneArrayBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("../node_modules/lodash/_Uint8Array.js");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "../node_modules/lodash/_cloneBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("../node_modules/lodash/_root.js");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../node_modules/lodash/_cloneTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("../node_modules/lodash/_cloneArrayBuffer.js");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "../node_modules/lodash/_compareAscending.js":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("../node_modules/lodash/isSymbol.js");

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ "../node_modules/lodash/_compareMultiple.js":
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__("../node_modules/lodash/_compareAscending.js");

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ "../node_modules/lodash/_copyArray.js":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "../node_modules/lodash/_copyObject.js":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("../node_modules/lodash/_assignValue.js"),
    baseAssignValue = __webpack_require__("../node_modules/lodash/_baseAssignValue.js");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "../node_modules/lodash/_createAssigner.js":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("../node_modules/lodash/_baseRest.js"),
    isIterateeCall = __webpack_require__("../node_modules/lodash/_isIterateeCall.js");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "../node_modules/lodash/_createBaseFor.js":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "../node_modules/lodash/_defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("../node_modules/lodash/_getNative.js");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "../node_modules/lodash/_equalArrays.js":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("../node_modules/lodash/_SetCache.js"),
    arraySome = __webpack_require__("../node_modules/lodash/_arraySome.js"),
    cacheHas = __webpack_require__("../node_modules/lodash/_cacheHas.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "../node_modules/lodash/_equalByTag.js":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "../node_modules/lodash/_equalObjects.js":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("../node_modules/lodash/_getAllKeys.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "../node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/lodash/_getAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("../node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "../node_modules/lodash/_getMatchData.js":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("../node_modules/lodash/_isStrictComparable.js"),
    keys = __webpack_require__("../node_modules/lodash/keys.js");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "../node_modules/lodash/_getNative.js":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "../node_modules/lodash/_getPrototype.js":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("../node_modules/lodash/_overArg.js");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "../node_modules/lodash/_getTag.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "../node_modules/lodash/_hasPath.js":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("../node_modules/lodash/_castPath.js"),
    isArguments = __webpack_require__("../node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    isIndex = __webpack_require__("../node_modules/lodash/_isIndex.js"),
    isLength = __webpack_require__("../node_modules/lodash/isLength.js"),
    toKey = __webpack_require__("../node_modules/lodash/_toKey.js");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "../node_modules/lodash/_initCloneObject.js":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("../node_modules/lodash/_baseCreate.js"),
    getPrototype = __webpack_require__("../node_modules/lodash/_getPrototype.js"),
    isPrototype = __webpack_require__("../node_modules/lodash/_isPrototype.js");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "../node_modules/lodash/_isIndex.js":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "../node_modules/lodash/_isIterateeCall.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/_isKey.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("../node_modules/lodash/isSymbol.js");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "../node_modules/lodash/_isPrototype.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/_isStrictComparable.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/lodash/isObject.js");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "../node_modules/lodash/_listCacheClear.js":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "../node_modules/lodash/_listCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("../node_modules/lodash/_assocIndexOf.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "../node_modules/lodash/_listCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("../node_modules/lodash/_assocIndexOf.js");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "../node_modules/lodash/_listCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("../node_modules/lodash/_assocIndexOf.js");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "../node_modules/lodash/_listCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("../node_modules/lodash/_assocIndexOf.js");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "../node_modules/lodash/_matchesStrictComparable.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "../node_modules/lodash/_memoizeCapped.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash/_overArg.js":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "../node_modules/lodash/_overRest.js":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("../node_modules/lodash/_apply.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "../node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("../node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "../node_modules/lodash/_safeGet.js":
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "../node_modules/lodash/_setToString.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash/_stringToPath.js":
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__("../node_modules/lodash/_memoizeCapped.js");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "../node_modules/lodash/_toKey.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/lodash/isObject.js"),
    now = __webpack_require__("../node_modules/lodash/now.js"),
    toNumber = __webpack_require__("../node_modules/lodash/toNumber.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "../node_modules/lodash/eq.js":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "../node_modules/lodash/get.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("../node_modules/lodash/_baseGet.js");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "../node_modules/lodash/hasIn.js":
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__("../node_modules/lodash/_baseHasIn.js"),
    hasPath = __webpack_require__("../node_modules/lodash/_hasPath.js");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "../node_modules/lodash/identity.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash/isArguments.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/isArray.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "../node_modules/lodash/isArrayLike.js":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("../node_modules/lodash/isFunction.js"),
    isLength = __webpack_require__("../node_modules/lodash/isLength.js");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "../node_modules/lodash/isArrayLikeObject.js":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("../node_modules/lodash/isArrayLike.js"),
    isObjectLike = __webpack_require__("../node_modules/lodash/isObjectLike.js");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "../node_modules/lodash/isBuffer.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/isFunction.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("../node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__("../node_modules/lodash/isObject.js");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "../node_modules/lodash/isLength.js":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "../node_modules/lodash/isObject.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "../node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "../node_modules/lodash/isPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("../node_modules/lodash/_baseGetTag.js"),
    getPrototype = __webpack_require__("../node_modules/lodash/_getPrototype.js"),
    isObjectLike = __webpack_require__("../node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "../node_modules/lodash/isSymbol.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/isTypedArray.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/keys.js":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("../node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "../node_modules/lodash/keysIn.js":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "../node_modules/lodash/merge.js":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("../node_modules/lodash/_baseMerge.js"),
    createAssigner = __webpack_require__("../node_modules/lodash/_createAssigner.js");

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ "../node_modules/lodash/now.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("../node_modules/lodash/_root.js");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "../node_modules/lodash/orderBy.js":
/***/ (function(module, exports, __webpack_require__) {

var baseOrderBy = __webpack_require__("../node_modules/lodash/_baseOrderBy.js"),
    isArray = __webpack_require__("../node_modules/lodash/isArray.js");

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),

/***/ "../node_modules/lodash/property.js":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("../node_modules/lodash/_baseProperty.js"),
    basePropertyDeep = __webpack_require__("../node_modules/lodash/_basePropertyDeep.js"),
    isKey = __webpack_require__("../node_modules/lodash/_isKey.js"),
    toKey = __webpack_require__("../node_modules/lodash/_toKey.js");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "../node_modules/lodash/toNumber.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash/toPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("../node_modules/lodash/_copyObject.js"),
    keysIn = __webpack_require__("../node_modules/lodash/keysIn.js");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "../node_modules/lodash/toString.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/ms/index.js":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ "../node_modules/node-polyglot/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//     (c) 2012-2016 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//



var forEach = __webpack_require__("../node_modules/for-each/index.js");
var warning = __webpack_require__("../node_modules/warning/browser.js");
var has = __webpack_require__("../node_modules/has/src/index.js");
var trim = __webpack_require__("../node_modules/string.prototype.trim/index.js");

var warn = function warn(message) {
  warning(false, message);
};

var replace = String.prototype.replace;
var split = String.prototype.split;

// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimeter = '||||';

// Mapping from pluralization group plural logic.
var pluralTypes = {
  arabic: function (n) {
    // http://www.arabeyes.org/Plural_Forms
    if (n < 3) { return n; }
    if (n % 100 >= 3 && n % 100 <= 10) return 3;
    return n % 100 >= 11 ? 4 : 5;
  },
  chinese: function () { return 0; },
  german: function (n) { return n !== 1 ? 1 : 0; },
  french: function (n) { return n > 1 ? 1 : 0; },
  russian: function (n) {
    if (n % 10 === 1 && n % 100 !== 11) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  czech: function (n) {
    if (n === 1) { return 0; }
    return (n >= 2 && n <= 4) ? 1 : 2;
  },
  polish: function (n) {
    if (n === 1) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
};

// Mapping from pluralization group to individual locales.
var pluralTypeToLanguages = {
  arabic: ['ar'],
  chinese: ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
  german: ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
  french: ['fr', 'tl', 'pt-br'],
  russian: ['hr', 'ru', 'lt'],
  czech: ['cs', 'sk'],
  polish: ['pl'],
  icelandic: ['is']
};

function langToTypeMap(mapping) {
  var ret = {};
  forEach(mapping, function (langs, type) {
    forEach(langs, function (lang) {
      ret[lang] = type;
    });
  });
  return ret;
}

function pluralTypeName(locale) {
  var langToPluralType = langToTypeMap(pluralTypeToLanguages);
  return langToPluralType[locale]
    || langToPluralType[split.call(locale, /-/, 1)[0]]
    || langToPluralType.en;
}

function pluralTypeIndex(locale, count) {
  return pluralTypes[pluralTypeName(locale)](count);
}

var dollarRegex = /\$/g;
var dollarBillsYall = '$$';
var tokenRegex = /%\{(.*?)\}/g;

// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase, substitutions, locale) {
  if (typeof phrase !== 'string') {
    throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
  }

  if (substitutions == null) {
    return phrase;
  }

  var result = phrase;

  // allow number as a pluralization shortcut
  var options = typeof substitutions === 'number' ? { smart_count: substitutions } : substitutions;

  // Select plural form: based on a phrase text that contains `n`
  // plural forms separated by `delimeter`, a `locale`, and a `substitutions.smart_count`,
  // choose the correct plural form. This is only done if `count` is set.
  if (options.smart_count != null && result) {
    var texts = split.call(result, delimeter);
    result = trim(texts[pluralTypeIndex(locale || 'en', options.smart_count)] || texts[0]);
  }

  // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
  result = replace.call(result, tokenRegex, function (expression, argument) {
    if (!has(options, argument) || options[argument] == null) { return expression; }
    // Ensure replacement value is escaped to prevent special $-prefixed regex replace tokens.
    return replace.call(options[argument], dollarRegex, dollarBillsYall);
  });

  return result;
}

// ### Polyglot class constructor
function Polyglot(options) {
  var opts = options || {};
  this.phrases = {};
  this.extend(opts.phrases || {});
  this.currentLocale = opts.locale || 'en';
  var allowMissing = opts.allowMissing ? transformPhrase : null;
  this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
  this.warn = opts.warn || warn;
}

// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale = function (newLocale) {
  if (newLocale) this.currentLocale = newLocale;
  return this.currentLocale;
};

// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend = function (morePhrases, prefix) {
  forEach(morePhrases, function (phrase, key) {
    var prefixedKey = prefix ? prefix + '.' + key : key;
    if (typeof phrase === 'object') {
      this.extend(phrase, prefixedKey);
    } else {
      this.phrases[prefixedKey] = phrase;
    }
  }, this);
};

// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset = function (morePhrases, prefix) {
  if (typeof morePhrases === 'string') {
    delete this.phrases[morePhrases];
  } else {
    forEach(morePhrases, function (phrase, key) {
      var prefixedKey = prefix ? prefix + '.' + key : key;
      if (typeof phrase === 'object') {
        this.unset(phrase, prefixedKey);
      } else {
        delete this.phrases[prefixedKey];
      }
    }, this);
  }
};

// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear = function () {
  this.phrases = {};
};

// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace = function (newPhrases) {
  this.clear();
  this.extend(newPhrases);
};


// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t = function (key, options) {
  var phrase, result;
  var opts = options == null ? {} : options;
  if (typeof this.phrases[key] === 'string') {
    phrase = this.phrases[key];
  } else if (typeof opts._ === 'string') {
    phrase = opts._;
  } else if (this.onMissingKey) {
    var onMissingKey = this.onMissingKey;
    result = onMissingKey(key, opts, this.currentLocale);
  } else {
    this.warn('Missing translation for key: "' + key + '"');
    result = key;
  }
  if (typeof phrase === 'string') {
    result = transformPhrase(phrase, opts, this.currentLocale);
  }
  return result;
};


// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has = function (key) {
  return has(this.phrases, key);
};

// export transformPhrase
Polyglot.transformPhrase = transformPhrase;

module.exports = Polyglot;


/***/ }),

/***/ "../node_modules/object-keys/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__("../node_modules/object-keys/isArguments.js");
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ "../node_modules/object-keys/isArguments.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ "../node_modules/performance-now/lib/performance-now.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "../node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/prop-types/index.js");

/***/ }),

/***/ "../node_modules/punycode/punycode.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/query-string/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/query-string/index.js");

/***/ }),

/***/ "../node_modules/querystring-es3/decode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),

/***/ "../node_modules/querystring-es3/encode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),

/***/ "../node_modules/querystring-es3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("../node_modules/querystring-es3/decode.js");
exports.encode = exports.stringify = __webpack_require__("../node_modules/querystring-es3/encode.js");


/***/ }),

/***/ "../node_modules/querystringify/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  //
  // Little nifty parsing hack, leverage the fact that RegExp.exec increments
  // the lastIndex property so we can continue executing this loop until we've
  // parsed all results.
  //
  for (;
    part = parser.exec(query);
    result[decode(part[1])] = decode(part[2])
  );

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = [];

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (var key in obj) {
    if (has.call(obj, key)) {
      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(obj[key]));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),

/***/ "../node_modules/raf/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("../node_modules/performance-now/lib/performance-now.js")
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/react-dom/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/react-dom/index.js");

/***/ }),

/***/ "../node_modules/react-headroom/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowequal = __webpack_require__("../node_modules/shallowequal/modules/index.js");

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _raf = __webpack_require__("../node_modules/raf/index.js");

var _raf2 = _interopRequireDefault(_raf);

var _shouldUpdate2 = __webpack_require__("../node_modules/react-headroom/dist/shouldUpdate.js");

var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-unresolved


var noop = function noop() {};

var Headroom = function (_Component) {
  _inherits(Headroom, _Component);

  function Headroom(props) {
    _classCallCheck(this, Headroom);

    // Class variables.
    var _this = _possibleConstructorReturn(this, (Headroom.__proto__ || Object.getPrototypeOf(Headroom)).call(this, props));

    _this.setHeightOffset = function () {
      _this.setState({
        height: _this.refs.inner.offsetHeight
      });
      _this.resizeTicking = false;
    };

    _this.getScrollY = function () {
      if (_this.props.parent().pageYOffset !== void 0) {
        return _this.props.parent().pageYOffset;
      } else if (_this.props.parent().scrollTop !== void 0) {
        return _this.props.parent().scrollTop;
      } else {
        return (document.documentElement || document.body.parentNode || document.body).scrollTop;
      }
    };

    _this.getViewportHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };

    _this.getDocumentHeight = function () {
      var body = document.body;
      var documentElement = document.documentElement;

      return Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight, body.clientHeight, documentElement.clientHeight);
    };

    _this.getElementPhysicalHeight = function (elm) {
      return Math.max(elm.offsetHeight, elm.clientHeight);
    };

    _this.getElementHeight = function (elm) {
      return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
    };

    _this.getScrollerPhysicalHeight = function () {
      var parent = _this.props.parent();

      return parent === window || parent === document.body ? _this.getViewportHeight() : _this.getElementPhysicalHeight(parent);
    };

    _this.getScrollerHeight = function () {
      var parent = _this.props.parent();

      return parent === window || parent === document.body ? _this.getDocumentHeight() : _this.getElementHeight(parent);
    };

    _this.isOutOfBound = function (currentScrollY) {
      var pastTop = currentScrollY < 0;

      var scrollerPhysicalHeight = _this.getScrollerPhysicalHeight();
      var scrollerHeight = _this.getScrollerHeight();

      var pastBottom = currentScrollY + scrollerPhysicalHeight > scrollerHeight;

      return pastTop || pastBottom;
    };

    _this.handleScroll = function () {
      if (!_this.scrollTicking) {
        _this.scrollTicking = true;
        (0, _raf2.default)(_this.update);
      }
    };

    _this.handleResize = function () {
      if (!_this.resizeTicking) {
        _this.resizeTicking = true;
        (0, _raf2.default)(_this.setHeightOffset);
      }
    };

    _this.unpin = function () {
      _this.props.onUnpin();

      _this.setState({
        translateY: '-100%',
        className: 'headroom headroom--unpinned'
      }, function () {
        setTimeout(function () {
          _this.setState({ state: 'unpinned' });
        }, 0);
      });
    };

    _this.pin = function () {
      _this.props.onPin();

      _this.setState({
        translateY: 0,
        className: 'headroom headroom--pinned',
        state: 'pinned'
      });
    };

    _this.unfix = function () {
      _this.props.onUnfix();

      _this.setState({
        translateY: 0,
        className: 'headroom headroom--unfixed',
        state: 'unfixed'
      });
    };

    _this.update = function () {
      _this.currentScrollY = _this.getScrollY();

      if (!_this.isOutOfBound(_this.currentScrollY)) {
        var _shouldUpdate = (0, _shouldUpdate3.default)(_this.lastKnownScrollY, _this.currentScrollY, _this.props, _this.state),
            action = _shouldUpdate.action;

        if (action === 'pin') {
          _this.pin();
        } else if (action === 'unpin') {
          _this.unpin();
        } else if (action === 'unfix') {
          _this.unfix();
        }
      }

      _this.lastKnownScrollY = _this.currentScrollY;
      _this.scrollTicking = false;
    };

    _this.currentScrollY = 0;
    _this.lastKnownScrollY = 0;
    _this.scrollTicking = false;
    _this.resizeTicking = false;
    _this.state = {
      state: 'unfixed',
      translateY: 0,
      className: 'headroom headroom--unfixed'
    };
    return _this;
  }

  _createClass(Headroom, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setHeightOffset();
      if (!this.props.disable) {
        this.props.parent().addEventListener('scroll', this.handleScroll);

        if (this.props.calcHeightOnResize) {
          this.props.parent().addEventListener('resize', this.handleResize);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disable && !this.props.disable) {
        this.unfix();
        this.props.parent().removeEventListener('scroll', this.handleScroll);
        this.props.parent().removeEventListener('resize', this.handleResize);
      } else if (!nextProps.disable && this.props.disable) {
        this.props.parent().addEventListener('scroll', this.handleScroll);

        if (this.props.calcHeightOnResize) {
          this.props.parent().addEventListener('resize', this.handleResize);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // If children have changed, remeasure height.
      if (prevProps.children !== this.props.children) {
        this.setHeightOffset();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.parent().removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.handleScroll);
      this.props.parent().removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          userClassName = _props.className,
          divProps = _objectWithoutProperties(_props, ['className']);

      delete divProps.onUnpin;
      delete divProps.onPin;
      delete divProps.onUnfix;
      delete divProps.disableInlineStyles;
      delete divProps.disable;
      delete divProps.parent;
      delete divProps.children;
      delete divProps.upTolerance;
      delete divProps.downTolerance;
      delete divProps.pinStart;
      delete divProps.calcHeightOnResize;

      var style = divProps.style,
          wrapperStyle = divProps.wrapperStyle,
          rest = _objectWithoutProperties(divProps, ['style', 'wrapperStyle']);

      var innerStyle = {
        position: this.props.disable || this.state.state === 'unfixed' ? 'relative' : 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1,
        WebkitTransform: 'translateY(' + this.state.translateY + ')',
        MsTransform: 'translateY(' + this.state.translateY + ')',
        transform: 'translateY(' + this.state.translateY + ')'
      };

      var className = this.state.className;

      // Don't add css transitions until after we've done the initial
      // negative transform when transitioning from 'unfixed' to 'unpinned'.
      // If we don't do this, the header will flash into view temporarily
      // while it transitions from 0 — -100%.
      if (this.state.state !== 'unfixed') {
        innerStyle = _extends({}, innerStyle, {
          WebkitTransition: 'all .2s ease-in-out',
          MozTransition: 'all .2s ease-in-out',
          OTransition: 'all .2s ease-in-out',
          transition: 'all .2s ease-in-out'
        });
        className += ' headroom--scrolled';
      }

      if (!this.props.disableInlineStyles) {
        innerStyle = _extends({}, innerStyle, style);
      } else {
        innerStyle = style;
      }

      var wrapperStyles = _extends({}, wrapperStyle, {
        height: this.state.height ? this.state.height : null
      });

      var wrapperClassName = userClassName ? userClassName + ' headroom-wrapper' : 'headroom-wrapper';

      return _react2.default.createElement(
        'div',
        { style: wrapperStyles, className: wrapperClassName },
        _react2.default.createElement(
          'div',
          _extends({
            ref: 'inner'
          }, rest, {
            style: innerStyle,
            className: className
          }),
          this.props.children
        )
      );
    }
  }]);

  return Headroom;
}(_react.Component);

Headroom.propTypes = {
  className: _propTypes2.default.string,
  parent: _propTypes2.default.func,
  children: _propTypes2.default.any.isRequired,
  disableInlineStyles: _propTypes2.default.bool,
  disable: _propTypes2.default.bool,
  upTolerance: _propTypes2.default.number,
  downTolerance: _propTypes2.default.number,
  onPin: _propTypes2.default.func,
  onUnpin: _propTypes2.default.func,
  onUnfix: _propTypes2.default.func,
  wrapperStyle: _propTypes2.default.object,
  pinStart: _propTypes2.default.func,
  style: _propTypes2.default.object,
  calcHeightOnResize: _propTypes2.default.bool
};
Headroom.defaultProps = {
  parent: function parent() {
    return window;
  },
  disableInlineStyles: false,
  disable: false,
  upTolerance: 5,
  downTolerance: 0,
  onPin: noop,
  onUnpin: noop,
  onUnfix: noop,
  wrapperStyle: {},
  pinStart: function pinStart() {
    return 0;
  },
  calcHeightOnResize: true
};
exports.default = Headroom;

/***/ }),

/***/ "../node_modules/react-headroom/dist/shouldUpdate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var lastKnownScrollY = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  var currentScrollY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    pinStart: function pinStart() {
      return 0;
    }
  };
  var state = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};

  var scrollDirection = currentScrollY >= lastKnownScrollY ? 'down' : 'up';
  var distanceScrolled = Math.abs(currentScrollY - lastKnownScrollY);

  // We're disabled
  if (props.disable) {
    return {
      action: 'none',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're at the top and not fixed yet.
    };
  } else if (currentScrollY <= props.pinStart() && state.state !== 'unfixed') {
    return {
      action: 'unfix',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're unfixed and headed down. Carry on.
    };
  } else if (currentScrollY <= state.height && scrollDirection === 'down' && state.state === 'unfixed') {
    return {
      action: 'none',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're past the header and scrolling down.
      // We transition to "unpinned" if necessary.
    };
  } else if (scrollDirection === 'down' && ['pinned', 'unfixed'].indexOf(state.state) >= 0 && currentScrollY > state.height + props.pinStart() && distanceScrolled > props.downTolerance) {
    return {
      action: 'unpin',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're scrolling up, we transition to "pinned"
    };
  } else if (scrollDirection === 'up' && distanceScrolled > props.upTolerance && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
    return {
      action: 'pin',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're scrolling up, and inside the header.
      // We transition to pin regardless of upTolerance
    };
  } else if (scrollDirection === 'up' && currentScrollY <= state.height && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
    return {
      action: 'pin',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
  } else {
    return {
      action: 'none',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
  }
};

/***/ }),

/***/ "../node_modules/react-redux/es/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/react-redux/es/index.js");

/***/ }),

/***/ "../node_modules/react-transition-group/CSSTransition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__("../node_modules/dom-helpers/class/addClass.js");

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__("../node_modules/dom-helpers/class/removeClass.js");

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__("../node_modules/react-transition-group/Transition.js");

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__("../node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter,
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit,
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node && node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/react-transition-group/Transition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("../node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__("../node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `entering`
 *  - `entered`
 *  - `exiting`
 *  - `exited`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),

/***/ "../node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),

/***/ "../node_modules/react/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/react/index.js");

/***/ }),

/***/ "../node_modules/redux-devtools-extension/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__("../node_modules/redux/es/index.js").compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),

/***/ "../node_modules/redux-persist/es/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEY_PREFIX", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REHYDRATE", function() { return REHYDRATE; });
var KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = 'persist/REHYDRATE';

/***/ }),

/***/ "../node_modules/redux-persist/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/redux-persist/es/constants.js
var constants = __webpack_require__("../node_modules/redux-persist/es/constants.js");

// EXTERNAL MODULE: delegated ../node_modules/lodash-es/isPlainObject.js from dll-reference vendor
var isPlainObjectfrom_dll_reference_vendor = __webpack_require__("../node_modules/lodash-es/isPlainObject.js");

// CONCATENATED MODULE: ../node_modules/redux-persist/es/utils/isStatePlainEnough.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function isStatePlainEnough(a) {
  // isPlainObject + duck type not immutable
  if (!a) return false;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
  if (typeof a.asMutable === 'function') return false;
  if (!Object(isPlainObjectfrom_dll_reference_vendor["default"])(a)) return false;
  return true;
}
// CONCATENATED MODULE: ../node_modules/redux-persist/es/autoRehydrate.js
var autoRehydrate__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function autoRehydrate() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var stateReconciler = config.stateReconciler || defaultStateReconciler;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var store = next(liftReducer(reducer), initialState, enhancer);
      return _extends({}, store, {
        replaceReducer: function replaceReducer(reducer) {
          return store.replaceReducer(liftReducer(reducer));
        }
      });
    };
  };

  function liftReducer(reducer) {
    var rehydrated = false;
    var preRehydrateActions = [];
    return function (state, action) {
      if (action.type !== constants["REHYDRATE"]) {
        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
        return reducer(state, action);
      } else {
        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
        rehydrated = true;

        var inboundState = action.payload;
        var reducedState = reducer(state, action);

        return stateReconciler(state, inboundState, reducedState, config.log);
      }
    };
  }
}

function logPreRehydrate(preRehydrateActions) {
  var concernedActions = preRehydrateActions.slice(1);
  if (concernedActions.length > 0) {
    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
  }
}

function defaultStateReconciler(state, inboundState, reducedState, log) {
  var newState = _extends({}, reducedState);

  Object.keys(inboundState).forEach(function (key) {
    // if initialState does not have key, skip auto rehydration
    if (!state.hasOwnProperty(key)) return;

    // if initial state is an object but inbound state is null/undefined, skip
    if (autoRehydrate__typeof(state[key]) === 'object' && !inboundState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
      return;
    }

    // if reducer modifies substate, skip auto rehydration
    if (state[key] !== reducedState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
      newState[key] = reducedState[key];
      return;
    }

    // otherwise take the inboundState
    if (isStatePlainEnough(inboundState[key]) && isStatePlainEnough(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
    else newState[key] = inboundState[key]; // hard set

    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
  });
  return newState;
}
// EXTERNAL MODULE: ../node_modules/redux-persist/es/utils/setImmediate.js
var setImmediate = __webpack_require__("../node_modules/redux-persist/es/utils/setImmediate.js");

// CONCATENATED MODULE: ../node_modules/redux-persist/es/defaults/asyncLocalStorage.js
var asyncLocalStorage__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var noStorage = function noStorage() {
  /* noop */return null;
};
if (false) {
  noStorage = function noStorage() {
    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
    return null;
  };
}

function _hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : asyncLocalStorage__typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function hasLocalStorage() {
  return _hasStorage('localStorage');
}

function hasSessionStorage() {
  return _hasStorage('sessionStorage');
}

function getStorage(type) {
  if (type === 'local') {
    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
  if (type === 'session') {
    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
}

/* harmony default export */ var asyncLocalStorage = (function (type, config) {
  var storage = getStorage(type);
  return {
    getAllKeys: function getAllKeys(cb) {
      return new Promise(function (resolve, reject) {
        try {
          var keys = [];
          for (var i = 0; i < storage.length; i++) {
            keys.push(storage.key(i));
          }
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null, keys);
            resolve(keys);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    getItem: function getItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          var s = storage.getItem(key);
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null, s);
            resolve(s);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    setItem: function setItem(key, string, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.setItem(key, string);
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    removeItem: function removeItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.removeItem(key);
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    }
  };
});
// CONCATENATED MODULE: ../node_modules/redux-persist/es/purgeStoredState.js


function purgeStoredState(config, keys) {
  var storage = config.storage;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : constants["KEY_PREFIX"];

  // basic validation
  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');

  if (typeof keys === 'undefined') {
    // if keys is not defined, purge all keys
    return new Promise(function (resolve, reject) {
      storage.getAllKeys(function (err, allKeys) {
        if (err) {
          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
          reject(err);
        } else {
          resolve(purgeStoredState(config, allKeys.filter(function (key) {
            return key.indexOf(keyPrefix) === 0;
          }).map(function (key) {
            return key.slice(keyPrefix.length);
          })));
        }
      });
    });
  } else {
    // otherwise purge specified keys
    return Promise.all(keys.map(function (key) {
      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
    }));
  }
}

function warnIfRemoveError(key) {
  return function removeError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}
// EXTERNAL MODULE: ../node_modules/json-stringify-safe/stringify.js
var stringify = __webpack_require__("../node_modules/json-stringify-safe/stringify.js");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ../node_modules/redux-persist/es/createPersistor.js





function createPersistor(store, config) {
  // defaults
  var serializer = config.serialize === false ? function (data) {
    return data;
  } : defaultSerializer;
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var debounce = config.debounce || false;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : constants["KEY_PREFIX"];

  // pluggable state shape (e.g. immutablejs)
  var stateInit = config._stateInit || {};
  var stateIterator = config._stateIterator || defaultStateIterator;
  var stateGetter = config._stateGetter || defaultStateGetter;
  var stateSetter = config._stateSetter || defaultStateSetter;

  // storage with keys -> getAllKeys for localForage support
  var storage = config.storage || asyncLocalStorage('local');
  if (storage.keys && !storage.getAllKeys) {
    storage.getAllKeys = storage.keys;
  }

  // initialize stateful values
  var lastState = stateInit;
  var paused = false;
  var storesToProcess = [];
  var timeIterator = null;

  store.subscribe(function () {
    if (paused) return;

    var state = store.getState();

    stateIterator(state, function (subState, key) {
      if (!passWhitelistBlacklist(key)) return;
      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
      if (storesToProcess.indexOf(key) !== -1) return;
      storesToProcess.push(key);
    });

    var len = storesToProcess.length;

    // time iterator (read: debounce)
    if (timeIterator === null) {
      timeIterator = setInterval(function () {
        if (paused && len === storesToProcess.length || storesToProcess.length === 0) {
          clearInterval(timeIterator);
          timeIterator = null;
          return;
        }

        var key = storesToProcess.shift();
        var storageKey = createStorageKey(key);
        var endState = transforms.reduce(function (subState, transformer) {
          return transformer.in(subState, key);
        }, stateGetter(store.getState(), key));
        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
      }, debounce);
    }

    lastState = state;
  });

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function adhocRehydrate(incoming) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var state = {};
    if (options.serial) {
      stateIterator(incoming, function (subState, key) {
        try {
          var data = deserializer(subState);
          var value = transforms.reduceRight(function (interState, transformer) {
            return transformer.out(interState, key);
          }, data);
          state = stateSetter(state, key, value);
        } catch (err) {
          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
        }
      });
    } else state = incoming;

    store.dispatch(rehydrateAction(state));
    return state;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  // return `persistor`
  return {
    rehydrate: adhocRehydrate,
    pause: function pause() {
      paused = true;
    },
    resume: function resume() {
      paused = false;
    },
    purge: function purge(keys) {
      return purgeStoredState({ storage: storage, keyPrefix: keyPrefix }, keys);
    }
  };
}

function warnIfSetError(key) {
  return function setError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function defaultSerializer(data) {
  return stringify_default()(data, null, null, function (k, v) {
    if (false) return null;
    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
  });
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

function rehydrateAction(data) {
  return {
    type: constants["REHYDRATE"],
    payload: data
  };
}

function defaultStateIterator(collection, callback) {
  return Object.keys(collection).forEach(function (key) {
    return callback(collection[key], key);
  });
}

function defaultStateGetter(state, key) {
  return state[key];
}

function defaultStateSetter(state, key, value) {
  state[key] = value;
  return state;
}
// CONCATENATED MODULE: ../node_modules/redux-persist/es/createTransform.js
function createTransform(inbound, outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
    },
    out: function out(state, key) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
    }
  };
}

/* harmony default export */ var es_createTransform = (createTransform);
// CONCATENATED MODULE: ../node_modules/redux-persist/es/getStoredState.js
var getStoredState__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function getStoredState(config, onComplete) {
  var storage = config.storage || asyncLocalStorage('local');
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : getStoredState_defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : constants["KEY_PREFIX"];

  // fallback getAllKeys to `keys` if present (LocalForage compatability)
  if (storage.keys && !storage.getAllKeys) storage = getStoredState__extends({}, storage, { getAllKeys: storage.keys });

  var restoredState = {};
  var completionCount = 0;

  storage.getAllKeys(function (err, allKeys) {
    if (err) {
      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
      complete(err);
    }

    var persistKeys = allKeys.filter(function (key) {
      return key.indexOf(keyPrefix) === 0;
    }).map(function (key) {
      return key.slice(keyPrefix.length);
    });
    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);

    var restoreCount = keysToRestore.length;
    if (restoreCount === 0) complete(null, restoredState);
    keysToRestore.forEach(function (key) {
      storage.getItem(createStorageKey(key), function (err, serialized) {
        if (err && "production" !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
        completionCount += 1;
        if (completionCount === restoreCount) complete(null, restoredState);
      });
    });
  });

  function rehydrate(key, serialized) {
    var state = null;

    try {
      var data = deserializer(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState, key);
      }, data);
    } catch (err) {
      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
    }

    return state;
  }

  function complete(err, restoredState) {
    onComplete(err, restoredState);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  if (typeof onComplete !== 'function' && !!Promise) {
    return new Promise(function (resolve, reject) {
      onComplete = function onComplete(err, restoredState) {
        if (err) reject(err);else resolve(restoredState);
      };
    });
  }
}

function getStoredState_defaultDeserializer(serial) {
  return JSON.parse(serial);
}
// CONCATENATED MODULE: ../node_modules/redux-persist/es/persistStore.js
var persistStore__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function persistStore(store) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onComplete = arguments[2];

  // defaults
  // @TODO remove shouldRestore
  var shouldRestore = !config.skipRestore;
  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');

  var purgeKeys = null;

  // create and pause persistor
  var persistor = createPersistor(store, config);
  persistor.pause();

  // restore
  if (shouldRestore) {
    Object(setImmediate["a" /* default */])(function () {
      getStoredState(config, function (err, restoredState) {
        if (err) {
          complete(err);
          return;
        }
        // do not persist state for purgeKeys
        if (purgeKeys) {
          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
            return delete restoredState[key];
          });
        }
        try {
          store.dispatch(persistStore_rehydrateAction(restoredState, err));
        } finally {
          complete(err, restoredState);
        }
      });
    });
  } else Object(setImmediate["a" /* default */])(complete);

  function complete(err, restoredState) {
    persistor.resume();
    onComplete && onComplete(err, restoredState);
  }

  return persistStore__extends({}, persistor, {
    purge: function purge(keys) {
      purgeKeys = keys || '*';
      return persistor.purge(keys);
    }
  });
}

function persistStore_rehydrateAction(payload) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: constants["REHYDRATE"],
    payload: payload,
    error: error
  };
}
// CONCATENATED MODULE: ../node_modules/redux-persist/es/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storages", function() { return storages; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "autoRehydrate", function() { return autoRehydrate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createPersistor", function() { return createPersistor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createTransform", function() { return es_createTransform; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getStoredState", function() { return getStoredState; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "persistStore", function() { return persistStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "purgeStoredState", function() { return purgeStoredState; });







// @TODO remove in v5
var deprecated = function deprecated(cb, cb2, cb3) {
  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
  if (typeof cb === 'function') cb();
  if (typeof cb2 === 'function') cb2();
  if (typeof cb3 === 'function') cb3();
};
var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
var storages = {
  asyncLocalStorage: deprecatedStorage,
  asyncSessionStorage: deprecatedStorage
};



/***/ }),

/***/ "../node_modules/redux-persist/es/utils/setImmediate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
var setImmediate = hasNativeSupport ? function (fn, ms) {
  return global.setImmediate(fn, ms);
} : function (fn, ms) {
  return setTimeout(fn, ms);
};

/* harmony default export */ __webpack_exports__["a"] = (setImmediate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/redux-thunk/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/redux-thunk/lib/index.js");

/***/ }),

/***/ "../node_modules/redux/es/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/redux/es/index.js");

/***/ }),

/***/ "../node_modules/regenerator-runtime/runtime-module.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("../node_modules/regenerator-runtime/runtime.js");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/regenerator-runtime/runtime.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/requires-port/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),

/***/ "../node_modules/reselect/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "../node_modules/shallowequal/modules/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__("../node_modules/lodash.keys/index.js");

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),

/***/ "../node_modules/string.prototype.trim/implementation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("../node_modules/function-bind/index.js");
var ES = __webpack_require__("../node_modules/es-abstract/es5.js");
var replace = bind.call(Function.call, String.prototype.replace);

var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};


/***/ }),

/***/ "../node_modules/string.prototype.trim/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("../node_modules/function-bind/index.js");
var define = __webpack_require__("../node_modules/define-properties/index.js");

var implementation = __webpack_require__("../node_modules/string.prototype.trim/implementation.js");
var getPolyfill = __webpack_require__("../node_modules/string.prototype.trim/polyfill.js");
var shim = __webpack_require__("../node_modules/string.prototype.trim/shim.js");

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;


/***/ }),

/***/ "../node_modules/string.prototype.trim/polyfill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("../node_modules/string.prototype.trim/implementation.js");

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};


/***/ }),

/***/ "../node_modules/string.prototype.trim/shim.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__("../node_modules/define-properties/index.js");
var getPolyfill = __webpack_require__("../node_modules/string.prototype.trim/polyfill.js");

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, { trim: function () { return String.prototype.trim !== polyfill; } });
	return polyfill;
};


/***/ }),

/***/ "../node_modules/ua-parser-js/src/ua-parser.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * UAParser.js v0.7.17
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.17',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
            ], [NAME, VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
                                                                                // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w+)*/i,                                                    // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w+)*/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w+)*/i                                                       // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]+)*/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w+)*/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)\s/i                                          // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i      // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i          // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [

            /android.+a000(1)\s+build/i                                         // OnePlus
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Venue[\d\s]*)\s+build/i                          // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i                        // ZTE K Series Tablet
            ], [[VENDOR, 'ZTE'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i          // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?.+)\s+build/i                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?.+)\s+build/i                         // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i             // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q.+)\s+build/i                           // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android.+)[;\/].+build/i                                          // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
            /(gnu)\s?([\w\.]+)*/i                                               // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                  // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i                 // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
            /(unix)\s?([\w\.]+)*/i                                              // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__("../node_modules/webpack/buildin/amd-options.js")) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ "../node_modules/url-parse/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__("../node_modules/requires-port/index.js")
  , qs = __webpack_require__("../node_modules/querystringify/index.js")
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @api public
 */
function lolcation(loc) {
  loc = loc || global.location || {};

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new URL(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new URL(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @api private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @api private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} location Location defaults for relative paths.
 * @param {Boolean|Function} parser Parser for the query string.
 * @api public
 */
function URL(address, location, parser) {
  if (!(this instanceof URL)) {
    return new URL(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[2] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];
    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL}
 * @api public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String}
 * @api public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

URL.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
URL.extractProtocol = extractProtocol;
URL.location = lolcation;
URL.qs = qs;

module.exports = URL;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/url/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__("../node_modules/punycode/punycode.js");
var util = __webpack_require__("../node_modules/url/util.js");

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__("../node_modules/querystring-es3/index.js");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),

/***/ "../node_modules/url/util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),

/***/ "../node_modules/warning/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "../node_modules/webpack/buildin/amd-options.js":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "../node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/webpack/buildin/global.js");

/***/ }),

/***/ "../node_modules/webpack/buildin/module.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/webpack/buildin/module.js");

/***/ }),

/***/ "../node_modules/whatwg-fetch/fetch.js":
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ "./api/apiUrls.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreferencesUrl = exports.getWelcomeMatUrl = exports.getWelcomeMessageUrl = exports.getPaymentProviderUrl = exports.getCountryUrl = exports.getNavigationSubtreeUrl = exports.getNavigationUrl = exports.getSuggestionsUrl = exports.buildUrl = undefined;

var _keys = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _context = __webpack_require__("./client/context/index.js");

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

var _queryString = __webpack_require__("../node_modules/query-string/index.js");

var _constants = __webpack_require__("./api/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientVariables = _clientConfig2.default.get();

/* These are going to be env vars */


var xSiteOrginCheck = function xSiteOrginCheck(params) {
  if ((_clientConfig2.default.isLocal() || _clientConfig2.default.isServer()) && clientVariables.API_XSITEORIGIN_BASE) {
    return (0, _extends3.default)({}, params, { "x-site-origin": clientVariables.API_XSITEORIGIN_BASE });
  }

  if (!_clientConfig2.default.isServer() && _clientConfig2.default.getXSiteOrigin()) {
    return (0, _extends3.default)({}, params, { "x-site-origin": _clientConfig2.default.getXSiteOrigin() });
  }

  return params;
};

var checkEmptyParams = function checkEmptyParams(params) {
  var ret = {};
  (0, _keys2.default)(params).forEach(function (key) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      ret[key] = params[key];
    }
  });
  return ret;
};

var getKSDV = function getKSDV() {
  var context = (0, _context.getContext)();
  if (!context) {
    return (0, _asosSiteChromeStorePresentation.getKeyStoreDataversion)();
  }
  return context.getKeyStoreDataversion();
};

var ensureKeyStoreDataversion = function ensureKeyStoreDataversion(params) {
  return params.keyStoreDataversion ? params : (0, _extends3.default)({}, params, { keyStoreDataversion: getKSDV() });
};

var buildUrl = exports.buildUrl = function buildUrl(origin) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  params = ensureKeyStoreDataversion(params);
  params = xSiteOrginCheck(params);
  params = checkEmptyParams(params);

  var queryString = (0, _queryString.stringify)(params);
  var url = origin + (queryString ? "?" + queryString : "");
  return url;
};

var getSuggestionsUrl = exports.getSuggestionsUrl = function getSuggestionsUrl(siteId, lang, query, country) {
  var params = { store: siteId, lang: lang, q: query, country: country, limit: 10 };
  var baseUrl = "" + clientVariables.API_BASE + _constants.SEARCH_API_SUGGESTIONS_PATH;
  return buildUrl(baseUrl, params);
};

var getNavigationUrl = exports.getNavigationUrl = function getNavigationUrl(params) {
  var API_BASE = clientVariables.API_BASE,
      NAVIGATION_API_PATH = clientVariables.NAVIGATION_API_PATH;

  var baseUrl = "" + API_BASE + NAVIGATION_API_PATH;
  return buildUrl(baseUrl, params);
};

var getNavigationSubtreeUrl = exports.getNavigationSubtreeUrl = function getNavigationSubtreeUrl(params) {
  var API_BASE = clientVariables.API_BASE,
      NAVIGATION_SUBTREE_API_PATH = clientVariables.NAVIGATION_SUBTREE_API_PATH;

  var baseUrl = "" + API_BASE + NAVIGATION_SUBTREE_API_PATH;
  return buildUrl(baseUrl, params);
};

var getCountryUrl = exports.getCountryUrl = function getCountryUrl(country, lang, platform) {
  var params = { lang: lang, platform: platform };
  var baseUrl = "" + clientVariables.COUNTRY_API_DOMAIN + _constants.COUNTRY_API_SELECTOR_PATH + "/" + country;
  return buildUrl(baseUrl, params);
};

var getPaymentProviderUrl = exports.getPaymentProviderUrl = function getPaymentProviderUrl(params) {
  var baseUrl = "" + clientVariables.COUNTRY_API_DOMAIN + _constants.PAYMENT_PROVIDER_API_PATH;
  return buildUrl(baseUrl, params);
};

var getWelcomeMessageUrl = exports.getWelcomeMessageUrl = function getWelcomeMessageUrl(geoCountry, browseCountry, platform) {
  var params = { geoCountry: geoCountry, browseCountry: browseCountry, platform: platform };
  var baseUrl = "" + clientVariables.COUNTRY_API_DOMAIN + _constants.COUNTRY_API_WELCOME_MESSAGE_PATH;
  return buildUrl(baseUrl, params);
};

var getWelcomeMatUrl = exports.getWelcomeMatUrl = function getWelcomeMatUrl(geoCountry, browseCountry, platform) {
  var params = { geoCountry: geoCountry, browseCountry: browseCountry, platform: platform };
  var baseUrl = "" + clientVariables.COUNTRY_API_DOMAIN + _constants.COUNTRY_API_WELCOME_MAT_PATH;
  return buildUrl(baseUrl, params);
};

var getPreferencesUrl = exports.getPreferencesUrl = function getPreferencesUrl(customerGuid) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  params = checkEmptyParams(params);

  var queryString = (0, _queryString.stringify)(params);
  var baseUrl = "" + clientVariables.PREFERENCES_API_DOMAIN + _constants.PREFERENCES_API_PATH + (customerGuid ? "/" + customerGuid : "");

  return baseUrl + (queryString ? "?" + queryString : "");
};

/***/ }),

/***/ "./api/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* These ought to be env vars */
var SEARCH_API_SUGGESTIONS_PATH = exports.SEARCH_API_SUGGESTIONS_PATH = "/product/search/v1/suggestions";
var COUNTRY_API_SELECTOR_PATH = exports.COUNTRY_API_SELECTOR_PATH = "/web/countrymetadata/v1/countrySelector";
var COUNTRY_API_WELCOME_MESSAGE_PATH = exports.COUNTRY_API_WELCOME_MESSAGE_PATH = "/web/countrymetadata/v1/welcomeMessage";
var COUNTRY_API_WELCOME_MAT_PATH = exports.COUNTRY_API_WELCOME_MAT_PATH = "/web/countrymetadata/v1/welcomeMat";
var PAYMENT_PROVIDER_API_PATH = exports.PAYMENT_PROVIDER_API_PATH = "/web/countrymetadata/v1/paymentProviders";
var PREFERENCES_API_PATH = exports.PREFERENCES_API_PATH = "/customer/preference/v1/preferences";

/***/ }),

/***/ "./api/fetchClientNavigation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _logger = __webpack_require__("./helpers/logger.js");

var _logger2 = _interopRequireDefault(_logger);

var _storeUrls = __webpack_require__("./helpers/storeUrls.js");

var _apiUrls = __webpack_require__("./api/apiUrls.js");

var _mapNavigationState = __webpack_require__("./api/navigation/mapNavigationState.js");

var _navigationUtils = __webpack_require__("./api/navigation/navigationUtils.js");

var _request = __webpack_require__("./api/request.js");

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchClientNavigation = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        country = _ref2.country,
        lang = _ref2.lang,
        dateTime = _ref2.dateTime,
        includeDraft = _ref2.includeDraft,
        showTestContent = _ref2.showTestContent,
        platform = _ref2.platform,
        storeCode = _ref2.storeCode,
        storeUrl = _ref2.storeUrl,
        keyStoreDataversion = _ref2.keyStoreDataversion,
        _ref2$opts = _ref2.opts,
        opts = _ref2$opts === undefined ? {} : _ref2$opts;

    var url, navigation, mappedNavigation;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = (0, _apiUrls.getNavigationSubtreeUrl)({
              country: country,
              lang: lang,
              keyStoreDataversion: keyStoreDataversion,
              dateTime: dateTime,
              includeDraft: includeDraft,
              showTestContent: showTestContent
            });


            if (!storeUrl && platform && storeCode) {
              storeUrl = (0, _storeUrls.storeUrlsForAllFloors)(storeCode, platform)[_storeUrls.DEFAULT];
            }

            _logger2.default.info("Fetching navigation API from", url);
            _context.next = 5;
            return (0, _request2.default)(url, opts, false);

          case 5:
            navigation = _context.sent;
            mappedNavigation = {
              countryCode: country,
              tree: (0, _mapNavigationState.mapNavigationState)(navigation, null, null, platform, storeUrl)
            };

            if ((0, _navigationUtils.validateMappedNavigation)(mappedNavigation)) {
              _context.next = 9;
              break;
            }

            throw new Error("Nav API response not valid");

          case 9:
            return _context.abrupt("return", mappedNavigation);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function fetchClientNavigation() {
    return _ref.apply(this, arguments);
  };
}();

exports.default = fetchClientNavigation;

/***/ }),

/***/ "./api/fetchNavigation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _logger = __webpack_require__("./helpers/logger.js");

var _logger2 = _interopRequireDefault(_logger);

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

var _storeUrls = __webpack_require__("./helpers/storeUrls.js");

var _apiUrls = __webpack_require__("./api/apiUrls.js");

var _mapNavigationState = __webpack_require__("./api/navigation/mapNavigationState.js");

var _navigationUtils = __webpack_require__("./api/navigation/navigationUtils.js");

var _request = __webpack_require__("./api/request.js");

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchNavigation = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        country = _ref2.country,
        lang = _ref2.lang,
        dateTime = _ref2.dateTime,
        includeDraft = _ref2.includeDraft,
        showTestContent = _ref2.showTestContent,
        platform = _ref2.platform,
        storeCode = _ref2.storeCode,
        storeUrl = _ref2.storeUrl,
        keyStoreDataversion = _ref2.keyStoreDataversion,
        _ref2$opts = _ref2.opts,
        opts = _ref2$opts === undefined ? {} : _ref2$opts;

    var url, navigation, mappedNavigation;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = (0, _apiUrls.getNavigationUrl)({
              country: country,
              lang: lang,
              keyStoreDataversion: keyStoreDataversion,
              dateTime: dateTime,
              includeDraft: includeDraft,
              showTestContent: showTestContent
            });


            if (!storeUrl && platform && storeCode) {
              storeUrl = (0, _storeUrls.storeUrlsForAllFloors)(storeCode, platform)[_storeUrls.DEFAULT];
            }

            _logger2.default.info("Fetching navigation API from", url);
            _context.next = 5;
            return (0, _request2.default)(url, opts, _clientConfig2.default.isServer());

          case 5:
            navigation = _context.sent;
            mappedNavigation = {
              countryCode: country,
              tree: (0, _mapNavigationState.mapNavigationState)(navigation.navigation, null, null, platform, storeUrl),
              footer: (0, _mapNavigationState.mapNavigationState)(navigation.footer, null, null, platform, storeUrl)
            };

            if ((0, _navigationUtils.validateMappedNavigation)(mappedNavigation)) {
              _context.next = 9;
              break;
            }

            throw new Error("Nav API response not valid");

          case 9:
            return _context.abrupt("return", mappedNavigation);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function fetchNavigation() {
    return _ref.apply(this, arguments);
  };
}();

exports.default = fetchNavigation;

/***/ }),

/***/ "./api/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendEventToAlfred = exports.fetchFeaturesManifest = exports.fetchPreferences = exports.updatePreferences = exports.fetchSitecoreBearerToken = exports.fetchWelcomeMat = exports.fetchWelcomeMessage = exports.fetchPaymentProviders = exports.fetchCountry = exports.fetchSuggestions = exports.fetchNavigation = exports.fetchClientNavigation = undefined;

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__("../node_modules/babel-runtime/core-js/json/stringify.js");

var _stringify2 = _interopRequireDefault(_stringify);

var updatePreferences = exports.updatePreferences = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(customerGuid, preferences) {
    var url, body, method, headers;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = (0, _apiUrls.getPreferencesUrl)(customerGuid);

            _logger2.default.info("Patching preferences for customer '" + customerGuid + "' from '" + url + "'");
            body = (0, _stringify2.default)({
              sourceReason: "SiteChrome",
              services: {
                marketing: preferences
              }
            });
            method = "PATCH";
            _context.t0 = Headers;
            _context.next = 7;
            return window.__sdk.identity.getAccessToken();

          case 7:
            _context.t1 = _context.sent;
            _context.t2 = "Bearer " + _context.t1;
            _context.t3 = {
              "asos-c-name": "asos-web-site-chrome",
              "Content-Type": "application/json",
              Authorization: _context.t2
            };
            headers = new _context.t0(_context.t3);
            return _context.abrupt("return", fetch(url, {
              method: method,
              headers: headers,
              body: body
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function updatePreferences(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _fetchClientNavigation = __webpack_require__("./api/fetchClientNavigation.js");

Object.defineProperty(exports, "fetchClientNavigation", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fetchClientNavigation).default;
  }
});

var _fetchNavigation = __webpack_require__("./api/fetchNavigation.js");

Object.defineProperty(exports, "fetchNavigation", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fetchNavigation).default;
  }
});

var _request = __webpack_require__("./api/request.js");

var _request2 = _interopRequireDefault(_request);

var _context2 = __webpack_require__("./client/context/index.js");

var _logger = __webpack_require__("./helpers/logger.js");

var _logger2 = _interopRequireDefault(_logger);

var _apiUrls = __webpack_require__("./api/apiUrls.js");

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

var _env = __webpack_require__("./env/index.js");

var _env2 = _interopRequireDefault(_env);

__webpack_require__("../node_modules/isomorphic-fetch/fetch-npm-browserify.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIsRunningOnServer = function getIsRunningOnServer() {
  return _clientConfig2.default.isServer();
};

var fetchSuggestions = exports.fetchSuggestions = function fetchSuggestions(siteId, lang, query, country) {
  var url = (0, _apiUrls.getSuggestionsUrl)(siteId, lang, query, country);

  _logger2.default.info("(" + siteId + ") - Fetching navigation from " + url);
  return (0, _request2.default)(url);
};

var fetchCountry = exports.fetchCountry = function fetchCountry(country, lang, platform) {
  var url = (0, _apiUrls.getCountryUrl)(country, lang, platform);
  _logger2.default.info("Fetching country data for " + country + " from " + url);
  return (0, _request2.default)(url);
};

var fetchPaymentProviders = exports.fetchPaymentProviders = function fetchPaymentProviders(keyStoreDataversion) {
  var url = (0, _apiUrls.getPaymentProviderUrl)({ keyStoreDataversion: keyStoreDataversion });
  _logger2.default.info("Fetching payment providers from " + url);
  return (0, _request2.default)(url);
};

var fetchWelcomeMessage = exports.fetchWelcomeMessage = function fetchWelcomeMessage(browseCountry, platform, keyStoreDataversion) {
  var context = (0, _context2.getContext)();
  var geoCountry = context && context.getGeoCountry();

  var url = (0, _apiUrls.getWelcomeMessageUrl)(geoCountry, browseCountry, platform, keyStoreDataversion);
  _logger2.default.info("Fetching welcome message for " + geoCountry + " from " + url);
  return (0, _request2.default)(url);
};

var fetchWelcomeMat = exports.fetchWelcomeMat = function fetchWelcomeMat(browseCountry, platform, keyStoreDataversion) {
  var context = (0, _context2.getContext)();
  var geoCountry = context && context.getGeoCountry();

  var url = (0, _apiUrls.getWelcomeMatUrl)(geoCountry, browseCountry, platform, keyStoreDataversion);
  _logger2.default.info("Fetching welcome mat for " + geoCountry + " from " + url);
  return (0, _request2.default)(url);
};

var fetchSitecoreBearerToken = exports.fetchSitecoreBearerToken = function fetchSitecoreBearerToken() {
  var _process$env = process.env,
      url = _process$env.SITECORE_LOGIN_URL,
      username = _process$env.SITECORE_LOGIN_USER,
      password = _process$env.SITECORE_LOGIN_PASS,
      domain = _process$env.SITECORE_LOGIN_DOMAIN;

  var body = (0, _stringify2.default)({
    username: username,
    password: password,
    domain: domain
  });
  var method = "POST";
  var headers = new Headers({
    "Content-Type": "application/json"
  });
  return (0, _request2.default)(url, { method: method, headers: headers, body: body });
};

var fetchPreferences = exports.fetchPreferences = function fetchPreferences(country, lang) {
  var url = (0, _apiUrls.getPreferencesUrl)(null, {
    lang: lang,
    country: country
  });
  _logger2.default.info("Fetching preferences for system from '" + url + "'");

  return (0, _request2.default)(url);
};

var fetchFeaturesManifest = exports.fetchFeaturesManifest = function fetchFeaturesManifest() {
  return (0, _request2.default)((0, _env2.default)("FEATURES_MANIFEST_JSON"));
};

var sendEventToAlfred = exports.sendEventToAlfred = function sendEventToAlfred(event, url) {
  var method = "POST";
  var headers = new Headers({
    "Content-Type": "application/json"
  });

  var body = (0, _stringify2.default)(event);
  return (0, _request2.default)(url, { method: method, headers: headers, body: body }, getIsRunningOnServer()).catch(function (e) {
    console.error("Alfred event failed", e);
  });
};

/***/ }),

/***/ "./api/navigation/mapNavigationState.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapNavigationState = undefined;

var _navigationUtils = __webpack_require__("./api/navigation/navigationUtils.js");

var _get = __webpack_require__("./helpers/get.js");

var _get2 = _interopRequireDefault(_get);

var _links = __webpack_require__("./helpers/links.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapNavigationState = exports.mapNavigationState = function mapNavigationState(navigation, gender) {
  var labelPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var platform = arguments[3];
  var storeUrl = arguments[4];
  return navigation.map(function (navigationItem) {
    var label = (0, _get2.default)(navigationItem, "content.title");
    var alias = (0, _get2.default)(navigationItem, "alias");
    var newLabelPath = [].concat(labelPath, [label]);
    var useGender = gender || alias;
    var link = (0, _get2.default)(navigationItem, "link.webUrl");
    var linkType = (0, _get2.default)(navigationItem, "link.linkType");
    if (link && platform && storeUrl && platform === "mobile") {
      link = (0, _links.desktopToMobile)(link, storeUrl);
    }

    return {
      id: (0, _get2.default)(navigationItem, "id"),
      alias: alias,
      label: label,
      subtitle: (0, _get2.default)(navigationItem, "content.subTitle"),
      link: link,
      linkType: linkType,
      type: (0, _get2.default)(navigationItem, "type"),
      labelPath: newLabelPath,
      gender: useGender,
      excludes: (0, _navigationUtils.getViewportExclusions)(navigationItem.channelExclusions),
      largeScreenPriority: (0, _get2.default)(navigationItem, "webLargePriority"),
      largeScreenColumnSpan: (0, _get2.default)(navigationItem, "display.webLargeColumnSpan"),
      largeScreenTemplateId: (0, _get2.default)(navigationItem, "display.webLargeTemplateId"),
      smallAndMediumTemplateId: (0, _get2.default)(navigationItem, "display.mobileTemplateId"),
      smallAndMediumLayout: (0, _get2.default)(navigationItem, "display.mobileDisplayLayout"),
      smallAndMediumImageUrl: (0, _get2.default)(navigationItem, "content.mobileImageUrl"),
      largeScreenImageUrl: (0, _get2.default)(navigationItem, "content.webLargeImageUrl"),
      largeScreenStyleType: (0, _get2.default)(navigationItem, "style.webLargeStyleType"),
      smallAndMediumStyleType: (0, _get2.default)(navigationItem, "style.mobileStyleType"),
      items: mapNavigationState(navigationItem.children, useGender, newLabelPath, platform, storeUrl)
    };
  });
};

/***/ }),

/***/ "./api/navigation/navigationUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateMappedNavigation = exports.getViewportExclusions = undefined;

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var getViewportExclusions = exports.getViewportExclusions = function getViewportExclusions() {
  var channelExclusions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var viewportExclusion = [];

  channelExclusions.forEach(function (exclusion) {
    if (exclusion === "webLarge") {
      viewportExclusion.push(_layout.LARGE_VIEWPORT);
    }
    if (exclusion === "webSmall") {
      viewportExclusion.push(_layout.SMALL_VIEWPORT);
      viewportExclusion.push(_layout.MEDIUM_VIEWPORT);
    }
  });

  return viewportExclusion;
};

var hasItems = function hasItems(tree) {
  var maleExists = (0, _navigation.maleLargePrimaryNavigationItems)({ navigation: { tree: tree } });
  var femaleExists = (0, _navigation.femaleLargePrimaryNavigationItems)({
    navigation: { tree: tree }
  });

  return !!(maleExists && femaleExists && maleExists.length && femaleExists.length);
};

var validateMappedNavigation = exports.validateMappedNavigation = function validateMappedNavigation(mappedNavigation) {
  return !!(mappedNavigation && mappedNavigation.tree && hasItems(mappedNavigation.tree));
};

/***/ }),

/***/ "./api/request.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _create = __webpack_require__("../node_modules/babel-runtime/core-js/object/create.js");

var _create2 = _interopRequireDefault(_create);

exports.ApiError = ApiError;

__webpack_require__("../node_modules/isomorphic-fetch/fetch-npm-browserify.js");

var _logger = __webpack_require__("./helpers/logger.js");

var _logger2 = _interopRequireDefault(_logger);

var _agentkeepalive = __webpack_require__("../node_modules/agentkeepalive/browser.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Until we're ES6 end to end we have to use this form because with Babel subclasses must extend a class https://github.com/babel/babel/issues/3083
function ApiError(message) {
  var fetchMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  this.name = "ApiError";
  this.message = message || "Api Error";
  this.stack = new Error().stack;
  this.status = fetchMetadata.status;
  this.statusText = fetchMetadata.statusText;
  this.url = fetchMetadata.url;
  this.responseText = fetchMetadata.responseText;
}
ApiError.prototype = (0, _create2.default)(Error.prototype);
ApiError.prototype.constructor = ApiError;

var handleErrors = function handleErrors(response) {
  return new _promise2.default(function (resolve, reject) {
    if (response.status >= 200 && response.status < 300) {
      resolve(response);
    } else {
      var status = response.status,
          statusText = response.statusText,
          url = response.url;


      response.text().then(function (responseText) {
        var error = new ApiError(response.statusText, {
          status: status,
          statusText: statusText,
          url: url,
          responseText: responseText
        });

        _logger2.default.error("Error response from API:", error);

        reject(error);
      });
    }
  });
};

var httpsKeepAliveAgent = new _agentkeepalive.HttpsAgent({
  maxSockets: 160,
  keepAliveMsecs: 3000
});

var request = function request(url) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var addHttpsKeepalives = arguments[2];

  if (addHttpsKeepalives) {
    opts.agent = httpsKeepAliveAgent;
  }

  return fetch(url, opts).then(handleErrors).then(function (response) {
    return response.json();
  });
};

exports.default = request;

/***/ }),

/***/ "./client/Root.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WelcomeWrapper = exports.Footer = exports.Header = exports.updateStateWithClientData = undefined;

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reduxPersist = __webpack_require__("../node_modules/redux-persist/es/index.js");

var _events = __webpack_require__("./helpers/events.js");

var _events2 = _interopRequireDefault(_events);

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _HtmlHeader = __webpack_require__("./template/components/HtmlHeader/index.js");

var _HtmlHeader2 = _interopRequireDefault(_HtmlHeader);

var _Footer = __webpack_require__("./template/components/Footer/index.js");

var _Footer2 = _interopRequireDefault(_Footer);

var _WelcomeWrapper = __webpack_require__("./template/components/WelcomeWrapper/index.js");

var _WelcomeWrapper2 = _interopRequireDefault(_WelcomeWrapper);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _state = __webpack_require__("./template/state/index.js");

var _state2 = _interopRequireDefault(_state);

var _constants = __webpack_require__("./template/constants.js");

__webpack_require__("./template/styles/fonts.css");

__webpack_require__("./template/styles/global.css");

__webpack_require__("./template/components/Breadcrumbs/index.css");

var _loadTokenBlock = __webpack_require__("./helpers/loadTokenBlock.js");

var _loadTokenBlock2 = _interopRequireDefault(_loadTokenBlock);

var _context2 = __webpack_require__("./client/context/index.js");

var _context3 = _interopRequireDefault(_context2);

var _navigation = __webpack_require__("./client/navigation/index.js");

var _sdk = __webpack_require__("./client/sdk/index.js");

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

var _loadUserProfile = __webpack_require__("./client/loadUserProfile.js");

var _loadUserProfile2 = _interopRequireDefault(_loadUserProfile);

var _addFeaturesToStore = __webpack_require__("./client/addFeaturesToStore.js");

var _addFeaturesToStore2 = _interopRequireDefault(_addFeaturesToStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _clientConfig$get = _clientConfig2.default.get(),
    NAVIGATION_SUBTREE_API_PATH = _clientConfig$get.NAVIGATION_SUBTREE_API_PATH; /* eslint-disable no-underscore-dangle */


var firstVisit = (0, _asosSiteChromeStorePresentation.isFirstVisit)();
var store = (0, _state2.default)(window[_constants.siteChromeInitialStore]);

var _context = (0, _context3.default)(store),
    contextFns = _context.context,
    updateRegionalStore = _context.updateRegionalStore;

window.analyticsEventEmitter = _events2.default;

window.__sdk = {};

window[_constants.siteChromePublicWindowApi] = {
  context: contextFns
};

var updateFeatures = (0, _addFeaturesToStore2.default)(store, _events2.default);

_events2.default.addListener("features-sdk-ready", function () {
  return updateFeatures("features-sdk-ready");
});
_events2.default.addListener("features-mvt-ready", function () {
  return updateFeatures("features-mvt-ready");
});

(0, _sdk.initialise)(store, contextFns);

var updateStateWithClientData = exports.updateStateWithClientData = function updateStateWithClientData() {
  updateRegionalStore();
  (0, _loadUserProfile2.default)(store);

  (0, _loadTokenBlock2.default)({
    store: store,
    initialState: window[_constants.siteChromeInitialStore],
    newState: window[_constants.siteChromeTokenValues]
  });

  if (firstVisit) {
    store.dispatch((0, _layout.openCookieMessage)());
  }

  if (!(NAVIGATION_SUBTREE_API_PATH.indexOf("/preview/") !== -1)) {
    (0, _navigation.reloadNavigation)(store);
  }

  (0, _reduxPersist.persistStore)(store, {
    keyPrefix: "chrome:",
    whitelist: ["search"]
  });
};

var Header = exports.Header = function Header() {
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_HtmlHeader2.default, null)
  );
};

var Footer = exports.Footer = function Footer() {
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_Footer2.default, { viewable: [_layout.LARGE_VIEWPORT, _layout.MEDIUM_VIEWPORT] })
  );
};

var WelcomeWrapper =
/* istanbul ignore next */
exports.WelcomeWrapper = function WelcomeWrapper() {
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_WelcomeWrapper2.default, null)
  );
};

/***/ }),

/***/ "./client/addFeaturesToStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _features = __webpack_require__("./template/state/modules/features/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store, emitter) {
  var dispatchFeatures = function dispatchFeatures(event) {
    return store.dispatch((0, _features.setFeatures)((0, _extends3.default)({
      loadComplete: event === "features-mvt-ready"
    }, window.__sdk.features.getFeatures())));
  };

  var postHydrate = false;
  var calledBeforeHydrate = false;
  var pendingCalls = [];

  emitter.addListener("hydrate-ready", function () {
    postHydrate = true;
    if (calledBeforeHydrate && pendingCalls.length) {
      pendingCalls.forEach(function (fn) {
        return fn();
      });
    }
  });

  return function (event) {
    if (postHydrate) {
      dispatchFeatures(event);
    } else {
      calledBeforeHydrate = true;
      pendingCalls.push(function () {
        return dispatchFeatures(event);
      });
    }
  };
}; /*
   
   Add features to store, waiting until DOM content has loaded to avoid template mismatches.
   
   */

/***/ }),

/***/ "./client/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var IDENTITY_SDK_RESET_COOKIE = exports.IDENTITY_SDK_RESET_COOKIE = "identitySdkResetRequired";

/***/ }),

/***/ "./client/context/checkForMismatch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkForMismatch;
var shouldRedirect = exports.shouldRedirect = function shouldRedirect(_ref) {
  var inRollback = _ref.inRollback,
      cookieValue = _ref.cookieValue,
      manifestValue = _ref.manifestValue;

  if (!manifestValue) {
    return false;
  }
  return inRollback && cookieValue !== manifestValue;
};

/* Note that we only set the cookie when not in rollback if the cookie doesn't exist.
This is so that we don't force the user on to a new experience during the same session. */
var shouldSetCookie = exports.shouldSetCookie = function shouldSetCookie(_ref2) {
  var inRollback = _ref2.inRollback,
      cookieValue = _ref2.cookieValue;
  return inRollback || !cookieValue;
};

function checkForMismatch(versionData, setCookie) {
  if (shouldSetCookie(versionData)) {
    setCookie();
  }

  return shouldRedirect(versionData);
}

/***/ }),

/***/ "./client/context/cookies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKeyedCookieValue = exports.setKeyedCookieValue = exports.removeCookie = exports.setCookieValue = exports.getCookieValue = undefined;

var _jsCookie = __webpack_require__("../node_modules/js-cookie/src/js.cookie.js");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oneYearInDays = 365;

var getCookieValue = exports.getCookieValue = function getCookieValue(cookieName) {
  return _jsCookie2.default.get(cookieName) || undefined;
};

var setCookieValue = exports.setCookieValue = function setCookieValue(cookieName, value) {
  var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : oneYearInDays;

  var options = { expires: expires };
  _jsCookie2.default.set(cookieName, value, options);
};

var removeCookie = exports.removeCookie = function removeCookie(name, domain) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/";

  _jsCookie2.default.remove(name, {
    domain: domain,
    path: path
  });
};

var findKeyValuePair = function findKeyValuePair(values, key) {
  return values ? values.split("&").filter(function (keyValue) {
    return keyValue.indexOf(key + "=") !== -1;
  })[0] : null;
};

var concatenateKeyValuePairs = function concatenateKeyValuePairs(cookieValue, newKey, newValue) {
  if (cookieValue) {
    var keyValueInCookie = findKeyValuePair(cookieValue, newKey);
    if (keyValueInCookie) {
      return cookieValue.replace(keyValueInCookie, newKey + "=" + newValue);
    } else {
      return cookieValue + "&" + newKey + "=" + newValue;
    }
  }
  return newKey + "=" + newValue;
};

var setKeyedCookieValue = exports.setKeyedCookieValue = function setKeyedCookieValue(cookieName, key, value) {
  var expires = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : oneYearInDays;

  setCookieValue(cookieName, concatenateKeyValuePairs(getCookieValue(cookieName), key, value), expires);
};

var getKeyedCookieValue = exports.getKeyedCookieValue = function getKeyedCookieValue(cookieName, key) {
  var keyValuePair = findKeyValuePair(getCookieValue(cookieName), key);
  return keyValuePair ? keyValuePair.split("=")[1] : null;
};

/***/ }),

/***/ "./client/context/geoCountryMapsToCurrentStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = geoCountryMapsToCurrentStore;

var _manifest = __webpack_require__("./helpers/manifest.js");

function geoCountryMapsToCurrentStore(geoCountry, manifest) {
  var store = (0, _manifest.getCurrentStore)(manifest);

  if (!store) {
    // current store is COM
    return (0, _manifest.mapsToTheComStore)(geoCountry, manifest);
  }

  return store.countryCodes.indexOf(geoCountry.toLowerCase()) !== -1;
}

/***/ }),

/***/ "./client/context/getAllVersions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStoreCodeToSiteChromeVersionMappings = exports.getSiteChromeVersionMappingsFromCookie = exports.getAllSiteChromeVersions = exports.getAllKeyStoreDataversions = undefined;

var _assign = __webpack_require__("../node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAllKeyStoreDataversions = exports.getAllKeyStoreDataversions = function getAllKeyStoreDataversions(state, manifest) {
  return {
    inRollback: !manifest.useCurrentKeyStoreDataversion,
    templateValue: (0, _regionalStore.getKeyStoreDataversion)(state),
    cookieValue: (0, _asosSiteChromeStorePresentation.getKeyStoreDataversion)(),
    manifestValue: manifest.useCurrentKeyStoreDataversion ? manifest.keyStoreDataversion.current : manifest.keyStoreDataversion.previous
  };
};

var getAllSiteChromeVersions = exports.getAllSiteChromeVersions = function getAllSiteChromeVersions(state, manifest) {
  var storeCode = (0, _regionalStore.getStoreCode)(state).toLowerCase();
  var liveObject = manifest.siteChromeVersion[storeCode];

  return {
    templateValue: state.version,
    cookieValue: (0, _asosSiteChromeStorePresentation.getTemplateVersion)(storeCode),
    inRollback: !liveObject.useCurrent,
    manifestValue: liveObject.useCurrent ? liveObject.current : liveObject.previous
  };
};

var getSiteChromeVersionMappingsFromCookie = exports.getSiteChromeVersionMappingsFromCookie = function getSiteChromeVersionMappingsFromCookie(manifest) {
  return (0, _keys2.default)(manifest.siteChromeVersion).reduce(function (mappings, storeCode) {
    var templateVersion = (0, _asosSiteChromeStorePresentation.getTemplateVersion)(storeCode);

    if (templateVersion) {
      mappings[storeCode] = templateVersion;
    }

    return mappings;
  }, {});
};

var getStoreCodeToSiteChromeVersionMappings = exports.getStoreCodeToSiteChromeVersionMappings = function getStoreCodeToSiteChromeVersionMappings(manifest) {
  var mappingsFromManifestNotInRollback = (0, _keys2.default)(manifest.siteChromeVersion).reduce(function (mappings, storeCode) {
    var mapping = manifest.siteChromeVersion[storeCode];

    if (mapping.useCurrent) {
      mappings[storeCode] = mapping.current;
    }

    return mappings;
  }, {});

  var mappingsFromCookie = getSiteChromeVersionMappingsFromCookie(manifest);

  var mappingsFromManifestInRollback = (0, _keys2.default)(manifest.siteChromeVersion).reduce(function (mappings, storeCode) {
    var mapping = manifest.siteChromeVersion[storeCode];

    if (!mapping.useCurrent) {
      mappings[storeCode] = mapping.previous;
    }

    return mappings;
  }, {});

  return (0, _assign2.default)(mappingsFromManifestNotInRollback, mappingsFromCookie, mappingsFromManifestInRollback);
};

/***/ }),

/***/ "./client/context/getters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getters;
function getters(values) {
  return {
    /**
     * User selected (country dropdown) or system selected Country code
     * @returns {string} ßISO 3166-1 alpha-2 code
     */
    getBrowseCountry: function getBrowseCountry() {
      return values.browseCountry;
    },

    /**
     * The currency the customer is using for their purchase
     * @returns {string} - ISO 4217 code
     */
    getBrowseCurrency: function getBrowseCurrency() {
      return values.browseCurrency;
    },

    /**
     * Language tag representing the language of the site the customer is currently viewing.
     * @returns {string} - RFC 5646 Language tag
     */
    getBrowseLanguage: function getBrowseLanguage() {
      return values.browseLanguage;
    },

    /**
     * The asos size schema identifier representing the sizing scheme the customer is currently shopping using.
     * @returns {string} - Size Schema name
     */
    getBrowseSizeSchema: function getBrowseSizeSchema() {
      return values.browseSizeSchema;
    },

    /**
     * Asos store identifier representing store associated with a country
     * @returns {string} store identifier
     */
    getStoreId: function getStoreId() {
      return values.storeId;
    },

    /**
     *  System default Country code for a specific site
     * @returns {string} - ISO 3166-1 alpha-2 code
     */
    getDefaultCountry: function getDefaultCountry() {
      return values.defaultCountry;
    },

    /**
     * Returns flag indicating whether response is using store V1 (store mode) or Store V2 (Country mode)
     * @returns {boolean}
     */
    getEnableStoreBasedOperation: function getEnableStoreBasedOperation() {
      return values.enableStoreBasedOperation;
    },

    /**
     * The version of Store API data that should be used by all the dependent services & APIs
     * @returns {number}
     */
    getKeyStoreDataversion: function getKeyStoreDataversion() {
      return values.keyStoreDataversion;
    },
    /**
     * The version of the current template
     * @returns {number}
     */
    getTemplateVersion: function getTemplateVersion() {
      return values.templateVersion;
    },

    /**
     * The current geo country from the akamai cookie
     * @returns {string}
     */
    getGeoCountry: function getGeoCountry() {
      return values.geoCountry;
    },

    /**
     * Returns affiliateId from cookies
     * @return {string}
     */
    getAffiliateId: function getAffiliateId() {
      return values.affiliateId;
    },

    /**
     * @type {webContext}
     * @property {string} affiliateId - Asos affiliate identifier
     * @property {string} storeId - Asos Store Id
     * @property {string} browseCountry - ISO code for chosen country
     * @property {string} defaultCountry - ISO code for template country
     * @property {string} geoCountry - ISO code for Geo Country
     * @property {string} browseCurrency - Users currency
     * @property {string} browseLanguage - users language
     * @property {string} browseSizeSchema - users size schema
     * @property {string} enableStoreBasedOperation - store or country mode
     * @property {number} keyStoreDataversion - version of Store API data
     * @property {number} templateVersion - version of Store API data
     */

    /**
     * Convenience collection of each individual properties
     * @returns {webContext}
     */
    getWebContext: function getWebContext() {
      return values;
    }
  };
}

/***/ }),

/***/ "./client/context/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("../node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = context;
exports.setCookies = setCookies;
exports.getContext = getContext;

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _checkForMismatch = __webpack_require__("./client/context/checkForMismatch.js");

var _checkForMismatch2 = _interopRequireDefault(_checkForMismatch);

var _getters = __webpack_require__("./client/context/getters.js");

var _getters2 = _interopRequireDefault(_getters);

var _getAllVersions = __webpack_require__("./client/context/getAllVersions.js");

var _constants = __webpack_require__("./template/constants.js");

var _currency = __webpack_require__("./helpers/currency.js");

var _cookies = __webpack_require__("./client/context/cookies.js");

var _redirectToPreferredSite = __webpack_require__("./client/redirectToPreferredSite/index.js");

var _redirectToPreferredSite2 = _interopRequireDefault(_redirectToPreferredSite);

var _templateMatchesCountry = __webpack_require__("./client/context/templateMatchesCountry.js");

var _templateMatchesCountry2 = _interopRequireDefault(_templateMatchesCountry);

var _geoCountryMapsToCurrentStore = __webpack_require__("./client/context/geoCountryMapsToCurrentStore.js");

var _geoCountryMapsToCurrentStore2 = _interopRequireDefault(_geoCountryMapsToCurrentStore);

var _url = __webpack_require__("./helpers/url.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findAffiliateId = function findAffiliateId() {
  var affiliateId = (0, _url.getParamValue)("affid") || (0, _url.getParamValue)("xaffid");
  var affiliateIdFromCookie = (0, _asosSiteChromeStorePresentation.getAffiliateId)();
  if (affiliateId && affiliateId !== affiliateIdFromCookie) {
    (0, _asosSiteChromeStorePresentation.setAffiliateId)(affiliateId);
    return affiliateId;
  }
  return affiliateIdFromCookie;
};

var getBrowseCurrency = function getBrowseCurrency(currencies) {
  var _getCurrency = (0, _currency.getCurrency)(parseInt((0, _url.getParamValue)("currencyId")), (0, _url.getParamValue)("browseCurrency"), currencies),
      currency = _getCurrency.currency,
      currencyId = _getCurrency.currencyId;

  return {
    browseCurrency: currency,
    browseCurrencyId: currencyId
  };
};

var getSharedBaseContext = function getSharedBaseContext(_ref) {
  var currencies = _ref.currencies,
      defaultLanguage = _ref.defaultLanguage,
      defaultSizeSchema = _ref.defaultSizeSchema,
      storeCode = _ref.storeCode;
  return (0, _extends3.default)({}, getBrowseCurrency(currencies), {
    browseLanguage: defaultLanguage,
    browseSizeSchema: defaultSizeSchema,
    storeId: storeCode
  });
};

var getBase = function getBase(_ref2) {
  var browseCountry = _ref2.browseCountry,
      regionalStoreVariant = _ref2.regionalStoreVariant,
      regionalStoreFromState = (0, _objectWithoutProperties3.default)(_ref2, ["browseCountry", "regionalStoreVariant"]);

  var affiliateId = findAffiliateId();
  var geoCountry = (0, _asosSiteChromeStorePresentation.getGeoCountry)() || browseCountry;

  var base = (0, _extends3.default)({
    affiliateId: affiliateId,
    browseCountry: browseCountry && browseCountry.toUpperCase(),
    enableStoreBasedOperation: false,
    geoCountry: geoCountry
  }, getSharedBaseContext(regionalStoreFromState));

  if (regionalStoreVariant) {
    return (0, _extends3.default)({}, base, getSharedBaseContext(regionalStoreVariant));
  }

  return base;
};

var buildContextObject = function buildContextObject(store, keyStoreDataversion, siteChromeVersions, latestManifest) {
  var contextObject = (0, _assign2.default)({}, {
    keyStoreDataversion: keyStoreDataversion,
    templateVersion: siteChromeVersions.cookieValue || siteChromeVersions.templateValue
  });

  var updateRegionalStore = function updateRegionalStore() {
    // update the keystoredataversion in state
    store.dispatch((0, _regionalStore.setKeyStoreDataversion)(contextObject.keyStoreDataversion));
    // update browseCurrency in state
    store.dispatch((0, _regionalStore.setBrowseCurrency)(contextObject.browseCurrency));
  };

  var state = store.getState();
  var base = getBase({
    browseCountry: (0, _regionalStore.getCountryCode)(state),
    storeCode: (0, _regionalStore.getStoreCode)(state),
    defaultLanguage: (0, _regionalStore.getDefaultLanguage)(state),
    defaultSizeSchema: (0, _regionalStore.getDefaultSizeSchema)(state),
    currencies: (0, _regionalStore.getCurrencies)(state),
    regionalStoreVariant: (0, _regionalStore.getRegionalStoreVariant)((0, _regionalStore.getStore)(state), contextObject.keyStoreDataversion)
  });

  contextObject = (0, _extends3.default)({}, base, contextObject);

  if (!(0, _templateMatchesCountry2.default)(contextObject)) {
    if ((0, _geoCountryMapsToCurrentStore2.default)((0, _asosSiteChromeStorePresentation.getGeoCountry)(), latestManifest)) {
      (0, _asosSiteChromeStorePresentation.setBrowseCountry)((0, _asosSiteChromeStorePresentation.getGeoCountry)());
      return window.location.reload();
    }
  }

  // Set new page cookies
  setCookies(contextObject);

  // Remove browse parameters from URL
  var url = ["browseCurrency", "browseCountry"].reduce(function (current, value) {
    return removeURLParameter(current, value);
  }, window.location.href);
  window.history.replaceState({}, "", url);

  // create context getters object, the external interface
  var contextGetters = (0, _getters2.default)(contextObject);

  return { context: contextGetters, updateRegionalStore: updateRegionalStore };
};

var mustReload = function mustReload(latestManifest, keyStoreDataversions, siteChromeVersions) {
  var storeCodeToSiteChromeVersionMappings = (0, _getAllVersions.getStoreCodeToSiteChromeVersionMappings)(latestManifest);

  var setTemplateVersionsCookie = _asosSiteChromeStorePresentation.setTemplateVersions.bind(null, storeCodeToSiteChromeVersionMappings);

  var setKeyStoreDataVersionCookie = _asosSiteChromeStorePresentation.setKeyStoreDataversion.bind(null, keyStoreDataversions.manifestValue);

  var siteChromeMismatch = (0, _checkForMismatch2.default)(siteChromeVersions, setTemplateVersionsCookie);

  var ksdvMismatch = (0, _checkForMismatch2.default)(keyStoreDataversions, setKeyStoreDataVersionCookie);

  var shouldRedirect = siteChromeMismatch || ksdvMismatch;

  return shouldRedirect;
};

var updateCookieExpiry = function updateCookieExpiry(latestManifest) {
  (0, _asosSiteChromeStorePresentation.setTemplateVersions)((0, _getAllVersions.getSiteChromeVersionMappingsFromCookie)(latestManifest));
  (0, _asosSiteChromeStorePresentation.setKeyStoreDataversion)((0, _asosSiteChromeStorePresentation.getKeyStoreDataversion)());
};

function context(store) {
  var latestManifest = window[_constants.manifestWindowKey];
  var state = store.getState();

  var keyStoreDataversions = (0, _getAllVersions.getAllKeyStoreDataversions)(state, latestManifest);

  var keyStoreDataversion = keyStoreDataversions.cookieValue || keyStoreDataversions.manifestValue;

  if ((0, _redirectToPreferredSite2.default)(latestManifest, state, keyStoreDataversion)) {
    return;
  }

  var siteChromeVersions = (0, _getAllVersions.getAllSiteChromeVersions)(state, latestManifest);

  var shouldReload = mustReload(latestManifest, keyStoreDataversions, siteChromeVersions);

  updateCookieExpiry(latestManifest);

  if (shouldReload) {
    window.location.reload();
  }

  return buildContextObject(store, keyStoreDataversion, siteChromeVersions, latestManifest);
}

function removeURLParameter(url, parameter) {
  var urlParts = url.split("?");
  if (urlParts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var parts = urlParts[1].split(/[&;]/g);

    for (var i = parts.length; i-- > 0;) {
      if (parts[i].lastIndexOf(prefix, 0) !== -1) {
        parts.splice(i, 1);
      }
    }

    return urlParts[0] + (parts.length > 0 ? "?" + parts.join("&") : "");
  } else {
    return url;
  }
}

function stripPrefSiteFromAsosCookie() {
  (0, _cookies.setKeyedCookieValue)("asos", "PreferredSite", "");
}

/*
 * @param {Object} webContext
 * @param {string} webContext.browseCountry
 * @param {string} webContext.browseCurrency
 * @param {string} webContext.browseLanguage
 * @param {string} webContext.browseSizeSchema
 * @param {string} webContext.storeId
 * @param {string} webContext.browseCurrencyId
 */
function setCookies(webContext) {
  // true represents session cookie
  //initAsosCookie();
  stripPrefSiteFromAsosCookie();
  (0, _asosSiteChromeStorePresentation.setBrowseCountry)(webContext.browseCountry);
  (0, _asosSiteChromeStorePresentation.setBrowseCurrency)(webContext.browseCurrency);
  (0, _asosSiteChromeStorePresentation.setBrowseLanguage)(webContext.browseLanguage);
  (0, _asosSiteChromeStorePresentation.setBrowseSizeSchema)(webContext.browseSizeSchema);
  (0, _asosSiteChromeStorePresentation.setStoreCode)(webContext.storeId);
  (0, _asosSiteChromeStorePresentation.setCurrency)({
    currencyCode: webContext.browseCurrency,
    currencyId: webContext.browseCurrencyId
  });
}

function getContext() {
  return typeof window !== "undefined" && window[_constants.siteChromePublicWindowApi] && window[_constants.siteChromePublicWindowApi].context;
}

/***/ }),

/***/ "./client/context/templateMatchesCountry.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = templateMatchesCountry;

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _url = __webpack_require__("./helpers/url.js");

function templateMatchesCountry(contextObject) {
  if ((0, _url.getParamValue)("browseCountry")) {
    return true;
  }

  if (userHasAPreferredCountry()) {
    return true;
  }

  if (!(0, _asosSiteChromeStorePresentation.getGeoCountry)()) {
    return true;
  }

  if (!contextObject || !contextObject.browseCountry) {
    return true;
  }

  if (templateMatchesGeolocation(contextObject.browseCountry)) {
    return true;
  }

  return false;
}

var userHasAPreferredCountry = function userHasAPreferredCountry() {
  return (0, _asosSiteChromeStorePresentation.getBrowseCountry)();
};
var templateMatchesGeolocation = function templateMatchesGeolocation(templateCountry) {
  return (0, _asosSiteChromeStorePresentation.getGeoCountry)() === templateCountry;
};

/***/ }),

/***/ "./client/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("../node_modules/core-js/modules/es6.typed.array-buffer.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.data-view.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.int8-array.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.uint8-array.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.uint8-clamped-array.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.int16-array.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.uint16-array.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.int32-array.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.uint32-array.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.float32-array.js");

__webpack_require__("../node_modules/core-js/modules/es6.typed.float64-array.js");

__webpack_require__("../node_modules/core-js/modules/es6.map.js");

__webpack_require__("../node_modules/core-js/modules/es6.set.js");

__webpack_require__("../node_modules/core-js/modules/es6.weak-map.js");

__webpack_require__("../node_modules/core-js/modules/es6.weak-set.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.apply.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.construct.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.define-property.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.delete-property.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.get.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.get-prototype-of.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.has.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.is-extensible.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.own-keys.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.prevent-extensions.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.set.js");

__webpack_require__("../node_modules/core-js/modules/es6.reflect.set-prototype-of.js");

__webpack_require__("../node_modules/core-js/modules/es6.promise.js");

__webpack_require__("../node_modules/core-js/modules/es6.symbol.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.freeze.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.seal.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.prevent-extensions.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.is-frozen.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.is-sealed.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.is-extensible.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.get-own-property-descriptor.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.get-prototype-of.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.keys.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.get-own-property-names.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.assign.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.is.js");

__webpack_require__("../node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__("../node_modules/core-js/modules/es6.function.name.js");

__webpack_require__("../node_modules/core-js/modules/es6.string.raw.js");

__webpack_require__("../node_modules/core-js/modules/es6.string.from-code-point.js");

__webpack_require__("../node_modules/core-js/modules/es6.string.code-point-at.js");

__webpack_require__("../node_modules/core-js/modules/es6.string.repeat.js");

__webpack_require__("../node_modules/core-js/modules/es6.string.starts-with.js");

__webpack_require__("../node_modules/core-js/modules/es6.string.ends-with.js");

__webpack_require__("../node_modules/core-js/modules/es6.string.includes.js");

__webpack_require__("../node_modules/core-js/modules/es6.regexp.flags.js");

__webpack_require__("../node_modules/core-js/modules/es6.regexp.match.js");

__webpack_require__("../node_modules/core-js/modules/es6.regexp.replace.js");

__webpack_require__("../node_modules/core-js/modules/es6.regexp.split.js");

__webpack_require__("../node_modules/core-js/modules/es6.regexp.search.js");

__webpack_require__("../node_modules/core-js/modules/es6.array.from.js");

__webpack_require__("../node_modules/core-js/modules/es6.array.of.js");

__webpack_require__("../node_modules/core-js/modules/es6.array.copy-within.js");

__webpack_require__("../node_modules/core-js/modules/es6.array.find.js");

__webpack_require__("../node_modules/core-js/modules/es6.array.find-index.js");

__webpack_require__("../node_modules/core-js/modules/es6.array.fill.js");

__webpack_require__("../node_modules/core-js/modules/es6.array.iterator.js");

__webpack_require__("../node_modules/core-js/modules/es6.number.is-finite.js");

__webpack_require__("../node_modules/core-js/modules/es6.number.is-integer.js");

__webpack_require__("../node_modules/core-js/modules/es6.number.is-safe-integer.js");

__webpack_require__("../node_modules/core-js/modules/es6.number.is-nan.js");

__webpack_require__("../node_modules/core-js/modules/es6.number.epsilon.js");

__webpack_require__("../node_modules/core-js/modules/es6.number.min-safe-integer.js");

__webpack_require__("../node_modules/core-js/modules/es6.number.max-safe-integer.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.acosh.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.asinh.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.atanh.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.cbrt.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.clz32.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.cosh.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.expm1.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.fround.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.hypot.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.imul.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.log1p.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.log10.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.log2.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.sign.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.sinh.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.tanh.js");

__webpack_require__("../node_modules/core-js/modules/es6.math.trunc.js");

__webpack_require__("../node_modules/core-js/modules/es7.array.includes.js");

__webpack_require__("../node_modules/core-js/modules/es7.object.values.js");

__webpack_require__("../node_modules/core-js/modules/es7.object.entries.js");

__webpack_require__("../node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");

__webpack_require__("../node_modules/core-js/modules/es7.string.pad-start.js");

__webpack_require__("../node_modules/core-js/modules/es7.string.pad-end.js");

__webpack_require__("../node_modules/core-js/modules/web.timers.js");

__webpack_require__("../node_modules/core-js/modules/web.immediate.js");

__webpack_require__("../node_modules/core-js/modules/web.dom.iterable.js");

__webpack_require__("../node_modules/regenerator-runtime/runtime.js");

__webpack_require__("../node_modules/details-polyfill/index.js");

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("../node_modules/react-dom/index.js");

var _Root = __webpack_require__("./client/Root.js");

var _thirdPartyCookie = __webpack_require__("./client/thirdPartyCookie.js");

var _thirdPartyCookie2 = _interopRequireDefault(_thirdPartyCookie);

__webpack_require__("./client/reactAxe.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener("DOMContentLoaded", function () {
  var headerElement = document.getElementById("chrome-header");
  var footerElement = document.getElementById("chrome-footer");
  var welcomeMatElement = document.getElementById("chrome-welcome-mat");

  (0, _reactDom.hydrate)(_react2.default.createElement(_Root.Header, null), headerElement);
  (0, _reactDom.hydrate)(_react2.default.createElement(_Root.Footer, null), footerElement);
  (0, _reactDom.hydrate)(_react2.default.createElement(_Root.WelcomeWrapper, null), welcomeMatElement);

  window.analyticsEventEmitter.emit("hydrate-ready");

  (0, _Root.updateStateWithClientData)();
});

(0, _thirdPartyCookie2.default)();

/***/ }),

/***/ "./client/loadUserProfile.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = __webpack_require__("./helpers/logger.js");

var _logger2 = _interopRequireDefault(_logger);

var _cookies = __webpack_require__("./client/context/cookies.js");

var _constants = __webpack_require__("./client/constants.js");

var _user = __webpack_require__("./template/state/modules/user/index.js");

var _url = __webpack_require__("./helpers/url.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchUserProfile = function fetchUserProfile(store) {
  if (!window.__sdk || !window.__sdk.identity) return;

  var identitySDK = window.__sdk.identity;


  if ((0, _cookies.getCookieValue)(_constants.IDENTITY_SDK_RESET_COOKIE) === "true") {
    var domain = "." + (0, _url.stripSubdomain)(window.location.hostname);

    identitySDK.customer.resetLocalCopy();
    (0, _cookies.removeCookie)(_constants.IDENTITY_SDK_RESET_COOKIE, domain);
  }

  store.dispatch((0, _user.setUserFetchingState)(_user.FETCHING));

  return identitySDK.customer.profile().then(function (profile) {
    if (!profile) {
      throw new Error("Empty profile");
    }

    store.dispatch((0, _user.setUserFetchingState)(_user.SUCCESS));
    store.dispatch((0, _user.setUserProfile)(profile));
    store.dispatch((0, _user.setLoggedInState)(profile.isAuthenticated));

    if (profile.isAuthenticated || profile.isRecognised) {
      return identitySDK.customer.isReconsentRequired().then(function (reconsentRequired) {
        return store.dispatch((0, _user.setUserReconsentStatus)(reconsentRequired));
      }).catch(_logger2.default.warn);
    }
  }).catch(function () {
    store.dispatch((0, _user.setUserFetchingState)(_user.FAILED));
  });
};

exports.default = function (store) {
  if (window.__sdk && window.__sdk.identity) {
    return fetchUserProfile(store);
  } else {
    return window.analyticsEventEmitter.addListener("sdk-ready", function () {
      return fetchUserProfile(store);
    });
  }
};

/***/ }),

/***/ "./client/navigation/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var siteChromeNavigationStoreKey = exports.siteChromeNavigationStoreKey = "chrome:navigation";
var expirationInMs = exports.expirationInMs = 5 * 60 * 1000;

/***/ }),

/***/ "./client/navigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reloadNavigation = undefined;

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = __webpack_require__("../node_modules/babel-runtime/helpers/slicedToArray.js");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _updateFromApi = __webpack_require__("./client/navigation/updateFromApi.js");

var _updateFromApi2 = _interopRequireDefault(_updateFromApi);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigationLocalStorage = __webpack_require__("./client/navigation/navigationLocalStorage.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCountryData = function getCountryData(store) {
  var _store$getState = store.getState(),
      _store$getState$regio = _store$getState.regionalStore,
      countryCode = _store$getState$regio.countryCode,
      defaultLanguage = _store$getState$regio.defaultLanguage,
      storeUrls = _store$getState$regio.storeUrls,
      platform = _store$getState.layout.platform;

  return [defaultLanguage, countryCode, storeUrls.default, platform];
};

var reloadNavigation = exports.reloadNavigation = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(store) {
    var _getCountryData, _getCountryData2, language, countryCode, storeUrl, platform, _getFromLocalStorage, data, time;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getCountryData = getCountryData(store), _getCountryData2 = (0, _slicedToArray3.default)(_getCountryData, 4), language = _getCountryData2[0], countryCode = _getCountryData2[1], storeUrl = _getCountryData2[2], platform = _getCountryData2[3];
            _getFromLocalStorage = (0, _navigationLocalStorage.getFromLocalStorage)({ countryCode: countryCode, language: language }), data = _getFromLocalStorage.data, time = _getFromLocalStorage.time;


            if (data && time > Date.now()) {
              store.dispatch((0, _navigation.updateNavigationTree)(data));
            } else {
              (0, _updateFromApi2.default)({
                countryCode: countryCode,
                language: language,
                store: store,
                storeUrl: storeUrl,
                platform: platform,
                fromLocalStorage: data
              });
            }

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function reloadNavigation(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./client/navigation/navigationLocalStorage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToLocalStorage = exports.getFromLocalStorage = undefined;

var _stringify = __webpack_require__("../node_modules/babel-runtime/core-js/json/stringify.js");

var _stringify2 = _interopRequireDefault(_stringify);

var _constants = __webpack_require__("./client/navigation/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFromLocalStorage = exports.getFromLocalStorage = function getFromLocalStorage(_ref) {
  var countryCode = _ref.countryCode,
      language = _ref.language;

  var storedJson = localStorage.getItem(_constants.siteChromeNavigationStoreKey);

  try {
    var stored = JSON.parse(storedJson);
    if (stored.countryCode === countryCode && stored.language === language) {
      return stored;
    }
  } catch (e) {
    return {};
  }

  return {};
};

var addToLocalStorage = exports.addToLocalStorage = function addToLocalStorage(_ref2) {
  var data = _ref2.data,
      countryCode = _ref2.countryCode,
      language = _ref2.language;
  return localStorage.setItem(_constants.siteChromeNavigationStoreKey, (0, _stringify2.default)({
    data: data,
    countryCode: countryCode,
    language: language,
    time: Date.now() + _constants.expirationInMs
  }));
};

/***/ }),

/***/ "./client/navigation/updateFromApi.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__("./api/index.js");

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigationLocalStorage = __webpack_require__("./client/navigation/navigationLocalStorage.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateFromApi = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {
    var countryCode = _ref.countryCode,
        language = _ref.language,
        store = _ref.store,
        storeUrl = _ref.storeUrl,
        platform = _ref.platform,
        fromLocalStorage = _ref.fromLocalStorage;
    var hasUpdateHappened, data;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            hasUpdateHappened = false;
            _context.prev = 1;
            _context.next = 4;
            return (0, _api.fetchClientNavigation)({
              country: countryCode,
              lang: language,
              storeUrl: storeUrl,
              platform: platform
            });

          case 4:
            data = _context.sent;


            try {
              (0, _navigationLocalStorage.addToLocalStorage)({ data: data, countryCode: countryCode, language: language });
              hasUpdateHappened = true;
            } catch (e) {
              console.warn("Saving navigation to localStorage failed: ", e);
            }

            store.dispatch((0, _navigation.updateNavigationTree)(data));
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);

            console.error("Nav update failed", _context.t0);
            if (fromLocalStorage) {
              store.dispatch((0, _navigation.updateNavigationTree)(fromLocalStorage));
              if (hasUpdateHappened) {
                (0, _navigationLocalStorage.addToLocalStorage)({ data: fromLocalStorage, countryCode: countryCode, language: language });
              }
            }

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined, [[1, 9]]);
  }));

  return function updateFromApi(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.default = updateFromApi;

/***/ }),

/***/ "./client/reactAxe.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (false) {
  var React = require("react");
  var ReactDom = require("react-dom");
  var axe = require("react-axe");
  var config = {
    runOnly: {
      type: "tag",
      values: ["wcag2a", "wcag2aa"]
    }
  };
  axe(React, ReactDom, 1000, config);
}

/***/ }),

/***/ "./client/redirectToPreferredSite/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__("../node_modules/babel-runtime/core-js/object/values.js");

var _values2 = _interopRequireDefault(_values);

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _url = __webpack_require__("./helpers/url.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withoutProtocol = function withoutProtocol(url) {
  return url.replace(/^https?:\/\//, "");
};

var withoutTrailingSlash = function withoutTrailingSlash(str) {
  return str.replace(/\/$/, "");
};

var normaliseUrl = (0, _redux.compose)(withoutProtocol, withoutTrailingSlash);

var normaliseCountryCode = function normaliseCountryCode(str) {
  return str.toLowerCase();
};

exports.default = function (manifest, state, keyStoreDataversion) {
  var preferredSiteRedirects = manifest.preferredSiteRedirects;

  if (!preferredSiteRedirects) {
    return false;
  }

  var enabled = preferredSiteRedirects.enabled,
      keyStoreDataversionVariants = preferredSiteRedirects.keyStoreDataversionVariants;

  if (!enabled || !keyStoreDataversionVariants) {
    return false;
  }

  var redirectsForKeyStoreDataversion = keyStoreDataversionVariants[keyStoreDataversion];

  if (!redirectsForKeyStoreDataversion) {
    return false;
  }

  var qsBrowseCountry = (0, _url.getParamValue)("browseCountry");

  if (qsBrowseCountry) {
    return false;
  }

  var browseCountry = normaliseCountryCode((0, _asosSiteChromeStorePresentation.getBrowseCountry)() || "");
  if (!browseCountry) {
    return false;
  }

  var match = redirectsForKeyStoreDataversion.find(function (_ref) {
    var countryCodes = _ref.countryCodes;
    return countryCodes.map(normaliseCountryCode).indexOf(browseCountry) !== -1;
  });

  if (!match) {
    return false;
  }

  var storeUrls = state.regionalStore.storeUrls;

  var floorUrls = (0, _values2.default)(storeUrls).map(normaliseUrl);
  var _window$location = window.location,
      hostname = _window$location.hostname,
      pathname = _window$location.pathname;

  var currentUrl = normaliseUrl("" + hostname + pathname);
  var isFloorUrl = floorUrls.find(function (url) {
    return url === currentUrl;
  });

  if (!isFloorUrl) {
    return false;
  }

  var platform = state.layout.platform;
  var mobileUrl = match.mobileUrl,
      desktopUrl = match.desktopUrl;


  var redirectUrl = platform === "mobile" ? mobileUrl : desktopUrl;

  if (currentUrl.indexOf(normaliseUrl(redirectUrl)) !== -1) {
    return false;
  }

  window.location.replace("//" + redirectUrl);

  return true;
};

/***/ }),

/***/ "./client/sdk/bag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startCheckout = exports.subscribeToUpdates = exports.getBag = exports.removeItem = exports.getBagSummary = exports.waitForBagSDK = exports.initialise = undefined;

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _bagConfiguration = __webpack_require__("./client/sdk/bagConfiguration.js");

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

var _events = __webpack_require__("./helpers/events.js");

var _events2 = _interopRequireDefault(_events);

var _promiseWithTimeout = __webpack_require__("./helpers/promiseWithTimeout.js");

var _promiseWithTimeout2 = _interopRequireDefault(_promiseWithTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global requirejs */
var initialise = exports.initialise = function initialise(context) {
  return new _promise2.default(function (resolve) {
    return requirejs(["bagSdk/sdk"], function (sdk) {
      return resolve(sdk.getInstance(context, (0, _bagConfiguration.getConfiguration)()));
    });
  });
};

var waitForBagSDK = exports.waitForBagSDK = function waitForBagSDK() {
  return new _promise2.default(function (resolve, reject) {
    if (_clientConfig2.default.isServer()) {
      return reject();
    }
    if (window.__sdk && window.__sdk.bag) {
      return resolve(window.__sdk.bag);
    }
    _events2.default.addListener("bag-sdk-ready", resolve);
  });
};

var getBagSummary = exports.getBagSummary = function getBagSummary() {
  return waitForBagSDK().then(function (bag) {
    return bag.getBagSummary();
  }).catch( /* istanbul ignore next */function (_) {
    return _;
  });
};

var removeItem = exports.removeItem = function removeItem(itemId, itemType) {
  return waitForBagSDK().then(function (bag) {
    return (0, _promiseWithTimeout2.default)(bag.removeItem(itemId, itemType));
  });
};

var getBag = exports.getBag = function getBag() {
  return waitForBagSDK().then(function (bag) {
    return bag.getBag();
  }).catch( /* istanbul ignore next */function (_) {
    return _;
  });
};

var subscribeToUpdates = exports.subscribeToUpdates = function subscribeToUpdates(callback) {
  return waitForBagSDK().then(function (bag) {
    //eslint-disable-next-line no-undef
    $(bag).on("bagUpdated:completed", function () {
      var _ref = arguments.length <= 2 ? undefined : arguments[2],
          bag = _ref.bag,
          messages = _ref.messages;

      callback({ bag: bag, messages: messages });
    });
  }).catch( /* istanbul ignore next */function (_) {
    return _;
  });
};

var startCheckout = exports.startCheckout = function startCheckout() {
  return waitForBagSDK().then(function (bag) {
    return bag.startCheckout();
  }).catch( /* istanbul ignore next */function (_) {
    return _;
  });
};

/***/ }),

/***/ "./client/sdk/bagConfiguration.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfiguration = undefined;

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildConfiguration = function buildConfiguration(config) {
  if (_clientConfig2.default.isLocal()) {
    return {
      postMessageUrl: config.SDK_POST_MESSAGE_URL,
      xSiteOrigin: config.SDK_X_SITE_ORIGIN,
      bagApiUrl: config.SDK_BAG_API_URL
    };
  }

  return {
    xSiteOrigin: _clientConfig2.default.getXSiteOrigin()
  };
};

var getConfiguration = exports.getConfiguration = function getConfiguration() {
  return buildConfiguration(_clientConfig2.default.get());
};

/***/ }),

/***/ "./client/sdk/features.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addManifestFeatures = exports.initialise = undefined;

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global requirejs */

var getVersionManifestFeatures = function getVersionManifestFeatures() {
  return window.__versionManifest && window.__versionManifest.features;
};

var getFeatureManifest = function getFeatureManifest() {
  return window.__featureManifest || {
    features: {},
    mvt: {}
  };
};

var initialise = exports.initialise = function initialise(context) {
  return new _promise2.default(function (resolve) {
    requirejs(["asos-web-features"], function (_ref) {
      var features = _ref.default;

      var instance = features.getInstance(getFeatureManifest(), context);
      resolve(instance);
    });
  });
};

var addManifestFeatures = exports.addManifestFeatures = function addManifestFeatures(instance) {
  return instance.addManifest({ features: getVersionManifestFeatures() });
};

/***/ }),

/***/ "./client/sdk/identity.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialise = undefined;

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global requirejs */
var TOKEN_TYPES = "id_token token";
var IDENTITY_SCOPES = "openid sensitive profile";

var initialise = exports.initialise = function initialise(store) {
  return new _promise2.default(function (resolve) {
    var config = _clientConfig2.default.get();
    var state = store.getState();
    var identityConfig = {
      lang: (0, _regionalStore.getDefaultLanguage)(state),
      regionalIsoCode: (0, _regionalStore.getDefaultLanguage)(state),
      clientId: config.IDENTITY_SDK_CLIENT_ID,
      customerApiUrl: config.IDENTITY_SDK_CUSTOMER_API_URL,
      authenticationHost: config.IDENTITY_SDK_AUTH_HOST,
      identityOrigin: config.IDENTITY_SDK_IDENTITY_ORIGIN,
      responseMode: "json",
      store: (0, _regionalStore.getStoreCode)(state),
      countryCode: (0, _regionalStore.getCountryCode)(state),
      keyStoreDataversion: (0, _regionalStore.getKeyStoreDataversion)(state),
      types: TOKEN_TYPES,
      scope: IDENTITY_SCOPES,
      redirectUri: window.location.href
    };

    requirejs(["asos.identity.sdk.config"], function (configurator) {
      configurator.setConfig(identityConfig);

      requirejs(["asos.identity.web.clientsdk"], resolve);
    });
  });
};

/***/ }),

/***/ "./client/sdk/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialise = undefined;

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _objectWithoutProperties2 = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _identity = __webpack_require__("./client/sdk/identity.js");

var _bag = __webpack_require__("./client/sdk/bag.js");

var _savedItems = __webpack_require__("./client/sdk/savedItems.js");

var _features = __webpack_require__("./client/sdk/features.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMappedContext = function getMappedContext(values) {
  return {
    storeId: values.storeId,
    country: values.browseCountry,
    originCountry: values.geoCountry,
    currency: values.browseCurrency,
    language: values.browseLanguage,
    sizeSchema: values.browseSizeSchema,
    keyStoreDataversion: values.keyStoreDataversion
  };
};

var ready = function ready(name) {
  return function (sdk) {
    window.__sdk[name] = sdk;
    window.analyticsEventEmitter.emit(name + "-sdk-ready", sdk);
    return sdk;
  };
};

var initialise = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(store, context) {
    var webContext, mappedWebContext, bagSdkContext, country, savedItemsSdkContext;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            webContext = context.getWebContext();
            mappedWebContext = getMappedContext(webContext);
            bagSdkContext = mappedWebContext;
            country = mappedWebContext.country, savedItemsSdkContext = (0, _objectWithoutProperties3.default)(mappedWebContext, ["country"]); // eslint-disable-line no-unused-vars

            return _context.abrupt("return", _promise2.default.all([(0, _features.initialise)(webContext).then(ready("features")).then(_features.addManifestFeatures).then(function () {
              window.analyticsEventEmitter.emit("features-mvt-ready", window.__sdk.features);
            }), (0, _identity.initialise)(store).then(ready("identity")).then(function () {
              return (0, _bag.initialise)(bagSdkContext).then(ready("bag"));
            }).then(function () {
              return (0, _savedItems.initialise)(savedItemsSdkContext).then(ready("savedItems"));
            })]).then(function () {
              return window.analyticsEventEmitter.emit("sdk-ready", window.__sdk);
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function initialise(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
exports.initialise = initialise;

/***/ }),

/***/ "./client/sdk/savedItems.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialise = undefined;

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _savedItemsConfiguration = __webpack_require__("./client/sdk/savedItemsConfiguration.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialise = exports.initialise = function initialise(context) {
  return new _promise2.default(function (resolve) {
    return requirejs(["savedItemsSdk/sdk"], function (sdk) {
      return resolve(sdk.getInstance(context, (0, _savedItemsConfiguration.getConfiguration)()));
    });
  });
}; /* global requirejs */

/***/ }),

/***/ "./client/sdk/savedItemsConfiguration.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfiguration = undefined;

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildConfiguration = function buildConfiguration(config) {
  if (_clientConfig2.default.isLocal()) {
    return {
      postMessageUrl: config.SDK_POST_MESSAGE_URL,
      xSiteOrigin: config.SDK_X_SITE_ORIGIN,
      savedItemsApiUrl: config.SDK_SAVED_ITEMS_API_URL
    };
  }

  return {
    xSiteOrigin: _clientConfig2.default.getXSiteOrigin()
  };
};

var getConfiguration = exports.getConfiguration = function getConfiguration() {
  return buildConfiguration(_clientConfig2.default.get());
};

/***/ }),

/***/ "./client/thirdPartyCookie.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = startIframe;

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

var _url = __webpack_require__("../node_modules/url/url.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALLOWED_DOMAINS = ["local.asos.com", "www.asos.com", "www.asos.fr", "www.asos.de", "test.asosservices.com", "test.asosservices.fr", "test.asosservices.de"];

var alreadyRedirected = function alreadyRedirected(query) {
  return query && query.crd && query.crd === "true";
};

function startIframe() {
  var iframeUrl = _clientConfig2.default.get().IFRAME_URL;
  var currentUrl = (0, _url.parse)(window.location.href, true, false);
  if (iframeUrl && !alreadyRedirected(currentUrl.query)) {
    window.addEventListener("message", function (event) {
      var domain = (0, _url.parse)(event.origin);
      if (ALLOWED_DOMAINS.indexOf(domain.hostname) !== -1 && event.data === "redirection_needed") {
        currentUrl.query["crd"] = "true";
        delete currentUrl.search;

        window.location.href = iframeUrl + "?doRedirect=true&referrer=" + encodeURIComponent((0, _url.format)(currentUrl));
      }
    });

    var iframe = document.createElement("iframe");
    iframe.src = iframeUrl;
    iframe.width = 0;
    iframe.height = 0;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
  }
}

/***/ }),

/***/ "./env/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var env = function env(key, defaultValue) {
  // eslint-disable-next-line no-prototype-builtins
  if (process.env.hasOwnProperty(key)) {
    return process.env[key];
  }
  if (typeof defaultValue !== "undefined") {
    return defaultValue;
  }
  throw new Error("No " + key + " environment variable is defined.");
};

exports.default = env;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "./helpers/accessibility.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var tabIndex = exports.tabIndex = function tabIndex() {
  var focusable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return focusable ? 0 : -1;
};

/***/ }),

/***/ "./helpers/currency.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrency = undefined;

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var getCurrency = exports.getCurrency = function getCurrency(currencyId, currencyCode, currencies) {
  var currency = void 0;
  if (currencyId) {
    currency = findCurrencyById(currencyId, currencies);
  } else if (currencyCode) {
    currency = findCurrencyByCode(currencyCode, currencies);
  } else {
    currency = findCurrencyByCode((0, _asosSiteChromeStorePresentation.getBrowseCurrency)(), currencies);
  }

  if (currency) {
    return currency;
  }

  return getPrimaryCurrency(currencies);
};

function findCurrencyById(id, currencies) {
  return currencies.find(function (_ref) {
    var currencyId = _ref.currencyId;
    return currencyId === id;
  });
}

function findCurrencyByCode(currencyCode, currencies) {
  var code = currencyCode && currencyCode.toLowerCase();
  return currencies.find(function (_ref2) {
    var currency = _ref2.currency;
    return currency.toLowerCase() === code;
  });
}

function getPrimaryCurrency(currencies) {
  return currencies.find(function (_ref3) {
    var isPrimary = _ref3.isPrimary;
    return isPrimary;
  });
}

/***/ }),

/***/ "./helpers/deviceDetection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _uaParserJs = __webpack_require__("../node_modules/ua-parser-js/src/ua-parser.js");

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserAgent = function getUserAgent() {
  return (0, _uaParserJs2.default)(typeof navigator !== "undefined" && navigator.userAgent);
};

var parseUserAgent = function parseUserAgent(agent) {
  return {
    browser: agent.browser.name || "",
    os: agent.os.name || ""
  };
};

var DeviceDetection = function () {
  function DeviceDetection() {
    (0, _classCallCheck3.default)(this, DeviceDetection);

    var _parseUserAgent = parseUserAgent(getUserAgent()),
        browser = _parseUserAgent.browser,
        os = _parseUserAgent.os;

    this.browser = browser;
    this.os = os;
  }

  (0, _createClass3.default)(DeviceDetection, [{
    key: "isIos",
    value: function isIos() {
      return this.os === "iOS";
    }
  }, {
    key: "isAndroidChrome",
    value: function isAndroidChrome() {
      return this.browser === "Chrome [WebView]" && this.os === "Android";
    }
  }]);
  return DeviceDetection;
}();

exports.default = DeviceDetection;

/***/ }),

/***/ "./helpers/events.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackOpenGdprModal = exports.trackGdprStopSending = exports.trackGdprKeepSending = exports.trackBannerClose = exports.trackBannerShown = exports.trackMiniBagProductDelete = exports.trackSubmitCountrySelector = exports.trackOpenCountryModal = exports.trackNavOpen = exports.trackSocialClick = exports.getGender = exports.ANALYTICS_CONTEXT = exports.ANALYTICS_POSITION_COUNTRY_SELECTOR = exports.ANALYTICS_POSITION_FOOTER = exports.ANALYTICS_POSITION_HEADER = exports.ANALYTICS_INTERACTION_SAVED = exports.ANALYTICS_INTERACTION_HOVER = exports.ANALYTICS_INTERACTION_EXPAND = exports.ANALYTICS_INTERACTION_CLICK = exports.LoggingEmitter = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get3 = __webpack_require__("../node_modules/babel-runtime/helpers/get.js");

var _get4 = _interopRequireDefault(_get3);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _fbemitter = __webpack_require__("../node_modules/fbemitter/index.js");

var _url = __webpack_require__("../node_modules/url/url.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
// file to be replaced by analytics.js implementation?
var LoggingEmitter = exports.LoggingEmitter = function (_EventEmitter) {
  (0, _inherits3.default)(LoggingEmitter, _EventEmitter);

  function LoggingEmitter() {
    (0, _classCallCheck3.default)(this, LoggingEmitter);
    return (0, _possibleConstructorReturn3.default)(this, (LoggingEmitter.__proto__ || (0, _getPrototypeOf2.default)(LoggingEmitter)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoggingEmitter, [{
    key: "emit",
    value: function emit() {
      var _get2;

      var _parse = (0, _url.parse)(location.toString(), true),
          query = _parse.query;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (query && query.analytics === "true") {
        var _console;

        (_console = console).log.apply(_console, args); //eslint-disable-line no-console
      }
      return (_get2 = (0, _get4.default)(LoggingEmitter.prototype.__proto__ || (0, _getPrototypeOf2.default)(LoggingEmitter.prototype), "emit", this)).call.apply(_get2, [this].concat(args));
    }
  }]);
  return LoggingEmitter;
}(_fbemitter.EventEmitter);

var emitter = new LoggingEmitter();
var emit = function emit(eventName, details) {
  return emitter.emit(eventName, details);
};
var pageLoadData = {};
var pageLoadEventsToTrack = ["tracking.productList.pageLoad"];

var trackPageLoads = function trackPageLoads() {
  //Capture selected pageLoad events
  pageLoadEventsToTrack.forEach(function (event) {
    emitter.addListener(event, function (payload) {
      pageLoadData[event] = payload;
    });
  });

  //re-emit them for signal when they're ready
  emitter.addListener("signal-ready", function () {
    (0, _keys2.default)(pageLoadData).forEach(function (event) {
      var payload = pageLoadData[event];
      emit(event + "-signal", payload);
    });
  });
};

trackPageLoads();

exports.default = emitter;
var ANALYTICS_INTERACTION_CLICK = exports.ANALYTICS_INTERACTION_CLICK = "click";
var ANALYTICS_INTERACTION_EXPAND = exports.ANALYTICS_INTERACTION_EXPAND = "expand";
var ANALYTICS_INTERACTION_HOVER = exports.ANALYTICS_INTERACTION_HOVER = "hover";
var ANALYTICS_INTERACTION_SAVED = exports.ANALYTICS_INTERACTION_SAVED = "saved";
var ANALYTICS_POSITION_HEADER = exports.ANALYTICS_POSITION_HEADER = "header";
var ANALYTICS_POSITION_FOOTER = exports.ANALYTICS_POSITION_FOOTER = "footer";
var ANALYTICS_POSITION_COUNTRY_SELECTOR = exports.ANALYTICS_POSITION_COUNTRY_SELECTOR = "country selector modal";
var ANALYTICS_CONTEXT = exports.ANALYTICS_CONTEXT = {
  navHover: "nav hover",
  openNav: "open nav section",
  social: "social icon",
  openCountryModal: "open country modal",
  footerExpandable: "concertina",
  countrySelector: "country preferences",
  minibagDeleteItem: "mini bag product delete"
};

var getGender = exports.getGender = function getGender(str) {
  if (str === "men" || str === "women") return str;
  if (str === "MW") return "men";
  if (str === "WW") return "women";
};

var trackSocialClick = exports.trackSocialClick = function trackSocialClick(details) {
  return emit("tracking.navigation.pageInteraction", details);
};

var trackNavOpen = exports.trackNavOpen = function trackNavOpen(details) {
  return emit("tracking.navigation.pageInteraction", details);
};

var trackOpenCountryModal = exports.trackOpenCountryModal = function trackOpenCountryModal(details) {
  return emit("tracking.navigation.pageInteraction", details);
};

var trackSubmitCountrySelector = exports.trackSubmitCountrySelector = function trackSubmitCountrySelector(details) {
  return emit("tracking.navigation.pageInteraction", details);
};

var trackMiniBagProductDelete = exports.trackMiniBagProductDelete = function trackMiniBagProductDelete(details) {
  return emit("tracking.miniBag.miniBagInteraction", details);
};

var trackBannerShown = exports.trackBannerShown = function trackBannerShown() {
  return emit("tracking.gdpr.bannerShow", {
    context: "gdpr banner shown",
    trackingFrequency: "session"
  });
};

var trackBannerClose = exports.trackBannerClose = function trackBannerClose() {
  return emit("tracking.gdpr.bannerClose", {
    context: "gdpr banner closed",
    trackingFrequency: "session"
  });
};

var trackGdprKeepSending = exports.trackGdprKeepSending = function trackGdprKeepSending(basicDetails) {
  return emit("tracking.gdpr.pageLoad", (0, _extends3.default)({}, basicDetails, {
    pageName: "gdpr keep sending",
    pageTitle: "gdpr keep sending"
  }));
};

var trackGdprStopSending = exports.trackGdprStopSending = function trackGdprStopSending(basicDetails) {
  return emit("tracking.gdpr.pageLoad", (0, _extends3.default)({}, basicDetails, {
    pageName: "gdpr stop sending",
    pageTitle: "gdpr stop sending"
  }));
};

var trackOpenGdprModal = exports.trackOpenGdprModal = function trackOpenGdprModal(basicDetails) {
  return emit("tracking.gdpr.pageLoad", (0, _extends3.default)({}, basicDetails, {
    pageName: "gdpr control my content",
    pageTitle: "gdpr control my content"
  }));
};

/***/ }),

/***/ "./helpers/formatting.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var truncateTitle = exports.truncateTitle = function truncateTitle(item) {
  return item.subtitle && item.subtitle.length > 0 ? item.label.substring(0, 24) : item.label.substring(0, 36);
};

/***/ }),

/***/ "./helpers/gesture.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = undefined;

var _slicedToArray2 = __webpack_require__("../node_modules/babel-runtime/helpers/slicedToArray.js");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _debounce = __webpack_require__("../node_modules/lodash/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventList = []; /*
                    
                    https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10511224/
                    
                    Edge browser running on a device with touch capability (such as Surface tablet) currently fires mouseover, mouseout, mouseover, click, and mouseout events when you tap.
                    
                    If you have a component that reacts to both tap and hover events (e.g., onMouseEnter, onMouseLeave), then you're going to need to filter out the additional mouse events to ensure the expected behaviour for tap on Edge + Surface.
                    
                    */

var processEvents = (0, _debounce2.default)(function () {
  var validEvent = eventList.find(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
        type = _ref2[0].type;

    return type === "click";
  }) || eventList[0];

  var _validEvent = (0, _slicedToArray3.default)(validEvent, 2),
      e = _validEvent[0],
      callbackFn = _validEvent[1];

  callbackFn(e);

  eventList = [];
}, 1);

/* will call callbackFn with e if it thinks e is a valid event and not a multi gesture variant */
var validate = exports.validate = function validate(e, callbackFn) {
  eventList.push([e.nativeEvent || e, callbackFn]);
  processEvents();
};

/***/ }),

/***/ "./helpers/get.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = get;
function get(object, path) {
  var splitPath = path.split(".");
  var length = splitPath.length;
  var index = 0;

  while (object != null && index < length) {
    object = object[splitPath[index++]];
  }

  return index && index === length ? object : undefined;
}

/***/ }),

/***/ "./helpers/links.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var desktopUrls = exports.desktopUrls = new RegExp(/http(s)?:\/\/(www|us|test|ustest)?(\.)?asos(services)?\.(com|de|fr)(\/(es|it|au|ru|se|nl))?\//gi);

var desktopToMobile = exports.desktopToMobile = function desktopToMobile(link, storeUrl) {
  if (link && storeUrl) {
    link = link.replace(desktopUrls, storeUrl);
  }
  return link;
};

/***/ }),

/***/ "./helpers/loadTokenBlock.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _actions = __webpack_require__("./template/state/modules/layout/actions.js");

var isValidGender = function isValidGender(gender) {
  return [_layout.FEMALE, _layout.MALE].indexOf(gender) !== -1;
};

var getTokenGender = function getTokenGender(tokens) {
  return isValidGender(tokens.gender) ? tokens.gender : _layout.DEFAULT;
};

var getStateGender = function getStateGender(state) {
  return state.layout.gender;
};

var getGender = function getGender(state, tokens) {
  var genders = [getTokenGender(tokens), (0, _asosSiteChromeStorePresentation.getFloor)(), getStateGender(state)];

  return genders.find(isValidGender) || _layout.DEFAULT;
};

var updateGenderCookie = function updateGenderCookie(gender) {
  (0, _asosSiteChromeStorePresentation.setFloor)(gender);
  return gender;
};

exports.default = function (_ref) {
  var store = _ref.store,
      initialState = _ref.initialState,
      newState = _ref.newState;

  var newGender = updateGenderCookie(getGender(initialState, newState));

  if (getStateGender(initialState) !== newGender) {
    store.dispatch((0, _actions.setGender)(newGender));
  }
};

/***/ }),

/***/ "./helpers/logger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var shouldLog = typeof window === "undefined" || "production" === "development";

var logger = {
  info: function info() {
    var _console;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return shouldLog && (_console = console).info.apply(_console, ["[" + new Date().toISOString() + "]"].concat(args));
  },
  error: function error() {
    var _console2;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return shouldLog && (_console2 = console).error.apply(_console2, ["[" + new Date().toISOString() + "]"].concat(args));
  },
  warn: function warn() {
    var _console3;

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return shouldLog && (_console3 = console).warn.apply(_console3, ["[" + new Date().toISOString() + "]"].concat(args));
  }
};

exports.default = logger;

/***/ }),

/***/ "./helpers/lowerEntries.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends4 = _interopRequireDefault(_extends3);

var _keys = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__("../node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = lowerEntries;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function lowerEntries(obj) {
  if ((typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) !== "object" || !obj) return obj;

  return (0, _keys2.default)(obj).reduce(function (lowered, key) {
    return (0, _extends4.default)({}, lowered, (0, _defineProperty3.default)({}, key, typeof obj[key] === "string" ? obj[key].toLowerCase() : obj[key]));
  }, {});
}

/***/ }),

/***/ "./helpers/manifest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentStore = exports.mapsToTheComStore = undefined;

var _url = __webpack_require__("./helpers/url.js");

var getPreferredSiteRedirects = function getPreferredSiteRedirects(manifest) {
  var keyStoreDataversion = manifest.keyStoreDataversion,
      preferredSiteRedirects = manifest.preferredSiteRedirects;

  var currentVersion = keyStoreDataversion.current;

  return preferredSiteRedirects.keyStoreDataversionVariants[currentVersion];
};

var getNonComCountryCodes = function getNonComCountryCodes(manifest) {
  return getPreferredSiteRedirects(manifest).map(function (item) {
    return item.countryCodes;
  }).reduce(function (a, v) {
    return a.concat(v);
  }, []);
};

var mapsToTheComStore = exports.mapsToTheComStore = function mapsToTheComStore(geoCountry, manifest) {
  return !(getNonComCountryCodes(manifest).indexOf(geoCountry.toLowerCase()) !== -1);
};

var getCurrentStore = exports.getCurrentStore = function getCurrentStore(manifest) {
  var url = (0, _url.getCurrentUrl)();

  return getPreferredSiteRedirects(manifest).find(function (store) {
    return url.startsWith(store.desktopUrl) || url.startsWith(store.mobileUrl);
  });
};

/***/ }),

/***/ "./helpers/monitoring.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var noticeError = exports.noticeError = function noticeError(error) {
  if (window.NREUM && window.NREUM.noticeError && error) {
    window.NREUM.noticeError(error);
  }
};

/***/ }),

/***/ "./helpers/promiseWithTimeout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROMISE_TIMEOUT = 5000;

var wrapPromiseWithTimeout = function wrapPromiseWithTimeout(promise) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PROMISE_TIMEOUT;
  return new _promise2.default(function (resolve, reject) {
    promise.then(resolve).catch(reject);
    setTimeout(function () {
      reject(new Error("Bag SDK not responding"));
    }, ms);
  });
};

exports.default = wrapPromiseWithTimeout;

/***/ }),

/***/ "./helpers/queryString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _urlParse = __webpack_require__("../node_modules/url-parse/index.js");

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withParams = exports.withParams = function withParams(link) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var parsedLink = (0, _urlParse2.default)(link, true);

  parsedLink.query = (0, _extends3.default)({}, parsedLink.query, params);

  return parsedLink.toString();
};

/***/ }),

/***/ "./helpers/storeUrls.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeLinksForAllFloors = exports.storeUrlsForAllFloors = exports.SECURE = exports.MALE = exports.FEMALE = exports.DEFAULT = undefined;

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends5 = _interopRequireDefault(_extends4);

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _utilities = __webpack_require__("../i18n/utilities/index.js");

var _constants = __webpack_require__("./template/state/modules/layout/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FLOORS = [_constants.DEFAULT, _constants.FEMALE, _constants.MALE, _constants.SECURE];

exports.DEFAULT = _constants.DEFAULT;
exports.FEMALE = _constants.FEMALE;
exports.MALE = _constants.MALE;
exports.SECURE = _constants.SECURE;


var addTrailingSlash = function addTrailingSlash(str) {
  return str + "/";
};

var storeUrlsForAllFloors = exports.storeUrlsForAllFloors = function storeUrlsForAllFloors(storeCode, platform) {
  return FLOORS.reduce(function (storeUrls, gender) {
    return (0, _extends5.default)({}, storeUrls, (0, _defineProperty3.default)({}, gender, addTrailingSlash((0, _asosSiteChromeStorePresentation.getStoreUrlByStoreCode)({
      storeCode: storeCode,
      gender: gender,
      isMobile: platform === "mobile",
      environmentMode: process.env.CLIENT_ENVIRONMENT_MODE
    }))));
  }, {});
};

var storeLinksForAllFloors = exports.storeLinksForAllFloors = function storeLinksForAllFloors(storeCode) {
  return FLOORS.reduce(function (links, floor) {
    return (0, _extends5.default)({}, links, (0, _defineProperty3.default)({}, floor, (0, _utilities.getSocialLinks)({ storeCode: storeCode, floor: floor })));
  }, {});
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "./helpers/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParamValue = getParamValue;
exports.getCurrentUrl = getCurrentUrl;
exports.removeURLParameter = removeURLParameter;
function getParamValue(urlParam) {
  var params = window.location.search.substring(1).split("&");
  var browseUrl = params.find(function (p) {
    return p.toLowerCase().startsWith(urlParam.toLowerCase() + "=");
  }) || "";

  return browseUrl.split("=")[1];
}

function getCurrentUrl() {
  var _window$location = window.location,
      host = _window$location.host,
      pathname = _window$location.pathname;

  return host + pathname;
}

function removeURLParameter(url, parameter) {
  var urlParts = url.split("?");
  if (urlParts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var parts = urlParts[1].split(/[&;]/g);

    for (var i = parts.length; i-- > 0;) {
      if (parts[i].lastIndexOf(prefix, 0) !== -1) {
        parts.splice(i, 1);
      }
    }

    return urlParts[0] + (parts.length ? "?" + parts.join("&") : "");
  } else {
    return url;
  }
}

var stripSubdomain = exports.stripSubdomain = function stripSubdomain(hostname) {
  return hostname.split(".").slice(1).join(".");
};

/***/ }),

/***/ "./helpers/webStorage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getValueFromSessionStorage = exports.getValueFromSessionStorage = function getValueFromSessionStorage(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    return false;
  }
};

var hasSessionStorageKey = exports.hasSessionStorageKey = function hasSessionStorageKey(key) {
  try {
    return !!sessionStorage.getItem(key);
  } catch (e) {
    return false;
  }
};

var setSessionStorage = exports.setSessionStorage = function setSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    return false;
  }
};

var setLocalStorage = exports.setLocalStorage = function setLocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    return false;
  }
};

var getValueFromLocalStorage = exports.getValueFromLocalStorage = function getValueFromLocalStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return false;
  }
};

var removeValueFromLocalStorage = exports.removeValueFromLocalStorage = function removeValueFromLocalStorage(key) {
  try {
    return localStorage.removeItem(key);
  } catch (e) {
    return false;
  }
};

/***/ }),

/***/ "./template/clientConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _constants = __webpack_require__("./template/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getClientConfigFromWindow = function getClientConfigFromWindow() {
  if (typeof window !== "undefined" && window[_constants.siteChromeClientConfig]) {
    return window[_constants.siteChromeClientConfig];
  }
  return false;
};

var isLocal = function isLocal() {
  return typeof window !== "undefined" && window.location.hostname.indexOf("local") !== -1;
};

var isServer = function isServer() {
  return typeof window === "undefined";
};

var getXSiteOrigin = function getXSiteOrigin() {
  var cookies = document.cookie.split(";");
  var xSite = cookies.find(function (cookie) {
    return cookie.toLowerCase().indexOf("x-site-origin=") !== -1;
  });

  if (!xSite) return;

  return xSite.split("=")[1];
};

var getClientConfig = function getClientConfig() {
  return getClientConfigFromWindow() || (0, _keys2.default)(process.env).filter(function (key) {
    return key.startsWith(_constants.clientEnvPrefix);
  }).reduce(function (acc, key) {
    acc[key.replace(_constants.clientEnvPrefix, "")] = process.env[key];
    return acc;
  }, {});
};

exports.default = {
  get: getClientConfig,
  isLocal: isLocal,
  isServer: isServer,
  getXSiteOrigin: getXSiteOrigin
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "./template/components/Breadcrumbs/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_26dhdzA","list":"_3_HulsW"};

/***/ }),

/***/ "./template/components/Burger/Burger.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"burger":"_387JN2Z","burger__hidden":"_2CZGxSY"};

/***/ }),

/***/ "./template/components/Burger/Burger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _Burger = __webpack_require__("./template/components/Burger/Burger.css");

var _Burger2 = _interopRequireDefault(_Burger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Burger = function (_Component) {
  (0, _inherits3.default)(Burger, _Component);

  function Burger() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Burger);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Burger.__proto__ || (0, _getPrototypeOf2.default)(Burger)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (component) {
      return _this.component = component;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Burger, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          openSidePanel = _props.openSidePanel,
          formatTranslation = _props.formatTranslation;

      return _react2.default.createElement("button", {
        className: _Burger2.default.burger,
        onClick: openSidePanel,
        ref: this.saveRef,
        "aria-label": formatTranslation("Burger.OpenNavigationLabel"),
        tabIndex: this.props.isSidePanelOpen ? -1 : 0,
        "data-testid": "burger-menu-button"
      });
    }
  }]);
  return Burger;
}(_react.Component);

exports.default = (0, _translation2.default)(Burger);

/***/ }),

/***/ "./template/components/Burger/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _Burger = __webpack_require__("./template/components/Burger/Burger.js");

var _Burger2 = _interopRequireDefault(_Burger);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _search = __webpack_require__("./template/state/modules/search/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ openSidePanel: _layout.openSidePanel }, dispatch);
}

function mapStateToProps(state) {
  return {
    isSidePanelOpen: (0, _layout.isSidePanelOpen)(state),
    isSearchVisible: (0, _search.getVisibility)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Burger2.default);

/***/ }),

/***/ "./template/components/Button/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_1DSc_jN","button__isPrimary":"cFiVQcw","button__isSecondary":"_3-TPxFN","button__isTertiary":"_2vYGg5k","button__isGreen":"_2qfI174","button__hasInvertedSize":"_1go2Ewe","content":"wAc4igN","content__isHidden":"_3cNyKVT","spinner":"_3CaW0je"};

/***/ }),

/***/ "./template/components/Button/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _Spinner = __webpack_require__("./template/components/Spinner/index.js");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _index = __webpack_require__("./template/components/Button/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_index2.default);

var Button = function Button(_ref) {
  var children = _ref.children,
      hasInvertedSize = _ref.hasInvertedSize,
      hasSpinner = _ref.hasSpinner,
      href = _ref.href,
      theme = _ref.theme,
      type = _ref.type,
      rest = (0, _objectWithoutProperties3.default)(_ref, ["children", "hasInvertedSize", "hasSpinner", "href", "theme", "type"]);

  var tag = href ? "a" : "button";
  var className = cx("button", {
    button__hasInvertedSize: hasInvertedSize,
    button__isPrimary: theme === "primary",
    button__isSecondary: theme === "secondary",
    button__isTertiary: theme === "tertiary",
    button__isGreen: theme === "green"
  });

  var content = _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "span",
      {
        className: cx("content", {
          content__isHidden: hasSpinner
        })
      },
      children
    ),
    hasSpinner && _react2.default.createElement(
      "span",
      { className: _index2.default.spinner },
      _react2.default.createElement(_Spinner2.default, { size: "small" })
    )
  );

  return _react2.default.createElement(tag, (0, _extends3.default)({}, rest, { className: className, href: href, type: type }), content);
};

Button.defaultProps = {
  type: "button"
};

exports.default = Button;

/***/ }),

/***/ "./template/components/ClickOutside/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClickOutside = function (_Component) {
  (0, _inherits3.default)(ClickOutside, _Component);

  function ClickOutside() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClickOutside);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickOutside.__proto__ || (0, _getPrototypeOf2.default)(ClickOutside)).call.apply(_ref, [this].concat(args))), _this), _this.handler = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          callback = _this$props.callback;


      if (!_this.el || disabled) {
        return;
      }

      var el = _this.el;
      var target = e.target;


      if (target === el || el.contains(target)) {
        return;
      }

      callback(e);

      if (_this.validPropagationTargets.find(function (t) {
        return t && t.contains(target);
      })) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClickOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("click", this.handler, true);
      document.addEventListener("touchend", this.handler, true);
      this.validPropagationTargets = (this.props.validPropagationTargets || []).map(function (selector) {
        return document.querySelector(selector);
      }).filter(function (v) {
        return v;
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.handler);
      document.removeEventListener("touchend", this.handler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        "div",
        {
          ref: function ref(el) {
            _this2.el = el;
          }
        },
        this.props.children
      );
    }
  }]);
  return ClickOutside;
}(_react.Component);

exports.default = ClickOutside;

/***/ }),

/***/ "./template/components/CountrySelector/Backdrop.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"_2l01zku"};

/***/ }),

/***/ "./template/components/CountrySelector/Backdrop.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Backdrop = __webpack_require__("./template/components/CountrySelector/Backdrop.css");

var _Backdrop2 = _interopRequireDefault(_Backdrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backdrop = function Backdrop(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    "div",
    { className: _Backdrop2.default.backdrop },
    children
  );
};

exports.default = Backdrop;

/***/ }),

/***/ "./template/components/CountrySelector/Container.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_37-lec9","container":"_1IWXq8E","container__notLoading":"_2Yqh5U6","container__withError":"Bb4CiTc"};

/***/ }),

/***/ "./template/components/CountrySelector/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Container = __webpack_require__("./template/components/CountrySelector/Container.css");

var _Container2 = _interopRequireDefault(_Container);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_Container2.default);

var Container = function (_Component) {
  (0, _inherits3.default)(Container, _Component);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Container.__proto__ || (0, _getPrototypeOf2.default)(Container)).call.apply(_ref, [this].concat(args))), _this), _this.state = { warningShowing: true }, _this.handleClose = /* istanbul ignore next */function (e) {
      var onClose = _this.props.onClose;

      // Escape

      if (e.keyCode === 27) {
        e.preventDefault();
        onClose();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Container, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        showWarning: this.showWarning.bind(this)
      };
    }

    /* istanbul ignore next */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keyup", this.handleClose);
    }

    /* istanbul ignore next */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keyup", this.handleClose);
    }
  }, {
    key: "showWarning",
    value: function showWarning(isShowing) {
      if (isShowing) this.wrapper.scrollTop = this.wrapper.scrollHeight;
      this.setState({
        warningShowing: isShowing
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _cx;

      var children = this.props.children;


      return _react2.default.createElement(
        "div",
        { className: _Container2.default.wrapper, ref: function ref(el) {
            return _this2.wrapper = el;
          } },
        _react2.default.createElement(
          "div",
          {
            className: cx([_Container2.default.container], (_cx = {}, (0, _defineProperty3.default)(_cx, _Container2.default.container__withError, this.props.withError), (0, _defineProperty3.default)(_cx, _Container2.default.container__notLoading, !this.props.isLoading), _cx))
          },
          children
        )
      );
    }
  }]);
  return Container;
}(_react.Component);

Container.childContextTypes = {
  showWarning: _propTypes2.default.func
};
exports.default = Container;

/***/ }),

/***/ "./template/components/CountrySelector/CountrySelector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Spinner = __webpack_require__("./template/components/Spinner/index.js");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Fade = __webpack_require__("./template/components/CountrySelector/Fade.js");

var _Fade2 = _interopRequireDefault(_Fade);

var _Backdrop = __webpack_require__("./template/components/CountrySelector/Backdrop.js");

var _Backdrop2 = _interopRequireDefault(_Backdrop);

var _Form = __webpack_require__("./template/components/CountrySelector/Form.js");

var _Form2 = _interopRequireDefault(_Form);

var _Container = __webpack_require__("./template/components/CountrySelector/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountrySelector = function CountrySelector(_ref) {
  var alternateUrls = _ref.alternateUrls,
      country = _ref.country,
      hasSetCurrencyError = _ref.hasSetCurrencyError,
      hasVoucherError = _ref.hasVoucherError,
      isLoading = _ref.isLoading,
      isOpen = _ref.isOpen,
      noOfProductsInBag = _ref.noOfProductsInBag,
      onClose = _ref.onClose,
      onCountryChange = _ref.onCountryChange,
      onSubmit = _ref.onSubmit,
      regionalStore = _ref.regionalStore;
  return _react2.default.createElement(
    _Fade2.default,
    { isActive: isOpen },
    _react2.default.createElement(_Backdrop2.default, null),
    _react2.default.createElement(
      _Container2.default,
      {
        onClose: onClose,
        isLoading: isLoading,
        withError: hasVoucherError || hasSetCurrencyError
      },
      isLoading || country == null ? _react2.default.createElement(_Spinner2.default, { size: "x-large" }) : _react2.default.createElement(_Form2.default, (0, _extends3.default)({}, country, {
        hasSetCurrencyError: hasSetCurrencyError,
        hasVoucherError: hasVoucherError,
        noOfProductsInBag: noOfProductsInBag,
        onClose: onClose,
        onCountryChange: onCountryChange,
        onSubmit: onSubmit,
        regionalStore: regionalStore,
        storeUrl: alternateUrls && alternateUrls[country.lang] && alternateUrls[country.lang].url
      }))
    )
  );
};

exports.default = CountrySelector;

/***/ }),

/***/ "./template/components/CountrySelector/Fade.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fade":"SnnTmDC","fade__entered":"dDRZo3X","fade__entering":"_3Sf7HnX","fade__exited":"_2DGNX8Z","fade__exiting":"_3IzcYIk"};

/***/ }),

/***/ "./template/components/CountrySelector/Fade.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _CSSTransition = __webpack_require__("../node_modules/react-transition-group/CSSTransition.js");

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _Fade = __webpack_require__("./template/components/CountrySelector/Fade.css");

var _Fade2 = _interopRequireDefault(_Fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fade = function (_Component) {
  (0, _inherits3.default)(Fade, _Component);

  function Fade() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Fade);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Fade.__proto__ || (0, _getPrototypeOf2.default)(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = /* istanbul ignore next */function () {
      _this.y = window.scrollY;
      scrollTo(0, 0);

      document.body.classList.add("chrome-bodylock");
    }, _this.handleExit = /* istanbul ignore next */function () {
      document.body.classList.remove("chrome-bodylock");

      scrollTo(0, _this.y);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // HACK: iOS 10 and below do not like fixed with forms


  (0, _createClass3.default)(Fade, [{
    key: "render",

    // end

    value: function render() {
      var _props = this.props,
          isActive = _props.isActive,
          children = _props.children;


      return _react2.default.createElement(
        _CSSTransition2.default,
        {
          "in": isActive,
          mountOnEnter: true,
          unmountOnExit: true,
          timeout: 300,
          onEnter: this.handleEnter,
          onExited: this.handleExit,
          classNames: {
            enter: _Fade2.default.fade__entered,
            enterActive: _Fade2.default.fade__entering,
            exit: _Fade2.default.fade__exited,
            exitActive: _Fade2.default.fade__exiting
          }
        },
        _react2.default.createElement(
          "div",
          { className: _Fade2.default.fade },
          children
        )
      );
    }
  }]);
  return Fade;
}(_react.Component);

Fade.defaultProps = {
  isActive: false
};

exports.default = Fade;

/***/ }),

/***/ "./template/components/CountrySelector/Form.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2WNIJuP","header":"_9Su1VYo","form":"_3uy0rRO","field":"OVtBwTj","features":"_3MEhp6k","proposition":"_2OFFw51","propositions":"_3-JfxSf","providers":"_1tjzQfV","provider":"_3P6snIZ","currency":"_1QmYx4Z","label":"kryyYP3","label__disabled":"_3odbvKF","select":"_3JpRU2l","actions":"_3qiSl8R","submitButton":"V7TpTZV","closeButton":"wXnknxI","error":"_12D7Y4x","warning":"_1BeDSc8"};

/***/ }),

/***/ "./template/components/CountrySelector/Form.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _Form = __webpack_require__("./template/components/CountrySelector/Form.css");

var _Form2 = _interopRequireDefault(_Form);

var _constants = __webpack_require__("./template/components/CountrySelector/constants.js");

var _events = __webpack_require__("./helpers/events.js");

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _context = __webpack_require__("./client/context/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_Form2.default);

var cleanUrl = function cleanUrl(url) {
  if (!url) return url;
  return url.replace(/&amp;/gi, "&").replace(/&#x3D;/gi, "=");
};

var Form = function (_Component) {
  (0, _inherits3.default)(Form, _Component);

  function Form(props) {
    (0, _classCallCheck3.default)(this, Form);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Form.__proto__ || (0, _getPrototypeOf2.default)(Form)).call(this, props));

    _this.handleCountryChange = function (e) {
      var _this$props = _this.props,
          onCountryChange = _this$props.onCountryChange,
          countryCode = _this$props.countryCode,
          countries = _this$props.countries;

      var country = countries.find(function (country) {
        return country.countryCode === e.target.value;
      });

      /* istanbul ignore next */
      if (countryCode.toLowerCase() !== e.target.value.toLowerCase() && country) {
        onCountryChange(e.target.value, country.defaultLanguage);
      }
    };

    _this.handleCurrencyChange = function (e) {
      if (_this.state.currencyId !== Number(e.target.value)) {
        _this.setState({
          currencyId: e.target.value,
          isCurrencyUpdateManual: true
        });
      }
    };

    _this.handleCloseClick = function () {
      var onClose = _this.props.onClose;


      onClose();
    };

    _this.handleCloseKeyDown = function (e) {
      // Tab
      if (e.keyCode === 9) {
        e.preventDefault();

        if (e.shiftKey) {
          _this.submitButton.focus();
        } else {
          _this.countrySelect.focus();
        }
      }
    };

    _this.handleCountryKeyDown = function (e) {
      // Tab && shift
      if (e.keyCode === 9 && e.shiftKey) {
        e.preventDefault();
        _this.closeButton.focus();
      }
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();

      var _this$props2 = _this.props,
          countryCode = _this$props2.countryCode,
          lang = _this$props2.lang,
          currencies = _this$props2.currencies,
          onSubmit = _this$props2.onSubmit,
          labels = _this$props2.labels,
          regionalStore = _this$props2.regionalStore,
          storeCode = _this$props2.storeCode,
          siteId = _this$props2.siteId,
          storeUrl = _this$props2.storeUrl,
          countries = _this$props2.countries,
          sizeSchema = _this$props2.sizeSchema;
      var _this$state = _this.state,
          currencyId = _this$state.currencyId,
          isCurrencyUpdateManual = _this$state.isCurrencyUpdateManual;


      var currentCurrencies = currencies.filter(function (currency) {
        return currency.currencyId == currencyId;
      }).map(function (currency) {
        return {
          currencyId: currency.currencyId,
          currencyCode: currency.currency
        };
      });
      var currentCurrency = currentCurrencies[0];

      var country = countries.find(function (country) {
        return country.countryCode === countryCode;
      });
      var affiliateId = (0, _context.getContext)() && (0, _context.getContext)().getAffiliateId();
      var isoLanguage = lang.slice(0, 2).toLowerCase();

      (0, _events.trackSubmitCountrySelector)({
        context: _events.ANALYTICS_CONTEXT.countrySelector,
        interaction: _events.ANALYTICS_INTERACTION_SAVED,
        elementText: labels.update,
        properties: {
          positionOnPage: _events.ANALYTICS_POSITION_COUNTRY_SELECTOR,
          formFields: {
            country: {
              countryISOFrom: regionalStore.countryCode,
              countryISOTo: countryCode,
              storeFrom: regionalStore.storeCode,
              storeTo: storeCode,
              siteIDFrom: regionalStore.siteId,
              siteIDTo: siteId,
              isUpdateManual: regionalStore.countryCode !== countryCode
            },
            currency: {
              currencyISOFrom: regionalStore.currency,
              currencyISOTo: currentCurrency.currencyCode,
              isUpdateManual: isCurrencyUpdateManual
            },
            language: {
              languageISOFrom: regionalStore.language.slice(0, 2).toLowerCase(),
              languageISOTo: isoLanguage,
              languageTextFrom: _constants.LANGUAGE_MAP[regionalStore.language.slice(0, 2).toLowerCase()],
              languageTextTo: _constants.LANGUAGE_MAP[lang.slice(0, 2).toLowerCase()],
              isUpdateManual: false
            }
          }
        }
      });

      onSubmit(countryCode, currentCurrency.currencyCode, cleanUrl(storeUrl) || "//" + country.url, regionalStore.countryCode, affiliateId);

      (0, _context.setCookies)({
        browseCountry: countryCode,
        browseCurrency: currentCurrency.currencyCode,
        browseCurrencyId: currentCurrency.currencyId,
        browseLanguage: isoLanguage,
        browseSizeSchema: sizeSchema,
        storeId: storeCode
      });
    };

    _this.state = {
      currencyId: _this.getCurrency(),
      isCurrencyUpdateManual: false
    };
    return _this;
  }

  (0, _createClass3.default)(Form, [{
    key: "shouldDisplayWarning",
    value: function shouldDisplayWarning() {
      var _props = this.props,
          hasSetCurrencyError = _props.hasSetCurrencyError,
          noOfProductsInBag = _props.noOfProductsInBag,
          countryCode = _props.countryCode,
          regionalStore = _props.regionalStore;


      return !hasSetCurrencyError && noOfProductsInBag > 0 && countryCode !== regionalStore.countryCode;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.context.showWarning(_this2.shouldDisplayWarning());
      }, 0);
    }
  }, {
    key: "getCurrency",
    value: function getCurrency() {
      var _props2 = this.props,
          currencies = _props2.currencies,
          regionalStore = _props2.regionalStore,
          countryCode = _props2.countryCode;


      var currentCurrency = currencies.find(function (currency) {
        return currency.currency === regionalStore.currency;
      });
      var defaultCurrency = currencies[0];

      return countryCode === regionalStore.countryCode && currentCurrency ? currentCurrency.currencyId : defaultCurrency.currencyId;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          countries = _props3.countries,
          countryCode = _props3.countryCode,
          currencies = _props3.currencies,
          formatTranslation = _props3.formatTranslation,
          hasSetCurrencyError = _props3.hasSetCurrencyError,
          hasVoucherError = _props3.hasVoucherError,
          labels = _props3.labels,
          paymentProviders = _props3.paymentProviders,
          propositions = _props3.propositions;
      var currencyId = this.state.currencyId;

      var displayWarning = this.shouldDisplayWarning();

      return _react2.default.createElement(
        "section",
        {
          className: _Form2.default.container,
          "data-testid": "country-selector-form",
          role: "dialog",
          "aria-labelledby": "country-title"
        },
        _react2.default.createElement(
          "h1",
          { id: "country-title", className: _Form2.default.header },
          labels.title
        ),
        _react2.default.createElement(
          "form",
          { className: _Form2.default.form, onSubmit: this.handleSubmit },
          _react2.default.createElement(
            "div",
            { className: _Form2.default.field },
            _react2.default.createElement(
              "label",
              { htmlFor: "country", className: _Form2.default.label },
              labels.countrySelect
            ),
            _react2.default.createElement(
              "select",
              {
                id: "country",
                className: _Form2.default.select,
                autoFocus: true,
                onChange: this.handleCountryChange,
                onKeyDown: this.handleCountryKeyDown,
                ref: function ref(c) {
                  return _this3.countrySelect = c;
                },
                defaultValue: countryCode
              },
              countries.map(function (country) {
                return _react2.default.createElement(
                  "option",
                  { key: country.countryCode, value: country.countryCode },
                  country.name
                );
              })
            ),
            _react2.default.createElement(
              "div",
              { className: _Form2.default.features },
              propositions.length > 0 && _react2.default.createElement(
                "ol",
                { className: _Form2.default.propositions },
                propositions.map(function (proposition, i) {
                  return _react2.default.createElement(
                    "li",
                    { key: i, className: _Form2.default.proposition },
                    proposition
                  );
                })
              ),
              paymentProviders.length > 0 && _react2.default.createElement(
                "ol",
                { className: _Form2.default.providers },
                paymentProviders.map(function (provider) {
                  return _react2.default.createElement(
                    "li",
                    { key: provider.name, className: _Form2.default.provider },
                    _react2.default.createElement("img", { src: provider.logo, alt: provider.name })
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _Form2.default.field },
            _react2.default.createElement(
              "label",
              {
                htmlFor: "currency",
                className: cx([_Form2.default.label], (0, _defineProperty3.default)({}, _Form2.default.label__disabled, hasSetCurrencyError))
              },
              labels.currencySelect
            ),
            currencies.length > 1 ? _react2.default.createElement(
              "select",
              {
                id: "currency",
                className: _Form2.default.select,
                defaultValue: currencyId,
                onBlur: this.handleCurrencyChange,
                disabled: hasSetCurrencyError
              },
              currencies.map(function (currency) {
                return _react2.default.createElement(
                  "option",
                  { key: currency.currencyId, value: currency.currencyId },
                  currency.text
                );
              })
            ) : _react2.default.createElement(
              "span",
              { id: "singleCurrency", className: _Form2.default.currency },
              currencies.length && currencies[0].text
            )
          ),
          hasSetCurrencyError && hasVoucherError && _react2.default.createElement(
            "div",
            { className: _Form2.default.error, "data-testid": "currency-message" },
            _react2.default.createElement(
              "p",
              null,
              labels.voucherErrorMessage
            )
          ),
          hasSetCurrencyError && !hasVoucherError && _react2.default.createElement(
            "div",
            { className: _Form2.default.error, "data-testid": "set-currency-message" },
            _react2.default.createElement(
              "p",
              null,
              formatTranslation("Errors.SomethingDoesntLookRight")
            )
          ),
          !hasSetCurrencyError && _react2.default.createElement(
            "div",
            { className: _Form2.default.actions },
            _react2.default.createElement(
              "button",
              {
                type: "submit",
                className: _Form2.default.submitButton,
                "data-testid": "save-country-button",
                ref: function ref(c) {
                  return _this3.submitButton = c;
                }
              },
              labels.update
            )
          ),
          displayWarning && _react2.default.createElement(
            "div",
            { className: _Form2.default.warning },
            _react2.default.createElement(
              "p",
              null,
              labels.bagErrorMessage
            )
          ),
          _react2.default.createElement(
            "button",
            {
              type: "button",
              className: _Form2.default.closeButton,
              "data-testid": "close-button",
              onClick: this.handleCloseClick,
              onKeyDown: this.handleCloseKeyDown,
              ref: function ref(c) {
                return _this3.closeButton = c;
              }
            },
            _react2.default.createElement(
              "span",
              null,
              "Close"
            )
          )
        )
      );
    }
  }]);
  return Form;
}(_react.Component);

Form.defaultProps = {
  countries: [],
  currencies: [],
  propositions: [],
  paymentProviders: []
};
Form.contextTypes = {
  showWarning: _propTypes2.default.func
};
exports.default = (0, _translation2.default)(Form);

/***/ }),

/***/ "./template/components/CountrySelector/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LANGUAGE_MAP = exports.LANGUAGE_MAP = {
  de: "German",
  es: "Spanish",
  en: "English",
  fr: "French",
  it: "Italian",
  ru: "Russian"
};

/***/ }),

/***/ "./template/components/CountrySelector/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _countrySelector = __webpack_require__("./template/state/modules/countrySelector/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

var _CountrySelector = __webpack_require__("./template/components/CountrySelector/CountrySelector.js");

var _CountrySelector2 = _interopRequireDefault(_CountrySelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    onClose: _countrySelector.closeCountrySelector,
    onCountryChange: _countrySelector.setCountry,
    onSubmit: _countrySelector.updatePreferences
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    alternateUrls: (0, _countrySelector.getCountrySelectorAlternateUrls)(state),
    country: (0, _countrySelector.getCountrySelectorCountry)(state),
    error: (0, _countrySelector.getCountrySelectorError)(state),
    hasSetCurrencyError: (0, _countrySelector.getHasSetCurrencyError)(state),
    hasVoucherError: (0, _countrySelector.getHasVoucherError)(state),
    isLoading: (0, _countrySelector.getCountrySelectorLoading)(state),
    isOpen: (0, _countrySelector.getCountrySelectorVisibility)(state),
    noOfProductsInBag: (0, _bag.getTotalQuantity)(state),
    regionalStore: {
      countryCode: (0, _regionalStore.getCountryCode)(state),
      storeCode: (0, _regionalStore.getStoreCode)(state),
      siteId: (0, _regionalStore.getSiteId)(state),
      currency: (0, _regionalStore.getCurrency)(state),
      language: (0, _regionalStore.getDefaultLanguage)(state),
      countryName: (0, _regionalStore.getCountryName)(state),
      sizeSchema: (0, _regionalStore.getDefaultSizeSchema)(state)
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_CountrySelector2.default);

/***/ }),

/***/ "./template/components/CountrySelectorButton/CountrySelectorButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("./template/components/CountrySelectorButton/index.css");

var _index2 = _interopRequireDefault(_index);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _events = __webpack_require__("./helpers/events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var CountrySelectorButton = function (_Component) {
  (0, _inherits3.default)(CountrySelectorButton, _Component);

  function CountrySelectorButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CountrySelectorButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CountrySelectorButton.__proto__ || (0, _getPrototypeOf2.default)(CountrySelectorButton)).call.apply(_ref, [this].concat(args))), _this), _this.trackOpenCountrySelector = function () {
      var position = _this.props.position;

      (0, _events.trackOpenCountryModal)({
        context: _events.ANALYTICS_CONTEXT.openCountryModal,
        interaction: _events.ANALYTICS_INTERACTION_CLICK,
        properties: {
          positionOnPage: position
        }
      });
    }, _this.handleClick = function () {
      var _this$props = _this.props,
          openCountrySelector = _this$props.openCountrySelector,
          closeSidePanel = _this$props.closeSidePanel;

      closeSidePanel();
      openCountrySelector();
      _this.trackOpenCountrySelector();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CountrySelectorButton, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          formatTranslation = _props.formatTranslation,
          countryFlag = _props.countryFlag,
          countryName = _props.countryName,
          withLabels = _props.withLabels;


      var containerClass = withLabels ? cx(_index2.default.container, _index2.default.withLabels) : _index2.default.container;

      return _react2.default.createElement(
        "div",
        { className: containerClass, "data-testid": "country-selector" },
        withLabels && _react2.default.createElement(
          "span",
          { className: _index2.default.header },
          formatTranslation("CountrySelectorButton.Heading")
        ),
        _react2.default.createElement(
          "button",
          {
            className: _index2.default.button,
            "data-testid": "country-selector-btn",
            type: "button",
            "aria-label": formatTranslation("CountrySelectorButton.Heading") + " " + countryName + ". " + formatTranslation("CountrySelectorButton.ChangeCountry"),
            onClick: this.handleClick
          },
          withLabels && _react2.default.createElement(
            "span",
            { className: _index2.default.locationText },
            formatTranslation("CountrySelectorButton.LocationText")
          ),
          _react2.default.createElement("img", {
            src: countryFlag,
            alt: countryName,
            className: _index2.default.countryFlag
          }),
          withLabels && _react2.default.createElement(
            "span",
            { className: _index2.default.changeLabel },
            formatTranslation("CountrySelectorButton.ChangeButton")
          )
        )
      );
    }
  }]);
  return CountrySelectorButton;
}(_react.Component);

CountrySelectorButton.defaultProps = {
  withLabels: false
};

exports.default = (0, _translation2.default)(CountrySelectorButton);

/***/ }),

/***/ "./template/components/CountrySelectorButton/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2yzMbJD","header":"_3g4nBO9","button":"YvZ3lbB","locationText":"_2F4ufl5","changeLabel":"Tg743C9","countryFlag":"_2S5PiQY","withLabels":"_3n7i0ux"};

/***/ }),

/***/ "./template/components/CountrySelectorButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _CountrySelectorButton = __webpack_require__("./template/components/CountrySelectorButton/CountrySelectorButton.js");

var _CountrySelectorButton2 = _interopRequireDefault(_CountrySelectorButton);

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _countrySelector = __webpack_require__("./template/state/modules/countrySelector/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    openCountrySelector: _countrySelector.openCountrySelector,
    closeSidePanel: _layout.closeSidePanel
  }, dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    countryName: (0, _regionalStore.getCountryName)(state),
    countryFlag: (0, _regionalStore.getCountryFlag)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_CountrySelectorButton2.default);

/***/ }),

/***/ "./template/components/Dropdown/Dropdown.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _IconButton = __webpack_require__("./template/components/IconButton/index.js");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _gesture = __webpack_require__("./helpers/gesture.js");

var _index = __webpack_require__("./template/components/Dropdown/index.css");

var _index2 = _interopRequireDefault(_index);

var _accessibility = __webpack_require__("./helpers/accessibility.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

var cx = _bind2.default.bind(_index2.default);
var ESCAPE_KEY = 27;
var ENTER_KEY = 13;
var keyCode = function keyCode(e) {
  return e.keyCode || e.which;
};

var Dropdown = function (_Component) {
  (0, _inherits3.default)(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
      return (0, _gesture.validate)(e, _this.props.open);
    }, _this.onMouseEnter = function (e) {
      return (0, _gesture.validate)(e, _this.props.open);
    }, _this.onMouseLeave = function (e) {
      return (0, _gesture.validate)(e, _this.props.onCloseWithMouse);
    }, _this.closeWithMouse = function (e) {
      e.stopPropagation();
      (0, _gesture.validate)(e, _this.props.onCloseWithMouse);
    }, _this.handleKeyDown = function (e) {
      if (keyCode(e) === ESCAPE_KEY) {
        _this.props.onCloseWithKeyboard(e);
      }
    }, _this.handleEnterKeyDown = function (e) {
      if (keyCode(e) === ENTER_KEY) {
        _this.props.onCloseWithKeyboard(e);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Dropdown, [{
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this;

      var _props = this.props,
          body = _props.body,
          children = _props.children,
          footer = _props.footer,
          header = _props.header,
          isHidden = _props.isHidden,
          isOpen = _props.isOpen,
          name = _props.name,
          _onTransitionEnd = _props.onTransitionEnd;


      var wrapperClassnames = cx(_index2.default.wrapper, (_cx = {}, (0, _defineProperty3.default)(_cx, _index2.default.wrapper__open, isOpen), (0, _defineProperty3.default)(_cx, _index2.default.wrapper__hidden, isHidden), _cx));

      return _react2.default.createElement(
        "div",
        {
          id: name + "Dropdown",
          className: wrapperClassnames,
          onClick: this.onClick,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          onKeyDown: this.handleKeyDown,
          role: "presentation"
        },
        children,
        _react2.default.createElement(
          "div",
          {
            className: _index2.default.outerWrapper,
            "data-testid": name.toLowerCase() + "-dropdown"
          },
          _react2.default.createElement(
            "div",
            { className: _index2.default.innerWrapper },
            _react2.default.createElement(
              "div",
              {
                className: _index2.default.slidedown,
                onTransitionEnd: function onTransitionEnd() {
                  if (!isOpen) {
                    _this2.body.scrollTop = 0;
                    _onTransitionEnd();
                  }
                }
              },
              _react2.default.createElement(
                "div",
                { className: _index2.default.header },
                header && _react2.default.cloneElement(header, { focusable: isOpen }),
                _react2.default.createElement(_IconButton2.default, {
                  icon: "close",
                  onClick: this.closeWithMouse,
                  onKeyDown: this.handleEnterKeyDown,
                  className: _index2.default.close,
                  tabIndex: (0, _accessibility.tabIndex)(isOpen),
                  "data-testid": "account-close-btn"
                })
              ),
              _react2.default.createElement(
                "div",
                { className: _index2.default.body, ref: function ref(el) {
                    return _this2.body = el;
                  } },
                body && _react2.default.cloneElement(body, {
                  focusable: isOpen,
                  queryParams: { nlid: "nav header" }
                })
              ),
              footer && _react2.default.createElement(
                "div",
                { className: _index2.default.footer },
                _react2.default.cloneElement(footer, { focusable: isOpen })
              )
            )
          )
        )
      );
    }
  }]);
  return Dropdown;
}(_react.Component);

exports.default = Dropdown;

/***/ }),

/***/ "./template/components/Dropdown/DropdownContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Dropdown = __webpack_require__("./template/components/Dropdown/Dropdown.js");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _ClickOutside = __webpack_require__("./template/components/ClickOutside/index.js");

var _ClickOutside2 = _interopRequireDefault(_ClickOutside);

var _TabOutside = __webpack_require__("./template/components/TabOutside/index.js");

var _TabOutside2 = _interopRequireDefault(_TabOutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var returnFocusToWidgetIcon = function returnFocusToWidgetIcon(e) {
  e.preventDefault();
  var focusTarget = document.getElementById("accountIcon");
  return focusTarget && focusTarget.focus();
};

var DropdownContainer = function DropdownContainer(_ref) {
  var body = _ref.body,
      children = _ref.children,
      close = _ref.close,
      footer = _ref.footer,
      header = _ref.header,
      isHidden = _ref.isHidden,
      isOpen = _ref.isOpen,
      name = _ref.name,
      open = _ref.open,
      openComplete = _ref.openComplete,
      closed = _ref.closed;

  return _react2.default.createElement(
    _TabOutside2.default,
    { disabled: !isOpen, callback: close },
    _react2.default.createElement(
      _ClickOutside2.default,
      {
        disabled: !isOpen,
        callback: close,
        validPropagationTargets: ["#chrome-header", "#chrome-breadcrumb"]
      },
      _react2.default.createElement(
        _Dropdown2.default,
        {
          name: name,
          isOpen: isOpen,
          isHidden: isHidden,
          open: open,
          openComplete: openComplete,
          onCloseWithMouse: close,
          onCloseWithKeyboard: function onCloseWithKeyboard(e) {
            close();
            returnFocusToWidgetIcon(e);
          },
          header: header,
          body: body,
          footer: footer,
          onTransitionEnd: closed
        },
        children
      )
    )
  );
};

DropdownContainer.defaultProps = {
  closed: _propTypes2.default.func
};

exports.default = DropdownContainer;

/***/ }),

/***/ "./template/components/Dropdown/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"xLEaimc","wrapper__open":"_1NIO-n7","outerWrapper":"_1__Ug8F","slidedown":"_2Ydfmv-","wrapper__hidden":"_3YiroC7","innerWrapper":"_2jIx_En","body":"_4dx9Nn7","header":"Zb-NiHG","footer":"_2-UJgpr","close":"_3rZlkmo","container":"_2nFo01D"};

/***/ }),

/***/ "./template/components/Dropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _DropdownContainer = __webpack_require__("./template/components/Dropdown/DropdownContainer.js");

var _DropdownContainer2 = _interopRequireDefault(_DropdownContainer);

var _dropdown = __webpack_require__("./template/state/modules/dropdown/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    isOpen: (0, _dropdown.getDropdownIsOpen)(state, props),
    isHidden: (0, _dropdown.getDropdownIsHidden)(state, props)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var name = _ref.name;
  return {
    open: function open() {
      return dispatch((0, _dropdown.openDropdown)(name));
    },
    close: function close() {
      return dispatch((0, _dropdown.closeDropdown)(name));
    },
    closed: function closed() {
      return dispatch((0, _dropdown.dropdownClosed)(name));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DropdownContainer2.default);

/***/ }),

/***/ "./template/components/FloorNavigation/FloorNavigation.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2htQAml","container__large":"_3nGd4mQ","button":"_1DZnw9e","selected":"_2O3Pt9j"};

/***/ }),

/***/ "./template/components/FloorNavigation/FloorNavigation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _globalEventHandler = __webpack_require__("./template/globalEventHandler.js");

var _globalEventHandler2 = _interopRequireDefault(_globalEventHandler);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _FloorNavigation = __webpack_require__("./template/components/FloorNavigation/FloorNavigation.css");

var _FloorNavigation2 = _interopRequireDefault(_FloorNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_FloorNavigation2.default);

var FloorNavigation = function (_PureComponent) {
  (0, _inherits3.default)(FloorNavigation, _PureComponent);

  function FloorNavigation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FloorNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloorNavigation.__proto__ || (0, _getPrototypeOf2.default)(FloorNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.floors = {}, _this.selectFloor /* istanbul ignore next - focus is not supported in jsdom */ = function (gender) {
      _this.floors[gender].focus();
    }, _this.handleFemaleClick = function () {
      _this.setGender(_layout.FEMALE);
    }, _this.handleMaleClick = function () {
      _this.setGender(_layout.MALE);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FloorNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focusFloorEventHandler = _globalEventHandler2.default.addListener(_globalEventHandler.events.focusBackToFloor, this.selectFloor);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.focusFloorEventHandler && this.focusFloorEventHandler.remove();
    }
  }, {
    key: "setGender",
    value: function setGender(gender) {
      this.props.setGender(gender);
      (0, _globalEventHandler.focusPrimaryNavigationFor)(gender);
    }
  }, {
    key: "isSelected",
    value: function isSelected(gender) {
      var _props = this.props,
          isFemale = _props.isFemale,
          isMale = _props.isMale,
          viewport = _props.viewport;


      if (gender === _layout.MALE) {
        return isMale;
      }

      if (viewport === _layout.LARGE_VIEWPORT) {
        return isFemale;
      }

      return !isMale;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          formatTranslation = _props2.formatTranslation,
          menStoreUrl = _props2.menStoreUrl,
          womenStoreUrl = _props2.womenStoreUrl,
          viewport = _props2.viewport,
          viewable = _props2.viewable;


      var MenuTagType = viewport === _layout.LARGE_VIEWPORT ? "a" : "button";
      var womenMenuActionProp = viewport === _layout.LARGE_VIEWPORT ? { href: womenStoreUrl } : { onClick: this.handleFemaleClick };
      var menMenuActionProp = viewport === _layout.LARGE_VIEWPORT ? { href: menStoreUrl } : { onClick: this.handleMaleClick };

      return _react2.default.createElement(
        "ul",
        {
          className: cx(_FloorNavigation2.default.container, (0, _defineProperty3.default)({}, _FloorNavigation2.default.container__large, viewable.indexOf(_layout.LARGE_VIEWPORT) !== -1)),
          "data-testid": "floornav"
        },
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            MenuTagType,
            (0, _extends3.default)({
              className: cx(_FloorNavigation2.default.button, (0, _defineProperty3.default)({}, _FloorNavigation2.default.selected, this.isSelected(_layout.FEMALE))),
              "data-testid": "women-floor",
              ref: function ref(el) {
                return _this2.floors[_layout.FEMALE] = el;
              }
            }, womenMenuActionProp),
            formatTranslation("Header.WomenFloor")
          )
        ),
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            MenuTagType,
            (0, _extends3.default)({
              className: cx(_FloorNavigation2.default.button, (0, _defineProperty3.default)({}, _FloorNavigation2.default.selected, this.isSelected(_layout.MALE))),
              "data-testid": "men-floor",
              ref: function ref(el) {
                return _this2.floors[_layout.MALE] = el;
              }
            }, menMenuActionProp),
            formatTranslation("Header.MenFloor")
          )
        )
      );
    }
  }]);
  return FloorNavigation;
}(_react.PureComponent);

FloorNavigation.defaultProps = {
  isFemale: false,
  isMale: false,
  viewable: []
};

exports.default = (0, _translation2.default)(FloorNavigation);

/***/ }),

/***/ "./template/components/FloorNavigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _FloorNavigation = __webpack_require__("./template/components/FloorNavigation/FloorNavigation.js");

var _FloorNavigation2 = _interopRequireDefault(_FloorNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    isMale: (0, _layout.isMale)(state),
    isFemale: (0, _layout.isFemale)(state),
    viewport: (0, _layout.getViewport)(state),
    menStoreUrl: (0, _regionalStore.getStoreUrlForMen)(state),
    womenStoreUrl: (0, _regionalStore.getStoreUrlForWomen)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ setGender: _layout.setGender }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FloorNavigation2.default);

/***/ }),

/***/ "./template/components/Footer/Footer.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_170bFmT","mainContent":"SKoJwiD","container__accordion":"seWJYwj","iconBar":"G2lBJZk","greeterWrapper":"HZ254Fm","myAccountLinksWrapper":"_2kRRN8_"};

/***/ }),

/***/ "./template/components/Footer/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _LegalBar = __webpack_require__("./template/components/LegalBar/index.js");

var _LegalBar2 = _interopRequireDefault(_LegalBar);

var _Links = __webpack_require__("./template/components/Footer/Links.js");

var _Links2 = _interopRequireDefault(_Links);

var _Footer = __webpack_require__("./template/components/Footer/Footer.css");

var _Footer2 = _interopRequireDefault(_Footer);

var _MyAccountLinks = __webpack_require__("./template/components/MyAccountLinks/index.js");

var _MyAccountLinks2 = _interopRequireDefault(_MyAccountLinks);

var _SocialLinks = __webpack_require__("./template/components/Footer/SocialLinks/index.js");

var _SocialLinks2 = _interopRequireDefault(_SocialLinks);

var _PaymentOptions = __webpack_require__("./template/components/Footer/PaymentOptions/index.js");

var _PaymentOptions2 = _interopRequireDefault(_PaymentOptions);

var _Greeter = __webpack_require__("./template/components/Greeter/index.js");

var _Greeter2 = _interopRequireDefault(_Greeter);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_Footer2.default);

var Footer = function Footer(_ref) {
  var isAccordion = _ref.isAccordion,
      items = _ref.items;
  return _react2.default.createElement(
    "footer",
    {
      className: cx(_Footer2.default.container, (0, _defineProperty3.default)({}, _Footer2.default.container__accordion, isAccordion)),
      "data-testid": "footer"
    },
    _react2.default.createElement(
      "div",
      { className: _Footer2.default.mainContent },
      _react2.default.createElement(
        "div",
        { className: _Footer2.default.iconBar },
        _react2.default.createElement(_SocialLinks2.default, null),
        _react2.default.createElement(_PaymentOptions2.default, null)
      ),
      _react2.default.createElement(
        "div",
        { className: _Footer2.default.greeterWrapper },
        _react2.default.createElement(_Greeter2.default, { viewable: [_layout.SMALL_VIEWPORT] })
      ),
      _react2.default.createElement(
        "div",
        { className: _Footer2.default.myAccountLinksWrapper },
        _react2.default.createElement(_MyAccountLinks2.default, {
          viewable: [_layout.SMALL_VIEWPORT],
          queryParams: { nlid: "nav footer" }
        })
      ),
      _react2.default.createElement(_Links2.default, { items: items, isAccordion: isAccordion })
    ),
    _react2.default.createElement(_LegalBar2.default, null)
  );
};

exports.default = Footer;

/***/ }),

/***/ "./template/components/Footer/LinkGroup/LinkGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _events = __webpack_require__("./helpers/events.js");

var _queryString = __webpack_require__("./helpers/queryString.js");

var _index = __webpack_require__("./template/components/Footer/LinkGroup/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var LinkGroup = function (_Component) {
  (0, _inherits3.default)(LinkGroup, _Component);

  function LinkGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LinkGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LinkGroup.__proto__ || (0, _getPrototypeOf2.default)(LinkGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hideFocus: false
    }, _this.handleOpen = function (e) {
      var isAccordion = _this.props.isAccordion;


      if (!isAccordion) {
        e.preventDefault();
      } else if (!_this.details.open) {
        (0, _events.trackNavOpen)({
          context: _events.ANALYTICS_CONTEXT.footerExpandable,
          elementText: _this.props.groupItem.label,
          interaction: _events.ANALYTICS_INTERACTION_EXPAND,
          properties: {
            positionOnPage: _events.ANALYTICS_POSITION_FOOTER
          }
        });
      }
    }, _this.handleMouseDown = function () {
      _this.setState({ hideFocus: true });
    }, _this.handleBlur = function () {
      _this.setState({ hideFocus: false });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LinkGroup, [{
    key: "render",


    /* eslint-disable jsx-a11y/no-static-element-interactions */
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          country = _props.countryCode,
          groupItem = _props.groupItem,
          isAccordion = _props.isAccordion,
          keyStoreDataversion = _props.keyStoreDataversion,
          lang = _props.lang,
          store = _props.storeCode;


      var withAdditionalParams = function withAdditionalParams(link, alias) {
        if (alias === "track_my_order") {
          return (0, _queryString.withParams)(link, {
            country: country,
            keyStoreDataversion: keyStoreDataversion,
            lang: lang,
            store: store
          });
        }

        if (link.indexOf("marketplace") !== -1) {
          return (0, _queryString.withParams)(link, {
            ctaref: "Global footer"
          });
        }

        return link;
      };

      return _react2.default.createElement(
        "details",
        {
          className: _index2.default.container,
          open: !isAccordion,
          "data-testid": "footer-links",
          ref: function ref(e) {
            return _this2.details = e;
          }
        },
        _react2.default.createElement(
          "summary",
          {
            className: cx(_index2.default.header, (0, _defineProperty3.default)({}, _index2.default.header__focused, this.state.hideFocus)),
            onMouseDown: this.handleMouseDown,
            onClick: this.handleOpen,
            onKeyPress: this.handleOpen,
            onBlur: this.handleBlur,
            tabIndex: !isAccordion ? -1 : null,
            role: "menu"
          },
          groupItem.label
        ),
        groupItem.items.map(function (_ref2) {
          var alias = _ref2.alias,
              id = _ref2.id,
              label = _ref2.label,
              link = _ref2.link,
              linkType = _ref2.linkType;
          return _react2.default.createElement(
            "a",
            {
              key: id,
              className: _index2.default.link,
              href: withAdditionalParams(link, alias),
              role: "menuitem",
              target: linkType === "external" ? "_blank" : "_self"
            },
            label
          );
        })
      );
    }
    /* eslint-enable */

  }]);
  return LinkGroup;
}(_react.Component);

exports.default = LinkGroup;

/***/ }),

/***/ "./template/components/Footer/LinkGroup/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Rg3LvF7","header":"AyPVvkm","header__focused":"_1s_xFHS","link":"_26xJFIo"};

/***/ }),

/***/ "./template/components/Footer/LinkGroup/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _LinkGroup = __webpack_require__("./template/components/Footer/LinkGroup/LinkGroup.js");

var _LinkGroup2 = _interopRequireDefault(_LinkGroup);

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    storeCode: (0, _regionalStore.getStoreCode)(state),
    lang: (0, _regionalStore.getDefaultLanguage)(state),
    countryCode: (0, _regionalStore.getCountryCode)(state),
    keyStoreDataversion: (0, _regionalStore.getKeyStoreDataversion)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_LinkGroup2.default);

/***/ }),

/***/ "./template/components/Footer/Links.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container__hidden":"_1c2IHsB","group":"_3RAMPY8","container":"_1gmIo4T","body":"_1ysB59M"};

/***/ }),

/***/ "./template/components/Footer/Links.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _LinkGroup = __webpack_require__("./template/components/Footer/LinkGroup/index.js");

var _LinkGroup2 = _interopRequireDefault(_LinkGroup);

var _CountrySelectorButton = __webpack_require__("./template/components/CountrySelectorButton/index.js");

var _CountrySelectorButton2 = _interopRequireDefault(_CountrySelectorButton);

var _Links = __webpack_require__("./template/components/Footer/Links.css");

var _Links2 = _interopRequireDefault(_Links);

var _events = __webpack_require__("./helpers/events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Links = function Links(_ref) {
  var groupItems = _ref.items,
      isAccordion = _ref.isAccordion;
  return _react2.default.createElement(
    "div",
    { className: _Links2.default.container },
    _react2.default.createElement(
      "div",
      { className: _Links2.default.body },
      groupItems.map(function (groupItem) {
        return _react2.default.createElement(_LinkGroup2.default, {
          key: groupItem.id,
          groupItem: groupItem,
          isAccordion: isAccordion
        });
      }),
      _react2.default.createElement(
        "div",
        { className: _Links2.default.group },
        _react2.default.createElement(_CountrySelectorButton2.default, {
          withLabels: true,
          position: _events.ANALYTICS_POSITION_FOOTER
        })
      )
    )
  );
};

Links.defaultProps = {
  isAccordion: false
};

exports.default = Links;

/***/ }),

/***/ "./template/components/Footer/PaymentOptions/PaymentOptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./template/components/Footer/PaymentOptions/index.css");

var _index2 = _interopRequireDefault(_index);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxProvidersFor = function maxProvidersFor(viewport) {
  return viewport === _layout.MEDIUM_VIEWPORT ? 7 : 10;
};

var PaymentOptions = function PaymentOptions(_ref) {
  var paymentProviders = _ref.paymentProviders,
      viewport = _ref.viewport;
  return viewport !== _layout.SMALL_VIEWPORT && _react2.default.createElement(
    "div",
    { className: _index2.default.paymentOptions },
    paymentProviders.slice(0, maxProvidersFor(viewport)).map(function (provider) {
      return _react2.default.createElement(
        "span",
        { key: provider.name, className: _index2.default.provider },
        _react2.default.createElement("img", { src: provider.logo, alt: provider.name })
      );
    })
  );
};

exports.default = PaymentOptions;

/***/ }),

/***/ "./template/components/Footer/PaymentOptions/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"paymentOptions":"d3hEogn","provider":"_2t5mfE3"};

/***/ }),

/***/ "./template/components/Footer/PaymentOptions/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PaymentOptions = __webpack_require__("./template/components/Footer/PaymentOptions/PaymentOptions.js");

var _PaymentOptions2 = _interopRequireDefault(_PaymentOptions);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    paymentProviders: (0, _regionalStore.getPaymentProviders)(state),
    viewport: (0, _layout.getViewport)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_PaymentOptions2.default);

/***/ }),

/***/ "./template/components/Footer/SocialLinks/SocialLinks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _events = __webpack_require__("./helpers/events.js");

var _index = __webpack_require__("./template/components/Footer/SocialLinks/index.css");

var _index2 = _interopRequireDefault(_index);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialLinks = function SocialLinks(_ref) {
  var links = _ref.links;
  return links ? _react2.default.createElement(
    "div",
    { className: _index2.default.socialLinks, "data-testid": "social-links-bar" },
    (0, _keys2.default)(links).map(function (link, index) {
      return _react2.default.createElement(
        "a",
        {
          title: link,
          className: (0, _classnames2.default)(_index2.default.socialLink, _index2.default[link]),
          href: links[link],
          target: "_blank",
          onClick: function onClick() {
            return trackClick(link);
          },
          key: index,
          "data-testid": "social-link"
        },
        link
      );
    })
  ) : null;
};

function trackClick(name) {
  (0, _events.trackSocialClick)({
    context: _events.ANALYTICS_CONTEXT.social,
    interaction: _events.ANALYTICS_INTERACTION_CLICK,
    elementText: name.toLowerCase(),
    properties: {
      positionOnPage: _events.ANALYTICS_POSITION_FOOTER
    }
  });
}

exports.default = (0, _translation2.default)(SocialLinks);

/***/ }),

/***/ "./template/components/Footer/SocialLinks/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"socialLinks":"_2WkalZ6","socialLink":"_1gagYVR","Facebook":"i8FxB9X","Instagram":"EOORuiO","Snapchat":"uQdwP38","Vk":"_2mLsYUT"};

/***/ }),

/***/ "./template/components/Footer/SocialLinks/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _SocialLinks = __webpack_require__("./template/components/Footer/SocialLinks/SocialLinks.js");

var _SocialLinks2 = _interopRequireDefault(_SocialLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    links: (0, _regionalStore.getSocialLinks)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(_SocialLinks2.default);

/***/ }),

/***/ "./template/components/Footer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _Footer = __webpack_require__("./template/components/Footer/Footer.js");

var _Footer2 = _interopRequireDefault(_Footer);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    items: (0, _navigation.footerNavigation)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Footer2.default);

/***/ }),

/***/ "./template/components/GDPR/Banner/Banner.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"transitionDurationMs":"1000","wrapper":"_366tGHh","container":"_3PytKwX","show":"_1fuIZin","content":"_1wuV2zN","close":"_16Yw48I","greeting":"_2wGzpIi","cta":"DDNlINf","error":"MvORN1Q"};

/***/ }),

/***/ "./template/components/GDPR/Banner/Banner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__("./template/components/Button/index.js");

var _Button2 = _interopRequireDefault(_Button);

var _IconButton = __webpack_require__("./template/components/IconButton/index.js");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _Banner = __webpack_require__("./template/components/GDPR/Banner/Banner.css");

var _Banner2 = _interopRequireDefault(_Banner);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _events = __webpack_require__("./helpers/events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANIMATION_INITIAL_WAIT_MS = 800;

var Banner = function (_Component) {
  (0, _inherits3.default)(Banner, _Component);

  function Banner(props) {
    (0, _classCallCheck3.default)(this, Banner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Banner.__proto__ || (0, _getPrototypeOf2.default)(Banner)).call(this, props));

    _this.handleClose = function () {
      var animationDurationMs = parseInt(_Banner2.default.transitionDurationMs, 10);
      _this.setState({ revealBanner: false });
      (0, _events.trackBannerClose)();

      setTimeout(function () {
        _this.props.dismissAction();
        _this.setState({ displayBanner: false });
      }, animationDurationMs);
    };

    _this.handleOpen = function () {
      _this.setState({ revealBanner: true });
      (0, _events.trackBannerShown)();
    };

    _this.state = {
      displayBanner: true,
      revealBanner: false
    };
    return _this;
  }

  (0, _createClass3.default)(Banner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setTimeout(this.handleOpen, ANIMATION_INITIAL_WAIT_MS);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _cx;

      var _props = this.props,
          chooseOptionsAction = _props.chooseOptionsAction,
          firstName = _props.firstName,
          formatTranslation = _props.formatTranslation,
          greeting = _props.greeting,
          hasErrored = _props.hasErrored,
          isLoading = _props.isLoading;


      if (!this.state.displayBanner) {
        return null;
      }

      var greetingText = greeting || formatTranslation("GDPR.Greeting");

      var greetingContent = hasErrored ? formatTranslation("GDPR.GreetingLabelError") : formatTranslation("GDPR.GreetingLabel", {
        name: firstName,
        greeting: greetingText
      });

      var buttonContent = formatTranslation("GDPR.GreetingButton".concat(hasErrored ? "Error" : ""));

      var handleButtonClick = function handleButtonClick() {
        chooseOptionsAction(_this2.handleClose);
      };

      return _react2.default.createElement(
        "div",
        { className: _Banner2.default.wrapper, "data-testid": "gdpr-wrapper-banner-div" },
        _react2.default.createElement(
          "div",
          {
            className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _Banner2.default.container, true), (0, _defineProperty3.default)(_cx, _Banner2.default.error, hasErrored), (0, _defineProperty3.default)(_cx, _Banner2.default.show, this.state.revealBanner), _cx))
          },
          _react2.default.createElement(
            "div",
            { className: _Banner2.default.content, "data-testid": "gdpr-banner-div" },
            _react2.default.createElement(
              "div",
              { className: _Banner2.default.greeting },
              greetingContent
            ),
            _react2.default.createElement(
              "div",
              { className: _Banner2.default.cta },
              _react2.default.createElement(
                _Button2.default,
                {
                  "data-testid": "gdpr-banner-button",
                  hasSpinner: isLoading,
                  hasInvertedSize: true,
                  theme: "primary",
                  onClick: handleButtonClick
                },
                buttonContent
              )
            ),
            _react2.default.createElement(_IconButton2.default, {
              "aria-label": "Close",
              className: _Banner2.default.close,
              icon: "close",
              onClick: this.handleClose
            })
          )
        )
      );
    }
  }]);
  return Banner;
}(_react.Component);

Banner.defaultProps = {
  isLoading: false
};
exports.default = (0, _translation2.default)(Banner);

/***/ }),

/***/ "./template/components/GDPR/Banner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _Banner = __webpack_require__("./template/components/GDPR/Banner/Banner.js");

var _Banner2 = _interopRequireDefault(_Banner);

var _user = __webpack_require__("./template/state/modules/user/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    firstName: (0, _user.getFirstName)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Banner2.default);

/***/ }),

/***/ "./template/components/GDPR/Confirmation/Confirmation.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3zuzTWZ","container__isIn":"siJXd1v","heading":"_7mMnkyq","body":"_3kmOQHR","actions":"B9-V2DF"};

/***/ }),

/***/ "./template/components/GDPR/Confirmation/Confirmation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _querystring = __webpack_require__("../node_modules/querystring-es3/index.js");

var _Button = __webpack_require__("./template/components/Button/index.js");

var _Button2 = _interopRequireDefault(_Button);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _externalLinks = __webpack_require__("./template/helpers/externalLinks.js");

var _events = __webpack_require__("./helpers/events.js");

var _Confirmation = __webpack_require__("./template/components/GDPR/Confirmation/Confirmation.css");

var _Confirmation2 = _interopRequireDefault(_Confirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_Confirmation2.default);

var ConfirmationSuccess = function (_Component) {
  (0, _inherits3.default)(ConfirmationSuccess, _Component);

  function ConfirmationSuccess() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmationSuccess);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmationSuccess.__proto__ || (0, _getPrototypeOf2.default)(ConfirmationSuccess)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var onClose = _this.props.onClose;


      onClose();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmationSuccess, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          buildBasicPayload = _props.buildBasicPayload,
          isOptedIn = _props.isOptedIn;

      var details = buildBasicPayload();
      if (isOptedIn) {
        (0, _events.trackGdprKeepSending)(details);
      } else {
        (0, _events.trackGdprStopSending)(details);
      }
    }
  }, {
    key: "buildMyAccountURL",
    value: function buildMyAccountURL() {
      var _props2 = this.props,
          countryCode = _props2.countryCode,
          ctaRef = _props2.ctaRef,
          keyStoreDataversion = _props2.keyStoreDataversion,
          lang = _props2.lang,
          storeCode = _props2.storeCode;


      var params = (0, _querystring.stringify)({
        lang: lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion: keyStoreDataversion,
        ctaRef: ctaRef
      });

      return [(0, _externalLinks.getMyAccountBaseUrl)() + "/contact-preferences", params].join("?");
    }
  }, {
    key: "getLabel",
    value: function getLabel(label) {
      var _props3 = this.props,
          formatTranslation = _props3.formatTranslation,
          isOptedIn = _props3.isOptedIn;

      var optInLabel = isOptedIn ? "In" : "Out";

      return formatTranslation("GDPR." + optInLabel + "Confirmation" + label);
    }
  }, {
    key: "render",
    value: function render() {
      var _props4 = this.props,
          formatTranslation = _props4.formatTranslation,
          isOptedIn = _props4.isOptedIn;


      return _react2.default.createElement(
        "section",
        {
          className: cx("container", {
            container__isIn: isOptedIn
          })
        },
        _react2.default.createElement(
          "h1",
          { className: _Confirmation2.default.heading, "data-testid": "gdpr-confirmation-heading" },
          this.getLabel("Heading")
        ),
        _react2.default.createElement(
          "p",
          { className: _Confirmation2.default.body, "data-testid": "gdpr-confirmation-body" },
          this.getLabel("Body")
        ),
        _react2.default.createElement(
          "div",
          { className: _Confirmation2.default.actions },
          _react2.default.createElement(
            _Button2.default,
            { theme: "primary", onClick: this.handleClick },
            formatTranslation("GDPR.ShoppingButton")
          ),
          _react2.default.createElement(
            _Button2.default,
            { theme: "secondary", href: this.buildMyAccountURL() },
            formatTranslation("GDPR.PreferencesButton")
          )
        )
      );
    }
  }]);
  return ConfirmationSuccess;
}(_react.Component);

ConfirmationSuccess.defaultProps = {
  isOptedIn: false
};

exports.default = (0, _translation2.default)(ConfirmationSuccess);

/***/ }),

/***/ "./template/components/GDPR/Confirmation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _actions = __webpack_require__("./template/state/modules/analytics/actions.js");

var _Confirmation = __webpack_require__("./template/components/GDPR/Confirmation/Confirmation.js");

var _Confirmation2 = _interopRequireDefault(_Confirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    countryCode: (0, _regionalStore.getCountryCode)(state),
    keyStoreDataversion: (0, _regionalStore.getKeyStoreDataversion)(state),
    lang: (0, _regionalStore.getDefaultLanguage)(state),
    storeCode: (0, _regionalStore.getStoreCode)(state)
  };
};

var mapDispatchToProps = {
  buildBasicPayload: _actions.buildBasicPayload
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Confirmation2.default);

/***/ }),

/***/ "./template/components/GDPR/ContactPreferences/ContactPreferences.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_-5QS2ky","header":"_3XVXPvs","body":"_2SyPnzx","footer":"_3xW3Ae8","small":"_2CfrGrH","optionListWrapper":"S97O2xk","optionList":"kQx1gKn","cta":"_271gBtw","errorWrapper":"_1TrNYB2","errorMessage":"_3YGziOA"};

/***/ }),

/***/ "./template/components/GDPR/ContactPreferences/ContactPreferences.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _querystring = __webpack_require__("../node_modules/querystring-es3/index.js");

var _externalLinks = __webpack_require__("./template/helpers/externalLinks.js");

var _Button = __webpack_require__("./template/components/Button/index.js");

var _Button2 = _interopRequireDefault(_Button);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _Option = __webpack_require__("./template/components/GDPR/Option/index.js");

var _Option2 = _interopRequireDefault(_Option);

var _ContactPreferences = __webpack_require__("./template/components/GDPR/ContactPreferences/ContactPreferences.css");

var _ContactPreferences2 = _interopRequireDefault(_ContactPreferences);

var _events = __webpack_require__("./helpers/events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactPreferences = function (_Component) {
  (0, _inherits3.default)(ContactPreferences, _Component);

  function ContactPreferences() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ContactPreferences);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContactPreferences.__proto__ || (0, _getPrototypeOf2.default)(ContactPreferences)).call.apply(_ref, [this].concat(args))), _this), _this.handleInClick = function () {
      var optIn = _this.props.optIn;


      optIn();
    }, _this.handleOutClick = function () {
      var optOut = _this.props.optOut;


      optOut();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ContactPreferences, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var buildBasicPayload = this.props.buildBasicPayload;


      (0, _events.trackOpenGdprModal)(buildBasicPayload());
    }
  }, {
    key: "buildMyAccountURL",
    value: function buildMyAccountURL() {
      var _props = this.props,
          countryCode = _props.countryCode,
          ctaRef = _props.ctaRef,
          keyStoreDataversion = _props.keyStoreDataversion,
          lang = _props.lang,
          storeCode = _props.storeCode;


      var params = (0, _querystring.stringify)({
        lang: lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion: keyStoreDataversion,
        ctaRef: ctaRef
      });

      return [(0, _externalLinks.getMyAccountBaseUrl)() + "/contact-preferences", params].join("?");
    }
  }, {
    key: "getTitleSubtitle",
    value: function getTitleSubtitle() {
      var _props2 = this.props,
          firstName = _props2.firstName,
          formatTranslation = _props2.formatTranslation,
          gdprDeadlineCopyFeature = _props2.gdprDeadlineCopyFeature;


      var path = "GDPR.ContactPreferences" + (gdprDeadlineCopyFeature ? ".Deadline" : "");

      return {
        title: formatTranslation(path + ".Header", { name: firstName }),
        subtitle: formatTranslation(path + ".Description")
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          ctaRef = _props3.ctaRef,
          formatTranslation = _props3.formatTranslation,
          gdprDeadlineCopyFeature = _props3.gdprDeadlineCopyFeature,
          hasError = _props3.hasError,
          isLoggedIn = _props3.isLoggedIn,
          isOptInLoading = _props3.isOptInLoading,
          isOptOutLoading = _props3.isOptOutLoading,
          preferences = _props3.preferences,
          privacyUrlSegment = _props3.privacyUrlSegment,
          testContent = _props3.testContent,
          termsUrlSegment = _props3.termsUrlSegment;


      var translate = function translate(key) {
        return formatTranslation("GDPR.ContactPreferences." + key);
      };

      var _ref2 = testContent ? testContent : this.getTitleSubtitle(),
          title = _ref2.title,
          subtitle = _ref2.subtitle;

      return _react2.default.createElement(
        "div",
        { className: _ContactPreferences2.default.container },
        _react2.default.createElement(
          "h1",
          { className: _ContactPreferences2.default.header },
          title
        ),
        _react2.default.createElement(
          "p",
          { className: _ContactPreferences2.default.body },
          subtitle
        ),
        _react2.default.createElement(
          "div",
          { className: _ContactPreferences2.default.optionListWrapper },
          _react2.default.createElement(
            "ul",
            { className: _ContactPreferences2.default.optionList },
            preferences.map(function (preference) {
              return _react2.default.createElement(_Option2.default, {
                key: preference.preferenceId,
                name: preference.title,
                src: preference.imageUrl,
                isSelected: !!preference.customerChannels.length
              });
            })
          )
        ),
        _react2.default.createElement(
          "p",
          { className: _ContactPreferences2.default.small },
          translate("Channels")
        ),
        hasError && _react2.default.createElement(
          "div",
          { className: _ContactPreferences2.default.errorWrapper },
          _react2.default.createElement(
            "div",
            { className: _ContactPreferences2.default.errorMessage },
            formatTranslation("GDPR.GreetingLabelError")
          )
        ),
        _react2.default.createElement(
          "div",
          { className: _ContactPreferences2.default.cta },
          _react2.default.createElement(
            _Button2.default,
            {
              "data-testid": "gdpr-modal-keep-button",
              theme: "primary",
              hasSpinner: isOptInLoading,
              onClick: this.handleInClick
            },
            translate(gdprDeadlineCopyFeature ? "Deadline.KeepButton" : "KeepButton")
          ),
          _react2.default.createElement(
            _Button2.default,
            {
              "data-testid": "gdpr-modal-myaccount-button",
              theme: "secondary",
              href: this.buildMyAccountURL()
            },
            isLoggedIn ? translate("EditButton") : translate("LoginButton")
          ),
          _react2.default.createElement(
            _Button2.default,
            {
              "data-testid": "gdpr-modal-optout-button",
              theme: "secondary",
              hasSpinner: isOptOutLoading,
              onClick: this.handleOutClick
            },
            translate(gdprDeadlineCopyFeature ? "Deadline.OptOutButton" : "OptOutButton")
          )
        ),
        _react2.default.createElement(
          "p",
          { className: _ContactPreferences2.default.footer },
          _react2.default.createElement(
            "a",
            { href: privacyUrlSegment + "?ctaref=" + ctaRef, target: "_blank" },
            translate("PrivacyLink")
          ),
          " & ",
          _react2.default.createElement(
            "a",
            { href: termsUrlSegment + "?ctaref=" + ctaRef, target: "_blank" },
            translate("Terms")
          )
        )
      );
    }
  }]);
  return ContactPreferences;
}(_react.Component);

ContactPreferences.defaultProps = {
  gdprDeadlineCopyFeature: false,
  preferences: []
};

exports.default = (0, _translation2.default)(ContactPreferences);

/***/ }),

/***/ "./template/components/GDPR/ContactPreferences/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _user = __webpack_require__("./template/state/modules/user/index.js");

var _ContactPreferences = __webpack_require__("./template/components/GDPR/ContactPreferences/ContactPreferences.js");

var _ContactPreferences2 = _interopRequireDefault(_ContactPreferences);

var _actions = __webpack_require__("./template/state/modules/analytics/actions.js");

var _features = __webpack_require__("./template/state/modules/features/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    countryCode: (0, _regionalStore.getCountryCode)(state),
    isLoggedIn: (0, _user.isLoggedIn)(state),
    firstName: (0, _user.getFirstName)(state),
    gdprDeadlineCopyFeature: (0, _features.getFeature)(state, "stc-gdpr-deadline-copy"),
    keyStoreDataversion: (0, _regionalStore.getKeyStoreDataversion)(state),
    lang: (0, _regionalStore.getDefaultLanguage)(state),
    storeCode: (0, _regionalStore.getStoreCode)(state)
  };
};

var mapDispatchToProps = {
  buildBasicPayload: _actions.buildBasicPayload
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ContactPreferences2.default);

/***/ }),

/***/ "./template/components/GDPR/GDPR.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GDPR_STORAGE_KEY = undefined;

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__("../node_modules/babel-runtime/core-js/json/stringify.js");

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _urlParse = __webpack_require__("../node_modules/url-parse/index.js");

var _urlParse2 = _interopRequireDefault(_urlParse);

var _Banner = __webpack_require__("./template/components/GDPR/Banner/index.js");

var _Banner2 = _interopRequireDefault(_Banner);

var _Confirmation = __webpack_require__("./template/components/GDPR/Confirmation/index.js");

var _Confirmation2 = _interopRequireDefault(_Confirmation);

var _ContactPreferences = __webpack_require__("./template/components/GDPR/ContactPreferences/index.js");

var _ContactPreferences2 = _interopRequireDefault(_ContactPreferences);

var _Modal = __webpack_require__("./template/components/Modal/index.js");

var _Modal2 = _interopRequireDefault(_Modal);

var _url = __webpack_require__("./helpers/url.js");

var _webStorage = __webpack_require__("./helpers/webStorage.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GDPR_STORAGE_KEY = exports.GDPR_STORAGE_KEY = "Asos.GdprBanner";

var GDPR = function (_Component) {
  (0, _inherits3.default)(GDPR, _Component);

  function GDPR() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GDPR);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GDPR.__proto__ || (0, _getPrototypeOf2.default)(GDPR)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fetchPreferencesError: false,
      preferencesInitialised: false,
      showBanner: true,
      showModal: false
    }, _this.dismissGdprNotificationsForSession = function () {
      var customerGuid = _this.props.customerGuid;

      var expiryDate = new Date();
      expiryDate.setHours(expiryDate.getHours() + 8); // set 8 hour expiry from now

      var setLocalStorageValues = (0, _stringify2.default)({
        customerGuid: customerGuid,
        expiry: expiryDate.toISOString()
      });

      (0, _webStorage.setLocalStorage)(GDPR_STORAGE_KEY, setLocalStorageValues);
    }, _this.handleBannerClick = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      var _this$props, setUserPreferences, gdprPhaseTwoFeature;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, setUserPreferences = _this$props.setUserPreferences, gdprPhaseTwoFeature = _this$props.gdprPhaseTwoFeature;


              _this.setState({
                isPreferencesLoading: true
              });

              _context.prev = 2;
              _context.next = 5;
              return setUserPreferences();

            case 5:

              _this.dismissGdprNotificationsForSession();

              _this.setState({
                fetchPreferencesError: false,
                isPreferencesLoading: false,
                showBanner: gdprPhaseTwoFeature,
                showModal: true
              });
              callback();
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);

              _this.setState({
                fetchPreferencesError: true,
                isPreferencesLoading: false
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[2, 10]]);
    })), _this.handleClose = function () {
      _this.setState({
        showBanner: false,
        showModal: false
      });

      var url = (0, _url.removeURLParameter)(window.location.href, "contact");
      window.history.replaceState({}, "", url);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GDPR, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        showModal: !!this.isContactAvailable()
      });
    }
  }, {
    key: "showModalGdprPhaseTwo",
    value: function showModalGdprPhaseTwo(shouldShowBanner) {
      var _this3 = this;

      if (this.props.gdprPhaseTwoFeature && this.props.testIsLoaded && !this.state.preferencesInitialised && shouldShowBanner) {
        setTimeout(function () {
          return _this3.handleBannerClick();
        }, 4000);

        this.setState({ preferencesInitialised: true });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var gdprSessionStorageObject = JSON.parse((0, _webStorage.getValueFromLocalStorage)(GDPR_STORAGE_KEY));

      var customerShouldSeeBanner = !(gdprSessionStorageObject && nextProps.customerGuid === gdprSessionStorageObject.customerGuid && gdprSessionStorageObject.expiry > new Date().toISOString());

      this.setState(function (state) {
        return {
          showBanner: state.showBanner && customerShouldSeeBanner
        };
      });

      this.showModalGdprPhaseTwo(customerShouldSeeBanner);
    }
  }, {
    key: "isContactAvailable",
    value: function isContactAvailable() {
      if (typeof window !== "undefined" && window.location) {
        return "contact" in (0, _urlParse2.default)(window.location.href, true).query;
      }
      return false;
    }
  }, {
    key: "getContact",
    value: function getContact() {
      if (typeof window !== "undefined" && window.location) {
        var url = (0, _urlParse2.default)(window.location.href, true);
        return url.query.contact;
      }
      return false;
    }
  }, {
    key: "getOptedIn",
    value: function getOptedIn() {
      var hasReconsented = this.props.hasReconsented;

      var hasContactInAsAQueryParam = this.getContact() ? !!(this.getContact().toLowerCase() === "in") : false;

      return hasReconsented || hasContactInAsAQueryParam;
    }
  }, {
    key: "renderPreferences",
    value: function renderPreferences() {
      var _props = this.props,
          ctaRef = _props.ctaRef,
          hasError = _props.hasError,
          isOptInLoading = _props.isOptInLoading,
          isOptOutLoading = _props.isOptOutLoading,
          isReconsentRequired = _props.isReconsentRequired,
          optIn = _props.optIn,
          optOut = _props.optOut,
          preferences = _props.preferences,
          privacyUrlSegment = _props.privacyUrlSegment,
          testContent = _props.testContent,
          termsUrlSegment = _props.termsUrlSegment;


      if (this.isContactAvailable()) {
        return null;
      }

      if (!isReconsentRequired) {
        return null;
      }

      return _react2.default.createElement(_ContactPreferences2.default, {
        ctaRef: ctaRef,
        hasError: hasError,
        isOptInLoading: isOptInLoading,
        isOptOutLoading: isOptOutLoading,
        optIn: optIn,
        optOut: optOut,
        preferences: preferences,
        privacyUrlSegment: privacyUrlSegment,
        testContent: testContent,
        termsUrlSegment: termsUrlSegment
      });
    }
  }, {
    key: "renderConfirmation",
    value: function renderConfirmation() {
      var _props2 = this.props,
          ctaRef = _props2.ctaRef,
          isReconsentRequired = _props2.isReconsentRequired,
          hasReconsented = _props2.hasReconsented;


      if (!this.isContactAvailable()) {
        if (isReconsentRequired) {
          return null;
        }

        if (hasReconsented === null) {
          return null;
        }
      }

      return _react2.default.createElement(_Confirmation2.default, {
        ctaRef: ctaRef,
        isOptedIn: this.getOptedIn(),
        onClose: this.handleClose
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          isReconsentRequired = _props3.isReconsentRequired,
          testContent = _props3.testContent,
          testIsLoaded = _props3.testIsLoaded,
          gdprPhaseTwoFeature = _props3.gdprPhaseTwoFeature,
          hasReconsented = _props3.hasReconsented;
      var _state = this.state,
          fetchPreferencesError = _state.fetchPreferencesError,
          isPreferencesLoading = _state.isPreferencesLoading,
          showBanner = _state.showBanner,
          showModal = _state.showModal;


      var shouldShowBanner = isReconsentRequired && showBanner && testIsLoaded;

      return gdprPhaseTwoFeature ? _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _Modal2.default,
          {
            isOpen: showModal && (shouldShowBanner || this.isContactAvailable() || hasReconsented !== null),
            onClose: this.handleClose
          },
          this.renderPreferences(),
          this.renderConfirmation()
        )
      ) : _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _Modal2.default,
          { isOpen: showModal, onClose: this.handleClose },
          this.renderPreferences(),
          this.renderConfirmation()
        ),
        shouldShowBanner && _react2.default.createElement(_Banner2.default, {
          chooseOptionsAction: this.handleBannerClick,
          dismissAction: this.dismissGdprNotificationsForSession,
          hasErrored: fetchPreferencesError,
          greeting: testContent && testContent.greeting,
          isLoading: isPreferencesLoading,
          onClick: this.handleBannerClick
        })
      );
    }
  }]);
  return GDPR;
}(_react.Component);

GDPR.defaultProps = {
  gdprPhaseTwoFeature: false,
  hasReconsented: null,
  preferences: [],
  testIsLoaded: false
};

exports.default = GDPR;

/***/ }),

/***/ "./template/components/GDPR/Option/Option.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3JF4T0N","wrapper":"TA65A10","image":"_3k_xFTF","name":"_2gB5Prx","optedOut":"_29dCOp8"};

/***/ }),

/***/ "./template/components/GDPR/Option/Option.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _Option = __webpack_require__("./template/components/GDPR/Option/Option.css");

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_Option2.default);

var Option = function Option(_ref) {
  var name = _ref.name,
      isSelected = _ref.isSelected,
      src = _ref.src;
  return _react2.default.createElement(
    "li",
    {
      className: cx("container", {
        optedOut: !isSelected
      })
    },
    _react2.default.createElement(
      "div",
      { className: _Option2.default.wrapper },
      _react2.default.createElement("div", {
        className: _Option2.default.image,
        style: { backgroundImage: "url(" + src + ")" }
      })
    ),
    _react2.default.createElement(
      "span",
      { className: _Option2.default.name },
      name
    )
  );
};

exports.default = Option;

/***/ }),

/***/ "./template/components/GDPR/Option/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Option = __webpack_require__("./template/components/GDPR/Option/Option.js");

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Option2.default;

/***/ }),

/***/ "./template/components/GDPR/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _features = __webpack_require__("./template/state/modules/features/index.js");

var _user = __webpack_require__("./template/state/modules/user/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _pageInfoProvider = __webpack_require__("./template/helpers/pageInfoProvider.js");

var _GDPR = __webpack_require__("./template/components/GDPR/GDPR.js");

var _GDPR2 = _interopRequireDefault(_GDPR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMvtContent = function getMvtContent(state) {
  var gdprFeature = (0, _features.getFeature)(state, "t1161-gdpr-test-web");

  if (gdprFeature && gdprFeature.content) {
    (0, _features.setGlobalFeatureName)(gdprFeature.mvtTestName);
    var content = gdprFeature.content;
    return {
      greeting: content.bubbleText,
      title: content.modalTitle,
      subtitle: content.modalSubtitle
    };
  }
  return undefined;
};

var mapStateToProps = function mapStateToProps(state) {
  var _getPageInfo = (0, _pageInfoProvider.getPageInfo)(),
      section = _getPageInfo.section;

  var platform = (0, _layout.getPlatform)(state);
  var ctaRef = platform + "|" + section + "|control my content";

  return {
    ctaRef: ctaRef,
    customerGuid: (0, _user.getCustomerGuid)(state),
    gdprPhaseTwoFeature: (0, _features.getFeature)(state, "stc-gdpr-phase-two"),
    hasError: (0, _user.getHasErrors)(state),
    hasReconsented: (0, _user.getHasReconsented)(state),
    isOptInLoading: (0, _user.getIsOptInLoading)(state),
    isOptOutLoading: (0, _user.getIsOptOutLoading)(state),
    isReconsentRequired: (0, _user.getIsReconsentRequired)(state),
    preferences: (0, _user.getPreferences)(state),
    privacyUrlSegment: (0, _user.getPrivacyUrlSegment)(state),
    termsUrlSegment: (0, _user.getTermsUrlSegment)(state),
    testContent: getMvtContent(state),
    testIsLoaded: (0, _features.getFeaturesLoaded)(state)
  };
};

var mapDispatchToProps = {
  optIn: _user.optIn,
  optOut: _user.optOut,
  setUserPreferences: _user.setUserPreferences
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_GDPR2.default);

/***/ }),

/***/ "./template/components/GlobalBanner/GlobalBanner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _withViewport = __webpack_require__("./template/components/Viewport/withViewport.js");

var _withViewport2 = _interopRequireDefault(_withViewport);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("./template/components/GlobalBanner/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-underscore-dangle */
var cx = _classnames2.default.bind(_index2.default);

var globalBannerId = "divGlobalBanner";

var GlobalBanner = function (_PureComponent) {
  (0, _inherits3.default)(GlobalBanner, _PureComponent);

  function GlobalBanner() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GlobalBanner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GlobalBanner.__proto__ || (0, _getPrototypeOf2.default)(GlobalBanner)).call.apply(_ref, [this].concat(args))), _this), _this.hasInitialised = false, _this.hasTimedOut = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GlobalBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.check();

      setTimeout(function () {
        _this2.timedOut = true;
        _this2.check();
      }, 500);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.check();
    }
  }, {
    key: "check",
    value: function check() {
      var _props = this.props,
          identityHasResponded = _props.identityHasResponded,
          isVisible = _props.isVisible,
          storeCode = _props.storeCode,
          language = _props.language,
          isPremier = _props.isPremier,
          browseCountry = _props.browseCountry;


      var needsInitialisation = !this.hasInitialised && isVisible;

      if ((identityHasResponded || this.timedOut) && needsInitialisation) {
        window.__globalBannerSDK.init(storeCode, language, isPremier, globalBannerId, browseCountry);

        this.hasInitialised = true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isVisible = this.props.isVisible;

      return _react2.default.createElement("div", {
        id: globalBannerId,
        className: cx(_index2.default.globalBanner, (0, _defineProperty3.default)({}, _index2.default.visible, isVisible))
      });
    }
  }]);
  return GlobalBanner;
}(_react.PureComponent);

exports.default = (0, _withViewport2.default)(GlobalBanner);

/***/ }),

/***/ "./template/components/GlobalBanner/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"divGlobalBanner":"_2_Qcp7I","globalBanner":"_3KTlVF9","visible":"_1PxGDvU"};

/***/ }),

/***/ "./template/components/GlobalBanner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _GlobalBanner = __webpack_require__("./template/components/GlobalBanner/GlobalBanner.js");

var _GlobalBanner2 = _interopRequireDefault(_GlobalBanner);

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _user = __webpack_require__("./template/state/modules/user/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    storeCode: (0, _regionalStore.getStoreCode)(state),
    language: (0, _regionalStore.getDefaultLanguage)(state),
    identityHasResponded: (0, _user.getIdentityHasResponded)(state),
    isPremier: (0, _user.getIsPremier)(state),
    browseCountry: (0, _regionalStore.getCountryCode)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_GlobalBanner2.default);

/***/ }),

/***/ "./template/components/GlobalBannerContentAPI/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _asosContentApiGlobalBanner = __webpack_require__("../node_modules/asos-content-api-global-banner/dist/asos-content-api-global-banner.min.js");

var _asosContentApiGlobalBanner2 = _interopRequireDefault(_asosContentApiGlobalBanner);

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _user = __webpack_require__("./template/state/modules/user/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    store: (0, _regionalStore.getStoreCode)(state),
    language: (0, _regionalStore.getDefaultLanguage)(state),
    isPremier: (0, _user.getIsPremier)(state),
    browseCountry: (0, _regionalStore.getCountryCode)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_asosContentApiGlobalBanner2.default);

/***/ }),

/***/ "./template/components/Greeter/Greeter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _externalLinks = __webpack_require__("./template/helpers/externalLinks.js");

var _accessibility = __webpack_require__("./helpers/accessibility.js");

var _queryString = __webpack_require__("./helpers/queryString.js");

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _withViewport = __webpack_require__("./template/components/Viewport/withViewport.js");

var _withViewport2 = _interopRequireDefault(_withViewport);

var _index = __webpack_require__("./template/components/Greeter/index.css");

var _index2 = _interopRequireDefault(_index);

var _GDPR = __webpack_require__("./template/components/GDPR/GDPR.js");

var _webStorage = __webpack_require__("./helpers/webStorage.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGreetingMessage = function getGreetingMessage(isKnown, firstName, formatTranslation) {
  return isKnown && _react2.default.createElement(
    "span",
    { className: _index2.default.welcome },
    formatTranslation("MyAccountLinks.Greeting", { name: firstName })
  );
}; /* eslint-disable no-underscore-dangle */


var getButtonLinks = function getButtonLinks(isLoggedIn, isRecognised, signUpLink, signInLink, formatTranslation, focusable) {
  var identitySdk = typeof window !== "undefined" && window.__sdk && window.__sdk.identity;

  if (!isLoggedIn && !isRecognised) {
    return _react2.default.createElement(
      "span",
      { className: _index2.default.links },
      _react2.default.createElement(
        "a",
        {
          className: _index2.default.link,
          href: signInLink,
          "data-testid": "signin-link",
          tabIndex: (0, _accessibility.tabIndex)(focusable),
          onClick: function onClick(e) {
            if (!identitySdk) {
              return;
            }
            e.preventDefault();
            identitySdk.login();
          }
        },
        formatTranslation("MyAccountLinks.SignInLabel")
      ),
      _react2.default.createElement("div", { className: _index2.default.pipe }),
      _react2.default.createElement(
        "a",
        {
          className: _index2.default.link,
          href: signUpLink,
          "data-testid": "signup-link",
          tabIndex: (0, _accessibility.tabIndex)(focusable)
        },
        formatTranslation("MyAccountLinks.SignUpLabel")
      )
    );
  }

  return _react2.default.createElement(
    "span",
    { className: _index2.default.links },
    _react2.default.createElement(
      "a",
      {
        className: _index2.default.link,
        href: "",
        onClick: function onClick(e) {
          e.preventDefault();
          (0, _webStorage.removeValueFromLocalStorage)(_GDPR.GDPR_STORAGE_KEY);
          identitySdk && identitySdk.logout();
        },
        "data-testid": "signout-link",
        tabIndex: (0, _accessibility.tabIndex)(focusable)
      },
      formatTranslation("MyAccountLinks.SignOutLabel")
    )
  );
};

var Greeter = function (_Component) {
  (0, _inherits3.default)(Greeter, _Component);

  function Greeter(props) {
    (0, _classCallCheck3.default)(this, Greeter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Greeter.__proto__ || (0, _getPrototypeOf2.default)(Greeter)).call(this, props));

    _this.state = {
      returnUrl: false
    };
    return _this;
  }

  (0, _createClass3.default)(Greeter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        returnUrl: window.location.href
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          isLoggedIn = _props.isLoggedIn,
          isRecognised = _props.isRecognised,
          firstName = _props.firstName,
          formatTranslation = _props.formatTranslation,
          lang = _props.lang,
          countryCode = _props.countryCode,
          storeCode = _props.storeCode,
          keyStoreDataversion = _props.keyStoreDataversion,
          focusable = _props.focusable;


      var params = {
        lang: lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion: keyStoreDataversion
      };

      var signUpBaseUrl = (0, _externalLinks.getIdentitySdkAuthHost)() + formatTranslation("MyAccountLinks.SignUpLink");

      var signUpLink = (0, _queryString.withParams)(signUpBaseUrl, (0, _extends3.default)({}, params, {
        returnUrl: this.state.returnUrl
      }));

      var signInLink = (0, _queryString.withParams)((0, _externalLinks.getMyAccountBaseUrl)(), params);

      return _react2.default.createElement(
        "div",
        { className: _index2.default.container },
        getGreetingMessage(isLoggedIn || isRecognised, firstName, formatTranslation),
        getButtonLinks(isLoggedIn, isRecognised, signUpLink, signInLink, formatTranslation, focusable)
      );
    }
  }]);
  return Greeter;
}(_react.Component);

exports.default = (0, _withViewport2.default)((0, _translation2.default)(Greeter));

/***/ }),

/***/ "./template/components/Greeter/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"VbnjanM","welcome":"_2T5vKuV","link":"_1k1reGo","links":"_1GV6Ntf","pipe":"_1tXI178"};

/***/ }),

/***/ "./template/components/Greeter/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _Greeter = __webpack_require__("./template/components/Greeter/Greeter.js");

var _Greeter2 = _interopRequireDefault(_Greeter);

var _user = __webpack_require__("./template/state/modules/user/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    isLoggedIn: (0, _user.isLoggedIn)(state),
    firstName: (0, _user.getFirstName)(state),
    isRecognised: (0, _user.getIsRecognised)(state),
    storeCode: (0, _regionalStore.getStoreCode)(state),
    lang: (0, _regionalStore.getDefaultLanguage)(state),
    countryCode: (0, _regionalStore.getCountryCode)(state),
    keyStoreDataversion: (0, _regionalStore.getKeyStoreDataversion)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Greeter2.default);

/***/ }),

/***/ "./template/components/Header/CookieDisclaimer/CookieDisclaimer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./template/components/Header/CookieDisclaimer/index.css");

var _index2 = _interopRequireDefault(_index);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CookieDisclaimer = function CookieDisclaimer(props) {
  var formatTranslation = props.formatTranslation,
      closeCookieMessage = props.closeCookieMessage,
      cookieMessageOpen = props.cookieMessageOpen,
      isSidePanelOpen = props.isSidePanelOpen,
      defaultStoreUrl = props.defaultStoreUrl;


  var shouldDisplayCookieDisclaimer = !isSidePanelOpen && cookieMessageOpen;

  return shouldDisplayCookieDisclaimer ? _react2.default.createElement(
    "div",
    { className: _index2.default.cookieDisclaimer },
    _react2.default.createElement(
      "div",
      { className: _index2.default.container, "data-testid": "cookie-disclaimer" },
      _react2.default.createElement(
        "p",
        { className: _index2.default.summary },
        formatTranslation("CookieDisclaimer.summary"),
        _react2.default.createElement(
          "a",
          {
            className: _index2.default.readMore,
            href: defaultStoreUrl.concat(formatTranslation("CookieDisclaimer.link"))
          },
          formatTranslation("CookieDisclaimer.readMore")
        )
      ),
      _react2.default.createElement("button", {
        type: "button",
        className: _index2.default.closeButton,
        onClick: closeCookieMessage,
        "data-testid": "close-button"
      })
    )
  ) : null;
};

exports.default = (0, _translation2.default)(CookieDisclaimer);

/***/ }),

/***/ "./template/components/Header/CookieDisclaimer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cookieDisclaimer":"_2pMurAl","container":"_1cJDHsE","summary":"_2EMw4Zz","readMore":"_2afHWeu","closeButton":"_1EF2tpx"};

/***/ }),

/***/ "./template/components/Header/CookieDisclaimer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _CookieDisclaimer = __webpack_require__("./template/components/Header/CookieDisclaimer/CookieDisclaimer.js");

var _CookieDisclaimer2 = _interopRequireDefault(_CookieDisclaimer);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ closeCookieMessage: _layout.closeCookieMessage }, dispatch);
}

function mapStateToProps(state) {
  return {
    cookieMessageOpen: (0, _layout.isCookieMessageOpen)(state),
    isSidePanelOpen: (0, _layout.isSidePanelOpen)(state),
    defaultStoreUrl: (0, _regionalStore.getDefaultStoreUrl)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_CookieDisclaimer2.default);

/***/ }),

/***/ "./template/components/Header/Header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__("./template/state/modules/layout/constants.js");

var _FloorNavigation = __webpack_require__("./template/components/FloorNavigation/index.js");

var _FloorNavigation2 = _interopRequireDefault(_FloorNavigation);

var _Burger = __webpack_require__("./template/components/Burger/index.js");

var _Burger2 = _interopRequireDefault(_Burger);

var _SearchForm = __webpack_require__("./template/components/SearchForm/index.js");

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _Widgets = __webpack_require__("./template/components/Widgets/index.js");

var _Widgets2 = _interopRequireDefault(_Widgets);

var _HomeLogo = __webpack_require__("./template/components/Header/HomeLogo/index.js");

var _HomeLogo2 = _interopRequireDefault(_HomeLogo);

var _index = __webpack_require__("./template/components/Header/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var clearNavActiveItem = _ref.clearNavActiveItem;
  return _react2.default.createElement(
    "div",
    { className: _index2.default.container, onMouseEnter: clearNavActiveItem },
    _react2.default.createElement(
      "div",
      { className: _index2.default.body, "data-testid": "header" },
      _react2.default.createElement(_Burger2.default, null),
      _react2.default.createElement(_HomeLogo2.default, null),
      _react2.default.createElement(_FloorNavigation2.default, { viewable: [_constants.LARGE_VIEWPORT] }),
      _react2.default.createElement(_SearchForm2.default, null),
      _react2.default.createElement(_Widgets2.default, null)
    )
  );
};

exports.default = Header;

/***/ }),

/***/ "./template/components/Header/HomeLogo/HomeLogo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Logo = __webpack_require__("./template/components/Header/Logo/index.js");

var _Logo2 = _interopRequireDefault(_Logo);

var _index = __webpack_require__("./template/components/Header/HomeLogo/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeLogo = function HomeLogo(_ref) {
  var storeUrls = _ref.storeUrls,
      _ref$gender = _ref.gender,
      gender = _ref$gender === undefined ? "default" : _ref$gender;
  return _react2.default.createElement(
    "a",
    { className: _index2.default.link, href: storeUrls[gender], "data-testid": "asoslogo" },
    _react2.default.createElement(_Logo2.default, null)
  );
};

exports.default = HomeLogo;

/***/ }),

/***/ "./template/components/Header/HomeLogo/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"_25irHcd"};

/***/ }),

/***/ "./template/components/Header/HomeLogo/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _HomeLogo = __webpack_require__("./template/components/Header/HomeLogo/HomeLogo.js");

var _HomeLogo2 = _interopRequireDefault(_HomeLogo);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    storeUrls: state.regionalStore.storeUrls,
    gender: (0, _layout.getCurrentGender)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_HomeLogo2.default);

/***/ }),

/***/ "./template/components/Header/Logo/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo":"_23G0l8x"};

/***/ }),

/***/ "./template/components/Header/Logo/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = undefined;

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _index = __webpack_require__("./template/components/Header/Logo/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logo = function Logo(_ref) {
  var formatTranslation = _ref.formatTranslation;
  return _react2.default.createElement(
    "svg",
    { className: _index2.default.logo, width: "104", height: "30", viewBox: "0 0 104 30" },
    _react2.default.createElement(
      "title",
      null,
      formatTranslation("Header.HomeAlt")
    ),
    _react2.default.createElement("path", {
      fill: "#FFF",
      fillRule: "evenodd",
      d: "M71.83 21.983c-1.558 1.666-3.56 2.51-5.95 2.51-2.387 0-4.39-.844-5.947-2.51-1.488-1.587-2.343-4.124-2.343-6.96 0-2.766.864-5.27 2.37-6.867 1.572-1.667 3.565-2.516 5.92-2.523 2.36.007 4.35.856 5.924 2.523 1.506 1.598 2.37 4.1 2.37 6.867 0 2.836-.855 5.373-2.343 6.96zm-20.915-6.96c0 .128.005.255.008.38-2.39-2.166-5.845-2.974-7.957-3.394-3.907-.82-6.89-1.58-6.89-4.35 0-1.96 1.757-3.38 5.132-3.14 3.085.224 4.384 2.102 4.74 3.914.05.3.19.515.53.517l5.547.05c.026 0 .048-.003.072-.004-.783 1.816-1.182 3.84-1.182 6.015zM41.48 25.19c-2.683 0-5.64-.95-6.32-4.624-.06-.35-.225-.496-.495-.503l-5.364-.07v-9.446c.71 2.768 3.04 4.684 8.09 5.816 3.38.806 9.24 1.318 9.24 4.774 0 2.408-1.78 4.11-5.15 4.054zm-26.714-.69c-4.327 0-8.29-3.394-8.29-9.47 0-4.77 2.97-9.39 8.32-9.39 2.315 0 8.188.79 8.188 9.39 0 8.62-6.132 9.47-8.218 9.47zm65.922-11.792c1.232 1.636 3.453 2.848 7.063 3.657 3.38.805 9.25 1.318 9.25 4.775 0 2.403-1.78 4.11-5.15 4.05-2.68 0-5.64-.95-6.32-4.625-.052-.35-.22-.497-.49-.504L80.06 20c.523-1.54.79-3.21.79-4.974 0-.793-.056-1.566-.16-2.317zM91.474 30c5.95 0 12.965-2.208 12.416-9.366-.606-6.355-7.244-7.964-10.562-8.625-3.907-.82-6.892-1.58-6.892-4.35 0-1.96 1.758-3.38 5.134-3.14 3.084.224 4.384 2.102 4.74 3.914.05.3.19.515.53.517l5.546.048c.422.002.554-.216.5-.516C101.8 1.874 96.246 0 91.133 0 86.03 0 79.88 1.43 79.443 7.754c-.015.246-.02.486-.02.722-.814-1.683-1.985-3.23-3.495-4.597C73.142 1.37 69.666.03 65.878 0h-.127c-1.81 0-3.58.333-5.26.99a15.26 15.26 0 0 0-4.65 2.888c-1.43 1.295-2.56 2.747-3.36 4.327C51.27 1.822 45.81 0 40.77 0 36.084 0 30.517 1.208 29.3 6.305v-5.06a.49.49 0 0 0-.49-.488h-5.224c-.27 0-.49.22-.49.49V2.61c0 .23-.155.31-.343.175-1.858-1.34-4.607-2.782-7.915-2.782-1.86 0-3.635.326-5.277.968-1.64.65-3.2 1.63-4.64 2.92C3.29 5.37 2.05 7.05 1.23 8.9.417 10.742 0 12.807 0 15.027 0 17.1.367 19.043 1.088 20.8c.722 1.756 1.82 3.382 3.267 4.83 1.446 1.45 3.063 2.553 4.804 3.276 1.74.722 3.66 1.09 5.7 1.09 3.51 0 6.15-1.493 7.88-2.85.19-.144.342-.067.342.17v1.435c0 .27.22.49.49.49H28.8c.27 0 .49-.22.49-.49v-4.83C31.766 29.7 38.04 30 41.113 30c5.137 0 11.06-1.647 12.234-6.7.55.818 1.192 1.597 1.924 2.33 2.8 2.807 6.47 4.316 10.62 4.362h.17c1.97 0 3.87-.377 5.648-1.12a14.82 14.82 0 0 0 4.79-3.242 15.25 15.25 0 0 0 2.594-3.43c1.86 7.438 9.035 7.8 12.387 7.8z"
    })
  );
};

var Component = exports.Component = Logo;
exports.default = (0, _translation2.default)(Logo);

/***/ }),

/***/ "./template/components/Header/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2tINcUI","body":"_1UGQQJn"};

/***/ }),

/***/ "./template/components/Header/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _Header = __webpack_require__("./template/components/Header/Header.js");

var _Header2 = _interopRequireDefault(_Header);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    clearNavActiveItem: _navigation.clearNavActiveItem
  }, dispatch);
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_Header2.default);

/***/ }),

/***/ "./template/components/HtmlHeader/HtmlHeader.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./template/components/HtmlHeader/HtmlHeader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _MiscBar = __webpack_require__("./template/components/MiscBar/index.js");

var _MiscBar2 = _interopRequireDefault(_MiscBar);

var _Header = __webpack_require__("./template/components/Header/index.js");

var _Header2 = _interopRequireDefault(_Header);

var _LargeNavigation = __webpack_require__("./template/components/Navigation/LargeNavigation/index.js");

var _LargeNavigation2 = _interopRequireDefault(_LargeNavigation);

var _SidePanel = __webpack_require__("./template/components/Navigation/SidePanel/index.js");

var _SidePanel2 = _interopRequireDefault(_SidePanel);

var _CookieDisclaimer = __webpack_require__("./template/components/Header/CookieDisclaimer/index.js");

var _CookieDisclaimer2 = _interopRequireDefault(_CookieDisclaimer);

var _UnsupportedBrowserMessage = __webpack_require__("./template/components/UnsupportedBrowserMessage/index.js");

var _UnsupportedBrowserMessage2 = _interopRequireDefault(_UnsupportedBrowserMessage);

var _LayoutManager = __webpack_require__("./template/components/LayoutManager/index.js");

var _LayoutManager2 = _interopRequireDefault(_LayoutManager);

var _NotQuiteStickyHeader = __webpack_require__("./template/components/NotQuiteStickyHeader/index.js");

var _NotQuiteStickyHeader2 = _interopRequireDefault(_NotQuiteStickyHeader);

var _GlobalBanner = __webpack_require__("./template/components/GlobalBanner/index.js");

var _GlobalBanner2 = _interopRequireDefault(_GlobalBanner);

var _GlobalBannerContentAPI = __webpack_require__("./template/components/GlobalBannerContentAPI/index.js");

var _GlobalBannerContentAPI2 = _interopRequireDefault(_GlobalBannerContentAPI);

var _GDPR = __webpack_require__("./template/components/GDPR/index.js");

var _GDPR2 = _interopRequireDefault(_GDPR);

var _CountrySelector = __webpack_require__("./template/components/CountrySelector/index.js");

var _CountrySelector2 = _interopRequireDefault(_CountrySelector);

__webpack_require__("./template/components/HtmlHeader/HtmlHeader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HtmlHeader = function (_Component) {
  (0, _inherits3.default)(HtmlHeader, _Component);

  function HtmlHeader() {
    (0, _classCallCheck3.default)(this, HtmlHeader);
    return (0, _possibleConstructorReturn3.default)(this, (HtmlHeader.__proto__ || (0, _getPrototypeOf2.default)(HtmlHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(HtmlHeader, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          viewport = _props.viewport,
          useContentAPIGlobalBanner = _props.useContentAPIGlobalBanner;


      return _react2.default.createElement(
        "header",
        null,
        _react2.default.createElement(_LayoutManager2.default, null),
        _react2.default.createElement(_CookieDisclaimer2.default, null),
        _react2.default.createElement(_UnsupportedBrowserMessage2.default, null),
        _react2.default.createElement(_MiscBar2.default, { viewable: [_layout.LARGE_VIEWPORT] }),
        _react2.default.createElement(
          _NotQuiteStickyHeader2.default,
          null,
          _react2.default.createElement(_Header2.default, null),
          viewport === _layout.LARGE_VIEWPORT ? _react2.default.createElement(_LargeNavigation2.default, null) : null
        ),
        [_layout.SMALL_VIEWPORT, _layout.MEDIUM_VIEWPORT].indexOf(viewport) !== -1 ? _react2.default.createElement(_SidePanel2.default, { viewable: [_layout.SMALL_VIEWPORT, _layout.MEDIUM_VIEWPORT] }) : null,
        _react2.default.createElement(_GDPR2.default, null),
        useContentAPIGlobalBanner ? _react2.default.createElement(_GlobalBannerContentAPI2.default, {
          viewable: [_layout.LARGE_VIEWPORT, _layout.MEDIUM_VIEWPORT]
        }) : _react2.default.createElement(_GlobalBanner2.default, { viewable: [_layout.LARGE_VIEWPORT, _layout.MEDIUM_VIEWPORT] }),
        _react2.default.createElement(_CountrySelector2.default, null)
      );
    }
  }]);
  return HtmlHeader;
}(_react.Component);

exports.default = HtmlHeader;

/***/ }),

/***/ "./template/components/HtmlHeader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _HtmlHeader = __webpack_require__("./template/components/HtmlHeader/HtmlHeader.js");

var _HtmlHeader2 = _interopRequireDefault(_HtmlHeader);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _features = __webpack_require__("./template/state/modules/features/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    viewport: (0, _layout.getViewport)(state),
    useContentAPIGlobalBanner: !!(0, _features.isFeatureActive)(state, "stc-global-banner-content-api")
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_HtmlHeader2.default);

/***/ }),

/***/ "./template/components/Icon/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_31xW4F2","medium":"OLtHnkd","small":"_1BuJJ3-"};

/***/ }),

/***/ "./template/components/Icon/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("./template/components/Icon/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      size = _ref.size,
      props = (0, _objectWithoutProperties3.default)(_ref, ["icon", "size"]);

  var svg = __webpack_require__("./template/styles/icons recursive ^\\.\\/.*\\.svg$")("./" + icon + ".svg");

  return _react2.default.createElement("span", (0, _extends3.default)({}, props, {
    className: (0, _classnames2.default)(_index2.default.container, _index2.default[size]),
    dangerouslySetInnerHTML: { __html: svg }
  }));
};

Icon.defaultProps = {
  size: "medium"
};

exports.default = Icon;

/***/ }),

/***/ "./template/components/IconButton/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_3TGKcxB"};

/***/ }),

/***/ "./template/components/IconButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("../node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Icon = __webpack_require__("./template/components/Icon/index.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("./template/components/IconButton/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/label-has-for */
var cx = _classnames2.default.bind(_index2.default);

var IconButton = function (_Component) {
  (0, _inherits3.default)(IconButton, _Component);

  function IconButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.icon = function () {
      return _react2.default.createElement(_Icon2.default, {
        style: _this.props.iconStyles || {},
        icon: _this.props.icon,
        size: _this.props.size
      });
    }, _this.classes = function () {
      return cx(_index2.default.button, _this.props.className);
    }, _this.button = function (props) {
      return _react2.default.createElement(
        "button",
        (0, _extends3.default)({ type: "button" }, props, { className: _this.classes() }),
        _this.icon()
      );
    }, _this.label = function (props) {
      return _react2.default.createElement(
        "label",
        (0, _extends3.default)({}, props, { className: _this.classes() }),
        _this.icon()
      );
    }, _this.link = function (props) {
      return _react2.default.createElement(
        "a",
        (0, _extends3.default)({}, props, { className: _this.classes() }),
        _this.icon(),
        _this.props.children
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IconButton, [{
    key: "render",
    value: function render() {
      var p = (0, _assign2.default)({}, this.props);

      if (p.iconStyles) {
        delete p.iconStyles;
      }
      switch (this.props.type) {
        case "a":
          return this.link(p);
        case "label":
          return this.label(p);
        case "button":
        default:
          return this.button(p);
      }
    }
  }]);
  return IconButton;
}(_react.Component);

IconButton.defaultProps = {
  type: "button"
};
exports.default = IconButton;

/***/ }),

/***/ "./template/components/IconNotification/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification":"eNJgAGE"};

/***/ }),

/***/ "./template/components/IconNotification/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./template/components/IconNotification/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconNotification = function IconNotification() {
  return _react2.default.createElement(
    "span",
    { className: _index2.default.notification, "aria-label": "You have one notification" },
    "1"
  );
};

exports.default = IconNotification;

/***/ }),

/***/ "./template/components/LayoutManager/LayoutManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEDIUM_VIEWPORT_MEDIA = "(min-width: 768px)";
var LARGE_VIEWPORT_MEDIA = "(min-width: 1024px)";

var LayoutManager = function (_Component) {
  (0, _inherits3.default)(LayoutManager, _Component);

  function LayoutManager() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LayoutManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LayoutManager.__proto__ || (0, _getPrototypeOf2.default)(LayoutManager)).call.apply(_ref, [this].concat(args))), _this), _this.watchers = {}, _this.onResize = function () {
      var _this$watchers = _this.watchers,
          medium = _this$watchers.medium,
          large = _this$watchers.large;
      var _this$props = _this.props,
          updateViewportCategory = _this$props.updateViewportCategory,
          closeSidePanel = _this$props.closeSidePanel;


      if (large.matches) {
        updateViewportCategory(_layout.LARGE_VIEWPORT);
        closeSidePanel();
      } else if (medium.matches) {
        updateViewportCategory(_layout.MEDIUM_VIEWPORT);
      } else {
        updateViewportCategory(_layout.SMALL_VIEWPORT);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LayoutManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.watchers.medium = window.matchMedia(MEDIUM_VIEWPORT_MEDIA);
      this.watchers.large = window.matchMedia(LARGE_VIEWPORT_MEDIA);
      setTimeout(function () {
        // don't change state too early
        // if not, we will get warning
        // in react if the user has a different
        // viewport as expected
        _this2.onResize();
      }, 0);
      this.watchers.medium.addListener(this.onResize);
      this.watchers.large.addListener(this.onResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _watchers = this.watchers,
          medium = _watchers.medium,
          large = _watchers.large;

      medium.removeListener(this.onResize);
      large.removeListener(this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return LayoutManager;
}(_react.Component);

exports.default = LayoutManager;

/***/ }),

/***/ "./template/components/LayoutManager/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _LayoutManager = __webpack_require__("./template/components/LayoutManager/LayoutManager.js");

var _LayoutManager2 = _interopRequireDefault(_LayoutManager);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    updateViewportCategory: _layout.updateViewportCategory,
    closeSidePanel: _layout.closeSidePanel
  }, dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    viewportCategory: (0, _layout.getViewport)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LayoutManager2.default);

/***/ }),

/***/ "./template/components/LegalBar/LegalBar.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2jz2mjA","body":"nUQMpvx","copyright":"_28lMicj","links":"W1vTixy","hideOnSmallViewport":"_2xktXa3"};

/***/ }),

/***/ "./template/components/LegalBar/LegalBar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _LegalBar = __webpack_require__("./template/components/LegalBar/LegalBar.css");

var _LegalBar2 = _interopRequireDefault(_LegalBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegalBar = function LegalBar(_ref) {
  var formatTranslation = _ref.formatTranslation,
      defaultStoreUrl = _ref.defaultStoreUrl;
  return _react2.default.createElement(
    "div",
    { className: _LegalBar2.default.container },
    _react2.default.createElement(
      "div",
      { className: _LegalBar2.default.body, "data-testid": "legalbar" },
      _react2.default.createElement(
        "p",
        { className: _LegalBar2.default.copyright },
        "\xA9 ",
        new Date().getFullYear(),
        " ASOS"
      ),
      _react2.default.createElement(
        "ul",
        { className: _LegalBar2.default.links },
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "a",
            {
              href: defaultStoreUrl.concat(formatTranslation("LegalBar.PrivacyLink"))
            },
            formatTranslation("LegalBar.Privacy")
          )
        ),
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "a",
            {
              href: defaultStoreUrl.concat(formatTranslation("LegalBar.TermsLink"))
            },
            formatTranslation("LegalBar.Terms")
          )
        ),
        _react2.default.createElement(
          "li",
          { className: _LegalBar2.default.hideOnSmallViewport },
          _react2.default.createElement(
            "a",
            {
              href: defaultStoreUrl.concat(formatTranslation("LegalBar.AccessibilityLink"))
            },
            formatTranslation("LegalBar.Accessibility")
          )
        )
      )
    )
  );
};

exports.default = (0, _translation2.default)(LegalBar);

/***/ }),

/***/ "./template/components/LegalBar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _LegalBar = __webpack_require__("./template/components/LegalBar/LegalBar.js");

var _LegalBar2 = _interopRequireDefault(_LegalBar);

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    defaultStoreUrl: (0, _regionalStore.getDefaultStoreUrl)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_LegalBar2.default);

/***/ }),

/***/ "./template/components/MiniBag/ErrorMessage/ErrorMessage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _Notification = __webpack_require__("./template/components/Notification/index.js");

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorMessage = function ErrorMessage(_ref) {
  var formatTranslation = _ref.formatTranslation,
      dismissBagError = _ref.dismissBagError,
      showError = _ref.showError;

  return showError ? _react2.default.createElement(
    _Notification2.default,
    { type: "alert", onClose: dismissBagError },
    _react2.default.createElement(
      "p",
      null,
      formatTranslation("MiniBag.ErrorMessage.firstLine")
    ),
    _react2.default.createElement(
      "p",
      null,
      formatTranslation("MiniBag.ErrorMessage.secondLine")
    )
  ) : null;
};

exports.default = (0, _translation2.default)(ErrorMessage);

/***/ }),

/***/ "./template/components/MiniBag/ErrorMessage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

var _ErrorMessage = __webpack_require__("./template/components/MiniBag/ErrorMessage/ErrorMessage.js");

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    showError: (0, _bag.bagError)(state)
  };
};

var mapDispatchToProps = { dismissBagError: _bag.dismissBagError };

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ErrorMessage2.default);

/***/ }),

/***/ "./template/components/MiniBag/Footer/BagLinks/BagLinks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _Button = __webpack_require__("./template/components/Button/index.js");

var _Button2 = _interopRequireDefault(_Button);

var _queryString = __webpack_require__("./helpers/queryString.js");

var _index = __webpack_require__("./template/components/MiniBag/Footer/BagLinks/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryProposition = function DeliveryProposition(_ref) {
  var defaultStoreUrl = _ref.defaultStoreUrl,
      formatTranslation = _ref.formatTranslation,
      startCheckout = _ref.startCheckout;

  function linkWithAnalytics(link) {
    return (0, _queryString.withParams)(link, { ctaref: "mini bag" });
  }
  return _react2.default.createElement(
    "div",
    { className: _index2.default.bagLinks },
    _react2.default.createElement(
      "div",
      { className: _index2.default.buttonContainer },
      _react2.default.createElement(
        _Button2.default,
        {
          theme: "secondary",
          href: linkWithAnalytics(defaultStoreUrl.concat(formatTranslation("Bag.Link"))),
          "data-test-id": "bag-link"
        },
        formatTranslation("MiniBag.Footer.BagLinks.Bag.Text")
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _index2.default.buttonContainer },
      _react2.default.createElement(
        _Button2.default,
        {
          theme: "green",
          href: "#",
          onClick: function onClick() {
            return startCheckout();
          },
          "data-test-id": "checkout-link"
        },
        formatTranslation("MiniBag.Footer.BagLinks.Checkout.Text")
      )
    )
  );
};

exports.default = (0, _translation2.default)(DeliveryProposition);

/***/ }),

/***/ "./template/components/MiniBag/Footer/BagLinks/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bagLinks":"OWGtwg_","buttonContainer":"_2VB_6B_"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/BagLinks/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _BagLinks = __webpack_require__("./template/components/MiniBag/Footer/BagLinks/BagLinks.js");

var _BagLinks2 = _interopRequireDefault(_BagLinks);

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    defaultStoreUrl: (0, _regionalStore.getDefaultStoreUrl)(state)
  };
};

var mapDispatchToProps = {
  startCheckout: _bag.startCheckout
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BagLinks2.default);

/***/ }),

/***/ "./template/components/MiniBag/Footer/DeliveryProposition/DeliveryProposition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _index = __webpack_require__("./template/components/MiniBag/Footer/DeliveryProposition/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryProposition = function DeliveryProposition(_ref) {
  var defaultStoreUrl = _ref.defaultStoreUrl,
      formatTranslation = _ref.formatTranslation;
  return _react2.default.createElement(
    "div",
    { className: _index2.default.deliveryProposition },
    _react2.default.createElement(
      "span",
      { className: _index2.default.title },
      formatTranslation("MiniBag.Footer.DeliveryProposition.Title")
    ),
    _react2.default.createElement(
      "span",
      { className: _index2.default.description },
      _react2.default.createElement(
        "span",
        null,
        formatTranslation("MiniBag.Footer.DeliveryProposition.Description")
      ),
      _react2.default.createElement(
        "a",
        {
          className: _index2.default.descriptionLink,
          href: defaultStoreUrl.concat(formatTranslation("MiniBag.Footer.DeliveryProposition.DeliveryInformationLink"))
        },
        formatTranslation("MiniBag.Footer.DeliveryProposition.LinkText")
      )
    )
  );
};

exports.default = (0, _translation2.default)(DeliveryProposition);

/***/ }),

/***/ "./template/components/MiniBag/Footer/DeliveryProposition/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"deliveryProposition":"_36n_JsH","title":"_21tn5Nb","description":"_4ldbEX5","descriptionLink":"s1XF5zI"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/DeliveryProposition/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _DeliveryProposition = __webpack_require__("./template/components/MiniBag/Footer/DeliveryProposition/DeliveryProposition.js");

var _DeliveryProposition2 = _interopRequireDefault(_DeliveryProposition);

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    defaultStoreUrl: (0, _regionalStore.getDefaultStoreUrl)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_DeliveryProposition2.default);

/***/ }),

/***/ "./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/GermanVATIncluded.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GermanVATIncluded = function GermanVATIncluded(_ref) {
  var storeCode = _ref.storeCode;
  return storeCode === "DE" ? "inkl. MwSt." : null;
};

exports.default = GermanVATIncluded;

/***/ }),

/***/ "./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _GermanVATIncluded = __webpack_require__("./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/GermanVATIncluded.js");

var _GermanVATIncluded2 = _interopRequireDefault(_GermanVATIncluded);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    storeCode: (0, _regionalStore.getStoreCode)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_GermanVATIncluded2.default);

/***/ }),

/***/ "./template/components/MiniBag/Footer/SubTotal/SubTotal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _index = __webpack_require__("./template/components/MiniBag/Footer/SubTotal/index.css");

var _index2 = _interopRequireDefault(_index);

var _GermanVATIncluded = __webpack_require__("./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/index.js");

var _GermanVATIncluded2 = _interopRequireDefault(_GermanVATIncluded);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubTotal = function SubTotal(_ref) {
  var text = _ref.text,
      formatTranslation = _ref.formatTranslation;
  return _react2.default.createElement(
    "div",
    { className: _index2.default.subTotalContainer },
    _react2.default.createElement(
      "h1",
      null,
      formatTranslation("MiniBag.SubTotal")
    ),
    _react2.default.createElement(
      "div",
      { "data-test-id": "miniBagSubTotal" },
      text,
      _react2.default.createElement(
        "small",
        { className: _index2.default.germanVATInc },
        _react2.default.createElement(_GermanVATIncluded2.default, null)
      )
    )
  );
};

SubTotal.defaultProps = {
  text: null
};

exports.default = (0, _translation2.default)(SubTotal);

/***/ }),

/***/ "./template/components/MiniBag/Footer/SubTotal/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"subTotalContainer":"_2AvxZ7t","germanVATInc":"_3avmlO4"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/SubTotal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _SubTotal = __webpack_require__("./template/components/MiniBag/Footer/SubTotal/SubTotal.js");

var _SubTotal2 = _interopRequireDefault(_SubTotal);

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    text: (0, _bag.getTotalPriceText)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_SubTotal2.default);

/***/ }),

/***/ "./template/components/MiniBag/Footer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"minibagFooter":"_3L-aps4"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./template/components/MiniBag/Footer/index.css");

var _index2 = _interopRequireDefault(_index);

var _DeliveryProposition = __webpack_require__("./template/components/MiniBag/Footer/DeliveryProposition/index.js");

var _DeliveryProposition2 = _interopRequireDefault(_DeliveryProposition);

var _BagLinks = __webpack_require__("./template/components/MiniBag/Footer/BagLinks/index.js");

var _BagLinks2 = _interopRequireDefault(_BagLinks);

var _SubTotal = __webpack_require__("./template/components/MiniBag/Footer/SubTotal/index.js");

var _SubTotal2 = _interopRequireDefault(_SubTotal);

var _ErrorMessage = __webpack_require__("./template/components/MiniBag/ErrorMessage/index.js");

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MinibagFooter = function MinibagFooter() {
  return _react2.default.createElement(
    "div",
    { "data-test-id": "miniBagFooter", className: _index2.default.minibagFooter },
    _react2.default.createElement(
      "div",
      { className: _index2.default.error },
      _react2.default.createElement(_ErrorMessage2.default, null)
    ),
    _react2.default.createElement(_SubTotal2.default, null),
    _react2.default.createElement(_BagLinks2.default, null),
    _react2.default.createElement(_DeliveryProposition2.default, null)
  );
};

exports.default = MinibagFooter;

/***/ }),

/***/ "./template/components/MiniBag/Header/MinibagHeader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _index = __webpack_require__("./template/components/MiniBag/Header/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MinibagHeader = function MinibagHeader(_ref) {
  var totalQuantity = _ref.totalQuantity,
      formatTranslation = _ref.formatTranslation;
  return _react2.default.createElement(
    "div",
    { "data-test-id": "miniBagHeader", className: _index2.default.container },
    _react2.default.createElement(
      "span",
      { className: _index2.default.bagTitle },
      formatTranslation("MiniBag.MyBag"),
      ","
    ),
    _react2.default.createElement(
      "span",
      { "data-test-id": "miniBagItemCount" },
      formatTranslation("MiniBag.ItemCount", {
        smart_count: totalQuantity
      })
    )
  );
};

exports.default = (0, _translation2.default)(MinibagHeader);

/***/ }),

/***/ "./template/components/MiniBag/Header/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"-JJfifv","bagTitle":"_1vvMfU_"};

/***/ }),

/***/ "./template/components/MiniBag/Header/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _MinibagHeader = __webpack_require__("./template/components/MiniBag/Header/MinibagHeader.js");

var _MinibagHeader2 = _interopRequireDefault(_MinibagHeader);

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    totalQuantity: (0, _bag.getTotalQuantity)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_MinibagHeader2.default);

/***/ }),

/***/ "./template/components/MiniBag/LineItem/DeleteItem/DeleteItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./template/components/MiniBag/LineItem/DeleteItem/index.css");

var _index2 = _interopRequireDefault(_index);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _events = __webpack_require__("./helpers/events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteItem = function DeleteItem(_ref) {
  var deleteBagItem = _ref.deleteBagItem,
      id = _ref.id,
      formatTranslation = _ref.formatTranslation;

  function deleteBagItemWithTracking(id) {
    deleteBagItem(id);
    (0, _events.trackMiniBagProductDelete)({
      interaction: _events.ANALYTICS_INTERACTION_CLICK,
      context: _events.ANALYTICS_CONTEXT.minibagDeleteItem,
      productId: id
    });
  }

  return _react2.default.createElement("button", {
    "aria-label": formatTranslation("MiniBag.DeleteBagItemText"),
    className: _index2.default.deleteItem,
    onClick: function onClick(e) {
      e.stopPropagation();
      deleteBagItemWithTracking(id);
    }
  });
};

exports.default = (0, _translation2.default)(DeleteItem);

/***/ }),

/***/ "./template/components/MiniBag/LineItem/DeleteItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"deleteItem":"XBF4Pwh"};

/***/ }),

/***/ "./template/components/MiniBag/LineItem/DeleteItem/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _DeleteItem = __webpack_require__("./template/components/MiniBag/LineItem/DeleteItem/DeleteItem.js");

var _DeleteItem2 = _interopRequireDefault(_DeleteItem);

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = {
  deleteBagItem: _bag.deleteBagItem
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_DeleteItem2.default);

/***/ }),

/***/ "./template/components/MiniBag/LineItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1W0zOsK","link":"_1hLNXDL","image":"_36eVKGL","details":"_11v_yFR","term":"_1NGI_3f","price":"_3GC3ciN","item":"_2AqO0mn","product":"_1X9v1ZD","name":"_3GJua_o","meta":"_3FcFWyr","color":"_2iqu9DU","size":"_1DeddFy","quantity":"_11JyDT0"};

/***/ }),

/***/ "./template/components/MiniBag/LineItem/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _DeleteItem = __webpack_require__("./template/components/MiniBag/LineItem/DeleteItem/index.js");

var _DeleteItem2 = _interopRequireDefault(_DeleteItem);

var _Price = __webpack_require__("./template/components/MiniBag/Price/index.js");

var _Price2 = _interopRequireDefault(_Price);

var _index = __webpack_require__("./template/components/MiniBag/LineItem/index.css");

var _index2 = _interopRequireDefault(_index);

var _queryString = __webpack_require__("./helpers/queryString.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_index2.default);

function getProductUrl(images, size) {
  var filteredImages = images.filter(function (image) {
    return image.size === size;
  });

  if (!filteredImages.length) {
    return null;
  }

  return filteredImages[0].url;
}

var containerClassNames = function containerClassNames() {
  var itemType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return cx("container", "item", itemType.toLowerCase());
};

var LineItem = function LineItem(_ref) {
  var color = _ref.colour,
      formatTranslation = _ref.formatTranslation,
      id = _ref.id,
      images = _ref.images,
      imageUrl = _ref.imageUrl,
      itemType = _ref.itemType,
      name = _ref.name,
      price = _ref.price,
      productUrl = _ref.productUrl,
      quantity = _ref.quantity,
      size = _ref.size;

  var linkWithAnalytics = (0, _queryString.withParams)(productUrl, {
    ctaref: "mini bag",
    featureref1: "mini bag"
  });
  return _react2.default.createElement(
    "div",
    { className: containerClassNames(itemType) },
    _react2.default.createElement(
      "a",
      { href: linkWithAnalytics, className: _index2.default.link },
      imageUrl && _react2.default.createElement("img", { src: imageUrl, alt: "", className: _index2.default.image }),
      images.length > 0 && _react2.default.createElement("img", {
        src: getProductUrl(images, "l"),
        srcSet: getProductUrl(images, "xl") + " 2x",
        alt: "",
        className: _index2.default.image
      }),
      _react2.default.createElement(
        "dl",
        { className: _index2.default.details },
        _react2.default.createElement(
          "div",
          { className: _index2.default.price },
          _react2.default.createElement(
            "dt",
            null,
            formatTranslation("MiniBag.Price")
          ),
          _react2.default.createElement(
            "dd",
            null,
            _react2.default.createElement(_Price2.default, price)
          )
        ),
        _react2.default.createElement(
          "div",
          { className: _index2.default.name },
          _react2.default.createElement(
            "dt",
            null,
            formatTranslation("MiniBag.Name")
          ),
          _react2.default.createElement(
            "dd",
            null,
            name
          )
        ),
        _react2.default.createElement(
          "div",
          { className: _index2.default.meta },
          color && itemType === "Product" && _react2.default.createElement(
            "div",
            { className: _index2.default.color },
            _react2.default.createElement(
              "dt",
              null,
              formatTranslation("MiniBag.Color")
            ),
            _react2.default.createElement(
              "dd",
              null,
              color
            )
          ),
          size && itemType === "Product" && _react2.default.createElement(
            "div",
            { className: _index2.default.size },
            _react2.default.createElement(
              "dt",
              null,
              formatTranslation("MiniBag.Size")
            ),
            _react2.default.createElement(
              "dd",
              null,
              size
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _index2.default.quantity },
            _react2.default.createElement(
              "dt",
              { className: _index2.default.term },
              _react2.default.createElement(
                "abbr",
                { title: formatTranslation("MiniBag.Quantity") },
                formatTranslation("MiniBag.Qty")
              )
            ),
            _react2.default.createElement(
              "dd",
              { className: _index2.default.quantity },
              quantity
            )
          )
        )
      )
    ),
    _react2.default.createElement(_DeleteItem2.default, { id: id })
  );
};

LineItem.defaultProps = {
  images: []
};

exports.default = (0, _translation2.default)(LineItem);

/***/ }),

/***/ "./template/components/MiniBag/MiniBag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firstTwentyItems = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _LineItem = __webpack_require__("./template/components/MiniBag/LineItem/index.js");

var _LineItem2 = _interopRequireDefault(_LineItem);

var _Notification = __webpack_require__("./template/components/Notification/index.js");

var _Notification2 = _interopRequireDefault(_Notification);

var _Spinner = __webpack_require__("./template/components/Spinner/index.js");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _ReservationMessage = __webpack_require__("./template/components/MiniBag/ReservationMessage/index.js");

var _ReservationMessage2 = _interopRequireDefault(_ReservationMessage);

var _TransitionList = __webpack_require__("./template/components/TransitionList/index.js");

var _TransitionList2 = _interopRequireDefault(_TransitionList);

var _index = __webpack_require__("./template/components/MiniBag/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var firstTwentyItems = exports.firstTwentyItems = function firstTwentyItems(items) {
  return items.slice(0, 20);
};

var MiniBag = function MiniBag(_ref) {
  var defaultStoreUrl = _ref.defaultStoreUrl,
      bagItemDeleteTransitionEnd = _ref.bagItemDeleteTransitionEnd,
      formatTranslation = _ref.formatTranslation,
      items = _ref.items,
      loading = _ref.loading;

  var moreThanTwentyItems = items.length > 20;
  var loaded = items.length && !loading;
  var itemsToRender = firstTwentyItems(items);

  return loaded ? _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_ReservationMessage2.default, null),
    _react2.default.createElement(
      "div",
      { className: _index2.default.miniBag },
      _react2.default.createElement(
        _TransitionList2.default,
        {
          onTransitionEnd: bagItemDeleteTransitionEnd,
          itemDeletedLabel: formatTranslation("MiniBag.ItemDeleted")
        },
        itemsToRender.map(function (item) {
          return _react2.default.createElement(_LineItem2.default, (0, _extends3.default)({ key: item.id }, item));
        })
      ),
      moreThanTwentyItems && _react2.default.createElement(
        _Notification2.default,
        {
          type: "alert",
          withClose: true,
          closeLabel: formatTranslation("MiniBag.DismissNotificationBtnText")
        },
        _react2.default.createElement(
          "div",
          { className: _index2.default.notification },
          _react2.default.createElement(
            "span",
            null,
            formatTranslation("MiniBag.Footer.MaximumItemsMessage")
          ),
          _react2.default.createElement(
            "span",
            null,
            formatTranslation("MiniBag.Footer.ViewBagMessage.PartOne"),
            _react2.default.createElement(
              "a",
              {
                className: _index2.default.link,
                href: defaultStoreUrl.concat(formatTranslation("Bag.Link"))
              },
              formatTranslation("MiniBag.Footer.ViewBagMessage.Link")
            ),
            formatTranslation("MiniBag.Footer.ViewBagMessage.PartTwo")
          )
        )
      )
    )
  ) : _react2.default.createElement(
    "div",
    { className: _index2.default.spinnerContainer },
    _react2.default.createElement(_Spinner2.default, { size: "large" })
  );
};

MiniBag.defaultProps = {
  items: [],
  loading: false
};

exports.default = (0, _translation2.default)(MiniBag);

/***/ }),

/***/ "./template/components/MiniBag/Price/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_38kkGWl","current":"he3XXzJ","highlight":"_1uD507y","previous":"_206h8Fg","rrp":"_255x-wT","rrpLabel":"_3a-eLYZ"};

/***/ }),

/***/ "./template/components/MiniBag/Price/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _index = __webpack_require__("./template/components/MiniBag/Price/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_index2.default);

var Price = function Price(_ref) {
  var text = _ref.text,
      current = _ref.current,
      previous = _ref.previous,
      rrp = _ref.rrp,
      isMarkedDown = _ref.isMarkedDown,
      isOutletPrice = _ref.isOutletPrice,
      formatTranslation = _ref.formatTranslation;
  return _react2.default.createElement(
    "div",
    { className: _index2.default.container },
    _react2.default.createElement(
      "span",
      {
        className: cx([_index2.default.current], (0, _defineProperty3.default)({}, _index2.default.highlight, isMarkedDown || isOutletPrice))
      },
      text || current.text
    ),
    isOutletPrice && _react2.default.createElement(
      "span",
      { className: _index2.default.rrp },
      _react2.default.createElement(
        "span",
        { className: _index2.default.rrpLabel },
        formatTranslation("MiniBag.RRP")
      ),
      rrp.text
    ),
    isMarkedDown && _react2.default.createElement(
      "span",
      { className: _index2.default.previous },
      previous.text
    )
  );
};

Price.defaultProps = {
  current: {}
};

exports.default = (0, _translation2.default)(Price);

/***/ }),

/***/ "./template/components/MiniBag/ReservationMessage/ReservationMessage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _Notification = __webpack_require__("./template/components/Notification/index.js");

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProductToMessage = {
  Product: "reservationMessage",
  Subscription: "subscriptionConfirmationMessage",
  Voucher: "voucherConfirmationMessage"
};

var ReservationMessage = function ReservationMessage(_ref) {
  var formatTranslation = _ref.formatTranslation,
      displayReservationMessage = _ref.displayReservationMessage,
      items = _ref.items;

  return displayReservationMessage ? _react2.default.createElement(
    _Notification2.default,
    { type: "success" },
    formatTranslation("MiniBag." + mapProductToMessage[items[0].itemType])
  ) : null;
};

ReservationMessage.defaultProps = {
  displayReservationMessage: false
};

exports.default = (0, _translation2.default)(ReservationMessage);

/***/ }),

/***/ "./template/components/MiniBag/ReservationMessage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

var _ReservationMessage = __webpack_require__("./template/components/MiniBag/ReservationMessage/ReservationMessage.js");

var _ReservationMessage2 = _interopRequireDefault(_ReservationMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    displayReservationMessage: (0, _bag.displayReservationMessage)(state),
    items: (0, _bag.getBagItems)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_ReservationMessage2.default);

/***/ }),

/***/ "./template/components/MiniBag/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification":"_3y1fLq5","miniBag":"_13bi4_K","link":"_11qZWTX","spinnerContainer":"_26s4UbK","error":"wm-Y41N"};

/***/ }),

/***/ "./template/components/MiniBag/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _MiniBag = __webpack_require__("./template/components/MiniBag/MiniBag.js");

var _MiniBag2 = _interopRequireDefault(_MiniBag);

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    defaultStoreUrl: (0, _regionalStore.getDefaultStoreUrl)(state),
    items: (0, _bag.getBagItems)(state),
    loading: (0, _bag.getLoading)(state)
  };
};

var mapDispatchToProps = {
  bagItemDeleteTransitionEnd: _bag.bagItemDeleteTransitionEnd
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_MiniBag2.default);

/***/ }),

/***/ "./template/components/MiscBar/MiscBar.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2mW0vnV","container__hidden":"_3Jzwqs8","body":"_2kDR6LR","navigation":"_2gP-s5Y"};

/***/ }),

/***/ "./template/components/MiscBar/MiscBar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _CountrySelectorButton = __webpack_require__("./template/components/CountrySelectorButton/index.js");

var _CountrySelectorButton2 = _interopRequireDefault(_CountrySelectorButton);

var _events = __webpack_require__("./helpers/events.js");

var _MiscBar = __webpack_require__("./template/components/MiscBar/MiscBar.css");

var _MiscBar2 = _interopRequireDefault(_MiscBar);

var _externalLinks = __webpack_require__("./template/helpers/externalLinks.js");

var _queryString = __webpack_require__("./helpers/queryString.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var marketplaceUrl = function marketplaceUrl() {
  return (0, _queryString.withParams)((0, _externalLinks.getMarketplaceUrl)(), {
    ctaref: "Global nav"
  });
};

var MiscBar = function MiscBar(_ref) {
  var formatTranslation = _ref.formatTranslation,
      defaultStoreUrl = _ref.defaultStoreUrl;
  return _react2.default.createElement(
    "div",
    { className: _MiscBar2.default.container, "data-testid": "topbar" },
    _react2.default.createElement(
      "div",
      { className: _MiscBar2.default.body },
      _react2.default.createElement(
        "ul",
        { className: _MiscBar2.default.navigation },
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "a",
            { href: marketplaceUrl(), "data-testid": "marketplace" },
            formatTranslation("MiscBar.Marketplace")
          )
        ),
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "a",
            {
              href: defaultStoreUrl.concat(formatTranslation("MiscBar.HelpLink")),
              "data-testid": "help"
            },
            formatTranslation("MiscBar.Help")
          )
        ),
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(_CountrySelectorButton2.default, { position: _events.ANALYTICS_POSITION_HEADER })
        )
      )
    )
  );
};

exports.default = (0, _translation2.default)(MiscBar);

/***/ }),

/***/ "./template/components/MiscBar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _MiscBar = __webpack_require__("./template/components/MiscBar/MiscBar.js");

var _MiscBar2 = _interopRequireDefault(_MiscBar);

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    defaultStoreUrl: (0, _regionalStore.getDefaultStoreUrl)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_MiscBar2.default);

/***/ }),

/***/ "./template/components/Modal/Backdrop.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"_20Pj1VE"};

/***/ }),

/***/ "./template/components/Modal/Backdrop.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Backdrop = __webpack_require__("./template/components/Modal/Backdrop.css");

var _Backdrop2 = _interopRequireDefault(_Backdrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backdrop = function Backdrop(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    "div",
    { className: _Backdrop2.default.backdrop },
    children
  );
};

exports.default = Backdrop;

/***/ }),

/***/ "./template/components/Modal/Container.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1IrYKRb","container":"_2GCIzUy","close":"_1afbYq-"};

/***/ }),

/***/ "./template/components/Modal/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _IconButton = __webpack_require__("./template/components/IconButton/index.js");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Container = __webpack_require__("./template/components/Modal/Container.css");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = function (_Component) {
  (0, _inherits3.default)(Container, _Component);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Container.__proto__ || (0, _getPrototypeOf2.default)(Container)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = /* istanbul ignore next */function (e) {
      var onClose = _this.props.onClose;

      // Escape

      if (e.keyCode === 27) {
        e.preventDefault();
      }

      onClose();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Container, [{
    key: "componentDidMount",


    /* istanbul ignore next */
    value: function componentDidMount() {
      document.addEventListener("keyup", this.handleClose);
    }

    /* istanbul ignore next */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keyup", this.handleClose);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;


      return _react2.default.createElement(
        "section",
        { className: _Container2.default.wrapper },
        _react2.default.createElement(
          "div",
          { className: _Container2.default.container },
          _react2.default.createElement(_IconButton2.default, {
            icon: "close",
            onClick: this.handleClose,
            className: _Container2.default.close
          }),
          children
        )
      );
    }
  }]);
  return Container;
}(_react.Component);

exports.default = Container;

/***/ }),

/***/ "./template/components/Modal/Fade.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fade":"_1Ak4Mxk","isAndroid":"oKBSAEs","isIos":"_1f8FALW","fade__entered":"_1nheg_4","fade__entering":"_1kv7c7T","fade__exited":"Glsad_N","fade__exiting":"_20ztZF3"};

/***/ }),

/***/ "./template/components/Modal/Fade.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _CSSTransition = __webpack_require__("../node_modules/react-transition-group/CSSTransition.js");

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _Fade = __webpack_require__("./template/components/Modal/Fade.css");

var _Fade2 = _interopRequireDefault(_Fade);

var _deviceDetection = __webpack_require__("./helpers/deviceDetection.js");

var _deviceDetection2 = _interopRequireDefault(_deviceDetection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fade = function (_Component) {
  (0, _inherits3.default)(Fade, _Component);

  function Fade() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Fade);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Fade.__proto__ || (0, _getPrototypeOf2.default)(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.deviceDetection = new _deviceDetection2.default(), _this.handleEnter = /* istanbul ignore next */function () {
      _this.y = window.scrollY;
      scrollTo(0, 0);

      document.body.classList.add("chrome-bodylock");
    }, _this.handleExit = /* istanbul ignore next */function () {
      document.body.classList.remove("chrome-bodylock");

      scrollTo(0, _this.y);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // HACK: iOS 10 and below do not like fixed with forms


  (0, _createClass3.default)(Fade, [{
    key: "render",

    // end

    value: function render() {
      var _cx;

      var _props = this.props,
          isActive = _props.isActive,
          children = _props.children;


      return _react2.default.createElement(
        _CSSTransition2.default,
        {
          "in": isActive,
          mountOnEnter: true,
          unmountOnExit: true,
          timeout: 300,
          onEnter: this.handleEnter,
          onExited: this.handleExit,
          classNames: {
            enter: _Fade2.default.fade__entered,
            enterActive: _Fade2.default.fade__entering,
            exit: _Fade2.default.fade__exited,
            exitActive: _Fade2.default.fade__exiting
          }
        },
        _react2.default.createElement(
          "div",
          {
            className: (0, _classnames2.default)(_Fade2.default.fade, (_cx = {}, (0, _defineProperty3.default)(_cx, _Fade2.default.isAndroid, this.deviceDetection.isAndroidChrome()), (0, _defineProperty3.default)(_cx, _Fade2.default.isIos, this.deviceDetection.isIos()), _cx))
          },
          children
        )
      );
    }
  }]);
  return Fade;
}(_react.Component);

Fade.defaultProps = {
  isActive: false
};

exports.default = Fade;

/***/ }),

/***/ "./template/components/Modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Backdrop = __webpack_require__("./template/components/Modal/Backdrop.js");

var _Backdrop2 = _interopRequireDefault(_Backdrop);

var _Container = __webpack_require__("./template/components/Modal/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _Fade = __webpack_require__("./template/components/Modal/Fade.js");

var _Fade2 = _interopRequireDefault(_Fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = /* istanbul ignore next */function () {
      var onClose = _this.props.onClose;


      if (onClose) {
        onClose();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Modal, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isOpen = _props.isOpen;


      return _react2.default.createElement(
        _Fade2.default,
        { isActive: isOpen },
        _react2.default.createElement(_Backdrop2.default, null),
        _react2.default.createElement(
          _Container2.default,
          { onClose: this.handleClose },
          children
        )
      );
    }
  }]);
  return Modal;
}(_react.Component);

exports.default = Modal;

/***/ }),

/***/ "./template/components/MyAccountLinks/MyAccountLinks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _queryString = __webpack_require__("../node_modules/query-string/index.js");

var _withViewport = __webpack_require__("./template/components/Viewport/withViewport.js");

var _withViewport2 = _interopRequireDefault(_withViewport);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _index = __webpack_require__("./template/components/MyAccountLinks/index.css");

var _index2 = _interopRequireDefault(_index);

var _IconNotification = __webpack_require__("./template/components/IconNotification/index.js");

var _IconNotification2 = _interopRequireDefault(_IconNotification);

var _externalLinks = __webpack_require__("./template/helpers/externalLinks.js");

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _accessibility = __webpack_require__("./helpers/accessibility.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTACT_PREFERENCES = "ContactPreferences";
var MY_ACCOUNT = "MyAccount";
var MY_ORDERS = "MyOrders";
var RETURNS_INFORMATION = "ReturnsInformation";

var cx = _classnames2.default.bind(_index2.default);

var MyAccountLinks = function (_PureComponent) {
  (0, _inherits3.default)(MyAccountLinks, _PureComponent);

  function MyAccountLinks() {
    (0, _classCallCheck3.default)(this, MyAccountLinks);
    return (0, _possibleConstructorReturn3.default)(this, (MyAccountLinks.__proto__ || (0, _getPrototypeOf2.default)(MyAccountLinks)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyAccountLinks, [{
    key: "buildLinks",
    value: function buildLinks() {
      var _props = this.props,
          countryCode = _props.countryCode,
          defaultStoreUrl = _props.defaultStoreUrl,
          formatTranslation = _props.formatTranslation,
          isReconsentRequired = _props.isReconsentRequired,
          keyStoreDataversion = _props.keyStoreDataversion,
          lang = _props.lang,
          _props$queryParams = _props.queryParams,
          queryParams = _props$queryParams === undefined ? {} : _props$queryParams,
          storeCode = _props.storeCode;


      var queryString = "?" + (0, _queryString.stringify)((0, _extends3.default)({}, queryParams, {
        lang: lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion: keyStoreDataversion
      }));

      var baseUrl = (0, _externalLinks.getMyAccountBaseUrl)();

      var links = [{
        id: MY_ACCOUNT,
        href: baseUrl + queryString,
        showNotification: false
      }, {
        id: MY_ORDERS,
        href: baseUrl + "/orders" + queryString,
        showNotification: false
      }, {
        id: RETURNS_INFORMATION,
        href: defaultStoreUrl.concat(formatTranslation("MyAccountLinks." + RETURNS_INFORMATION + "Link"), "&", (0, _queryString.stringify)(queryParams)),
        showNotification: false
      }, {
        id: CONTACT_PREFERENCES,
        href: baseUrl + "/contact-preferences" + queryString,
        showNotification: isReconsentRequired
      }];

      return links;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          isVisible = _props2.isVisible,
          formatTranslation = _props2.formatTranslation,
          focusable = _props2.focusable;


      if (!isVisible) return null;

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        this.buildLinks().map(function (_ref) {
          var id = _ref.id,
              href = _ref.href,
              showNotification = _ref.showNotification;
          return _react2.default.createElement(
            "a",
            {
              href: href,
              className: cx(_index2.default.link, _index2.default[id]),
              key: id,
              tabIndex: (0, _accessibility.tabIndex)(focusable),
              "data-testid": id.toLowerCase() + "-link"
            },
            showNotification && _react2.default.createElement(
              "span",
              { className: cx(_index2.default.notificationContainer) },
              _react2.default.createElement(_IconNotification2.default, null)
            ),
            formatTranslation("MyAccountLinks." + id)
          );
        })
      );
    }
  }]);
  return MyAccountLinks;
}(_react.PureComponent);

exports.default = (0, _withViewport2.default)((0, _translation2.default)(MyAccountLinks));

/***/ }),

/***/ "./template/components/MyAccountLinks/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3C22DSI","notificationContainer":"_1FUcAu2","link":"_1U-LQGT","MyAccount":"CbK3vyi","MyOrders":"sEG4Jt8","ReturnsInformation":"gWnk_r7","ContactPreferences":"lWdTQ9X"};

/***/ }),

/***/ "./template/components/MyAccountLinks/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _MyAccountLinks = __webpack_require__("./template/components/MyAccountLinks/MyAccountLinks.js");

var _MyAccountLinks2 = _interopRequireDefault(_MyAccountLinks);

var _user = __webpack_require__("./template/state/modules/user/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    countryCode: (0, _regionalStore.getCountryCode)(state),
    defaultStoreUrl: (0, _regionalStore.getDefaultStoreUrl)(state),
    isReconsentRequired: (0, _user.getIsReconsentRequired)(state),
    keyStoreDataversion: (0, _regionalStore.getKeyStoreDataversion)(state),
    lang: (0, _regionalStore.getDefaultLanguage)(state),
    storeCode: (0, _regionalStore.getStoreCode)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_MyAccountLinks2.default);

/***/ }),

/***/ "./template/components/Navigation/LargeNavigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _LargePrimaryNavigation = __webpack_require__("./template/components/Navigation/LargePrimaryNavigation/index.js");

var _LargePrimaryNavigation2 = _interopRequireDefault(_LargePrimaryNavigation);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LargeNavigation = function LargeNavigation() {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(_LargePrimaryNavigation2.default, { forGender: _layout.FEMALE, viewable: [_layout.LARGE_VIEWPORT] }),
    _react2.default.createElement(_LargePrimaryNavigation2.default, { forGender: _layout.MALE, viewable: [_layout.LARGE_VIEWPORT] })
  );
};

exports.default = LargeNavigation;

/***/ }),

/***/ "./template/components/Navigation/LargePrimaryNavigation/LargePrimaryNavigation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _events = __webpack_require__("./helpers/events.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _globalEventHandler = __webpack_require__("./template/globalEventHandler.js");

var _globalEventHandler2 = _interopRequireDefault(_globalEventHandler);

var _withViewport = __webpack_require__("./template/components/Viewport/withViewport.js");

var _withViewport2 = _interopRequireDefault(_withViewport);

var _LargeSecondaryNavigation = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/index.js");

var _LargeSecondaryNavigation2 = _interopRequireDefault(_LargeSecondaryNavigation);

var _index = __webpack_require__("./template/components/Navigation/LargePrimaryNavigation/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_index2.default);

var DOCUMENT_POSITION_CONTAINS = 8;
var HOVER_DELAY = 250;

var LargePrimaryNavigation = function (_Component) {
  (0, _inherits3.default)(LargePrimaryNavigation, _Component);

  function LargePrimaryNavigation() {
    (0, _classCallCheck3.default)(this, LargePrimaryNavigation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LargePrimaryNavigation.__proto__ || (0, _getPrototypeOf2.default)(LargePrimaryNavigation)).call(this));

    _this.globalTrackingTimer = null;

    _this.handleKeyDown = /* istanbul ignore next - focus is not supported in jsdom */function (event) {
      if (event.key === _globalEventHandler.keys.tab && event.originalEvent.shiftKey) {
        if (document.activeElement.attributes["data-id"] && _this.props.items[0].id === document.activeElement.attributes["data-id"].value) {
          event.originalEvent.preventDefault();
          (0, _globalEventHandler.focusFloorNavigationFor)(_this.props.forGender);
        }
      }
    };

    _this.isHidden = function () {
      return _this.props.forGender !== _this.props.currentGender;
    };

    _this.handleActiveChild = function (id) {
      _this.props.setNavActiveItem(id);
    };

    _this.handleClick = function (event) {
      var current = _this.getCurrentItemFromEvent(event);
      _this.handleActiveChild(current.id);
      _this.track(current.label, _events.ANALYTICS_INTERACTION_CLICK);
    };

    _this.handleMouseEnter = function (event) {
      var current = _this.getCurrentItemFromEvent(event);
      _this.delayedHover = setTimeout(function () {
        _this.handleActiveChild(current.id);
        _this.beginTracking(current.label);
      }, HOVER_DELAY);
    };

    _this.handleMouseLeave = function (event) {
      if (_this.state.isTouch) {
        event.preventDefault();
      } else {
        if (_this.delayedHover) {
          clearTimeout(_this.delayedHover);
          _this.delayedHover = null;
        }
        _this.clearTracking();
      }
    };

    _this.handleTouchStart = function () {
      _this.setState({ isTouch: true });
      setTimeout(function () {
        _this.setState({ isTouch: false });
      }, 600);
    };

    _this.track = function (label, interaction) {
      var context = interaction === "click" ? _events.ANALYTICS_CONTEXT.openNav : _events.ANALYTICS_CONTEXT.navHover;

      (0, _events.trackNavOpen)({
        context: context,
        interaction: interaction,
        elementText: label,
        properties: {
          positionOnPage: _events.ANALYTICS_POSITION_HEADER,
          gender: (0, _events.getGender)(_this.props.forGender)
        }
      });
    };

    _this.beginTracking = function (label) {
      _this.globalTrackingTimer = setTimeout(function () {
        return _this.track(label, _events.ANALYTICS_INTERACTION_HOVER);
      }, 2000);
    };

    _this.clearTracking = function () {
      clearTimeout(_this.globalTrackingTimer);
    };

    _this.hasClickedInside = function (event) {
      return (event.target.compareDocumentPosition(_this.container) & DOCUMENT_POSITION_CONTAINS) !== 0;
    };

    _this.state = {
      isTouch: false
    };
    return _this;
  }

  (0, _createClass3.default)(LargePrimaryNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.keyDownEventListener = _globalEventHandler2.default.addListener(_globalEventHandler.events.keyDown, this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.keyDownEventListener && this.keyDownEventListener.remove();
    }
  }, {
    key: "getCurrentItemFromEvent",
    value: function getCurrentItemFromEvent(event) {
      var currentId = event.currentTarget.attributes["data-id"].value;
      return this.props.items.find(function (item) {
        return item.id === currentId;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          largeNavActiveItemId = _props.largeNavActiveItemId,
          isVisible = _props.isVisible;


      return _react2.default.createElement(
        "nav",
        {
          "aria-hidden": this.isHidden(),
          className: cx([_index2.default.container], (0, _defineProperty3.default)({}, _index2.default.container__hidden, !isVisible || this.isHidden())),
          "data-testid": "primarynav-large",
          ref: function ref(container) {
            return _this2.container = container;
          }
        },
        _react2.default.createElement(
          "div",
          { className: _index2.default.navigation },
          _react2.default.createElement(
            "div",
            { className: _index2.default.navButtons },
            items.map(function (_ref) {
              var _cx3;

              var id = _ref.id,
                  label = _ref.label,
                  largeScreenStyleType = _ref.largeScreenStyleType;
              return _react2.default.createElement(
                "button",
                {
                  key: id,
                  "data-id": id,
                  className: cx(_index2.default.navButton, (0, _defineProperty3.default)({}, _index2.default.navButton__active, id === largeNavActiveItemId)),
                  "data-testid": "primarynav-button",
                  onClick: _this2.handleClick,
                  onMouseEnter: _this2.handleMouseEnter,
                  onMouseLeave: _this2.handleMouseLeave,
                  onTouchStart: _this2.handleTouchStart
                },
                _react2.default.createElement(
                  "span",
                  {
                    className: cx((_cx3 = {}, (0, _defineProperty3.default)(_cx3, _index2.default.slant, largeScreenStyleType === "sale"), (0, _defineProperty3.default)(_cx3, _index2.default.bold, largeScreenStyleType === "premium"), _cx3))
                  },
                  _react2.default.createElement(
                    "span",
                    null,
                    label
                  )
                )
              );
            })
          ),
          items.map(function (item) {
            return _react2.default.createElement(_LargeSecondaryNavigation2.default, {
              item: item,
              key: item.id,
              hasClickedInside: _this2.hasClickedInside
            });
          })
        )
      );
    }
  }]);
  return LargePrimaryNavigation;
}(_react.Component);

exports.default = (0, _withViewport2.default)(LargePrimaryNavigation);

/***/ }),

/***/ "./template/components/Navigation/LargePrimaryNavigation/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3kg3G5e","container__hidden":"_3VhrZsw","navigation":"_25By0Z8","navButtons":"_3r7rW4o","navButton":"_2Ac9WRp","navButton__active":"QlRTIh7","slant":"_2mZjF9Z","bold":"VukdW2l"};

/***/ }),

/***/ "./template/components/Navigation/LargePrimaryNavigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _LargePrimaryNavigation = __webpack_require__("./template/components/Navigation/LargePrimaryNavigation/LargePrimaryNavigation.js");

var _LargePrimaryNavigation2 = _interopRequireDefault(_LargePrimaryNavigation);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemsSelector = function itemsSelector(forGender, state) {
  switch (forGender) {
    case _layout.MALE:
      return (0, _navigation.maleLargePrimaryNavigationItems)(state);
    case _layout.FEMALE:
      return (0, _navigation.femaleLargePrimaryNavigationItems)(state);
    default:
      return [];
  }
};

var mapStateToProps = function mapStateToProps(state, _ref) {
  var forGender = _ref.forGender;
  return {
    currentGender: state.layout.gender,
    items: itemsSelector(forGender, state),
    largeNavActiveItemId: (0, _navigation.getNavActiveItem)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ setNavActiveItem: _navigation.setNavActiveItem }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LargePrimaryNavigation2.default);

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/CircleImageLink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

var _NavAnchor = __webpack_require__("./template/components/Navigation/NavAnchor/index.js");

var _NavAnchor2 = _interopRequireDefault(_NavAnchor);

var _index = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var CircleImageLink = function CircleImageLink(_ref) {
  var _cx;

  var item = _ref.item;
  var label = item.label,
      largeScreenImageUrl = item.largeScreenImageUrl,
      largeScreenStyleType = item.largeScreenStyleType;


  return _react2.default.createElement(
    "div",
    { className: _index2.default.circleImageLink },
    _react2.default.createElement(
      _NavAnchor2.default,
      { item: item },
      _react2.default.createElement(
        "div",
        { className: _index2.default.circleImageBorder },
        _react2.default.createElement("div", {
          "aria-hidden": "true",
          className: _index2.default.circleImage,
          role: "presentation",
          style: {
            backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(largeScreenImageUrl, 240) + ")"
          }
        })
      ),
      _react2.default.createElement(
        "span",
        {
          className: cx(_index2.default.label, (_cx = {}, (0, _defineProperty3.default)(_cx, _index2.default.label__sale, largeScreenStyleType === "sale"), (0, _defineProperty3.default)(_cx, _index2.default.label__bold, largeScreenStyleType === "premium"), _cx))
        },
        label.substring(0, 16)
      )
    )
  );
};

exports.default = CircleImageLink;

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"circleImageList":"_3rpsc2u","circleImageLink":"_3X9INkc","circleImageBorder":"tIg6Zov","circleImage":"CzRt8da","label":"_1dHc1LM","label__sale":"BLIJwya","label__bold":"_3wvpOZT"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _CircleImageLink = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/CircleImageLink.js");

var _CircleImageLink2 = _interopRequireDefault(_CircleImageLink);

var _index = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleImageList = function CircleImageList(_ref) {
  var links = _ref.item.items;

  return _react2.default.createElement(
    "div",
    { className: _index2.default.circleImageList },
    links.map(function (item) {
      return _react2.default.createElement(_CircleImageLink2.default, { item: item, key: item.id });
    })
  );
};

exports.default = CircleImageList;

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3j3wPvK","gridItem":"_3V0KF--","gridItem__sale":"_3fZXQRD","gridItemImageBorder":"_2GC-7QL","gridItemImage":"_38TV2Q5"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _NavAnchor = __webpack_require__("./template/components/Navigation/NavAnchor/index.js");

var _NavAnchor2 = _interopRequireDefault(_NavAnchor);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

var _index = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.css");

var _index2 = _interopRequireDefault(_index);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var MAX_ITEM_COUNT = 4;
var MAX_LETTER_COUNT = 26;

var GridCircleImage = function GridCircleImage(_ref) {
  var item = _ref.item;

  var items = [].concat(item.items);
  return _react2.default.createElement(
    "div",
    { className: _index2.default.container },
    items.splice(0, MAX_ITEM_COUNT).map(gridItem)
  );
};

var gridItem = function gridItem(item) {
  return _react2.default.createElement(
    _NavAnchor2.default,
    {
      key: item.id,
      item: item,
      className: cx(_index2.default.gridItem, (0, _defineProperty3.default)({}, _index2.default.gridItem__sale, item.largeScreenStyleType === "sale"))
    },
    _react2.default.createElement(
      "div",
      { className: _index2.default.gridItemImageBorder },
      _react2.default.createElement("div", {
        "aria-hidden": "true",
        className: _index2.default.gridItemImage,
        role: "presentation",
        style: {
          backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(item.largeScreenImageUrl, 240) + ")"
        },
        title: item.label
      })
    ),
    _react2.default.createElement(
      "span",
      null,
      item.label.substr(0, MAX_LETTER_COUNT)
    )
  );
};

exports.default = GridCircleImage;

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/ImageCardWithDescription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

var _NavAnchor = __webpack_require__("./template/components/Navigation/NavAnchor/index.js");

var _NavAnchor2 = _interopRequireDefault(_NavAnchor);

var _index = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var ImageCardWithDescription = function ImageCardWithDescription(_ref) {
  var item = _ref.item;
  var label = item.label,
      subtitle = item.subtitle,
      largeScreenImageUrl = item.largeScreenImageUrl,
      _item$largeScreenStyl = item.largeScreenStyleType,
      largeScreenStyleType = _item$largeScreenStyl === undefined ? "light" : _item$largeScreenStyl;


  return _react2.default.createElement(
    _NavAnchor2.default,
    { item: item, className: _index2.default.card },
    _react2.default.createElement(
      "div",
      { className: _index2.default.thumbnailWrapper },
      _react2.default.createElement("div", {
        "aria-hidden": "true",
        className: _index2.default.image,
        role: "presentation",
        style: largeScreenImageUrl && {
          backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(largeScreenImageUrl, 320) + ")"
        }
      }),
      _react2.default.createElement("div", {
        className: cx(_index2.default.thumbnailCover, _index2.default[largeScreenStyleType])
      }),
      item.largeScreenStyleType !== "noTitle" && _react2.default.createElement(
        "span",
        { className: cx(_index2.default.cardTitle, _index2.default[largeScreenStyleType]) },
        label.substring(0, 24)
      )
    ),
    _react2.default.createElement(
      "span",
      { className: _index2.default.cardDescription },
      subtitle && subtitle.substring(0, 45)
    )
  );
};

exports.default = ImageCardWithDescription;

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cardList":"lxl1m4p","card":"cEafYrU","thumbnailWrapper":"Es0d-oL","thumbnailCover":"_9q4POoy","light":"_3QYsQtS","dark":"_1VbtZ8X","image":"_3ARlt8n","cardTitle":"_3skrDb5","cardDescription":"_2DUsWiv"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _ImageCardWithDescription = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/ImageCardWithDescription.js");

var _ImageCardWithDescription2 = _interopRequireDefault(_ImageCardWithDescription);

var _index = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCardsWithDescription = function ImageCardsWithDescription(_ref) {
  var items = _ref.item.items;

  return _react2.default.createElement(
    "div",
    { className: _index2.default.cardList },
    items.slice(0, 8).map(function (item) {
      return _react2.default.createElement(_ImageCardWithDescription2.default, { item: item, key: item.id });
    })
  );
};

exports.default = ImageCardsWithDescription;

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/LargeSecondaryNavigation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _index = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/index.css");

var _index2 = _interopRequireDefault(_index);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _globalEventHandler = __webpack_require__("./template/globalEventHandler.js");

var _globalEventHandler2 = _interopRequireDefault(_globalEventHandler);

var _navigationTemplatesResolver = __webpack_require__("./template/helpers/navigationTemplatesResolver.js");

var _Spinner = __webpack_require__("./template/components/Spinner/index.js");

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_index2.default);

var inferTemplateComponent = function inferTemplateComponent(item) {
  var id = item.largeScreenTemplateId;

  var TemplateComponent = (0, _navigationTemplatesResolver.getDesktopTemplate)(id);

  return _react2.default.createElement(TemplateComponent, { item: item });
};

var LargeSecondaryNavigation = function (_Component) {
  (0, _inherits3.default)(LargeSecondaryNavigation, _Component);

  function LargeSecondaryNavigation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LargeSecondaryNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LargeSecondaryNavigation.__proto__ || (0, _getPrototypeOf2.default)(LargeSecondaryNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.isVisible = function () {
      return _this.props.item.id === _this.props.largeNavActiveItemId && _this.props.viewport === _layout.LARGE_VIEWPORT;
    }, _this.globalTrackingTimer = null, _this.renderHeading = function (label) {
      if (!label) return null;
      return _react2.default.createElement(
        "div",
        { className: _index2.default.columnHeaderContainer },
        _react2.default.createElement(
          "span",
          { className: _index2.default.columnHeader },
          label
        )
      );
    }, _this.renderContainer = function (item) {
      var largeScreenStyleType = item.largeScreenStyleType,
          largeScreenColumnSpan = item.largeScreenColumnSpan;

      var showHeading = largeScreenStyleType !== "noTitle";

      return _react2.default.createElement(
        "section",
        {
          key: item.id,
          className: cx(_index2.default.column, _index2.default["colspan-" + (largeScreenColumnSpan || 1)])
        },
        showHeading && _this.renderHeading(item.label),
        inferTemplateComponent(item)
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LargeSecondaryNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          hasClickedInside = _props.hasClickedInside,
          clearNavActiveItem = _props.clearNavActiveItem;


      this.globalClickListener = _globalEventHandler2.default.addListener(_globalEventHandler.events.click, function (event) {
        if (_this2.isVisible() && !hasClickedInside(event)) {
          clearNavActiveItem();
        }
      });
      this.globalKeyDownListener = _globalEventHandler2.default.addListener(_globalEventHandler.events.keyDown, function (event) {
        if (event.key === _globalEventHandler.keys.escape) {
          clearNavActiveItem();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.globalClickListener && this.globalClickListener.remove();
      this.globalKeyDownListener && this.globalKeyDownListener.remove();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          item = _props2.item,
          clearNavActiveItem = _props2.clearNavActiveItem;

      var classes = cx(_index2.default.container, (0, _defineProperty3.default)({}, _index2.default.visible, this.isVisible()));

      var hasNoItems = !item.items.length;

      //The window type checking is a work around to
      //make the classes match server and client side
      var flyoutClasses = cx(_index2.default.flyout, (0, _defineProperty3.default)({}, _index2.default.isLoading, hasNoItems || typeof window === "undefined"));

      return _react2.default.createElement(
        "div",
        {
          className: classes,
          "data-testid": "secondarynav-container",
          ref: function ref(c) {
            return _this3.container = c;
          }
        },
        _react2.default.createElement("div", {
          className: _index2.default.backdrop,
          onClick: clearNavActiveItem,
          onMouseEnter: clearNavActiveItem,
          "aria-hidden": "true",
          "data-testid": "backdrop"
        }),
        _react2.default.createElement(
          "div",
          { className: _index2.default.flyoutContainer },
          _react2.default.createElement(
            "div",
            {
              className: flyoutClasses,
              "data-id": item.id,
              "data-testid": "secondarynav-flyout"
            },
            hasNoItems ? _react2.default.createElement(_Spinner2.default, { size: "x-large" }) : item.items.map(this.renderContainer)
          )
        )
      );
    }
  }]);
  return LargeSecondaryNavigation;
}(_react.Component);

exports.default = LargeSecondaryNavigation;

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1NtxSD3","container__column":"_26_yujQ","item":"_2uD85Ca","label":"_3ORur7s","label__dark":"_30YKIbT","label__light":"_16EFHZ4","image":"_2PBH9Tw","thumbnail":"zgb64R9","vertical":"_2_fWyUH","light":"_3RbcbtV","dark":"_2Qt4a5S","horizontal":"_3t_t-Xe"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

var _NavAnchor = __webpack_require__("./template/components/Navigation/NavAnchor/index.js");

var _NavAnchor2 = _interopRequireDefault(_NavAnchor);

var _index = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var MarketingImage = function MarketingImage(_ref) {
  var item = _ref.item;
  return _react2.default.createElement(
    "div",
    {
      className: cx(_index2.default.container, (0, _defineProperty3.default)({}, _index2.default.container__column, item.largeScreenColumnSpan === 1))
    },
    itemList(item)
  );
};

var truncatedLabel = function truncatedLabel(item, largeScreenColumnSpan) {
  return largeScreenColumnSpan === 3 ? item.label.substring(0, 26) : item.label.substring(0, 36);
};

var itemList = function itemList(_ref2) {
  var items = _ref2.items,
      largeScreenColumnSpan = _ref2.largeScreenColumnSpan;
  return items.map(function (item) {
    var labelClasses = (0, _defineProperty3.default)({}, _index2.default["label__" + item.largeScreenStyleType], true);

    var thumbnailGradientType = function thumbnailGradientType(numberOfItems, numberOfCols) {
      var type = numberOfItems / numberOfCols;
      return type > 2 ? "horizontal" : "vertical";
    };

    return _react2.default.createElement(
      _NavAnchor2.default,
      {
        key: item.id,
        item: item,
        className: _index2.default.item,
        "data-testid": "marketing-image"
      },
      _react2.default.createElement("img", {
        alt: "",
        src: (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(item.largeScreenImageUrl, 320),
        className: _index2.default.image
      }),
      _react2.default.createElement("div", {
        className: cx(_index2.default.thumbnail, _index2.default[thumbnailGradientType(items.length, largeScreenColumnSpan)], _index2.default[item.largeScreenStyleType])
      }),
      item.largeScreenStyleType !== "noTitle" ? _react2.default.createElement(
        "span",
        { className: cx(_index2.default.label, labelClasses) },
        truncatedLabel(item, largeScreenColumnSpan)
      ) : null
    );
  });
};

exports.default = MarketingImage;

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/TextList/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _NavAnchor = __webpack_require__("./template/components/Navigation/NavAnchor/index.js");

var _NavAnchor2 = _interopRequireDefault(_NavAnchor);

var _index = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var makeUl = function makeUl(items, i) {
  return _react2.default.createElement(
    "ul",
    { key: i, className: _index2.default.textList },
    items.map(function (item) {
      var _cx;

      return _react2.default.createElement(
        "li",
        { key: item.id },
        _react2.default.createElement(
          _NavAnchor2.default,
          {
            className: cx(_index2.default.textLink, (_cx = {}, (0, _defineProperty3.default)(_cx, _index2.default.textLink__sale, item.largeScreenStyleType === "sale"), (0, _defineProperty3.default)(_cx, _index2.default.textLink__bold, item.largeScreenStyleType === "premium"), _cx)),
            item: item,
            "data-testid": "text-link"
          },
          item.label.substring(0, 32)
        )
      );
    })
  );
};

var TextList = function TextList(_ref) {
  var item = _ref.item;

  // split items array into a set of arrays
  // with max size of 9 (max text list length)
  var lists = [];
  var items = [].concat(item.items);
  var maxUlLength = items.length / 2 > _navigation.UL_ITEM_COUNT ? Math.ceil(items.length / 2) : _navigation.UL_ITEM_COUNT;
  while (items.length) {
    lists.push(items.splice(0, maxUlLength));
  }return _react2.default.createElement(
    "div",
    null,
    lists.map(makeUl)
  );
};

exports.default = TextList;

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1c4zf5o","backdrop":"rbfmVpk","flyoutContainer":"_1Exx-PU","flyout":"_1dZZci7","isLoading":"_20X3gNb","visible":"_2Fshgzz","column":"_1QmxDO_","colspan-1":"nEoIIe5","textList":"z36sLT1","colspan-2":"YlqXo8e","colspan-3":"_1D_SQB6","colspan-4":"_3iT6Z7q","columnHeaderContain":"qHb8CDW","columnHeader":"_2HjZSOc","textLink":"_2Aejr0d","textLink__sale":"_2rDFtsg","textLink__bold":"_1iUbby0"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _LargeSecondaryNavigation = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/LargeSecondaryNavigation.js");

var _LargeSecondaryNavigation2 = _interopRequireDefault(_LargeSecondaryNavigation);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ setNavActiveItem: _navigation.setNavActiveItem, clearNavActiveItem: _navigation.clearNavActiveItem }, dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    largeNavActiveItemId: (0, _navigation.getNavActiveItem)(state),
    viewport: (0, _layout.getViewport)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LargeSecondaryNavigation2.default);

/***/ }),

/***/ "./template/components/Navigation/NavAnchor/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _events = __webpack_require__("./helpers/events.js");

var _addAnalyticsDataToLink = __webpack_require__("./template/helpers/addAnalyticsDataToLink.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavAnchor = function NavAnchor(props) {
  var item = props.item,
      children = props.children,
      restOfProps = (0, _objectWithoutProperties3.default)(props, ["item", "children"]);
  var gender = item.gender,
      label = item.label;


  var handleClick = function handleClick() {
    (0, _events.trackNavOpen)({
      context: _events.ANALYTICS_CONTEXT.openNav,
      interaction: _events.ANALYTICS_INTERACTION_CLICK,
      elementText: label,
      properties: {
        positionOnPage: _events.ANALYTICS_POSITION_HEADER,
        gender: (0, _events.getGender)(gender)
      }
    });
  };

  var isExternal = item.linkType === "external";

  return _react2.default.createElement(
    "a",
    (0, _extends3.default)({}, restOfProps, {
      onClick: handleClick,
      href: (0, _addAnalyticsDataToLink.addAnalyticsDataToLink)(item),
      target: isExternal ? "_blank" : "_self"
    }),
    children
  );
};

exports.default = NavAnchor;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1UgySfN","carouselLink":"_3H8AuY1","label":"lFlpBn6","label__light":"_1ivrAR2","label__sale":"J4dMEZd","subtitle":"_1-ghia1"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _CarouselLink = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.css");

var _CarouselLink2 = _interopRequireDefault(_CarouselLink);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _formatting = __webpack_require__("./helpers/formatting.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

var _addAnalyticsDataToLink = __webpack_require__("./template/helpers/addAnalyticsDataToLink.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(undefined);

var CarouselLink = function CarouselLink(_ref) {
  var _cx;

  var item = _ref.item,
      className = _ref.className,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === undefined ? 0 : _ref$tabIndex;

  return _react2.default.createElement(
    "li",
    { className: cx(_CarouselLink2.default.container, className) },
    _react2.default.createElement(
      "a",
      {
        href: (0, _addAnalyticsDataToLink.addAnalyticsDataToLink)(item),
        className: _CarouselLink2.default.carouselLink,
        tabIndex: tabIndex,
        style: {
          backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(item.smallAndMediumImageUrl, 320) + ")"
        }
      },
      _react2.default.createElement(
        "p",
        {
          className: cx(_CarouselLink2.default.label, (_cx = {}, (0, _defineProperty3.default)(_cx, _CarouselLink2.default.label__sale, item.smallAndMediumStyleType === "sale"), (0, _defineProperty3.default)(_cx, _CarouselLink2.default.label__light, item.smallAndMediumStyleType === "light"), _cx))
        },
        item.smallAndMediumStyleType !== "noTitle" && _react2.default.createElement(
          "span",
          null,
          (0, _formatting.truncateTitle)(item)
        ),
        item.subtitle && _react2.default.createElement(
          "span",
          { className: _CarouselLink2.default.subtitle },
          item.subtitle.substring(0, 24)
        )
      )
    )
  );
};

exports.default = CarouselLink;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list":"_2JwYR9n","list__animate":"DfrfywO","carouselLink":"_1Fg6Mkn"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _CarouselLink = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.js");

var _CarouselLink2 = _interopRequireDefault(_CarouselLink);

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.css");

var _index2 = _interopRequireDefault(_index);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var Carousel = function Carousel(_ref) {
  var items = _ref.items,
      currentIndex = _ref.currentIndex,
      swipeOffset = _ref.swipeOffset;

  var activeItemPosition = -100 * currentIndex + "%";

  return _react2.default.createElement(
    "ul",
    {
      className: cx(_index2.default.list, (0, _defineProperty3.default)({}, _index2.default.list__animate, swipeOffset === 0)),
      style: {
        transform: "translateX(" + activeItemPosition + ") translateX(" + swipeOffset + "px)"
      },
      "data-testid": "carousel"
    },
    items.map(function (item) {
      return _react2.default.createElement(_CarouselLink2.default, {
        key: item.id,
        className: _index2.default.carouselLink,
        item: item,
        tabIndex: items.length > 1 ? -1 : null
      });
    })
  );
};

exports.default = Carousel;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/CarouselContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.css");

var _index2 = _interopRequireDefault(_index);

var _Carousel = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.js");

var _Carousel2 = _interopRequireDefault(_Carousel);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _NavigationDots = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.js");

var _NavigationDots2 = _interopRequireDefault(_NavigationDots);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselContainer = function (_PureComponent) {
  (0, _inherits3.default)(CarouselContainer, _PureComponent);

  function CarouselContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CarouselContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CarouselContainer.__proto__ || (0, _getPrototypeOf2.default)(CarouselContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentIndex: 0,
      swipeOffset: 0
    }, _this.setCurrentItem = function (currentIndex) {
      return function () {
        return _this.setState({ currentIndex: currentIndex });
      };
    }, _this.isNextChevronVisible = function () {
      return _this.state.currentIndex < _this.props.item.items.length - 1;
    }, _this.isPreviousChevronVisible = function () {
      return _this.state.currentIndex > 0;
    }, _this.isSingleItem = function () {
      return _this.props.item.items.length === 1;
    }, _this.startingTouchX = null, _this.touchMoveFrameRequest = null, _this.touchEndFrameRequest = null, _this.touchStart = function (_ref2) {
      var touches = _ref2.touches;

      if (!_this.isSingleItem()) {
        _this.startingTouchX = _this.startingTouchX || touches[0].clientX;
      }
    }, _this.touchMove = function (_ref3) {
      var touches = _ref3.touches;

      cancelAnimationFrame(_this.touchMoveFrameRequest);
      _this.touchMoveFrameRequest = requestAnimationFrame(function () {
        _this.requested = false;
        if (_this.startingTouchX) {
          _this.setState({
            swipeOffset: _this.adjustSwipeOffset(touches[0].clientX - _this.startingTouchX)
          });
        }
      });
    }, _this.touchEnd = function (event) {
      var _this$state = _this.state,
          currentIndex = _this$state.currentIndex,
          swipeOffset = _this$state.swipeOffset;


      if (swipeOffset !== 0) {
        var swipeDirection = swipeOffset > 0 ? -1 : 1;
        cancelAnimationFrame(_this.touchEndFrameRequest);
        _this.touchEndFrameRequest = requestAnimationFrame(function () {
          _this.requested = false;
          _this.setState({
            swipeOffset: 0,
            currentIndex: _this.adjustSuggestedIndex(currentIndex + swipeDirection)
          });
        });
        event.preventDefault();
      }

      _this.startingTouchX = null;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CarouselContainer, [{
    key: "adjustSwipeOffset",
    value: function adjustSwipeOffset(suggestedOffset) {
      var currentIndex = this.state.currentIndex;
      var item = this.props.item;

      if (currentIndex === 0) {
        return Math.min(suggestedOffset, 40);
      } else if (currentIndex === item.items.length - 1) {
        return Math.max(suggestedOffset, -40);
      }
      return suggestedOffset;
    }
  }, {
    key: "adjustSuggestedIndex",
    value: function adjustSuggestedIndex(suggestedIndex) {
      var item = this.props.item;

      if (suggestedIndex < 0) {
        return 0;
      }
      if (suggestedIndex > item.items.length - 1) {
        return item.items.length - 1;
      }
      return suggestedIndex;
    }
  }, {
    key: "renderChevrons",
    value: function renderChevrons() {
      var currentIndex = this.state.currentIndex;


      if (this.isSingleItem()) {
        return null;
      }

      return [this.isPreviousChevronVisible() && _react2.default.createElement("button", {
        type: "button",
        className: _index2.default.chevronLeft,
        tabIndex: -1,
        onClick: this.setCurrentItem(currentIndex - 1),
        key: "1",
        "aria-hidden": "true",
        "data-testid": "left-chevron"
      }), this.isNextChevronVisible() && _react2.default.createElement("button", {
        type: "button",
        className: _index2.default.chevronRight,
        tabIndex: -1,
        onClick: this.setCurrentItem(currentIndex + 1),
        key: "2",
        "aria-hidden": "true",
        "data-testid": "right-chevron"
      })];
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          currentIndex = _state.currentIndex,
          swipeOffset = _state.swipeOffset;
      var _props = this.props,
          item = _props.item,
          setNavActiveItem = _props.setNavActiveItem,
          saveNavigationItem = _props.saveNavigationItem,
          viewportCategory = _props.viewportCategory;


      return _react2.default.createElement(
        "div",
        { className: _index2.default.container },
        _react2.default.createElement(
          "div",
          {
            className: _index2.default.hitArea,
            onTouchStart: this.touchStart,
            onTouchMove: this.touchMove,
            onTouchEnd: this.touchEnd,
            onTouchCancel: this.touchEnd,
            "data-testid": "carousel-area"
          },
          _react2.default.createElement(_Carousel2.default, {
            items: item.items,
            setNavActiveItem: setNavActiveItem,
            saveNavigationItem: saveNavigationItem,
            currentIndex: currentIndex,
            viewportCategory: viewportCategory,
            swipeOffset: swipeOffset
          }),
          _react2.default.createElement(_NavigationDots2.default, {
            items: item.items,
            currentIndex: currentIndex,
            setCurrentItem: this.setCurrentItem
          }),
          this.renderChevrons()
        )
      );
    }
  }]);
  return CarouselContainer;
}(_react.PureComponent);

exports.default = CarouselContainer;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dotContainer":"IxXpg-P","dotItem":"_2dX_dN9","dot":"_1ooe7Gy","dot__selected":"_1rTNrrq"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var renderOnlyIf = function renderOnlyIf(predicate, component) {
  return function (props) {
    return predicate(props) ? component(props) : null;
  };
};

var hasMultipleItems = function hasMultipleItems(_ref) {
  var items = _ref.items;
  return items.length > 1;
};

var NavigationDots = renderOnlyIf(hasMultipleItems, function (_ref2) {
  var items = _ref2.items,
      currentIndex = _ref2.currentIndex,
      setCurrentItem = _ref2.setCurrentItem;
  return _react2.default.createElement(
    "ul",
    { className: _index2.default.dotContainer, "data-testid": "navigation-dots" },
    items.map(function (item, index) {
      return _react2.default.createElement(
        "li",
        { key: item.id, className: _index2.default.dotItem },
        _react2.default.createElement("button", {
          type: "button",
          className: cx(_index2.default.dot, (0, _defineProperty3.default)({}, _index2.default.dot__selected, index === currentIndex)),
          onClick: setCurrentItem(index),
          onFocus: setCurrentItem(index),
          "aria-label": item.label
        })
      );
    })
  );
});

NavigationDots.propTypes = {
  items: _propTypes2.default.arrayOf(_navigation.navigationPropType).isRequired,
  currentIndex: _propTypes2.default.number.isRequired,
  setCurrentItem: _propTypes2.default.func.isRequired
};

exports.default = NavigationDots;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"UEG5lkc","hitArea":"_3l4GUXL","chevronRight":"_2aCAEI1","chevronLeft":"_22cDiP5"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _CarouselContainer = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/CarouselContainer.js");

var _CarouselContainer2 = _interopRequireDefault(_CarouselContainer);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    viewportCategory: (0, _layout.getViewport)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_CarouselContainer2.default);

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menuItem":"_2qt4H8Z","button":"_1xJ3tLR","circleImage":"_2e3YCj1","label":"_39II9oU","label__sale":"_1sIwZh0","label__bold":"_3G7NJJ1"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _NavAnchor = __webpack_require__("./template/components/Navigation/NavAnchor/index.js");

var _NavAnchor2 = _interopRequireDefault(_NavAnchor);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var CircleImageLeftItem = function CircleImageLeftItem(_ref) {
  var _cx;

  var item = _ref.item;
  var label = item.label,
      smallAndMediumImageUrl = item.smallAndMediumImageUrl,
      smallAndMediumStyleType = item.smallAndMediumStyleType;


  return _react2.default.createElement(
    "li",
    { className: _index2.default.menuItem },
    _react2.default.createElement(
      _NavAnchor2.default,
      { className: _index2.default.button, item: item },
      _react2.default.createElement("div", {
        "aria-hidden": "true",
        className: _index2.default.circleImage,
        role: "presentation",
        style: {
          backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(smallAndMediumImageUrl, 240) + ")"
        },
        title: label
      }),
      _react2.default.createElement(
        "span",
        {
          className: cx(_index2.default.label, (_cx = {}, (0, _defineProperty3.default)(_cx, _index2.default.label__sale, smallAndMediumStyleType === "sale"), (0, _defineProperty3.default)(_cx, _index2.default.label__bold, smallAndMediumStyleType === "premium"), _cx))
        },
        label.substring(0, 40)
      )
    )
  );
};

exports.default = CircleImageLeftItem;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3uiF0ti","menuItem":"_3-GouR_","label":"_2KVLkPB","label__sale":"_1mGvVLn","image":"_2ipto0o"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

var _NavAnchor = __webpack_require__("./template/components/Navigation/NavAnchor/index.js");

var _NavAnchor2 = _interopRequireDefault(_NavAnchor);

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var CircleImageRightItem = function CircleImageRightItem(_ref) {
  var item = _ref.item;
  return _react2.default.createElement(
    "li",
    { className: _index2.default.container },
    _react2.default.createElement(
      _NavAnchor2.default,
      { "data-navid": item.id, className: _index2.default.menuItem, item: item },
      _react2.default.createElement(
        "span",
        {
          className: cx(_index2.default.label, (0, _defineProperty3.default)({}, _index2.default.label__sale, item.smallAndMediumStyleType === "sale"))
        },
        item.label.substring(0, 36)
      ),
      _react2.default.createElement("div", {
        "aria-hidden": "true",
        className: _index2.default.image,
        role: "presentation",
        style: {
          backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(item.smallAndMediumImageUrl, 240) + ")"
        }
      })
    )
  );
};

exports.default = CircleImageRightItem;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/FlatItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2CKCa0c","menuItem":"_2ZrmXYA","label":"jsC7K1m","label__light":"_3uQ41qA","label__sale":"_1dvZaW2","subtitle":"_3XTwJYe","flatMenuItem":"_2rvxCv1"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/FlatItem/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/FlatItem/index.css");

var _index2 = _interopRequireDefault(_index);

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var FlatItem = function FlatItem(_ref) {
  var className = _ref.className,
      item = _ref.item,
      saveNavigationItem = _ref.saveNavigationItem,
      tabIndex = _ref.tabIndex;
  return _react2.default.createElement(
    "li",
    { className: cx(_index2.default.container, className) },
    _react2.default.createElement(
      "a",
      {
        href: item.link,
        "data-navid": item.id,
        className: cx(_index2.default.menuItem, _index2.default.flatMenuItem),
        ref: saveNavigationItem,
        tabIndex: tabIndex,
        "data-testid": "menu-item",
        style: item.smallAndMediumImageUrl && {
          backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(item.smallAndMediumImageUrl, 320) + ")"
        }
      },
      _react2.default.createElement(
        "p",
        {
          className: cx(_index2.default.label, (0, _defineProperty3.default)({}, _index2.default.label__light, item.smallAndMediumStyleType === "light"))
        },
        item.label.substring(0, 24)
      )
    )
  );
};

FlatItem.defaultProps = {
  tabIndex: 0
};

exports.default = FlatItem;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/InspirationItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card":"tw0FNVJ","wrapper":"_33t9V20","image":"id8ZbV1","title":"_1bdcYOM","description":"_2ZyLvxL","dark":"RSfOR1U","light":"_14_kzQ5"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/InspirationItem/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

var _NavAnchor = __webpack_require__("./template/components/Navigation/NavAnchor/index.js");

var _NavAnchor2 = _interopRequireDefault(_NavAnchor);

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/InspirationItem/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var InspirationItem = function InspirationItem(_ref) {
  var item = _ref.item;
  return _react2.default.createElement(
    _NavAnchor2.default,
    { className: _index2.default.card, item: item },
    _react2.default.createElement(
      "div",
      { className: _index2.default.wrapper },
      _react2.default.createElement("div", {
        "aria-hidden": "true",
        className: _index2.default.image,
        role: "presentation",
        style: item.smallAndMediumImageUrl && {
          backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(item.smallAndMediumImageUrl, 320) + ")"
        }
      }),
      item.smallAndMediumStyleType !== "noTitle" && _react2.default.createElement(
        "span",
        {
          className: cx(_index2.default.title, _index2.default[item.smallAndMediumStyleType])
        },
        item.label.substring(0, 24)
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _index2.default.description },
      item.subtitle && item.subtitle.substring(0, 45)
    )
  );
};

exports.default = InspirationItem;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/ListContainer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3sonpri","container__noBackground":"_2uQ-C2e"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/ListContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _ViewAllBlock = __webpack_require__("./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.js");

var _ViewAllBlock2 = _interopRequireDefault(_ViewAllBlock);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/ListContainer/index.css");

var _index2 = _interopRequireDefault(_index);

var _navigationTemplatesResolver = __webpack_require__("./template/helpers/navigationTemplatesResolver.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// At the moment only templateId 4 (Inspiration Item) needs transparent background
var COMPONENT_WITH_NO_BACKGROUND = [4];

var hasNoBackground = function hasNoBackground(_ref) {
  var smallAndMediumTemplateId = _ref.smallAndMediumTemplateId;
  return COMPONENT_WITH_NO_BACKGROUND.indexOf(smallAndMediumTemplateId) !== -1;
};

var cx = _classnames2.default.bind(_index2.default);

var ListContainer = function ListContainer(_ref2) {
  var item = _ref2.item,
      setNavActiveItem = _ref2.setNavActiveItem,
      saveNavigationItem = _ref2.saveNavigationItem;

  var Component = (0, _navigationTemplatesResolver.getMobileTemplate)(item.smallAndMediumTemplateId);

  return _react2.default.createElement(
    "ul",
    {
      className: cx(_index2.default.container, (0, _defineProperty3.default)({}, _index2.default.container__noBackground, hasNoBackground(item))),
      "data-testid": "list-container"
    },
    item.items.map(function (item) {
      if (item.type === "aToZBrands") {
        return _react2.default.createElement(_ViewAllBlock2.default, { key: item.id, item: item });
      }

      return _react2.default.createElement(Component, {
        key: item.id,
        item: item,
        setNavActiveItem: setNavActiveItem,
        saveNavigationItem: saveNavigationItem
      });
    })
  );
};

exports.default = ListContainer;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/MenuItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_287Xr1i","menuItem":"_1Lr9s52","label":"_2UoQGIz","label__light":"_9unZirh","label__sale":"_3xmb2OY","subtitle":"_1cky1mG"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/MenuItem/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _events = __webpack_require__("./helpers/events.js");

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/MenuItem/index.css");

var _index2 = _interopRequireDefault(_index);

var _formatting = __webpack_require__("./helpers/formatting.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var MenuItem = function MenuItem(_ref) {
  var _cx;

  var className = _ref.className,
      item = _ref.item,
      setNavActiveItem = _ref.setNavActiveItem,
      saveNavigationItem = _ref.saveNavigationItem,
      tabIndex = _ref.tabIndex;

  var clickItem = function clickItem() {
    setNavActiveItem(item.id);
    (0, _events.trackNavOpen)({
      context: _events.ANALYTICS_CONTEXT.openNav,
      interaction: _events.ANALYTICS_INTERACTION_CLICK,
      elementText: item.label,
      properties: {
        positionOnPage: _events.ANALYTICS_POSITION_HEADER,
        gender: (0, _events.getGender)(item.gender)
      }
    });
  };

  return _react2.default.createElement(
    "li",
    { className: cx(_index2.default.container, className) },
    _react2.default.createElement(
      "button",
      {
        key: item.id,
        "data-navid": item.id,
        className: _index2.default.menuItem,
        type: "button",
        onClick: clickItem,
        ref: saveNavigationItem,
        tabIndex: tabIndex,
        "data-testid": "menu-item",
        style: item.smallAndMediumImageUrl && {
          backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(item.smallAndMediumImageUrl, 320) + ")"
        }
      },
      _react2.default.createElement(
        "p",
        {
          className: cx(_index2.default.label, (_cx = {}, (0, _defineProperty3.default)(_cx, _index2.default.label__sale, item.smallAndMediumStyleType === "sale"), (0, _defineProperty3.default)(_cx, _index2.default.label__light, item.smallAndMediumStyleType === "light"), _cx))
        },
        item.smallAndMediumStyleType !== "noTitle" && _react2.default.createElement(
          "span",
          null,
          (0, _formatting.truncateTitle)(item)
        ),
        item.subtitle && _react2.default.createElement(
          "span",
          { className: _index2.default.subtitle },
          item.subtitle.substring(0, 24)
        )
      )
    )
  );
};

MenuItem.defaultProps = {
  tabIndex: 0
};

exports.default = MenuItem;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/SideNavigationContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _ListContainer = __webpack_require__("./template/components/Navigation/SideNavigationContainer/ListContainer/index.js");

var _ListContainer2 = _interopRequireDefault(_ListContainer);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _CarouselContainer = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.js");

var _CarouselContainer2 = _interopRequireDefault(_CarouselContainer);

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sideNavigationContainers = {
  list: _ListContainer2.default,
  carousel: _CarouselContainer2.default
};

var renderTitle = function renderTitle(label, styleType) {
  return label && styleType !== "noTitle" ? _react2.default.createElement(
    "h3",
    { className: _index2.default.title },
    label
  ) : null;
};

var SideNavigationContainer = function SideNavigationContainer(_ref) {
  var setNavActiveItem = _ref.setNavActiveItem,
      saveNavigationItem = _ref.saveNavigationItem,
      item = _ref.item;

  var isValidLayout = sideNavigationContainers.hasOwnProperty(item.smallAndMediumLayout);

  var Container = isValidLayout ? sideNavigationContainers[item.smallAndMediumLayout] : _ListContainer2.default;

  if (!item.items || !item.items.length) {
    return null;
  }

  return _react2.default.createElement(
    "div",
    { className: _index2.default.listContainer },
    renderTitle(item.label, item.smallAndMediumStyleType),
    _react2.default.createElement(Container, {
      setNavActiveItem: setNavActiveItem,
      saveNavigationItem: saveNavigationItem,
      item: item
    })
  );
};

SideNavigationContainer.defaultProps = {
  saveNavigationItem: /* istanbul ignore next */function saveNavigationItem() {}
};

exports.default = SideNavigationContainer;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/SquareItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1yTTgtG","link":"_1z75khH","image":"_30Ntdiu","label":"RYZoujz","label__sale":"_1EDIGUs"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/SquareItem/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _navigationLinkResolver = __webpack_require__("./template/helpers/navigationLinkResolver.js");

var _navigationBackgroundImageResolver = __webpack_require__("./template/helpers/navigationBackgroundImageResolver.js");

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/SquareItem/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var SquareItem = function (_Component) {
  (0, _inherits3.default)(SquareItem, _Component);

  function SquareItem(props) {
    (0, _classCallCheck3.default)(this, SquareItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SquareItem.__proto__ || (0, _getPrototypeOf2.default)(SquareItem)).call(this, props));

    _this.state = { link: props && props.item && props.item.link };
    return _this;
  }

  (0, _createClass3.default)(SquareItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props$item = this.props.item,
          link = _props$item.link,
          alias = _props$item.alias;


      if (alias === "app_download") {
        this.setState({
          link: (0, _navigationLinkResolver.resolveLink)(link, alias)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          item = _props.item,
          saveNavigationItem = _props.saveNavigationItem,
          tabIndex = _props.tabIndex;


      var isExternal = item.linkType === "external";

      return _react2.default.createElement(
        "li",
        { className: cx(_index2.default.container, className), "data-testid": "square-item" },
        _react2.default.createElement(
          "a",
          {
            "data-navid": item.id,
            className: _index2.default.link,
            href: this.state.link,
            ref: saveNavigationItem,
            tabIndex: tabIndex,
            target: isExternal ? "_blank" : "_self"
          },
          item.smallAndMediumImageUrl && _react2.default.createElement("div", {
            "aria-hidden": "true",
            className: _index2.default.image,
            role: "presentation",
            style: {
              backgroundImage: "url(" + (0, _navigationBackgroundImageResolver.getBackgroundImageUrl)(item.smallAndMediumImageUrl, 320) + ")"
            }
          }),
          _react2.default.createElement(
            "p",
            {
              className: cx(_index2.default.label, (0, _defineProperty3.default)({}, _index2.default.label__sale, item.smallAndMediumStyleType === "sale"))
            },
            item.label
          )
        )
      );
    }
  }]);
  return SquareItem;
}(_react.Component);

exports.default = SquareItem;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"block":"_2tsa3Tm","fakeOutsideBlock":"xGHs8oT"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _NavAnchor = __webpack_require__("./template/components/Navigation/NavAnchor/index.js");

var _NavAnchor2 = _interopRequireDefault(_NavAnchor);

var _index = __webpack_require__("./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewAllBlock = function ViewAllBlock(_ref) {
  var item = _ref.item;
  return _react2.default.createElement(
    "li",
    { className: _index2.default.block },
    _react2.default.createElement(
      "div",
      { className: _index2.default.fakeOutsideBlock },
      _react2.default.createElement(
        _NavAnchor2.default,
        { item: item },
        item.label
      )
    )
  );
};

exports.default = ViewAllBlock;

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"pQxhHu0","listContainer":"_2vx2JAg"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _SideNavigationContainer = __webpack_require__("./template/components/Navigation/SideNavigationContainer/SideNavigationContainer.js");

var _SideNavigationContainer2 = _interopRequireDefault(_SideNavigationContainer);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ setNavActiveItem: _navigation.setNavActiveItem }, dispatch);
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_SideNavigationContainer2.default);

/***/ }),

/***/ "./template/components/Navigation/SidePanel/SidePanel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _constants = __webpack_require__("./template/state/modules/layout/constants.js");

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _FloorNavigation = __webpack_require__("./template/components/FloorNavigation/index.js");

var _FloorNavigation2 = _interopRequireDefault(_FloorNavigation);

var _SidePrimaryNavigation = __webpack_require__("./template/components/Navigation/SidePrimaryNavigation/index.js");

var _SidePrimaryNavigation2 = _interopRequireDefault(_SidePrimaryNavigation);

var _SideSecondaryNavigation = __webpack_require__("./template/components/Navigation/SideSecondaryNavigation/index.js");

var _SideSecondaryNavigation2 = _interopRequireDefault(_SideSecondaryNavigation);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _withViewport = __webpack_require__("./template/components/Viewport/withViewport.js");

var _withViewport2 = _interopRequireDefault(_withViewport);

var _Footer = __webpack_require__("./template/components/Footer/index.js");

var _Footer2 = _interopRequireDefault(_Footer);

var _index = __webpack_require__("./template/components/Navigation/SidePanel/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_index2.default);

var SidePanel = function (_PureComponent) {
  (0, _inherits3.default)(SidePanel, _PureComponent);

  function SidePanel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SidePanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SidePanel.__proto__ || (0, _getPrototypeOf2.default)(SidePanel)).call.apply(_ref, [this].concat(args))), _this), _this.shouldAnimate = false, _this.handleTransitionEnd = /* istanbul ignore next - dom el eventlistener is not supported in jsdom */function (_ref2) {
      var target = _ref2.target,
          currentTarget = _ref2.currentTarget;

      _this.triggerRedraw();
      if (target === currentTarget) {
        _this.props.clearNavActiveItem();
      }
    }, _this.saveDialog = function (component) {
      return _this.dialog = component;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SidePanel, [{
    key: "componentDidUpdate",


    /* istanbul ignore next - focus is not supported in jsdom */
    value: function componentDidUpdate(_ref3) {
      var isSidePanelOpen = _ref3.isSidePanelOpen;

      if (this.props.isSidePanelOpen !== isSidePanelOpen && this.component) {
        this.component.focus();
      }
    }
    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.dialog.addEventListener("transitionend", this.handleTransitionEnd);
    }

    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.dialog.removeEventListener("transitionend", this.handleTransitionEnd);
    }
  }, {
    key: "triggerRedraw",


    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */
    value: function triggerRedraw() {
      this.dialog.style.display = "none";
      this.dialog.offsetHeight;
      this.dialog.style.display = "block";
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this,
          _cx2,
          _cx3;

      var _props = this.props,
          formatTranslation = _props.formatTranslation,
          isSidePanelOpen = _props.isSidePanelOpen,
          isVisible = _props.isVisible,
          closeSidePanel = _props.closeSidePanel,
          navActiveItem = _props.navActiveItem,
          setNavActiveItem = _props.setNavActiveItem,
          clearNavActiveItem = _props.clearNavActiveItem,
          currentGender = _props.currentGender,
          maleItems = _props.maleItems,
          femaleItems = _props.femaleItems;

      this.shouldAnimate = this.shouldAnimate || isSidePanelOpen && isVisible;

      var navProps = {
        currentGender: currentGender,
        navActiveItem: navActiveItem,
        setNavActiveItem: setNavActiveItem,
        clearNavActiveItem: clearNavActiveItem
      };

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          {
            role: "dialog",
            "aria-label": formatTranslation("SidePanel.NavigationLabel"),
            "aria-hidden": !isSidePanelOpen,
            ref: this.saveDialog,
            className: cx(_index2.default.dialog, (_cx = {}, (0, _defineProperty3.default)(_cx, _index2.default.dialog__visible, isSidePanelOpen && isVisible), (0, _defineProperty3.default)(_cx, _index2.default.dialog__animate, this.shouldAnimate), _cx)),
            "data-testid": "sidepanel"
          },
          _react2.default.createElement(
            "div",
            { className: _index2.default.container },
            _react2.default.createElement("button", {
              className: _index2.default.close,
              onClick: closeSidePanel,
              "aria-label": formatTranslation("SidePanel.CloseNavigationLabel"),
              ref: function ref(c) {
                return _this2.component = c;
              },
              "data-testid": "close-button"
            }),
            _react2.default.createElement(
              "div",
              { className: _index2.default.dontHideButtonContainer },
              _react2.default.createElement(
                "div",
                {
                  className: cx(_index2.default.primarySideContainer, (_cx2 = {}, (0, _defineProperty3.default)(_cx2, _index2.default.primarySideContainer__hidden, !!navActiveItem), (0, _defineProperty3.default)(_cx2, _index2.default.primarySideContainer__animate, this.shouldAnimate), _cx2))
                },
                _react2.default.createElement(_FloorNavigation2.default, { viewable: [_constants.SMALL_VIEWPORT, _constants.MEDIUM_VIEWPORT] }),
                _react2.default.createElement(
                  "div",
                  { className: _index2.default.content },
                  _react2.default.createElement(_SidePrimaryNavigation2.default, (0, _extends3.default)({}, navProps, {
                    items: femaleItems,
                    forGender: _layout.FEMALE
                  })),
                  _react2.default.createElement(_SidePrimaryNavigation2.default, (0, _extends3.default)({}, navProps, {
                    items: maleItems,
                    forGender: _layout.MALE
                  })),
                  _react2.default.createElement(_Footer2.default, { isAccordion: true })
                )
              ),
              _react2.default.createElement(_SideSecondaryNavigation2.default, (0, _extends3.default)({}, navProps, {
                items: femaleItems,
                forGender: _layout.FEMALE
              })),
              _react2.default.createElement(_SideSecondaryNavigation2.default, (0, _extends3.default)({}, navProps, {
                items: maleItems,
                forGender: _layout.MALE
              }))
            )
          )
        ),
        _react2.default.createElement("aside", {
          className: cx(_index2.default.overlay, (_cx3 = {}, (0, _defineProperty3.default)(_cx3, _index2.default.overlay__show, isSidePanelOpen && isVisible), (0, _defineProperty3.default)(_cx3, _index2.default.overlay__animate, this.shouldAnimate), _cx3)),
          role: "button",
          onClick: closeSidePanel,
          onTouchMove: function onTouchMove(event) {
            event.preventDefault();
            return false;
          },
          "aria-hidden": "true"
        })
      );
    }
  }]);
  return SidePanel;
}(_react.PureComponent);

exports.default = (0, _withViewport2.default)((0, _translation2.default)(SidePanel));

/***/ }),

/***/ "./template/components/Navigation/SidePanel/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"e9BXhnn","dialog__animate":"_2vVXZSW","primarySideContainer__animate":"_2Xn4-fu","dialog__visible":"_3xr4O-L","dontHideButtonContainer":"_1cXZlsM","container":"_3mJw6fH","primarySideContainer":"_2LKGpcC","primarySideContainer__hidden":"_15Khghp","content":"_1vPhLeL","close":"_23Cf8RU","overlay":"_2k_yRgJ","overlay__animate":"_1eod1iN","overlay__show":"_3jZhZbN"};

/***/ }),

/***/ "./template/components/Navigation/SidePanel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _SidePanel = __webpack_require__("./template/components/Navigation/SidePanel/SidePanel.js");

var _SidePanel2 = _interopRequireDefault(_SidePanel);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ closeSidePanel: _layout.closeSidePanel, clearNavActiveItem: _navigation.clearNavActiveItem, setNavActiveItem: _navigation.setNavActiveItem }, dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isSidePanelOpen: (0, _layout.isSidePanelOpen)(state),
    navActiveItem: (0, _navigation.getNavActiveItem)(state),
    currentGender: (0, _layout.getCurrentGender)(state),
    maleItems: (0, _navigation.maleSidePrimaryNavigationItems)(state),
    femaleItems: (0, _navigation.femaleSidePrimaryNavigationItems)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SidePanel2.default);

/***/ }),

/***/ "./template/components/Navigation/SidePrimaryNavigation/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2P0dWBm"};

/***/ }),

/***/ "./template/components/Navigation/SidePrimaryNavigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _SideNavigationContainer = __webpack_require__("./template/components/Navigation/SideNavigationContainer/index.js");

var _SideNavigationContainer2 = _interopRequireDefault(_SideNavigationContainer);

var _globalEventHandler = __webpack_require__("./template/globalEventHandler.js");

var _globalEventHandler2 = _interopRequireDefault(_globalEventHandler);

var _index = __webpack_require__("./template/components/Navigation/SidePrimaryNavigation/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isVisible = function isVisible(navActiveItem, forGender, currentGender) {
  return !navActiveItem && (forGender === currentGender || forGender === _layout.FEMALE && currentGender === _layout.DEFAULT);
};

var SidePrimaryNavigation = function (_Component) {
  (0, _inherits3.default)(SidePrimaryNavigation, _Component);

  function SidePrimaryNavigation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SidePrimaryNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SidePrimaryNavigation.__proto__ || (0, _getPrototypeOf2.default)(SidePrimaryNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.selectFirstNavigationItem = /* istanbul ignore next - focus is not supported in jsdom  */function (selectedGender) {
      if (selectedGender === _this.props.forGender) {
        _this.firstItem && _this.firstItem.focus();
      }
    }, _this.handleKeyDown = /* istanbul ignore next - focus is not supported in jsdom  */function (event) {
      if (event.key === _globalEventHandler.keys.tab && event.originalEvent.shiftKey) {
        if (_this.firstItem && _this.firstItem === document.activeElement) {
          event.originalEvent.preventDefault();
          (0, _globalEventHandler.focusFloorNavigationFor)(_this.props.forGender);
        }
      }
    }, _this.saveNavigationItem = /* istanbul ignore next - focus is not supported in jsdom  */function (component) {
      if (typeof _this.firstItem === "undefined") {
        _this.firstItem = component;
      }
    }, _this.renderContainer = function (item) {
      return _react2.default.createElement(_SideNavigationContainer2.default, {
        key: item.id,
        item: item,
        setNavActiveItem: _this.props.setNavActiveItem,
        saveNavigationItem: _this.saveNavigationItem
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SidePrimaryNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.removeFloorSelectedEventHandler = _globalEventHandler2.default.addListener(_globalEventHandler.events.focusFirstPrimaryNavigationItem, this.selectFirstNavigationItem);

      this.keyDownEventListener = _globalEventHandler2.default.addListener(_globalEventHandler.events.keyDown, this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeFloorSelectedEventHandler && this.removeFloorSelectedEventHandler.remove();
      this.keyDownEventListener && this.keyDownEventListener.remove();
    }

    // will use item.display.mobileDisplayLayout to decide the type of the container

  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          forGender = _props.forGender,
          currentGender = _props.currentGender,
          navActiveItem = _props.navActiveItem,
          groupNavigationItems = _props.items;

      var visible = isVisible(navActiveItem, forGender, currentGender);

      return _react2.default.createElement(
        "nav",
        {
          className: _index2.default.container,
          "aria-hidden": !visible,
          "data-testid": "sidePanel-itemsList"
        },
        groupNavigationItems.map(this.renderContainer)
      );
    }
  }]);
  return SidePrimaryNavigation;
}(_react.Component);

exports.default = SidePrimaryNavigation;

/***/ }),

/***/ "./template/components/Navigation/SideSecondaryNavigation/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SO8a70","container__visible":"_1St3kFK","header":"LugcOmY","close":"R1CKLoS","secondary":"_2ALYZ5D","item":"_1XBO_x3","item__visible":"GSjf4AI"};

/***/ }),

/***/ "./template/components/Navigation/SideSecondaryNavigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("./template/components/Navigation/SideSecondaryNavigation/index.css");

var _index2 = _interopRequireDefault(_index);

var _SideNavigationContainer = __webpack_require__("./template/components/Navigation/SideNavigationContainer/index.js");

var _SideNavigationContainer2 = _interopRequireDefault(_SideNavigationContainer);

var _Spinner = __webpack_require__("./template/components/Spinner/index.js");

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _classnames2.default.bind(_index2.default);

var SideSecondaryNavigation = function (_PureComponent) {
  (0, _inherits3.default)(SideSecondaryNavigation, _PureComponent);

  function SideSecondaryNavigation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SideSecondaryNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SideSecondaryNavigation.__proto__ || (0, _getPrototypeOf2.default)(SideSecondaryNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = { animating: "" }, _this.renderNavigationPanel = function (_ref2) {
      var label = _ref2.label,
          id = _ref2.id,
          items = _ref2.items;
      return _react2.default.createElement(
        "div",
        {
          key: id,
          className: cx(_index2.default.item, (0, _defineProperty3.default)({}, _index2.default.item__visible, _this.props.navActiveItem === id || _this.state.animating === id))
        },
        _react2.default.createElement(
          "section",
          { className: _index2.default.header },
          _this.renderCloseSecondaryButton(),
          _react2.default.createElement(
            "h3",
            null,
            label
          )
        ),
        _react2.default.createElement(
          "nav",
          { className: _index2.default.secondary, ref: function ref(el) {
              return el && (el.scrollTop = 0);
            } },
          !items.length ? _react2.default.createElement(_Spinner2.default, { size: "x-large", position: "centre" }) : items.map(function (item) {
            return _react2.default.createElement(_SideNavigationContainer2.default, { key: item.id, item: item });
          })
        )
      );
    }, _this.clearNavActiveItem = function () {
      _this.setState({ animating: _this.props.navActiveItem });
      _this.props.clearNavActiveItem();
    }, _this.renderCloseSecondaryButton = function () {
      return _react2.default.createElement("button", { className: _index2.default.close, onClick: _this.clearNavActiveItem });
    }, _this.saveSecondaryPanel = function (component) {
      return _this.secondaryPanel = component;
    }, _this.isVisible = function () {
      var _this$props = _this.props,
          forGender = _this$props.forGender,
          currentGender = _this$props.currentGender,
          navActiveItem = _this$props.navActiveItem;


      return !!navActiveItem && (forGender === currentGender || forGender === _layout.FEMALE && currentGender === _layout.DEFAULT);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SideSecondaryNavigation, [{
    key: "componentDidMount",


    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */
    value: function componentDidMount() {
      var _this2 = this;

      this.secondaryPanel.addEventListener("transitionend", function (_ref3) {
        var target = _ref3.target,
            currentTarget = _ref3.currentTarget;

        if (target === currentTarget) {
          _this2.setState({ animating: "" });
        }
      });
    }

    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */

  }, {
    key: "componentWillUnmmount",
    value: function componentWillUnmmount() {
      this.secondaryPanel.removeEventListener("transitionend");
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var groupNavigationItems = this.props.items;


      return _react2.default.createElement(
        "div",
        {
          className: cx(_index2.default.container, (0, _defineProperty3.default)({}, _index2.default.container__visible, this.isVisible())),
          ref: this.saveSecondaryPanel,
          "aria-hidden": !this.isVisible(),
          "data-testid": "secondary-nav"
        },
        groupNavigationItems.map(function (_ref4) {
          var primaryNavigationItems = _ref4.items;
          return primaryNavigationItems.map(_this3.renderNavigationPanel);
        })
      );
    }
  }]);
  return SideSecondaryNavigation;
}(_react.PureComponent);

exports.default = SideSecondaryNavigation;

/***/ }),

/***/ "./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stickyHeader":"_2qbxfQF","stickyHeader__sidePanelOpen":"_3VnsaeI"};

/***/ }),

/***/ "./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactHeadroom = __webpack_require__("../node_modules/react-headroom/dist/index.js");

var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _NotQuiteStickyHeader = __webpack_require__("./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.css");

var _NotQuiteStickyHeader2 = _interopRequireDefault(_NotQuiteStickyHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_NotQuiteStickyHeader2.default);

var getCookieMessageOffset = function getCookieMessageOffset(open, viewport) {
  var _offsets;

  if (!open) return 0;

  var offsets = (_offsets = {}, (0, _defineProperty3.default)(_offsets, _layout.LARGE_VIEWPORT, 50), (0, _defineProperty3.default)(_offsets, _layout.MEDIUM_VIEWPORT, 70), (0, _defineProperty3.default)(_offsets, _layout.SMALL_VIEWPORT, 105), _offsets);

  return offsets[viewport];
};

var NotQuiteStickyHeader = function (_PureComponent) {
  (0, _inherits3.default)(NotQuiteStickyHeader, _PureComponent);

  function NotQuiteStickyHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NotQuiteStickyHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NotQuiteStickyHeader.__proto__ || (0, _getPrototypeOf2.default)(NotQuiteStickyHeader)).call.apply(_ref, [this].concat(args))), _this), _this.getPinStart = function () {
      var cookieMessageOffset = getCookieMessageOffset(_this.props.cookieMessageOpen, _this.props.viewportCategory);
      var miscBarHeight = _this.props.viewportCategory === _layout.LARGE_VIEWPORT ? 30 : 0;

      return cookieMessageOffset + miscBarHeight;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NotQuiteStickyHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.headroom && this.headroom.handleResize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _reactHeadroom2.default,
        {
          className: cx("stickyHeader", {
            stickyHeader__sidePanelOpen: this.props.isSidePanelOpen
          }),
          disableInlineStyles: true,
          pinStart: this.getPinStart,
          id: "chrome-sticky-header",
          upTolerance: 17,
          ref: function ref(d) {
            return _this2.headroom = d;
          }
        },
        this.props.children
      );
    }
  }]);
  return NotQuiteStickyHeader;
}(_react.PureComponent);

exports.default = NotQuiteStickyHeader;

/***/ }),

/***/ "./template/components/NotQuiteStickyHeader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _NotQuiteStickyHeader = __webpack_require__("./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.js");

var _NotQuiteStickyHeader2 = _interopRequireDefault(_NotQuiteStickyHeader);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    viewportCategory: (0, _layout.getViewport)(state),
    isSidePanelOpen: (0, _layout.isSidePanelOpen)(state),
    cookieMessageOpen: (0, _layout.isCookieMessageOpen)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_NotQuiteStickyHeader2.default);

/***/ }),

/***/ "./template/components/Notification/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification":"EEAetjH","text":"_3OOTF2t","hasBackground":"_2jSFszG","hasIcon":"_1YG5Vyj","success":"_10Z5DXC","error":"_3GU5ymQ","promotion":"_1xX3I5f","alert":"_1qhdF5P"};

/***/ }),

/***/ "./template/components/Notification/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__("../node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _IconButton = __webpack_require__("./template/components/IconButton/index.js");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _index = __webpack_require__("./template/components/Notification/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notification = function (_Component) {
  (0, _inherits3.default)(Notification, _Component);

  function Notification() {
    (0, _classCallCheck3.default)(this, Notification);
    return (0, _possibleConstructorReturn3.default)(this, (Notification.__proto__ || (0, _getPrototypeOf2.default)(Notification)).apply(this, arguments));
  }

  (0, _createClass3.default)(Notification, [{
    key: "render",
    value: function render() {
      var _classnames;

      var ariaLiveForType = {
        alert: "assertive",
        error: "assertive",
        promotion: "polite",
        success: "polite"
      };

      var _props = this.props,
          children = _props.children,
          hasIcon = _props.hasIcon,
          type = _props.type,
          onClose = _props.onClose,
          closeLabel = _props.closeLabel;


      return _react2.default.createElement(
        "div",
        {
          "aria-live": ariaLiveForType[type],
          className: (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, _index2.default.notification, true), (0, _defineProperty3.default)(_classnames, _index2.default[type], true), (0, _defineProperty3.default)(_classnames, _index2.default.hasBackground, true), (0, _defineProperty3.default)(_classnames, _index2.default.hasIcon, hasIcon), _classnames))
        },
        _react2.default.createElement(
          "div",
          { className: _index2.default.text },
          children
        ),
        onClose && _react2.default.createElement(_IconButton2.default, {
          icon: "close",
          className: _index2.default.close,
          "data-testid": "notification-close-btn",
          size: "small",
          onClick: onClose,
          "aria-label": closeLabel ? closeLabel : "Dismiss this message"
        })
      );
    }
  }]);
  return Notification;
}(_react.Component);

Notification.defaultProps = {
  hasIcon: true
};

exports.default = Notification;

/***/ }),

/***/ "./template/components/SearchDropdown/ResultItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"_2O1emdg","count":"_3_Y4sZZ","bold":"_179bjqa","button":"_1kpn9KI"};

/***/ }),

/***/ "./template/components/SearchDropdown/ResultItem/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./template/components/SearchDropdown/ResultItem/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResultItem = function (_Component) {
  (0, _inherits3.default)(ResultItem, _Component);

  function ResultItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResultItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResultItem.__proto__ || (0, _getPrototypeOf2.default)(ResultItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function () {
      var _this$props = _this.props,
          setSearchTerm = _this$props.setSearchTerm,
          searchTerm = _this$props.item.searchTerm;


      setSearchTerm(searchTerm);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResultItem, [{
    key: "renderResultLabel",
    value: function renderResultLabel(label) {
      var term = this.props.term;


      var text = ResultItem.formatText(label);
      var bolded = ResultItem.boldTermInText(text, term);

      return bolded;
    }
  }, {
    key: "renderResultCount",
    value: function renderResultCount(resultCount) {
      return _react2.default.createElement(
        "span",
        { className: _index2.default.count },
        resultCount.toLocaleString().replace(/\.00$/, "")
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          onKeyDown = _props.onKeyDown,
          _props$item = _props.item,
          numberOfResults = _props$item.numberOfResults,
          searchTerm = _props$item.searchTerm;


      return _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "button",
          {
            role: "option",
            ref: this.props.buttonRef,
            onKeyDown: onKeyDown,
            className: _index2.default.button,
            onClick: this.handleSubmit
          },
          _react2.default.createElement("span", {
            className: _index2.default.label,
            dangerouslySetInnerHTML: {
              __html: this.renderResultLabel(searchTerm)
            }
          }),
          numberOfResults && this.renderResultCount(numberOfResults)
        )
      );
    }
  }]);
  return ResultItem;
}(_react.Component);

ResultItem.bold = function (match, word) {
  var boldIndex = word.toLowerCase().indexOf(match.toLowerCase());

  return word.substring(0, boldIndex) + ("<span class=\"" + _index2.default.bold + "\">" + word.substr(boldIndex, match.length) + "</span>") + word.substring(boldIndex + match.length);
};

ResultItem.boldTermInText = function (suggestion, term) {
  var searchWords = term.split(/ /g);
  var suggestionWords = suggestion.split(/ /g);

  return suggestionWords.map(function (suggestionWord) {
    var firstMatch = searchWords.find(function (searchTerm) {
      return suggestionWord.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
    });

    return firstMatch ? ResultItem.bold(firstMatch, suggestionWord) : suggestionWord;
  }).join(" ");
};

ResultItem.formatText = function (phrase) {
  return phrase.replace(/asos/i, "ASOS").split(/ /g).map(function (word) {
    return "" + word.substring(0, 1).toUpperCase() + word.substring(1);
  }).join(" ");
};

exports.default = ResultItem;

/***/ }),

/***/ "./template/components/SearchDropdown/ResultList/ResultList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./template/components/SearchDropdown/index.css");

var _index2 = _interopRequireDefault(_index);

var _ResultItem = __webpack_require__("./template/components/SearchDropdown/ResultItem/index.js");

var _ResultItem2 = _interopRequireDefault(_ResultItem);

var _globalEventHandler = __webpack_require__("./template/globalEventHandler.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResultList = function (_Component) {
  (0, _inherits3.default)(ResultList, _Component);

  function ResultList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResultList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResultList.__proto__ || (0, _getPrototypeOf2.default)(ResultList)).call.apply(_ref, [this].concat(args))), _this), _this.items = [], _this.handleKeyDown = /* istanbul ignore next */function (e) {
      var currentIndex = _this.items.indexOf(e.target);

      if (e.keyCode === 40) {
        var next = _this.items[currentIndex + 1];

        if (!next) {
          return _this.props.focusSearchBox();
        }

        next.focus();
      }

      if (e.keyCode === 38) {
        if (currentIndex === 0) {
          return _this.props.focusSearchBox();
        }

        var _next = _this.items[currentIndex - 1] || _this.items[0];
        _next.focus();
      }

      if (e.keyCode === 9 && !e.shiftKey) {
        var _next2 = _this.items[currentIndex + 1];

        if (!_next2) {
          (0, _globalEventHandler.closeSearchOverlay)();
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResultList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          setSearchTerm = _props.setSearchTerm,
          term = _props.term,
          focusSearchBox = _props.focusSearchBox;


      return items && _react2.default.createElement(
        "ul",
        {
          className: _index2.default.list,
          role: "listbox",
          id: "search-results",
          ref: this.props.listRef
        },
        items.map(function (item, i) {
          return _react2.default.createElement(_ResultItem2.default, {
            buttonRef: function buttonRef(el) {
              return _this2.items[i] = el;
            },
            key: i,
            item: item,
            term: term,
            setSearchTerm: setSearchTerm,
            focusSearchBox: focusSearchBox,
            onKeyDown: _this2.handleKeyDown
          });
        })
      );
    }
  }]);
  return ResultList;
}(_react.Component);

exports.default = ResultList;

/***/ }),

/***/ "./template/components/SearchDropdown/ResultList/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _search = __webpack_require__("./template/state/modules/search/index.js");

var _ResultList = __webpack_require__("./template/components/SearchDropdown/ResultList/ResultList.js");

var _ResultList2 = _interopRequireDefault(_ResultList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    term: (0, _search.getSearchTerm)(state)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setSearchTerm: _search.setSearchTerm
  }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ResultList2.default);

/***/ }),

/***/ "./template/components/SearchDropdown/SearchDropdown.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _ResultList = __webpack_require__("./template/components/SearchDropdown/ResultList/index.js");

var _ResultList2 = _interopRequireDefault(_ResultList);

var _index = __webpack_require__("./template/components/SearchDropdown/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchDropdown = function (_Component) {
  (0, _inherits3.default)(SearchDropdown, _Component);

  function SearchDropdown() {
    (0, _classCallCheck3.default)(this, SearchDropdown);
    return (0, _possibleConstructorReturn3.default)(this, (SearchDropdown.__proto__ || (0, _getPrototypeOf2.default)(SearchDropdown)).apply(this, arguments));
  }

  (0, _createClass3.default)(SearchDropdown, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          recentSearches = _props.recentSearches,
          suggestions = _props.suggestions;

      if (!recentSearches.length && !suggestions.length) return null;

      return _react2.default.createElement(
        "div",
        { className: _index2.default.container },
        suggestions.length ? this.renderSuggestions() : this.renderSearches()
      );
    }
  }, {
    key: "renderSuggestions",
    value: function renderSuggestions() {
      return _react2.default.createElement(_ResultList2.default, {
        items: this.props.suggestions,
        focusSearchBox: this.props.focusSearchBox,
        listRef: this.props.listRef
      });
    }
  }, {
    key: "renderSearches",
    value: function renderSearches() {
      var _props2 = this.props,
          recentSearches = _props2.recentSearches,
          formatTranslation = _props2.formatTranslation,
          clearRecentSearches = _props2.clearRecentSearches;

      // normalise searches to be the same format as suggestions

      var searches = recentSearches.map(function (searchTerm) {
        return { searchTerm: searchTerm };
      });

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "h3",
          { className: _index2.default.recentSearchesHeader },
          formatTranslation("SearchBar.RecentSearches")
        ),
        _react2.default.createElement(
          "button",
          {
            className: _index2.default.recentSearchesClear,
            "aria-label": formatTranslation("SearchBar.ClearRecentSearchesLabel"),
            onClick: clearRecentSearches,
            "data-testid": "clear-recent-searches"
          },
          formatTranslation("SearchBar.ClearRecentSearchesText")
        ),
        _react2.default.createElement(_ResultList2.default, {
          items: searches,
          focusSearchBox: this.props.focusSearchBox,
          listRef: this.props.listRef
        })
      );
    }
  }]);
  return SearchDropdown;
}(_react.Component);

exports.default = (0, _translation2.default)(SearchDropdown);

/***/ }),

/***/ "./template/components/SearchDropdown/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2m6gPa2","list":"_1Sq1DvZ","recentSearchesHeader":"_3WFlxZM","recentSearchesClear":"_27Sj3UY"};

/***/ }),

/***/ "./template/components/SearchDropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _SearchDropdown = __webpack_require__("./template/components/SearchDropdown/SearchDropdown.js");

var _SearchDropdown2 = _interopRequireDefault(_SearchDropdown);

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _search = __webpack_require__("./template/state/modules/search/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    recentSearches: (0, _search.getSearchHistory)(state),
    suggestions: (0, _search.getSearchSuggestions)(state)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ clearRecentSearches: _search.clearRecentSearches }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SearchDropdown2.default);

/***/ }),

/***/ "./template/components/SearchForm/SearchControls/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3wYFryj","container__hidden":"_254uRVH"};

/***/ }),

/***/ "./template/components/SearchForm/SearchControls/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _withViewport = __webpack_require__("./template/components/Viewport/withViewport.js");

var _withViewport2 = _interopRequireDefault(_withViewport);

var _index = __webpack_require__("./template/components/SearchForm/SearchControls/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_index2.default);

var SearchControls = function SearchControls(_ref) {
  var children = _ref.children,
      isVisible = _ref.isVisible;
  return _react2.default.createElement(
    "div",
    {
      className: cx(_index2.default.container, (0, _defineProperty3.default)({}, _index2.default.container__hidden, !isVisible))
    },
    children
  );
};

exports.default = (0, _withViewport2.default)(SearchControls);

/***/ }),

/***/ "./template/components/SearchForm/SearchForm.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchContainer":"_AXFL6D","backdrop":"_2OrxWsX","backdrop__active":"_3mlaV0h","controls":"_37kcNWv","container":"_2Idp6BM","container__active":"_3ChAiVG","fieldContainer":"_3mgvuXW","field":"_2z-tgin","field__active":"_1-Ok1So","button":"_1PEaSbT","button__active":"_3STtqeg","results":"_15ReAU2","label":"_1eJyqnP","results__active":"_1iHsCF4"};

/***/ }),

/***/ "./template/components/SearchForm/SearchForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _constants = __webpack_require__("./template/state/modules/layout/constants.js");

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _SearchIcon = __webpack_require__("./template/components/SearchIcon/index.js");

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

var _IconButton = __webpack_require__("./template/components/IconButton/index.js");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _SearchDropdown = __webpack_require__("./template/components/SearchDropdown/index.js");

var _SearchDropdown2 = _interopRequireDefault(_SearchDropdown);

var _SearchControls = __webpack_require__("./template/components/SearchForm/SearchControls/index.js");

var _SearchControls2 = _interopRequireDefault(_SearchControls);

var _globalEventHandler = __webpack_require__("./template/globalEventHandler.js");

var _globalEventHandler2 = _interopRequireDefault(_globalEventHandler);

var _SearchForm = __webpack_require__("./template/components/SearchForm/SearchForm.css");

var _SearchForm2 = _interopRequireDefault(_SearchForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_SearchForm2.default);

var SEARCH_SUGGESTIONS_DEBOUNCE_INTERVAL = 300;
var MAX_CHARACTER_VALUE_FOR_SEARCH = "150";

var SearchForm = function (_Component) {
  (0, _inherits3.default)(SearchForm, _Component);

  function SearchForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SearchForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchForm.__proto__ || (0, _getPrototypeOf2.default)(SearchForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (_ref2) {
      var target = _ref2.target;

      _this.changeTerm(target.value);
    }, _this.handleClose = function () {
      _this.props.closeSearch();
      _this.props.setSearchTerm("");

      /* istanbul ignore next */
      if (_this.term) _this.term.value = "";
    }, _this.handleSubmit = function (event) {
      var _this$props = _this.props,
          onSearch = _this$props.onSearch,
          term = _this$props.term;


      if (term.length === 0) {
        event.preventDefault();
      } else {
        /* istanbul ignore next */
        if (_this.term) {
          _this.term.value = term;
        }

        onSearch(term);
      }
    }, _this.handleFocus = /* istanbul ignore next */function () {
      _this.props.openSearch();
    }, _this.handleBlur = function () {
      var _this$props2 = _this.props,
          closeSearch = _this$props2.closeSearch,
          viewport = _this$props2.viewport;

      if (viewport !== _constants.SMALL_VIEWPORT) {
        closeSearch();
      }
    }, _this.handleKeyDown = /* istanbul ignore next */function (e) {
      if (e.keyCode === 40) {
        _this.listRef.firstElementChild.firstElementChild.focus();
      } else if (e.shiftKey && e.keyCode === 9) {
        _this.handleBlur();
      }
    }, _this.handleCloseKeyDown = /* istanbul ignore next */function (e) {
      if (e.keyCode === 9) {
        _this.focusSelf();
      }
    }, _this.handleSearchInputBlur = /* istanbul ignore next */function (p, e, ignoreTerm) {
      var _this$props3 = _this.props,
          isSearchResultsPanelOpen = _this$props3.isSearchResultsPanelOpen,
          term = _this$props3.term;

      if (!isSearchResultsPanelOpen && (ignoreTerm || !term)) {
        _this.handleBlur();
      }
    }, _this.handleSearchButtonBlur = /* istanbul ignore next */function () {
      _this.handleSearchInputBlur(null, null, true);
    }, _this.focusSelf = /* istanbul ignore next */function () {
      setTimeout(function () {
        return _this.term.focus();
      }, 0);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SearchForm, [{
    key: "componentWillReceiveProps",

    /* istanbul ignore next */
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var isVisible = this.props.isVisible;

      var blockScrollStyle = "chrome-hide-overflow";

      if (!isVisible && nextProps.isVisible) {
        typeof document !== "undefined" && document.body.classList.add(blockScrollStyle);
        setTimeout(function () {
          return _this2.term.focus();
        }, 0);
      } else if (isVisible && !nextProps.isVisible) {
        typeof document !== "undefined" && document.body.classList.remove(blockScrollStyle);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.closeSearchOverlay = _globalEventHandler2.default.addListener(_globalEventHandler.events.closeSearchOverlay, this.handleBlur);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.closeSearchOverlay && this.closeSearchOverlay.remove();
    }
  }, {
    key: "changeTerm",
    value: function changeTerm(term) {
      var _props = this.props,
          setSearchTerm = _props.setSearchTerm,
          loadSuggestions = _props.loadSuggestions;


      setSearchTerm(term);

      clearTimeout(this.timer);
      this.timer = setTimeout(loadSuggestions, SEARCH_SUGGESTIONS_DEBOUNCE_INTERVAL);
    }
  }, {
    key: "render",
    value: function render() {
      var _cx5,
          _this3 = this;

      var _props2 = this.props,
          isVisible = _props2.isVisible,
          hasVisibleResults = _props2.hasVisibleResults,
          term = _props2.term,
          formatTranslation = _props2.formatTranslation;


      var buttonClassName = cx(_SearchForm2.default.button, (0, _defineProperty3.default)({}, _SearchForm2.default.button__active, term));

      var resultsClassName = cx(_SearchForm2.default.results, (0, _defineProperty3.default)({}, _SearchForm2.default.results__active, hasVisibleResults));

      var containerClassName = cx(_SearchForm2.default.container, (0, _defineProperty3.default)({}, _SearchForm2.default.container__active, isVisible));

      var backdropClassName = cx(_SearchForm2.default.backdrop, (0, _defineProperty3.default)({}, _SearchForm2.default.backdrop__active, isVisible));

      var fieldClassName = cx((_cx5 = {}, (0, _defineProperty3.default)(_cx5, _SearchForm2.default.field, true), (0, _defineProperty3.default)(_cx5, _SearchForm2.default.field__active, isVisible), _cx5));

      var searchAction = this.props.searchUrl;

      return _react2.default.createElement(
        "div",
        {
          className: _SearchForm2.default.searchContainer,
          onTouchMove: function onTouchMove(event) {
            return event.preventDefault();
          }
        },
        _react2.default.createElement("div", {
          className: backdropClassName,
          "aria-hidden": "true",
          onClick: this.handleBlur,
          "data-testid": "search-overlay-shadow"
        }),
        _react2.default.createElement(
          "form",
          {
            action: searchAction,
            method: "get",
            onSubmit: this.handleSubmit,
            className: containerClassName,
            "data-testid": "search-form"
          },
          _react2.default.createElement(
            "div",
            { className: _SearchForm2.default.fieldContainer, "data-testid": "search-field" },
            _react2.default.createElement(
              "label",
              { htmlFor: "chrome-search" },
              _react2.default.createElement(
                "span",
                { className: _SearchForm2.default.label },
                formatTranslation("SearchBar.Label")
              ),
              _react2.default.createElement("input", {
                id: "chrome-search",
                name: "q",
                role: "combobox",
                className: fieldClassName,
                type: "search",
                autoComplete: "off",
                placeholder: formatTranslation("SearchBar.Placeholder"),
                onChange: this.handleChange,
                onFocus: this.handleFocus,
                onKeyDown: this.handleKeyDown,
                onBlur: this.handleSearchInputBlur,
                "data-testid": "search-input",
                ref: /* istanbul ignore next */function ref(c) {
                  return _this3.term = c;
                },
                "aria-autocomplete": "both",
                "aria-controls": "search-results",
                "aria-expanded": hasVisibleResults,
                maxLength: MAX_CHARACTER_VALUE_FOR_SEARCH
              })
            ),
            _react2.default.createElement(
              "button",
              {
                className: buttonClassName,
                type: "submit",
                onBlur: this.handleSearchButtonBlur,
                "data-testid": "search-button-inline",
                disabled: term.length === 0
              },
              _react2.default.createElement(_SearchIcon2.default, null)
            ),
            _react2.default.createElement(
              "section",
              { className: resultsClassName },
              _react2.default.createElement(_SearchDropdown2.default, {
                focusSearchBox: this.focusSelf,
                listRef: /* istanbul ignore next */function listRef(el) {
                  return _this3.listRef = el;
                }
              })
            )
          ),
          _react2.default.createElement(
            _SearchControls2.default,
            { viewable: [_constants.SMALL_VIEWPORT] },
            _react2.default.createElement(_IconButton2.default, {
              height: 50,
              icon: "close",
              onClick: this.handleClose,
              onKeyDown: this.handleCloseKeyDown,
              "aria-label": "Close"
            })
          )
        )
      );
    }
  }]);
  return SearchForm;
}(_react.Component);

SearchForm.defaultProps = {
  isVisible: false,
  hasVisibleResults: false
};

exports.default = (0, _translation2.default)(SearchForm);

/***/ }),

/***/ "./template/components/SearchForm/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchForm = __webpack_require__("./template/components/SearchForm/SearchForm.js");

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _search = __webpack_require__("./template/state/modules/search/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    isVisible: (0, _search.getVisibility)(state),
    hasVisibleResults: (0, _search.getResultVisibility)(state),
    viewport: (0, _layout.getViewport)(state),
    term: (0, _search.getSearchTerm)(state),
    isSearchResultsPanelOpen: (0, _search.isSearchResultsPanelOpen)(state),
    searchUrl: (0, _regionalStore.getSearchUrl)(state),
    storeUrl: (0, _regionalStore.getDefaultStoreUrl)(state)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    onSearch: _search.submitSearch,
    loadSuggestions: _search.loadSuggestions,
    setSearchTerm: _search.setSearchTerm,
    closeSearch: _search.closeSearch,
    openSearch: _search.openSearch
  }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SearchForm2.default);

/***/ }),

/***/ "./template/components/SearchIcon/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchIcon = function SearchIcon(_ref) {
  var formatTranslation = _ref.formatTranslation;
  return _react2.default.createElement(
    "svg",
    { viewBox: "0 0 17 17" },
    _react2.default.createElement(
      "title",
      null,
      formatTranslation("Icon.Search")
    ),
    _react2.default.createElement("path", {
      fill: "currentColor",
      fillRule: "nonzero",
      d: "M7.65 15.3a7.65 7.65 0 1 1 5.997-2.9c-.01.012 3.183 3.297 3.183 3.297l-1.22 1.18s-3.144-3.283-3.154-3.275A7.618 7.618 0 0 1 7.65 15.3zm0-2a5.65 5.65 0 1 0 0-11.3 5.65 5.65 0 0 0 0 11.3z"
    })
  );
};

exports.default = (0, _translation2.default)(SearchIcon);

/***/ }),

/***/ "./template/components/Spinner/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_3F3-zot","rotate":"_1EbMuyW","small":"_1PHabRi","medium":"_2SN11Ha","large":"_3x2345_","x-large":"_24EDmS-","default":"w0zXMnO","centre":"_2QWwebb"};

/***/ }),

/***/ "./template/components/Spinner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("./template/components/Spinner/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(_ref) {
  var size = _ref.size,
      position = _ref.position;
  return _react2.default.createElement("div", { className: (0, _classnames2.default)(_index2.default.spinner, _index2.default[size], _index2.default[position]) });
};

Spinner.defaultProps = {
  size: "small",
  position: "default"
};

exports.default = Spinner;

/***/ }),

/***/ "./template/components/TabOutside/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAB_KEY = 9;

var TabOutside = function (_Component) {
  (0, _inherits3.default)(TabOutside, _Component);

  function TabOutside() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TabOutside);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TabOutside.__proto__ || (0, _getPrototypeOf2.default)(TabOutside)).call.apply(_ref, [this].concat(args))), _this), _this.handler = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          callback = _this$props.callback;


      if (disabled) {
        return;
      }

      var el = _this.el;
      var target = e.target;

      var key = e.keyCode || e.which;

      if (key !== TAB_KEY) {
        return;
      }

      if (target === el || el.contains(target)) {
        return;
      }

      callback(e);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TabOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keyup", this.handler, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keyup", this.handler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        "div",
        {
          ref: function ref(el) {
            _this2.el = el;
          }
        },
        this.props.children
      );
    }
  }]);
  return TabOutside;
}(_react.Component);

exports.default = TabOutside;

/***/ }),

/***/ "./template/components/TransitionList/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3jJF-YY","transitionList__element":"_7A5raQ3","transitionList__overlay":"_5za5cGj","transitionList__element--exiting":"_33JlLjK","transitionList_itemDeletedLabel":"_1iNwCvT","scaler":"_14Vh9ji"};

/***/ }),

/***/ "./template/components/TransitionList/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _index = __webpack_require__("./template/components/TransitionList/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_index2.default);

var TransitionList = function TransitionList(_ref) {
  var children = _ref.children,
      itemDeletedLabel = _ref.itemDeletedLabel,
      _onTransitionEnd = _ref.onTransitionEnd;

  return _react2.default.createElement(
    "ul",
    { className: _index2.default.transitionList },
    children.map(function (child) {
      var classes = cx("transitionList__element", {
        "transitionList__element--exiting": child.props.transition === "exiting"
      });

      return _react2.default.createElement(
        "li",
        { key: child.key, className: _index2.default.wrapper },
        _react2.default.createElement(
          "div",
          {
            className: classes,
            onTransitionEnd: function onTransitionEnd(e) {
              if (e.nativeEvent.propertyName === "height") {
                _onTransitionEnd(child.props.id);
              }
            }
          },
          _react2.default.createElement(
            "div",
            { className: _index2.default.transitionList_itemDeletedLabel },
            itemDeletedLabel
          ),
          child,
          _react2.default.createElement("div", { className: _index2.default.transitionList__overlay })
        )
      );
    })
  );
};

exports.default = TransitionList;

/***/ }),

/***/ "./template/components/UnsupportedBrowserMessage/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3lW8Y31","content":"_1eJmCBp","message":"_23QFXRT","header":"_2PQizAW","details":"_3CnPFRy"};

/***/ }),

/***/ "./template/components/UnsupportedBrowserMessage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsupportedBrowserMessage = undefined;

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _index = __webpack_require__("./template/components/UnsupportedBrowserMessage/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsupportedBrowserMessage = exports.UnsupportedBrowserMessage = function (_Component) {
  (0, _inherits3.default)(UnsupportedBrowserMessage, _Component);

  function UnsupportedBrowserMessage() {
    (0, _classCallCheck3.default)(this, UnsupportedBrowserMessage);
    return (0, _possibleConstructorReturn3.default)(this, (UnsupportedBrowserMessage.__proto__ || (0, _getPrototypeOf2.default)(UnsupportedBrowserMessage)).apply(this, arguments));
  }

  (0, _createClass3.default)(UnsupportedBrowserMessage, [{
    key: "render",
    value: function render() {
      var formatTranslation = this.props.formatTranslation;

      return _react2.default.createElement(
        "div",
        {
          className: _index2.default.container,
          "data-testid": "unsupported-browser-message"
        },
        _react2.default.createElement(
          "div",
          { className: _index2.default.content },
          _react2.default.createElement(
            "div",
            { className: _index2.default.message },
            _react2.default.createElement(
              "div",
              { className: _index2.default.header },
              formatTranslation("UnsupportedBrowserMessage.Header")
            ),
            _react2.default.createElement(
              "div",
              { className: _index2.default.details },
              formatTranslation("UnsupportedBrowserMessage.Details")
            )
          )
        )
      );
    }
  }]);
  return UnsupportedBrowserMessage;
}(_react.Component);

exports.default = (0, _translation2.default)(UnsupportedBrowserMessage);

/***/ }),

/***/ "./template/components/Viewport/withViewport.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var viewportsPropType = _propTypes2.default.oneOf([_layout.SMALL_VIEWPORT, _layout.MEDIUM_VIEWPORT, _layout.LARGE_VIEWPORT]);

function withViewport(WrappedComponent) {
  var ComposedComponent = function ComposedComponent(_ref) {
    var _ref$viewable = _ref.viewable,
        viewable = _ref$viewable === undefined ? [] : _ref$viewable,
        viewportCategory = _ref.viewportCategory,
        rest = (0, _objectWithoutProperties3.default)(_ref, ["viewable", "viewportCategory"]);

    if (!viewable.length || viewable.indexOf(viewportCategory) !== -1) {
      return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({ isVisible: true }, rest));
    }

    return null;
  };

  ComposedComponent.displayName = "withViewport(" + (WrappedComponent.displayName || WrappedComponent.name) + ")";


  function mapStateToProps(state) {
    return {
      viewportCategory: (0, _layout.getViewport)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)(ComposedComponent);
}

exports.default = withViewport;

/***/ }),

/***/ "./template/components/WelcomeMat/Message/Message.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1rQzr0T","flag":"EjR5TbT","text":"_3dXU2qH","redirectLink":"sE0SDig","changeButton":"_3qeH1gO"};

/***/ }),

/***/ "./template/components/WelcomeMat/Message/Message.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _getRedirectionUrl = __webpack_require__("./template/components/WelcomeMat/Message/getRedirectionUrl.js");

var _getRedirectionUrl2 = _interopRequireDefault(_getRedirectionUrl);

var _Message = __webpack_require__("./template/components/WelcomeMat/Message/Message.css");

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticLink = function StaticLink(_ref) {
  var url = _ref.url,
      label = _ref.label,
      browseCountry = _ref.browseCountry;
  return _react2.default.createElement(
    "a",
    {
      className: _Message2.default.redirectLink,
      href: (0, _getRedirectionUrl2.default)(url, browseCountry).toString(),
      "data-testid": "shop-there-button"
    },
    label
  );
};

var ChangeButton = function ChangeButton(_ref2) {
  var label = _ref2.label,
      openCountrySelector = _ref2.openCountrySelector;
  return _react2.default.createElement(
    "button",
    {
      className: _Message2.default.changeButton,
      onClick: openCountrySelector,
      "data-testid": "change-button"
    },
    label
  );
};

var Message = function Message(_ref3) {
  var text = _ref3.text,
      redirectUrl = _ref3.redirectUrl,
      imageUrl = _ref3.imageUrl,
      imageLabel = _ref3.imageLabel,
      openCountrySelector = _ref3.openCountrySelector,
      withCountrySelector = _ref3.withCountrySelector,
      targetCountryCode = _ref3.targetCountryCode;
  return _react2.default.createElement(
    "div",
    { className: _Message2.default.container },
    imageUrl && _react2.default.createElement("img", {
      src: imageUrl,
      alt: imageLabel,
      className: _Message2.default.flag,
      "data-testid": "icon"
    }),
    _react2.default.createElement(
      "p",
      { className: _Message2.default.text, "data-testid": "text" },
      text
    ),
    withCountrySelector ? _react2.default.createElement(ChangeButton, {
      label: redirectUrl.label,
      openCountrySelector: openCountrySelector
    }) : _react2.default.createElement(StaticLink, (0, _extends3.default)({}, redirectUrl, { browseCountry: targetCountryCode }))
  );
};

Message.defaultProps = {
  withCountrySelector: false
};

exports.default = Message;

/***/ }),

/***/ "./template/components/WelcomeMat/Message/getRedirectionUrl.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _context = __webpack_require__("./client/context/index.js");

var _urlParse = __webpack_require__("../node_modules/url-parse/index.js");

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRedirectionUrl = function getRedirectionUrl(url, browseCountry) {
  var parsedUrl = (0, _urlParse2.default)("//" + url);
  var extraParams = { r: 1, ctaref: "welcome mat", browseCountry: browseCountry };

  var affiliateId = (0, _context.getContext)().getAffiliateId();
  if (affiliateId) {
    extraParams.xaffid = affiliateId;
  }

  parsedUrl.query = (0, _extends3.default)({}, parsedUrl.query, extraParams);

  return parsedUrl;
};

exports.default = getRedirectionUrl;

/***/ }),

/***/ "./template/components/WelcomeMat/Message/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _Message = __webpack_require__("./template/components/WelcomeMat/Message/Message.js");

var _Message2 = _interopRequireDefault(_Message);

var _countrySelector = __webpack_require__("./template/state/modules/countrySelector/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ openCountrySelector: _countrySelector.openCountrySelector }, dispatch);
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_Message2.default);

/***/ }),

/***/ "./template/components/WelcomeMat/PaymentOptions.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_40vlZJG","container":"uVISX5m","paymentOption":"_1dJsPRL","logo":"XFU8Dea"};

/***/ }),

/***/ "./template/components/WelcomeMat/PaymentOptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _PaymentOptions = __webpack_require__("./template/components/WelcomeMat/PaymentOptions.css");

var _PaymentOptions2 = _interopRequireDefault(_PaymentOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentOptions = function PaymentOptions(_ref) {
  var paymentOptions = _ref.paymentOptions;
  return _react2.default.createElement(
    "div",
    { className: _PaymentOptions2.default.wrapper },
    _react2.default.createElement(
      "ul",
      {
        className: _PaymentOptions2.default.container,
        "data-testid": "payment-options",
        "aria-label": "Available payment methods"
      },
      paymentOptions.map(function (option) {
        return _react2.default.createElement(
          "li",
          { key: option.name, className: _PaymentOptions2.default.paymentOption },
          _react2.default.createElement("img", {
            src: option.logo,
            alt: option.name,
            className: _PaymentOptions2.default.logo,
            width: "32",
            height: "20"
          })
        );
      })
    )
  );
};

exports.default = PaymentOptions;

/***/ }),

/***/ "./template/components/WelcomeMat/ValueProposition.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Krmchy1","header":"_3mY3SxI","message":"_323c2w8"};

/***/ }),

/***/ "./template/components/WelcomeMat/ValueProposition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _ValueProposition = __webpack_require__("./template/components/WelcomeMat/ValueProposition.css");

var _ValueProposition2 = _interopRequireDefault(_ValueProposition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValueProposition = function ValueProposition(_ref) {
  var messages = _ref.messages,
      header = _ref.header;
  return _react2.default.createElement(
    "div",
    { className: _ValueProposition2.default.container, "data-testid": "value-proposition" },
    _react2.default.createElement(
      "div",
      { className: _ValueProposition2.default.header },
      header
    ),
    messages.map(function (message) {
      return _react2.default.createElement(
        "p",
        { key: message, className: _ValueProposition2.default.message },
        message
      );
    })
  );
};

exports.default = ValueProposition;

/***/ }),

/***/ "./template/components/WelcomeMat/WelcomeMat.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2zbKZA9","containerWrapper":"_1G5WFnO","slideUp":"_1TLIkUE","titleBarWrapper":"pd-tTev","contentBarWrapper":"_2RzbZoX","titleBar":"_1Mm24sv","title":"_1YuC05z","closeButton":"_1jxNAGm","contentBar":"_1jlh44H"};

/***/ }),

/***/ "./template/components/WelcomeMat/WelcomeMat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _IconButton = __webpack_require__("./template/components/IconButton/index.js");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Message = __webpack_require__("./template/components/WelcomeMat/Message/index.js");

var _Message2 = _interopRequireDefault(_Message);

var _ValueProposition = __webpack_require__("./template/components/WelcomeMat/ValueProposition.js");

var _ValueProposition2 = _interopRequireDefault(_ValueProposition);

var _PaymentOptions = __webpack_require__("./template/components/WelcomeMat/PaymentOptions.js");

var _PaymentOptions2 = _interopRequireDefault(_PaymentOptions);

var _WelcomeMat = __webpack_require__("./template/components/WelcomeMat/WelcomeMat.css");

var _WelcomeMat2 = _interopRequireDefault(_WelcomeMat);

var _context = __webpack_require__("./client/context/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WelcomeMat = function (_PureComponent) {
  (0, _inherits3.default)(WelcomeMat, _PureComponent);

  function WelcomeMat() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, WelcomeMat);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WelcomeMat.__proto__ || (0, _getPrototypeOf2.default)(WelcomeMat)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isClosed: false
    }, _this.close = function () {
      var isCorrectCountry = _this.props.isCorrectCountry;


      if (!isCorrectCountry) {
        (0, _asosSiteChromeStorePresentation.setWelcomeMatClosedForWrongCountry)(true);
      }

      _this.setState({
        isClosed: true
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(WelcomeMat, [{
    key: "shouldRequestWelcomeMatData",
    value: function shouldRequestWelcomeMatData() {
      var isCorrectCountry = this.props.isCorrectCountry;

      var hasCookieForCountry = isCorrectCountry ? _asosSiteChromeStorePresentation.getWelcomeMatClosedForCorrectCountry : _asosSiteChromeStorePresentation.getWelcomeMatClosedForWrongCountry;
      return !hasCookieForCountry();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          requestWelcomeMat = _props.requestWelcomeMat,
          platform = _props.platform;


      if (this.shouldRequestWelcomeMatData()) {
        requestWelcomeMat(platform);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          text = _props2.text,
          redirectUrl = _props2.redirectUrl,
          country = _props2.country,
          messages = _props2.messages,
          paymentOptions = _props2.paymentOptions,
          isCorrectCountry = _props2.isCorrectCountry,
          valueHeader = _props2.valueHeader,
          welcome = _props2.welcome;
      var isClosed = this.state.isClosed;


      if (isClosed || !redirectUrl || !(0, _context.getContext)()) {
        return null;
      }

      if (isCorrectCountry) {
        (0, _asosSiteChromeStorePresentation.setWelcomeMatClosedForCorrectCountry)(true);
      }

      var imageUrl = country.imageUrl,
          imageLabel = country.name;


      return _react2.default.createElement(
        "div",
        { className: _WelcomeMat2.default.container },
        _react2.default.createElement(
          "div",
          { className: _WelcomeMat2.default.containerWrapper },
          _react2.default.createElement(
            "div",
            { className: _WelcomeMat2.default.titleBarWrapper },
            _react2.default.createElement(
              "div",
              { className: _WelcomeMat2.default.titleBar },
              _react2.default.createElement(
                "div",
                { className: _WelcomeMat2.default.title },
                welcome
              ),
              _react2.default.createElement(_IconButton2.default, {
                icon: "close",
                className: _WelcomeMat2.default.closeButton,
                "data-testid": "close-button",
                onClick: this.close
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _WelcomeMat2.default.contentBarWrapper },
            _react2.default.createElement(
              "div",
              { className: _WelcomeMat2.default.contentBar },
              _react2.default.createElement(_Message2.default, {
                text: text,
                redirectUrl: redirectUrl,
                imageUrl: imageUrl,
                imageLabel: imageLabel,
                withCountrySelector: isCorrectCountry,
                targetCountryCode: country.countryCode
              }),
              messages && messages.length > 0 && _react2.default.createElement(_ValueProposition2.default, { messages: messages, header: valueHeader }),
              paymentOptions.length > 0 && _react2.default.createElement(_PaymentOptions2.default, { paymentOptions: paymentOptions })
            )
          )
        )
      );
    }
  }]);
  return WelcomeMat;
}(_react.PureComponent);

exports.default = WelcomeMat;

/***/ }),

/***/ "./template/components/WelcomeMat/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _WelcomeMat = __webpack_require__("./template/components/WelcomeMat/WelcomeMat.js");

var _WelcomeMat2 = _interopRequireDefault(_WelcomeMat);

var _welcomeMat = __webpack_require__("./template/state/modules/welcomeMat/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    text: (0, _welcomeMat.getWelcomeMessage)(state),
    redirectUrl: (0, _welcomeMat.getWelcomeMatRedirectUrl)(state),
    country: (0, _welcomeMat.getWelcomeMatCountry)(state),
    messages: (0, _welcomeMat.getValuePropositionMessages)(state),
    platform: (0, _layout.getPlatform)(state),
    isCorrectCountry: (0, _regionalStore.isCorrectCountry)(state),
    paymentOptions: (0, _welcomeMat.getPaymentOptions)(state),
    valueHeader: (0, _welcomeMat.getValueHeader)(state),
    welcome: (0, _welcomeMat.getWelcomeText)(state)
  };
};

var mapDispatchToProps = {
  requestWelcomeMat: _welcomeMat.requestWelcomeMat
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WelcomeMat2.default);

/***/ }),

/***/ "./template/components/WelcomeMessage/WelcomeMessage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _asosSiteChromeStorePresentation = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/index.js");

var _index = __webpack_require__("./template/components/WelcomeMessage/index.css");

var _index2 = _interopRequireDefault(_index);

var _Icon = __webpack_require__("./template/components/Icon/index.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _urlParse = __webpack_require__("../node_modules/url-parse/index.js");

var _urlParse2 = _interopRequireDefault(_urlParse);

var _context = __webpack_require__("./client/context/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WelcomeMessage = function (_Component) {
  (0, _inherits3.default)(WelcomeMessage, _Component);

  function WelcomeMessage() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, WelcomeMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WelcomeMessage.__proto__ || (0, _getPrototypeOf2.default)(WelcomeMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.close = function () {
      (0, _asosSiteChromeStorePresentation.setWelcomeMessage)(true);
      _this.setState({
        isClosed: true
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(WelcomeMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hasWelcomeMatBeenClosed = (0, _asosSiteChromeStorePresentation.getWelcomeMessage)();
      if (hasWelcomeMatBeenClosed) {
        return;
      }

      return this.props.requestWelcomeMessage(this.props.platform);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          browsingLocalStore = _props.browsingLocalStore,
          redirectUrl = _props.redirectUrl,
          text = _props.text;


      if (this.state.isClosed || !redirectUrl || browsingLocalStore) {
        return null;
      }

      var affid = (0, _context.getContext)().getAffiliateId();
      var url = (0, _urlParse2.default)("//" + redirectUrl.url);

      if (affid) {
        url.query = (0, _extends3.default)({}, url.query, { xaffid: affid });
      }

      url.query = (0, _extends3.default)({}, url.query, {
        r: 1,
        ctaref: "welcome mat",
        browseCountry: this.props.country && this.props.country.countryCode
      });

      var _props$country = this.props.country,
          name = _props$country.name,
          imageUrl = _props$country.imageUrl;


      return _react2.default.createElement(
        "div",
        { className: _index2.default.container, "data-testid": "welcome-message" },
        _react2.default.createElement(
          "div",
          { className: _index2.default.wrapper },
          _react2.default.createElement("img", {
            src: imageUrl,
            alt: name,
            className: _index2.default.flag,
            "data-testid": "icon"
          }),
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "p",
              { className: _index2.default.text, "data-testid": "text" },
              text
            ),
            _react2.default.createElement(
              "a",
              {
                onClick: this.close,
                className: _index2.default.redirectLink,
                href: url.toString(),
                "data-testid": "link"
              },
              redirectUrl.label
            )
          ),
          _react2.default.createElement(
            "button",
            {
              className: _index2.default.closeButton,
              onClick: this.close,
              "data-testid": "close-button"
            },
            _react2.default.createElement(_Icon2.default, { icon: "close" })
          )
        )
      );
    }
  }]);
  return WelcomeMessage;
}(_react.Component);

exports.default = WelcomeMessage;

/***/ }),

/***/ "./template/components/WelcomeMessage/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_21wIL3t","wrapper":"fDaZ3Z4","slideUp":"_2avUdZl","flag":"zTT_AGe","text":"BRd5uim","redirectLink":"_3Mus2JK","closeButton":"_2np3kDs"};

/***/ }),

/***/ "./template/components/WelcomeMessage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _actions = __webpack_require__("./template/state/modules/welcomeMessage/actions.js");

var _WelcomeMessage = __webpack_require__("./template/components/WelcomeMessage/WelcomeMessage.js");

var _WelcomeMessage2 = _interopRequireDefault(_WelcomeMessage);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return (0, _extends3.default)({}, state.welcomeMessage, {
    platform: (0, _layout.getPlatform)(state)
  });
};

var mapDispatchToProps = {
  requestWelcomeMessage: _actions.requestWelcomeMessage
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WelcomeMessage2.default);

/***/ }),

/***/ "./template/components/WelcomeWrapper/WelcomeWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _WelcomeMat = __webpack_require__("./template/components/WelcomeMat/index.js");

var _WelcomeMat2 = _interopRequireDefault(_WelcomeMat);

var _WelcomeMessage = __webpack_require__("./template/components/WelcomeMessage/index.js");

var _WelcomeMessage2 = _interopRequireDefault(_WelcomeMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WelcomeWrapper = function WelcomeWrapper(_ref) {
  var useWelcomeMat = _ref.useWelcomeMat;

  return useWelcomeMat ? _react2.default.createElement(_WelcomeMat2.default, null) : _react2.default.createElement(_WelcomeMessage2.default, null);
};

exports.default = WelcomeWrapper;

/***/ }),

/***/ "./template/components/WelcomeWrapper/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _WelcomeWrapper = __webpack_require__("./template/components/WelcomeWrapper/WelcomeWrapper.js");

var _WelcomeWrapper2 = _interopRequireDefault(_WelcomeWrapper);

var _features = __webpack_require__("./template/state/modules/features/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    useWelcomeMat: !!(0, _features.isFeatureActive)(state, "stc-welcome-mat-changes")
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_WelcomeWrapper2.default);

/***/ }),

/***/ "./template/components/Widgets/Widget/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2F9qY-C","container__hidden":"_2X1h55w","myAccountWidget":"_46ucpdl"};

/***/ }),

/***/ "./template/components/Widgets/Widget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("../node_modules/classnames/bind.js");

var _bind2 = _interopRequireDefault(_bind);

var _withViewport = __webpack_require__("./template/components/Viewport/withViewport.js");

var _withViewport2 = _interopRequireDefault(_withViewport);

var _index = __webpack_require__("./template/components/Widgets/Widget/index.css");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_index2.default);

var Widget = function Widget(_ref) {
  var style = _ref.style,
      children = _ref.children,
      isVisible = _ref.isVisible,
      className = _ref.className;
  return _react2.default.createElement(
    "li",
    {
      style: style,
      className: cx(_index2.default.container, className, (0, _defineProperty3.default)({}, _index2.default.container__hidden, !isVisible))
    },
    children
  );
};

exports.default = (0, _withViewport2.default)(Widget);

/***/ }),

/***/ "./template/components/Widgets/Widgets.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1OLInBo","widgetButton":"wN7TsRy","noOfBagItems":"_1EbtfBz","bounce-minibag":"_26mzG9J"};

/***/ }),

/***/ "./template/components/Widgets/Widgets.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _CSSTransition = __webpack_require__("../node_modules/react-transition-group/CSSTransition.js");

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _IconButton = __webpack_require__("./template/components/IconButton/index.js");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _IconNotification = __webpack_require__("./template/components/IconNotification/index.js");

var _IconNotification2 = _interopRequireDefault(_IconNotification);

var _Widget = __webpack_require__("./template/components/Widgets/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _Widgets = __webpack_require__("./template/components/Widgets/Widgets.css");

var _Widgets2 = _interopRequireDefault(_Widgets);

var _Dropdown = __webpack_require__("./template/components/Dropdown/index.js");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Greeter = __webpack_require__("./template/components/Greeter/index.js");

var _Greeter2 = _interopRequireDefault(_Greeter);

var _MyAccountLinks = __webpack_require__("./template/components/MyAccountLinks/index.js");

var _MyAccountLinks2 = _interopRequireDefault(_MyAccountLinks);

var _MiniBag = __webpack_require__("./template/components/MiniBag/index.js");

var _MiniBag2 = _interopRequireDefault(_MiniBag);

var _Header = __webpack_require__("./template/components/MiniBag/Header/index.js");

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__("./template/components/MiniBag/Footer/index.js");

var _Footer2 = _interopRequireDefault(_Footer);

var _translation = __webpack_require__("./template/components/translation/index.js");

var _translation2 = _interopRequireDefault(_translation);

var _index = __webpack_require__("./template/components/Widgets/Widget/index.css");

var _index2 = _interopRequireDefault(_index);

var _externalLinks = __webpack_require__("./template/helpers/externalLinks.js");

var _queryString = __webpack_require__("./helpers/queryString.js");

var _dropdown = __webpack_require__("./template/state/modules/dropdown/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackingQuery = "?nlid=nav header";

var ENTER_KEY = 13;
var keyCode = function keyCode(e) {
  return e.keyCode || e.which;
};

var Widgets = function (_Component) {
  (0, _inherits3.default)(Widgets, _Component);

  function Widgets() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Widgets);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Widgets.__proto__ || (0, _getPrototypeOf2.default)(Widgets)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isBagIconAnimating: false,
      isBagPage: false
    }, _this.componentDidMount = function () {
      var _this$props = _this.props,
          getSavedItemsFromSDK = _this$props.getSavedItemsFromSDK,
          formatTranslation = _this$props.formatTranslation;

      getSavedItemsFromSDK();
      _this.setState({
        isBagPage: window.location.pathname.indexOf("/" + formatTranslation("Bag.Link")) > -1
      });
    }, _this.componentWillReceiveProps = function (nextProps) {
      if (nextProps.isUpdated && nextProps.noOfBagItems > _this.props.noOfBagItems) {
        _this.toggleAnimation();
      }
    }, _this.handleSearch = function () {
      var openSearch = _this.props.openSearch;

      openSearch();
    }, _this.toggleAnimation = function () {
      _this.setState(function (state) {
        return {
          isBagIconAnimating: !state.isBagIconAnimating
        };
      });
    }, _this.searchWidget = function () {
      return _react2.default.createElement(
        _Widget2.default,
        { viewable: [_layout.SMALL_VIEWPORT] },
        _react2.default.createElement(_IconButton2.default, {
          type: "label",
          htmlFor: "chrome-search",
          icon: "search",
          onClick: _this.handleSearch,
          "data-testid": "searchIcon",
          className: _Widgets2.default.widgetButton,
          "aria-label": _this.props.formatTranslation("Icon.Search")
        })
      );
    }, _this.accountWidget = function () {
      var viewport = _this.props.viewport;


      var iconName = _this.props.isLoggedIn ? "accountFilled" : "accountUnfilled";

      if (viewport !== _layout.SMALL_VIEWPORT) {
        return _react2.default.createElement(
          _Widget2.default,
          { className: _index2.default.myAccountWidget },
          _react2.default.createElement(
            _Dropdown2.default,
            {
              name: _dropdown.MY_ACCOUNT,
              header: _react2.default.createElement(_Greeter2.default, null),
              body: _react2.default.createElement(_MyAccountLinks2.default, null),
              footer: null
            },
            _react2.default.createElement(_IconButton2.default, {
              type: "button",
              icon: iconName,
              "data-testid": "accountIcon",
              className: _Widgets2.default.widgetButton,
              "aria-label": _this.props.formatTranslation("Icon.MyAccount")
            }),
            _this.props.isReconsentRequired ? _react2.default.createElement(_IconNotification2.default, { "data-testid": "gdpr-icon-notification" }) : null
          )
        );
      } else {
        var _this$props2 = _this.props,
            countryCode = _this$props2.countryCode,
            lang = _this$props2.lang,
            keyStoreDataversion = _this$props2.keyStoreDataversion,
            storeCode = _this$props2.storeCode;


        var params = {
          lang: lang,
          store: storeCode,
          country: countryCode,
          keyStoreDataversion: keyStoreDataversion,
          nlid: "nav header"
        };

        var href = (0, _queryString.withParams)((0, _externalLinks.getMyAccountBaseUrl)(), params);

        return _react2.default.createElement(
          _Widget2.default,
          { className: _index2.default.myAccountWidget },
          _react2.default.createElement(
            _IconButton2.default,
            {
              type: "a",
              href: href,
              icon: iconName,
              "data-testid": "accountIcon",
              className: _Widgets2.default.widgetButton,
              "aria-label": _this.props.formatTranslation("Icon.MyAccount")
            },
            _this.props.isReconsentRequired ? _react2.default.createElement(_IconNotification2.default, { "data-testid": "gdpr-icon-notification" }) : null
          )
        );
      }
    }, _this.bagWidget = function () {
      var _this$props3 = _this.props,
          viewport = _this$props3.viewport,
          noOfBagItems = _this$props3.noOfBagItems,
          defaultStoreUrl = _this$props3.defaultStoreUrl,
          miniBagToggle = _this$props3.miniBagToggle;
      var isBagPage = _this.state.isBagPage;

      var bagIconName = noOfBagItems ? "bagFilled" : "bagUnfilled";

      var bagUrl = defaultStoreUrl.concat(_this.props.formatTranslation("Bag.Link"), trackingQuery);

      var bagIcon = function bagIcon() {
        var hasDropdown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return _react2.default.createElement(
          _IconButton2.default,
          {
            type: "a",
            href: bagUrl,
            onClick: function onClick(e) {
              return hasDropdown && e.preventDefault();
            },
            onKeyDown: function onKeyDown(e) {
              if (keyCode(e) === ENTER_KEY) {
                window.location.assign(bagUrl);
                e.preventDefault();
              }
            },
            icon: bagIconName,
            "data-testid": "bagIcon",
            className: _Widgets2.default.widgetButton,
            "aria-label": _this.props.formatTranslation("Icon.Bag")
          },
          noOfBagItems && _react2.default.createElement(
            "span",
            { className: _Widgets2.default.noOfBagItems },
            noOfBagItems
          )
        );
      };

      return _react2.default.createElement(
        _Widget2.default,
        null,
        !isBagPage && viewport !== _layout.SMALL_VIEWPORT && miniBagToggle && noOfBagItems ? _react2.default.createElement(
          _Dropdown2.default,
          {
            name: _dropdown.MINIBAG,
            header: _react2.default.createElement(_Header2.default, null),
            body: _react2.default.createElement(_MiniBag2.default, null),
            footer: _react2.default.createElement(_Footer2.default, null)
          },
          bagIcon(true)
        ) : _react2.default.createElement(
          _CSSTransition2.default,
          {
            "in": _this.state.isBagIconAnimating,
            timeout: 1000,
            classNames: "bounce",
            onEntered: _this.toggleAnimation
          },
          bagIcon()
        )
      );
    }, _this.savedItemsWidget = function () {
      return _react2.default.createElement(
        _Widget2.default,
        null,
        _react2.default.createElement(_IconButton2.default, {
          type: "a",
          href: _this.props.defaultStoreUrl.concat(_this.props.formatTranslation("SavedItems.Link"), trackingQuery),
          icon: _this.props.prideToggle ? "heartPrideFilled" : _this.props.hasSavedItems ? "heartFilled" : "heartUnfilled",
          "data-testid": "savedItemsIcon",
          className: _Widgets2.default.widgetButton,
          "aria-label": _this.props.formatTranslation("Icon.SavedItems")
        })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Widgets, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "ul",
        { className: _Widgets2.default.container, "data-testid": "widgets" },
        this.searchWidget(),
        this.accountWidget(),
        this.savedItemsWidget(),
        this.bagWidget()
      );
    }
  }]);
  return Widgets;
}(_react.Component);

exports.default = (0, _translation2.default)(Widgets);

/***/ }),

/***/ "./template/components/Widgets/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _Widgets = __webpack_require__("./template/components/Widgets/Widgets.js");

var _Widgets2 = _interopRequireDefault(_Widgets);

var _search = __webpack_require__("./template/state/modules/search/index.js");

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

var _user = __webpack_require__("./template/state/modules/user/index.js");

var _savedItems = __webpack_require__("./template/state/modules/savedItems/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _features = __webpack_require__("./template/state/modules/features/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    openSearch: _search.openSearch,
    getSavedItemsFromSDK: _savedItems.getSavedItemsFromSDK
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    isLoggedIn: (0, _user.isLoggedIn)(state),
    hasSavedItems: (0, _savedItems.hasSavedItems)(state),
    noOfBagItems: (0, _bag.getTotalQuantity)(state),
    storeCode: (0, _regionalStore.getStoreCode)(state),
    lang: (0, _regionalStore.getDefaultLanguage)(state),
    countryCode: (0, _regionalStore.getCountryCode)(state),
    keyStoreDataversion: (0, _regionalStore.getKeyStoreDataversion)(state),
    defaultStoreUrl: (0, _regionalStore.getDefaultStoreUrl)(state),
    isUpdated: (0, _bag.getUpdated)(state),
    isReconsentRequired: (0, _user.getIsReconsentRequired)(state),
    viewport: (0, _layout.getViewport)(state),
    miniBagToggle: (0, _features.isFeatureActive)(state, "stc-minibag-dropdown"),
    prideToggle: (0, _features.isFeatureActive)(state, "stc-pride-heart")
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Widgets2.default);

/***/ }),

/***/ "./template/components/translation/addLanguage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLanguage = undefined;

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var mapStateToProps = function mapStateToProps(state) {
  return { language: (0, _regionalStore.getDefaultLanguage)(state) };
};

var addLanguage = exports.addLanguage = function addLanguage(Component) {
  return (0, _reactRedux.connect)(mapStateToProps)(Component);
};

/***/ }),

/***/ "./template/components/translation/buildTranslationFormatter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTranslationFormatter = undefined;

var _stringify = __webpack_require__("../node_modules/babel-runtime/core-js/json/stringify.js");

var _stringify2 = _interopRequireDefault(_stringify);

var _nodePolyglot = __webpack_require__("../node_modules/node-polyglot/index.js");

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _i18n = __webpack_require__("../i18n/index.js");

var _i18n2 = _interopRequireDefault(_i18n);

var _utilities = __webpack_require__("../i18n/utilities/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildTranslationFormatter = exports.buildTranslationFormatter = function buildTranslationFormatter(language) {
  var locale = (0, _utilities.getLanguage)(language);
  var phrases = (0, _i18n2.default)(language);

  var polyglot = new _nodePolyglot2.default({
    locale: locale,
    phrases: phrases,
    onMissingKey: function onMissingKey(key, args, language) {
      throw new Error("No translations for \"" + key + "\" with arguments " + (0, _stringify2.default)(args) + " in " + language + " locale.");
    }
  });

  return function () {
    return polyglot.t.apply(polyglot, arguments);
  };
};

/***/ }),

/***/ "./template/components/translation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _addLanguage = __webpack_require__("./template/components/translation/addLanguage.js");

var _buildTranslationFormatter = __webpack_require__("./template/components/translation/buildTranslationFormatter.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withTranslation = function withTranslation(Component) {
  var ComposedComponent = function ComposedComponent(_ref) {
    var language = _ref.language,
        props = (0, _objectWithoutProperties3.default)(_ref, ["language"]);
    return _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
      formatTranslation: (0, _buildTranslationFormatter.buildTranslationFormatter)(language)
    }));
  };

  ComposedComponent.displayName = "withTranslation(" + (Component.displayName || Component.name || "Component") + ")";
  ComposedComponent.WrappedComponent = Component;
  ComposedComponent.initActions = Component.initActions;

  return (0, _addLanguage.addLanguage)(ComposedComponent);
};

exports.default = withTranslation;

/***/ }),

/***/ "./template/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExternalScripts = exports.clientEnvPrefix = exports.sdkPublicWindow = exports.siteChromeClientConfig = exports.RECENT_SEARCHES_KEY = exports.siteChromeTokenValues = exports.siteChromeInitialStore = exports.manifestWindowKey = exports.siteChromePublicWindowApi = undefined;

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteChromePublicWindowApi = exports.siteChromePublicWindowApi = "__siteChrome";
var manifestWindowKey = exports.manifestWindowKey = "__versionManifest";
var siteChromeInitialStore = exports.siteChromeInitialStore = "__siteChromeInitialStore";
var siteChromeTokenValues = exports.siteChromeTokenValues = "__siteChromeTokenValues";
var RECENT_SEARCHES_KEY = exports.RECENT_SEARCHES_KEY = "__asosRecentSearches";
var siteChromeClientConfig = exports.siteChromeClientConfig = "__chromeConfig";
var sdkPublicWindow = exports.sdkPublicWindow = "__sdk";
var clientEnvPrefix = exports.clientEnvPrefix = "CLIENT_";
var getExternalScripts = exports.getExternalScripts = function getExternalScripts() {
  return [_clientConfig2.default.get().WEB_ANALYTICS_URL];
};

/***/ }),

/***/ "./template/globalEventHandler.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeSearchOverlay = exports.focusFloorNavigationFor = exports.focusPrimaryNavigationFor = exports.keys = exports.events = undefined;

var _fbemitter = __webpack_require__("../node_modules/fbemitter/index.js");

var globalEventHandler = new _fbemitter.EventEmitter();

var events = exports.events = {
  focusFirstPrimaryNavigationItem: "focusFirstPrimaryNavigationItem",
  closeSearchOverlay: "closeSearchOverlay",
  focusBackToFloor: "focusBackToFloor",
  keyDown: "keydown",
  click: "click",
  scroll: "scroll",
  resize: "resize"
};

var keys = exports.keys = {
  tab: "Tab",
  escape: "Escape"
};

var normaliseKey = function normaliseKey(event) {
  if (event.key) {
    return event.key;
  }

  switch (event.which) {
    case 9:
      return keys.tab;
    case 27:
      return keys.escape;
  }
};

typeof window !== "undefined" && window.addEventListener(events.keyDown, function (event) {
  return globalEventHandler.emit(events.keyDown, {
    key: normaliseKey(event),
    originalEvent: event
  });
});

typeof window !== "undefined" && window.addEventListener(events.click, function (event) {
  return globalEventHandler.emit(events.click, event);
});

typeof window !== "undefined" && window.addEventListener(events.scroll, function () {
  return globalEventHandler.emit(events.scroll);
});

typeof window !== "undefined" && window.addEventListener(events.resize, function () {
  return globalEventHandler.emit(events.resize);
});

exports.default = globalEventHandler;
var focusPrimaryNavigationFor = exports.focusPrimaryNavigationFor = function focusPrimaryNavigationFor(gender) {
  return globalEventHandler.emit(events.focusFirstPrimaryNavigationItem, gender);
};

var focusFloorNavigationFor = exports.focusFloorNavigationFor = function focusFloorNavigationFor(gender) {
  return globalEventHandler.emit(events.focusBackToFloor, gender);
};

var closeSearchOverlay = exports.closeSearchOverlay = function closeSearchOverlay() {
  return globalEventHandler.emit(events.closeSearchOverlay);
};

/***/ }),

/***/ "./template/helpers/addAnalyticsDataToLink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAnalyticsDataToLink = undefined;

var _slicedToArray2 = __webpack_require__("../node_modules/babel-runtime/helpers/slicedToArray.js");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prep = function prep(string) {
  return encodeURIComponent(string.toLowerCase()).replace(/%20/g, "+");
};

var addQuerystringSuffix = function addQuerystringSuffix(link) {
  return link.indexOf("?") !== -1 ? link + "&" : link + "?";
};

var addAnalyticsDataToLink = exports.addAnalyticsDataToLink = function addAnalyticsDataToLink(_ref) {
  var link = _ref.link,
      gender = _ref.gender,
      labelPath = _ref.labelPath;

  if (!link) {
    return null;
  }

  if (!gender) {
    return link;
  }

  if (labelPath.length === 6) {
    var _labelPath = (0, _slicedToArray3.default)(labelPath, 5),
        section = _labelPath[3],
        container = _labelPath[4];

    if (section && container) {
      return addQuerystringSuffix(link) + "nlid=" + prep(gender) + "|" + prep(section) + "|" + prep(container);
    }
  }

  if (labelPath.length === 4) {
    var _labelPath2 = (0, _slicedToArray3.default)(labelPath, 3),
        _section = _labelPath2[2];

    if (_section) {
      return addQuerystringSuffix(link) + "nlid=" + prep(gender) + "|" + prep(_section);
    }
  }

  return link;
};

/***/ }),

/***/ "./template/helpers/externalLinks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIdentitySdkAuthHost = exports.getMyAccountBaseUrl = exports.getMarketplaceUrl = undefined;

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMarketplaceUrl = exports.getMarketplaceUrl = function getMarketplaceUrl() {
  return _clientConfig2.default.get().MARKETPLACE_URL;
};
var getMyAccountBaseUrl = exports.getMyAccountBaseUrl = function getMyAccountBaseUrl() {
  return _clientConfig2.default.get().MY_ACCOUNT_BASE_URL;
};
var getIdentitySdkAuthHost = exports.getIdentitySdkAuthHost = function getIdentitySdkAuthHost() {
  return _clientConfig2.default.get().IDENTITY_SDK_AUTH_HOST;
};

/***/ }),

/***/ "./template/helpers/navigationBackgroundImageResolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBackgroundImageUrl = undefined;

var _urlParse = __webpack_require__("../node_modules/url-parse/index.js");

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBackgroundImageUrl = exports.getBackgroundImageUrl = function getBackgroundImageUrl(imageUrl, width) {
  if (!imageUrl) {
    return "";
  }

  var backgroundImageUrl = (0, _urlParse2.default)(imageUrl);

  if (width) {
    backgroundImageUrl.query += "&$n_" + width + "w$";
  }

  return backgroundImageUrl.toString();
};

/***/ }),

/***/ "./template/helpers/navigationLinkResolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveLink = undefined;

var _uaParserJs = __webpack_require__("../node_modules/ua-parser-js/src/ua-parser.js");

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolveLink = exports.resolveLink = function resolveLink(href, alias) {
  if (alias === "app_download" && typeof navigator !== "undefined") {
    var agent = (0, _uaParserJs2.default)(navigator.userAgent);
    var os = agent ? agent.os.name.toLowerCase() : "";
    switch (os) {
      case "android":
        return _clientConfig2.default.get().APP_DOWNLOAD_PLAY_STORE_URI;
      case "ios":
        return _clientConfig2.default.get().APP_DOWNLOAD_APP_STORE_URI;
    }
  }
  return href;
};

/***/ }),

/***/ "./template/helpers/navigationTemplatesResolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDesktopTemplate = exports.getMobileTemplate = undefined;

var _isInteger = __webpack_require__("../node_modules/babel-runtime/core-js/number/is-integer.js");

var _isInteger2 = _interopRequireDefault(_isInteger);

var _CircleImageRightItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.js");

var _CircleImageRightItem2 = _interopRequireDefault(_CircleImageRightItem);

var _CircleImageLeftItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.js");

var _CircleImageLeftItem2 = _interopRequireDefault(_CircleImageLeftItem);

var _InspirationItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/InspirationItem/index.js");

var _InspirationItem2 = _interopRequireDefault(_InspirationItem);

var _MenuItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/MenuItem/index.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _SquareItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/SquareItem/index.js");

var _SquareItem2 = _interopRequireDefault(_SquareItem);

var _FlatItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/FlatItem/index.js");

var _FlatItem2 = _interopRequireDefault(_FlatItem);

var _TextList = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/TextList/index.js");

var _TextList2 = _interopRequireDefault(_TextList);

var _MarketingImage = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.js");

var _MarketingImage2 = _interopRequireDefault(_MarketingImage);

var _CircleImageList = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.js");

var _CircleImageList2 = _interopRequireDefault(_CircleImageList);

var _GridCircleImage = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.js");

var _GridCircleImage2 = _interopRequireDefault(_GridCircleImage);

var _ImageCardsWithDescription = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.js");

var _ImageCardsWithDescription2 = _interopRequireDefault(_ImageCardsWithDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOBILE_TEMPLATES = {
  1: _MenuItem2.default,
  2: _CircleImageRightItem2.default,
  3: _CircleImageLeftItem2.default,
  4: _InspirationItem2.default,
  6: _SquareItem2.default,
  7: _FlatItem2.default
};

var DESKTOP_TEMPLATES = {
  1: _TextList2.default,
  2: _MarketingImage2.default,
  3: _MarketingImage2.default,
  4: _MarketingImage2.default,
  5: _CircleImageList2.default,
  6: _GridCircleImage2.default,
  7: _ImageCardsWithDescription2.default
};

var getTemplate = function getTemplate(collection, defaultIndex) {
  return function (index) {
    if (!(0, _isInteger2.default)(index)) {
      console.warn("no navigation template index to resolve");
    }

    return collection[index] || collection[defaultIndex];
  };
};

var getMobileTemplate = exports.getMobileTemplate = getTemplate(MOBILE_TEMPLATES, 3);
var getDesktopTemplate = exports.getDesktopTemplate = getTemplate(DESKTOP_TEMPLATES, 1);

/***/ }),

/***/ "./template/helpers/pageInfoProvider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SITE_SECTIONS = {
  bag: "bag",
  category: "category",
  creative: "creative",
  homepage: "homepage",
  product: "product",
  savedItems: "saved-items",
  search: "search"
};

var getPageInfo = exports.getPageInfo = function getPageInfo() {
  var page = {
    section: "",
    gender: ""
  };
  if (typeof window !== "undefined" && window.location && window.location.pathname) {
    var path = window.location.pathname.toLowerCase().replace(/\/$/, "");
    if (path === "" || path === "/fr" || path === "/it" || path === "/de" || path === "/us" || path === "/au" || path === "/es" || path === "/ru") {
      page.section = SITE_SECTIONS.homepage;
    } else if (path.search(/\/search\//) > -1) {
      page.section = SITE_SECTIONS.search;
    } else if (path.match(/\/cat$/)) {
      page.section = SITE_SECTIONS.category;
    } else if (path.match(/\/prd\/[0-9]+$/) || path.match(/\/grp\/[0-9]+$/)) {
      page.section = SITE_SECTIONS.product;
    } else if (path.match(/\/women$/) || path.match(/\/donna$/) || path.match(/\/mujer$/) || path.match(/\/damen$/) || path.match(/\/femme$/)) {
      page.section = SITE_SECTIONS.homepage;
      page.gender = "women";
    } else if (path.match(/\/men$/) || path.match(/\/uomo$/) || path.match(/\/hombre$/) || path.match(/\/herren$/) || path.match(/\/homme$/)) {
      page.section = SITE_SECTIONS.homepage;
      page.gender = "men";
    } else if (path.match(/\/saved-items$/)) {
      page.section = SITE_SECTIONS.savedItems;
    } else if (path.match(/\/bag$/)) {
      page.section = SITE_SECTIONS.bag;
    } else {
      page.section = SITE_SECTIONS.creative;
    }
  }
  return page;
};

/***/ }),

/***/ "./template/helpers/removeProtocolFromUrl.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeProtocolFromUrl;
function removeProtocolFromUrl(string) {
  return string.replace(/(^\w+:|^)/, "");
}

/***/ }),

/***/ "./template/helpers/searchTermCleanser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = searchTermCleanser;
function searchTermCleanser(string) {
  return string.toLowerCase().trim().replace(/<\/?[^>]+(>|$)|\t/g, "");
}

/***/ }),

/***/ "./template/state/enhancers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reduxPersist = __webpack_require__("../node_modules/redux-persist/es/index.js");

var _reduxDevtoolsExtension = __webpack_require__("../node_modules/redux-devtools-extension/index.js");

var _bag = __webpack_require__("./template/state/middleware/bag/index.js");

var _bag2 = _interopRequireDefault(_bag);

var _actionDeferral = __webpack_require__("./template/state/middleware/actionDeferral/index.js");

var _actionDeferral2 = _interopRequireDefault(_actionDeferral);

var _reduxThunk = __webpack_require__("../node_modules/redux-thunk/lib/index.js");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _api = __webpack_require__("./api/index.js");

var api = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _reduxDevtoolsExtension.composeWithDevTools)((0, _redux.applyMiddleware)(_actionDeferral2.default, //must go first!
  _reduxThunk2.default.withExtraArgument({
    api: api,
    get identity() {
      return window.__sdk.identity;
    }
  }), _bag2.default), (0, _reduxPersist.autoRehydrate)());
};

/***/ }),

/***/ "./template/state/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _enhancers = __webpack_require__("./template/state/enhancers.js");

var _enhancers2 = _interopRequireDefault(_enhancers);

var _modules = __webpack_require__("./template/state/modules/index.js");

var _modules2 = _interopRequireDefault(_modules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var composedEnhancers = (0, _enhancers2.default)();

exports.default = function (preloadedState) {
  return (0, _redux.createStore)(_modules2.default, preloadedState, composedEnhancers);
};

/***/ }),

/***/ "./template/state/middleware/actionDeferral/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFER_ACTIONS = undefined;

var _slicedToArray2 = __webpack_require__("../node_modules/babel-runtime/helpers/slicedToArray.js");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__("../node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = __webpack_require__("../node_modules/babel-runtime/core-js/map.js");

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFER_ACTIONS = exports.DEFER_ACTIONS = "DEFER_ACTIONS";

/*
For example...

const actions = {
  BAG_ITEM_DELETE_TRANSITION_END: [{},{},{}]
}

const types = {
  OPEN_DROPDOWN: BAG_ITEM_DELETE_TRANSITION_END,
  CLOSE_DROPDOWN: BAG_ITEM_DELETE_TRANSITION_END
}

const cancel = {
  BAG_ERROR: BAG_ITEM_DELETE_TRANSITION_END
}
*/

var actionDeferralMiddleware = function actionDeferralMiddleware() {
  var actions = new _map2.default();
  var types = new _map2.default();
  var cancel = new _map2.default();

  var clear = function clear(actionType) {
    actions.delete(actionType);

    [].concat((0, _toConsumableArray3.default)(types)).filter(function (_ref) {
      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
          type = _ref2[1];

      return type === actionType;
    }).forEach(function (_ref3) {
      var _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
          key = _ref4[0];

      return types.delete(key);
    });

    [].concat((0, _toConsumableArray3.default)(cancel)).filter(function (_ref5) {
      var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
          type = _ref6[1];

      return type === actionType;
    }).forEach(function (_ref7) {
      var _ref8 = (0, _slicedToArray3.default)(_ref7, 1),
          key = _ref8[0];

      return cancel.delete(key);
    });
  };

  return function (next) {
    return function (action) {
      if (action.type === DEFER_ACTIONS) {
        var _action$payload = action.payload,
            actionsToDefer = _action$payload.actionsToDefer,
            _actionToWaitFor = _action$payload.actionToWaitFor,
            _action$payload$actio = _action$payload.actionsToCancelOn,
            actionsToCancelOn = _action$payload$actio === undefined ? [] : _action$payload$actio;


        actions.set(_actionToWaitFor, []);

        actionsToDefer.forEach(function (type) {
          types.set(type, _actionToWaitFor);
        });

        actionsToCancelOn.forEach(function (type) {
          cancel.set(type, _actionToWaitFor);
        });

        return next(action);
      }

      var cancelled = cancel.get(action.type);

      if (cancelled) {
        clear(cancelled);
      }

      var actionToWaitFor = types.get(action.type);

      if (actionToWaitFor) {
        var _deferredActions = actions.get(actionToWaitFor).concat(action);

        actions.set(actionToWaitFor, _deferredActions);

        return next({ type: null });
      }

      var deferredActions = actions.get(action.type);

      if (deferredActions) {
        deferredActions.forEach(function (action) {
          return next(action);
        });
        clear(action.type);
      }

      return next(action);
    };
  };
};

exports.default = actionDeferralMiddleware;

/***/ }),

/***/ "./template/state/middleware/bag/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _bag = __webpack_require__("./client/sdk/bag.js");

var _bag2 = __webpack_require__("./template/state/modules/bag/index.js");

var _dropdown = __webpack_require__("./template/state/modules/dropdown/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _features = __webpack_require__("./template/state/modules/features/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _queryString = __webpack_require__("./helpers/queryString.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var miniBagEnabled = function miniBagEnabled(state) {
  return (0, _features.isFeatureActive)(state, "stc-minibag-dropdown") && (0, _layout.getViewport)(state) !== _layout.SMALL_VIEWPORT;
};

var withProductLink = function withProductLink(defaultStoreUrl) {
  return function (item) {
    return item.variantId ? (0, _extends3.default)({}, item, { productUrl: defaultStoreUrl + "prd/" + item.variantId }) : item;
  };
};

var bagWithProductLinks = function bagWithProductLinks(bag, getState) {
  var state = getState();
  var defaultStoreUrl = (0, _regionalStore.getDefaultStoreUrl)(state);
  return (0, _extends3.default)({}, bag, {
    items: bag.items.map(withProductLink(defaultStoreUrl))
  });
};

var closeMinibagTimerId = void 0;

var bagMiddleware = function bagMiddleware(_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;

  (0, _bag.getBagSummary)().then(function (summary) {
    return dispatch({
      type: _bag2.SET_BAG,
      payload: { bag: { summary: summary } }
    });
  });

  (0, _bag.subscribeToUpdates)(function (_ref2) {
    var bag = _ref2.bag,
        messages = _ref2.messages;

    var state = getState();
    var current = (0, _bag2.getBagItems)(state) || [];
    var next = (0, _bag2.getBagItems)({ bag: bag });
    var removed = current.filter(function (_ref3) {
      var id = _ref3.id;
      return !next.find(function (item) {
        return item.id === id;
      });
    });
    var miniBagIsEnabled = miniBagEnabled(state);

    if (miniBagIsEnabled && removed.length) {
      var items = current.map(function (item) {
        return removed.find(function (_ref4) {
          var id = _ref4.id;
          return id === item.id;
        }) ? (0, _extends3.default)({}, item, { transition: "exiting" }) : item;
      });

      dispatch({
        type: _bag2.SET_BAG,
        payload: {
          bag: (0, _extends3.default)({}, bagWithProductLinks((0, _extends3.default)({}, state.bag, { items: items }), getState), {
            incoming: bag,
            isUpdated: true
          }),
          messages: messages
        }
      });

      return;
    }

    dispatch({
      type: _bag2.SET_BAG,
      payload: {
        bag: (0, _extends3.default)({}, bagWithProductLinks(bag, getState), {
          isUpdated: true
        }),
        messages: messages
      }
    });

    if (!miniBagIsEnabled) {
      return;
    }

    var oldQuantity = (0, _bag2.getTotalQuantity)(state);
    var newQuantity = (0, _bag2.getTotalQuantity)({ bag: bag });

    if (newQuantity > oldQuantity) {
      dispatch({
        type: _dropdown.OPEN_DROPDOWN,
        name: _dropdown.MINIBAG,
        programmatic: true
      });

      dispatch({
        type: _bag2.SHOW_RESERVATION_MESSAGE
      });

      clearTimeout(closeMinibagTimerId);

      closeMinibagTimerId = setTimeout(function () {
        var state = getState();

        var isProgrammatic = (0, _dropdown.getDropdownProgrammatic)(state, {
          name: _dropdown.MINIBAG
        });

        if (isProgrammatic) {
          dispatch({
            type: _dropdown.CLOSE_DROPDOWN,
            name: _dropdown.MINIBAG,
            programmatic: true
          });
        }
      }, 3000);
    }
  });

  return function (next) {
    return function (action) {
      var state = getState();

      if (!miniBagEnabled(state)) {
        return next(action);
      }

      if (action.type === _bag2.START_REMOVE_BAG_ITEM) {
        dispatch({
          type: "DEFER_ACTIONS",
          payload: {
            actionsToDefer: [_dropdown.OPEN_DROPDOWN, _dropdown.CLOSE_DROPDOWN],
            actionToWaitFor: _bag2.BAG_ITEM_DELETE_TRANSITION_END,
            actionsToCancelOn: [_bag2.BAG_ERROR]
          }
        });
      }

      if (action.type === _bag2.START_REMOVE_BAG_ITEM) {
        var items = (0, _bag2.getBagItems)(state);
        var item = items.find(function (_ref5) {
          var id = _ref5.id;
          return id === action.item;
        });

        (0, _bag.removeItem)(item.id, item.itemType.toLowerCase()).then(function () {
          return dispatch({ type: _bag2.FINISH_REMOVE_BAG_ITEM, itemId: action.item });
        }).catch(function () {
          return dispatch({ type: _bag2.BAG_ERROR });
        });
      }

      if (action.type === _dropdown.OPEN_DROPDOWN && action.name === _dropdown.MINIBAG && !action.programmatic) {
        var miniBagDropdownIsOpen = (0, _dropdown.getDropdownIsOpen)(state, { name: _dropdown.MINIBAG });

        if (!miniBagDropdownIsOpen) {
          dispatch({ type: _bag2.SET_LOADING });
          (0, _bag.getBag)().then(function (_ref6) {
            var bag = _ref6.bag,
                messages = _ref6.messages;
            return dispatch({
              type: _bag2.SET_BAG,
              payload: {
                bag: bagWithProductLinks(bag, getState),
                messages: messages
              }
            });
          }).catch(function () {
            return dispatch({ type: _bag2.BAG_ERROR });
          });
        }
      }

      if (action.type === _dropdown.DROPDOWN_CLOSED && action.name === _dropdown.MINIBAG) {
        dispatch({
          type: _bag2.HIDE_RESERVATION_MESSAGE
        });

        /* if the dropdown closed after the last item was removed then we still need to update state with the latest items... */
        var incoming = state.bag.incoming;

        if (incoming && incoming.items.length === 0) {
          dispatch({
            type: _bag2.SET_BAG,
            payload: {
              bag: bagWithProductLinks((0, _extends3.default)({}, incoming, { incoming: undefined }), getState)
            }
          });
        }
      }

      if (action.type === _bag2.BAG_ITEM_DELETE_TRANSITION_END && action.itemId === state.bag.lastItemRemoved) {
        var _incoming = state.bag.incoming;
        var _items = (0, _bag2.getBagItems)({ bag: _incoming });
        /*
          If the user has deleted the last item in the minibag, then close the bag before updating state so that the dropdown doesn't just vanish.
        */

        if (_items.length === 0) {
          dispatch({
            type: _dropdown.CLOSE_DROPDOWN,
            name: _dropdown.MINIBAG
          });
        } else {
          dispatch({
            type: _bag2.SET_BAG,
            payload: {
              bag: bagWithProductLinks((0, _extends3.default)({}, _incoming, { incoming: undefined }), getState)
            }
          });
        }
      }

      if (action.type === _bag2.START_CHECKOUT) {
        var _state = getState();
        var checkoutLink = (0, _regionalStore.getSecureStoreUrl)(_state);

        (0, _bag.startCheckout)().then(function () {
          var checkoutUrl = checkoutLink + "initialise";
          window.location.replace((0, _queryString.withParams)(checkoutUrl, { ctaref: "mini bag" }));
        }).catch(console.err);
      }

      return next(action);
    };
  };
};

exports.default = bagMiddleware;

/***/ }),

/***/ "./template/state/modules/analytics/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildBasicPayload = undefined;

var _pageInfoProvider = __webpack_require__("./template/helpers/pageInfoProvider.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _user = __webpack_require__("./template/state/modules/user/index.js");

var buildBasicPayload = exports.buildBasicPayload = function buildBasicPayload() {
  return function (dispatch, getState) {
    var state = getState();

    var _getPageInfo = (0, _pageInfoProvider.getPageInfo)(),
        section = _getPageInfo.section;

    return {
      countryCode: (0, _regionalStore.getCountryCode)(state),
      currency: (0, _regionalStore.getCurrency)(state),
      customerID: (0, _user.getCustomerId)(state),
      language: (0, _regionalStore.getDefaultLanguage)(state),
      pageName: "",
      pageTitle: "",
      pageType: section,
      platform: (0, _layout.getPlatform)(state),
      premierUser: (0, _user.getIsPremier)(state),
      recognizedUser: (0, _user.getIsRecognised)(state),
      storeCode: (0, _regionalStore.getStoreCode)(state),
      storeID: (0, _regionalStore.getSiteId)(state),
      trackingFrequency: "always"
    };
  };
};

/***/ }),

/***/ "./template/state/modules/bag/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startCheckout = exports.deleteBagItem = exports.bagItemDeleteTransitionEnd = exports.getUpdated = exports.dismissBagError = exports.bagError = exports.displayReservationMessage = exports.getTotalQuantity = exports.getTotalPriceText = exports.getTotalPrice = exports.getBagSummary = exports.getBagItems = exports.getLoading = exports.getBag = exports.SET_LOADING = exports.DISMISS_BAG_ERROR = exports.BAG_ERROR = exports.BAG_ITEM_DELETE_TRANSITION_END = exports.START_CHECKOUT = exports.HIDE_RESERVATION_MESSAGE = exports.SHOW_RESERVATION_MESSAGE = exports.FINISH_REMOVE_BAG_ITEM = exports.START_REMOVE_BAG_ITEM = exports.SET_BAG = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_BAG = exports.SET_BAG = "SET_BAG";

var START_REMOVE_BAG_ITEM = exports.START_REMOVE_BAG_ITEM = "START_REMOVE_BAG_ITEM";
var FINISH_REMOVE_BAG_ITEM = exports.FINISH_REMOVE_BAG_ITEM = "FINISH_REMOVE_BAG_ITEM";
var SHOW_RESERVATION_MESSAGE = exports.SHOW_RESERVATION_MESSAGE = "SHOW_RESERVATION_MESSAGE";
var HIDE_RESERVATION_MESSAGE = exports.HIDE_RESERVATION_MESSAGE = "HIDE_RESERVATION_MESSAGE";
var START_CHECKOUT = exports.START_CHECKOUT = "START_CHECKOUT";

var BAG_ITEM_DELETE_TRANSITION_END = exports.BAG_ITEM_DELETE_TRANSITION_END = "BAG_ITEM_DELETE_TRANSITION_END";
var BAG_ERROR = exports.BAG_ERROR = "BAG_ERROR";
var DISMISS_BAG_ERROR = exports.DISMISS_BAG_ERROR = "DISMISS_BAG_ERROR";
var SET_LOADING = exports.SET_LOADING = "SET_LOADING";

var getBag = exports.getBag = function getBag(state) {
  return state.bag;
};

var getLoading = exports.getLoading = (0, _reselect.createSelector)(getBag, function (_ref) {
  var loading = _ref.loading;
  return loading;
});

var getBagItems = exports.getBagItems = (0, _reselect.createSelector)(getBag, function (_ref2) {
  var items = _ref2.items;
  return items;
});

var getBagSummary = exports.getBagSummary = (0, _reselect.createSelector)(getBag, function (_ref3) {
  var summary = _ref3.summary;
  return summary;
});

var getTotalPrice = exports.getTotalPrice = (0, _reselect.createSelector)(getBagSummary, function (_ref4) {
  var totalPrice = _ref4.totalPrice;
  return totalPrice || {};
});

var getTotalPriceText = exports.getTotalPriceText = (0, _reselect.createSelector)(getTotalPrice, function (_ref5) {
  var text = _ref5.text;
  return text;
});

var getTotalQuantity = exports.getTotalQuantity = (0, _reselect.createSelector)(getBagSummary, function (_ref6) {
  var totalQuantity = _ref6.totalQuantity;
  return totalQuantity;
});

var displayReservationMessage = exports.displayReservationMessage = (0, _reselect.createSelector)(getBag, function (_ref7) {
  var displayReservationMessage = _ref7.displayReservationMessage;
  return displayReservationMessage;
});

var bagError = exports.bagError = (0, _reselect.createSelector)(getBag, function (_ref8) {
  var bagError = _ref8.bagError;
  return bagError;
});

var dismissBagError = exports.dismissBagError = function dismissBagError() {
  return function (dispatch) {
    dispatch({
      type: DISMISS_BAG_ERROR
    });
  };
};

var getUpdated = exports.getUpdated = (0, _reselect.createSelector)(getBag, function (_ref9) {
  var isUpdated = _ref9.isUpdated;
  return isUpdated;
});

var bagItemDeleteTransitionEnd = exports.bagItemDeleteTransitionEnd = function bagItemDeleteTransitionEnd(itemId) {
  return function (dispatch) {
    return dispatch({
      type: BAG_ITEM_DELETE_TRANSITION_END,
      itemId: itemId
    });
  };
};

var deleteBagItem = exports.deleteBagItem = function deleteBagItem(bagItem) {
  return function (dispatch) {
    dispatch({
      type: START_REMOVE_BAG_ITEM,
      item: bagItem
    });
  };
};

var startCheckout = exports.startCheckout = function startCheckout() {
  return function (dispatch) {
    dispatch({
      type: START_CHECKOUT
    });
  };
};

var initialState = {
  summary: {
    totalPrice: {}
  },
  loading: true
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case SET_BAG:
      {
        var _action$payload = action.payload,
            bag = _action$payload.bag,
            messages = _action$payload.messages;

        return (0, _extends3.default)({}, state, bag, {
          messages: messages,
          bagError: false,
          loading: false
        });
      }
    case SET_LOADING:
      {
        return (0, _extends3.default)({}, state, {
          loading: true
        });
      }
    case START_REMOVE_BAG_ITEM:
      {
        return (0, _extends3.default)({}, state);
      }
    case SHOW_RESERVATION_MESSAGE:
      {
        return (0, _extends3.default)({}, state, {
          displayReservationMessage: true
        });
      }
    case HIDE_RESERVATION_MESSAGE:
      {
        return (0, _extends3.default)({}, state, {
          displayReservationMessage: false
        });
      }

    case BAG_ERROR:
      {
        return (0, _extends3.default)({}, state, {
          bagError: true,
          loading: false
        });
      }
    case DISMISS_BAG_ERROR:
      {
        return (0, _extends3.default)({}, state, {
          bagError: false
        });
      }
    case FINISH_REMOVE_BAG_ITEM:
      {
        return (0, _extends3.default)({}, state, {
          lastItemRemoved: action.itemId
        });
      }
    default:
      return state;
  }
};

/***/ }),

/***/ "./template/state/modules/countrySelector/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePreferences = exports.setCurrency = exports.setCountry = exports.closeCountrySelector = exports.openCountrySelector = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _urlParse = __webpack_require__("../node_modules/url-parse/index.js");

var _urlParse2 = _interopRequireDefault(_urlParse);

var _constants = __webpack_require__("./template/state/modules/countrySelector/constants.js");

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

var _monitoring = __webpack_require__("./helpers/monitoring.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openCountrySelector = exports.openCountrySelector = function openCountrySelector() {
  return function (dispatch, getState) {
    dispatch({ type: _constants.OPEN_COUNTRY_SELECTOR });

    var _getState = getState(),
        regionalStore = _getState.regionalStore;

    return dispatch(setCountry(regionalStore.countryCode, regionalStore.defaultLanguage));
  };
};

var closeCountrySelector = exports.closeCountrySelector = function closeCountrySelector() {
  return {
    type: _constants.CLOSE_COUNTRY_SELECTOR
  };
};

var setCountry = exports.setCountry = function setCountry(country, defaultLanguage) {
  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState, _ref) {
      var api = _ref.api;
      var state, platform, response;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              state = getState();
              platform = state.layout.platform;

              dispatch({ type: _constants.LOAD_COUNTRY });
              _context.next = 6;
              return api.fetchCountry(country, defaultLanguage, platform);

            case 6:
              response = _context.sent;
              return _context.abrupt("return", dispatch({ type: _constants.SET_COUNTRY, payload: response.data }));

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", dispatch({ type: _constants.SET_COUNTRY, error: true, payload: _context.t0 }));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 10]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var setCurrency = exports.setCurrency = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(currencyCode) {
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(window.__sdk && window.__sdk.bag && window.__sdk.bag.updateCurrency && currencyCode)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", window.__sdk.bag.updateCurrency(currencyCode));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function setCurrency(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var updatePreferences = exports.updatePreferences = function updatePreferences(countryCode, currencyCode, storeUrl, initialCountryCode, affiliateId) {
  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch) {
      var res, url, xSiteOrigin;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (!(countryCode === initialCountryCode)) {
                _context3.next = 8;
                break;
              }

              dispatch({ type: _constants.LOAD_CURRENCY });
              _context3.next = 5;
              return setCurrency(currencyCode);

            case 5:
              res = _context3.sent;

              dispatch({ type: _constants.SET_CURRENCY });
              if (res && res.bag && res.bag.summary) {
                dispatch({ type: _bag.SET_BAG, payload: res.bag.summary });
              }

            case 8:
              url = (0, _urlParse2.default)(storeUrl || window.location.href, true);
              xSiteOrigin = _clientConfig2.default.getXSiteOrigin();


              if (countryCode) {
                url.query = (0, _extends3.default)({}, url.query, { browseCountry: countryCode });
              }
              if (currencyCode) {
                url.query = (0, _extends3.default)({}, url.query, { browseCurrency: currencyCode });
              }
              if (affiliateId) {
                url.query = (0, _extends3.default)({}, url.query, { xaffid: affiliateId });
              }
              if (xSiteOrigin) {
                url.query = (0, _extends3.default)({}, url.query, { "x-site-origin": xSiteOrigin });
              }
              url.query = (0, _extends3.default)({}, url.query, { r: 1 });

              window.location.href = url.toString();
              _context3.next = 22;
              break;

            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](0);

              (0, _monitoring.noticeError)(_context3.t0);
              dispatch({ type: _constants.SET_CURRENCY, payload: _context3.t0.message, error: true });

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[0, 18]]);
    }));

    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ "./template/state/modules/countrySelector/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OPEN_COUNTRY_SELECTOR = exports.OPEN_COUNTRY_SELECTOR = "OPEN_COUNTRY_SELECTOR";
var CLOSE_COUNTRY_SELECTOR = exports.CLOSE_COUNTRY_SELECTOR = "CLOSE_COUNTRY_SELECTOR";
var SET_COUNTRY = exports.SET_COUNTRY = "SET_COUNTRY";
var LOAD_COUNTRY = exports.LOAD_COUNTRY = "LOAD_COUNTRY";
var LOAD_CURRENCY = exports.LOAD_CURRENCY = "LOAD_CURRENCY";
var SET_CURRENCY = exports.SET_CURRENCY = "SET_CURRENCY";
var VOUCHER_CURRENCY_ERROR = exports.VOUCHER_CURRENCY_ERROR = "cannotchangetonongbpcurrencyifvoucherisinbag";

/***/ }),

/***/ "./template/state/modules/countrySelector/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasVoucherError = exports.getHasVoucherError = exports.getHasSetCurrencyError = exports.getCountrySelectorVisibility = exports.getCountrySelectorLoading = exports.getCountrySelectorError = exports.getCountrySelectorCountry = exports.getCountrySelectorAlternateUrls = exports.updatePreferences = exports.setCountry = exports.closeCountrySelector = exports.openCountrySelector = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _actions = __webpack_require__("./template/state/modules/countrySelector/actions.js");

Object.defineProperty(exports, "openCountrySelector", {
  enumerable: true,
  get: function get() {
    return _actions.openCountrySelector;
  }
});
Object.defineProperty(exports, "closeCountrySelector", {
  enumerable: true,
  get: function get() {
    return _actions.closeCountrySelector;
  }
});
Object.defineProperty(exports, "setCountry", {
  enumerable: true,
  get: function get() {
    return _actions.setCountry;
  }
});
Object.defineProperty(exports, "updatePreferences", {
  enumerable: true,
  get: function get() {
    return _actions.updatePreferences;
  }
});

var _selectors = __webpack_require__("./template/state/modules/countrySelector/selectors.js");

Object.defineProperty(exports, "getCountrySelectorAlternateUrls", {
  enumerable: true,
  get: function get() {
    return _selectors.getCountrySelectorAlternateUrls;
  }
});
Object.defineProperty(exports, "getCountrySelectorCountry", {
  enumerable: true,
  get: function get() {
    return _selectors.getCountrySelectorCountry;
  }
});
Object.defineProperty(exports, "getCountrySelectorError", {
  enumerable: true,
  get: function get() {
    return _selectors.getCountrySelectorError;
  }
});
Object.defineProperty(exports, "getCountrySelectorLoading", {
  enumerable: true,
  get: function get() {
    return _selectors.getCountrySelectorLoading;
  }
});
Object.defineProperty(exports, "getCountrySelectorVisibility", {
  enumerable: true,
  get: function get() {
    return _selectors.getCountrySelectorVisibility;
  }
});
Object.defineProperty(exports, "getHasSetCurrencyError", {
  enumerable: true,
  get: function get() {
    return _selectors.getHasSetCurrencyError;
  }
});
Object.defineProperty(exports, "getHasVoucherError", {
  enumerable: true,
  get: function get() {
    return _selectors.getHasVoucherError;
  }
});

var _constants = __webpack_require__("./template/state/modules/countrySelector/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isOpen: false,
  isLoading: true,
  hasVoucherError: false,
  hasSetCurrencyError: false
};

var hasVoucherError = exports.hasVoucherError = function hasVoucherError(messages) {
  return !!(messages && messages.some(function (_ref) {
    var errorCode = _ref.errorCode;
    return errorCode && errorCode.toLowerCase() === _constants.VOUCHER_CURRENCY_ERROR;
  }));
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.OPEN_COUNTRY_SELECTOR:
      return (0, _extends3.default)({}, state, {
        isOpen: true,
        isLoading: true,
        hasVoucherError: false,
        hasSetCurrencyError: false
      });
    case _constants.CLOSE_COUNTRY_SELECTOR:
      return (0, _extends3.default)({}, state, {
        isOpen: false
      });
    case _constants.LOAD_COUNTRY:
      return (0, _extends3.default)({}, state, { isLoading: true });
    case _constants.SET_COUNTRY:
      return (0, _extends3.default)({}, state, {
        country: !action.error ? action.payload : null,
        isLoading: false,
        error: action.error,
        isOpen: !action.error
      });
    case _constants.LOAD_CURRENCY:
      return (0, _extends3.default)({}, state, { isLoading: true });
    case _constants.SET_CURRENCY:
      return (0, _extends3.default)({}, state, {
        isLoading: false,
        hasSetCurrencyError: action.error,
        hasVoucherError: hasVoucherError(action.payload)
      });
    default:
      return state;
  }
};

/***/ }),

/***/ "./template/state/modules/countrySelector/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasSetCurrencyError = exports.getHasVoucherError = exports.getCountrySelectorAlternateUrls = exports.getCountrySelectorCountry = exports.getCountrySelectorError = exports.getCountrySelectorLoading = exports.getCountrySelectorVisibility = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var getCountrySelector = function getCountrySelector(state) {
  return state.countrySelector;
};

var getCountrySelectorVisibility = exports.getCountrySelectorVisibility = (0, _reselect.createSelector)(getCountrySelector, function (countrySelector) {
  return countrySelector.isOpen;
});

var getCountrySelectorLoading = exports.getCountrySelectorLoading = (0, _reselect.createSelector)(getCountrySelector, function (countrySelector) {
  return countrySelector.isLoading;
});

var getCountrySelectorError = exports.getCountrySelectorError = (0, _reselect.createSelector)(getCountrySelector, function (countrySelector) {
  return countrySelector.error;
});

var getCountrySelectorCountry = exports.getCountrySelectorCountry = (0, _reselect.createSelector)(getCountrySelector, function (countrySelector) {
  return countrySelector.country;
});

var getCountrySelectorAlternateUrls = exports.getCountrySelectorAlternateUrls = (0, _reselect.createSelector)(getCountrySelector, function (countrySelector) {
  return countrySelector.alternateUrls;
});

var getHasVoucherError = exports.getHasVoucherError = (0, _reselect.createSelector)(getCountrySelector, function (countrySelector) {
  return countrySelector.hasVoucherError;
});

var getHasSetCurrencyError = exports.getHasSetCurrencyError = (0, _reselect.createSelector)(getCountrySelector, function (countrySelector) {
  return countrySelector.hasSetCurrencyError;
});

/***/ }),

/***/ "./template/state/modules/dropdown/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownClosed = exports.closeDropdown = exports.openComplete = exports.openDropdown = undefined;

var _constants = __webpack_require__("./template/state/modules/dropdown/constants.js");

var openDropdown = exports.openDropdown = function openDropdown(name) {
  return { type: _constants.OPEN_DROPDOWN, name: name };
};

var openComplete = exports.openComplete = function openComplete(name) {
  return { type: _constants.OPEN_COMPLETE, name: name };
};

var closeDropdown = exports.closeDropdown = function closeDropdown(name) {
  return { type: _constants.CLOSE_DROPDOWN, name: name };
};

var dropdownClosed = exports.dropdownClosed = function dropdownClosed(name) {
  return { type: _constants.DROPDOWN_CLOSED, name: name };
};

/***/ }),

/***/ "./template/state/modules/dropdown/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OPEN_DROPDOWN = exports.OPEN_DROPDOWN = "OPEN_DROPDOWN";
var OPEN_COMPLETE = exports.OPEN_COMPLETE = "OPEN_COMPLETE";
var CLOSE_DROPDOWN = exports.CLOSE_DROPDOWN = "CLOSE_DROPDOWN";
var MY_ACCOUNT = exports.MY_ACCOUNT = "myAccount";
var MINIBAG = exports.MINIBAG = "miniBag";
var DROPDOWN_NAMES = exports.DROPDOWN_NAMES = [MY_ACCOUNT, MINIBAG];
var DROPDOWN_CLOSED = exports.DROPDOWN_CLOSED = "DROPDOWN_CLOSED";

/***/ }),

/***/ "./template/state/modules/dropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDropdownStates = exports.DROPDOWN_CLOSED = exports.MINIBAG = exports.MY_ACCOUNT = exports.DROPDOWN_NAMES = exports.CLOSE_DROPDOWN = exports.OPEN_DROPDOWN = exports.getDropdownProgrammatic = exports.getDropdownIsHidden = exports.getDropdownIsOpen = exports.dropdownClosed = exports.closeDropdown = exports.openDropdown = undefined;

var _defineProperty2 = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends4 = _interopRequireDefault(_extends3);

var _actions = __webpack_require__("./template/state/modules/dropdown/actions.js");

Object.defineProperty(exports, "openDropdown", {
  enumerable: true,
  get: function get() {
    return _actions.openDropdown;
  }
});
Object.defineProperty(exports, "closeDropdown", {
  enumerable: true,
  get: function get() {
    return _actions.closeDropdown;
  }
});
Object.defineProperty(exports, "dropdownClosed", {
  enumerable: true,
  get: function get() {
    return _actions.dropdownClosed;
  }
});

var _selectors = __webpack_require__("./template/state/modules/dropdown/selectors.js");

Object.defineProperty(exports, "getDropdownIsOpen", {
  enumerable: true,
  get: function get() {
    return _selectors.getDropdownIsOpen;
  }
});
Object.defineProperty(exports, "getDropdownIsHidden", {
  enumerable: true,
  get: function get() {
    return _selectors.getDropdownIsHidden;
  }
});
Object.defineProperty(exports, "getDropdownProgrammatic", {
  enumerable: true,
  get: function get() {
    return _selectors.getDropdownProgrammatic;
  }
});

var _constants = __webpack_require__("./template/state/modules/dropdown/constants.js");

Object.defineProperty(exports, "OPEN_DROPDOWN", {
  enumerable: true,
  get: function get() {
    return _constants.OPEN_DROPDOWN;
  }
});
Object.defineProperty(exports, "CLOSE_DROPDOWN", {
  enumerable: true,
  get: function get() {
    return _constants.CLOSE_DROPDOWN;
  }
});
Object.defineProperty(exports, "DROPDOWN_NAMES", {
  enumerable: true,
  get: function get() {
    return _constants.DROPDOWN_NAMES;
  }
});
Object.defineProperty(exports, "MY_ACCOUNT", {
  enumerable: true,
  get: function get() {
    return _constants.MY_ACCOUNT;
  }
});
Object.defineProperty(exports, "MINIBAG", {
  enumerable: true,
  get: function get() {
    return _constants.MINIBAG;
  }
});
Object.defineProperty(exports, "DROPDOWN_CLOSED", {
  enumerable: true,
  get: function get() {
    return _constants.DROPDOWN_CLOSED;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initDropdownStates = exports.initDropdownStates = function initDropdownStates(dropdownNames) {
  return dropdownNames.reduce(function (dropdowns, name) {
    dropdowns[name] = {
      isOpen: false
    };
    return dropdowns;
  }, {});
};

var initialState = initDropdownStates(_constants.DROPDOWN_NAMES);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.OPEN_DROPDOWN:
      {
        var dropdownToggles = _constants.DROPDOWN_NAMES.reduce(function (dropdowns, name) {
          dropdowns[name] = name === action.name ? { isOpen: true, programmatic: action.programmatic } : { isOpen: false, isHidden: true };
          return dropdowns;
        }, {});

        return (0, _extends4.default)({}, state, dropdownToggles);
      }
    case _constants.CLOSE_DROPDOWN:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.name, { isOpen: false }));
    default:
      return state;
  }
};

/***/ }),

/***/ "./template/state/modules/dropdown/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDropdownIsOpen = exports.getDropdownIsOpen = function getDropdownIsOpen(state, props) {
  return state.dropdown[props.name] && state.dropdown[props.name].isOpen;
};

var getDropdownIsHidden = exports.getDropdownIsHidden = function getDropdownIsHidden(state, props) {
  return state.dropdown[props.name] && state.dropdown[props.name].isHidden;
};

var getDropdownProgrammatic = exports.getDropdownProgrammatic = function getDropdownProgrammatic(state, props) {
  return state.dropdown[props.name] && state.dropdown[props.name].programmatic;
};

/***/ }),

/***/ "./template/state/modules/features/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGlobalFeatureName = exports.setFeatures = undefined;

var _constants = __webpack_require__("./template/state/modules/features/constants.js");

var setFeatures = exports.setFeatures = function setFeatures(features) {
  return {
    type: _constants.SET_FEATURES,
    payload: features
  };
};

var setGlobalFeatureName = exports.setGlobalFeatureName = function setGlobalFeatureName(testName) {
  /* istanbul ignore else */
  if (typeof window !== "undefined") {
    window.mvtTestName = testName;
  }
};

/***/ }),

/***/ "./template/state/modules/features/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_FEATURES = exports.SET_FEATURES = "SET_FEATURES";

/***/ }),

/***/ "./template/state/modules/features/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeaturesLoaded = exports.isFeatureActive = exports.getFeature = exports.setGlobalFeatureName = exports.setFeatures = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _actions = __webpack_require__("./template/state/modules/features/actions.js");

Object.defineProperty(exports, "setFeatures", {
  enumerable: true,
  get: function get() {
    return _actions.setFeatures;
  }
});
Object.defineProperty(exports, "setGlobalFeatureName", {
  enumerable: true,
  get: function get() {
    return _actions.setGlobalFeatureName;
  }
});

var _selectors = __webpack_require__("./template/state/modules/features/selectors.js");

Object.defineProperty(exports, "getFeature", {
  enumerable: true,
  get: function get() {
    return _selectors.getFeature;
  }
});
Object.defineProperty(exports, "isFeatureActive", {
  enumerable: true,
  get: function get() {
    return _selectors.isFeatureActive;
  }
});
Object.defineProperty(exports, "getFeaturesLoaded", {
  enumerable: true,
  get: function get() {
    return _selectors.getFeaturesLoaded;
  }
});

var _constants = __webpack_require__("./template/state/modules/features/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  features: {},
  mvt: {},
  loadComplete: false
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.SET_FEATURES:
      return (0, _extends3.default)({}, state, action.payload);
    default:
      return state;
  }
};

/***/ }),

/***/ "./template/state/modules/features/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeaturesLoaded = exports.isFeatureActive = exports.getFeature = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFeaturesStore = function getFeaturesStore(state) {
  return state.features;
};

var getMvt = (0, _reselect.createSelector)(getFeaturesStore, function (feature) {
  return feature.mvt;
});

var getFeatures = (0, _reselect.createSelector)(getFeaturesStore, function (feature) {
  return feature.features;
});

var getFlatFeaturesStore = function getFlatFeaturesStore(state) {
  return (0, _extends3.default)({}, getMvt(state), getFeatures(state));
};

var getFeature = exports.getFeature = function getFeature(state, key) {
  return getFlatFeaturesStore(state)[key];
};

var isFeatureActive = exports.isFeatureActive = function isFeatureActive(state, key) {
  var features = getFlatFeaturesStore(state);
  var feature = key in features ? features[key] : false;

  return feature && feature !== {};
};

var getFeaturesLoaded = exports.getFeaturesLoaded = (0, _reselect.createSelector)(getFeaturesStore, function (feature) {
  return feature.loadComplete;
});

/***/ }),

/***/ "./template/state/modules/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _layout2 = _interopRequireDefault(_layout);

var _navigation = __webpack_require__("./template/state/modules/navigation/index.js");

var _navigation2 = _interopRequireDefault(_navigation);

var _regionalStore = __webpack_require__("./template/state/modules/regionalStore/index.js");

var _regionalStore2 = _interopRequireDefault(_regionalStore);

var _search = __webpack_require__("./template/state/modules/search/index.js");

var _search2 = _interopRequireDefault(_search);

var _savedItems = __webpack_require__("./template/state/modules/savedItems/index.js");

var _savedItems2 = _interopRequireDefault(_savedItems);

var _bag = __webpack_require__("./template/state/modules/bag/index.js");

var _bag2 = _interopRequireDefault(_bag);

var _countrySelector = __webpack_require__("./template/state/modules/countrySelector/index.js");

var _countrySelector2 = _interopRequireDefault(_countrySelector);

var _version = __webpack_require__("./template/state/modules/version/index.js");

var _version2 = _interopRequireDefault(_version);

var _welcomeMessage = __webpack_require__("./template/state/modules/welcomeMessage/index.js");

var _welcomeMessage2 = _interopRequireDefault(_welcomeMessage);

var _welcomeMat = __webpack_require__("./template/state/modules/welcomeMat/index.js");

var _welcomeMat2 = _interopRequireDefault(_welcomeMat);

var _user = __webpack_require__("./template/state/modules/user/index.js");

var _user2 = _interopRequireDefault(_user);

var _dropdown = __webpack_require__("./template/state/modules/dropdown/index.js");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _features = __webpack_require__("./template/state/modules/features/index.js");

var _features2 = _interopRequireDefault(_features);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  layout: _layout2.default,
  navigation: _navigation2.default,
  regionalStore: _regionalStore2.default,
  search: _search2.default,
  savedItems: _savedItems2.default,
  bag: _bag2.default,
  countrySelector: _countrySelector2.default,
  version: _version2.default,
  welcomeMessage: _welcomeMessage2.default,
  welcomeMat: _welcomeMat2.default,
  user: _user2.default,
  dropdown: _dropdown2.default,
  features: _features2.default
});

/***/ }),

/***/ "./template/state/modules/layout/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openCookieMessage = exports.closeCookieMessage = exports.closeSidePanel = exports.openSidePanel = exports.setGender = exports.updateViewportCategory = undefined;

var _constants = __webpack_require__("./template/state/modules/layout/constants.js");

var updateViewportCategory = exports.updateViewportCategory = function updateViewportCategory(viewportCategory) {
  return {
    type: _constants.UPDATE_VIEWPORT_CATEGORY,
    payload: {
      viewportCategory: viewportCategory
    }
  };
};

var setGender = exports.setGender = function setGender(gender) {
  return {
    type: _constants.SET_GENDER,
    payload: gender
  };
};

var openSidePanel = exports.openSidePanel = function openSidePanel() {
  return {
    type: _constants.OPEN_SIDE_PANEL
  };
};

var closeSidePanel = exports.closeSidePanel = function closeSidePanel() {
  return {
    type: _constants.CLOSE_SIDE_PANEL
  };
};

var closeCookieMessage = exports.closeCookieMessage = function closeCookieMessage() {
  return {
    type: _constants.CLOSE_COOKIE_MESSAGE
  };
};

var openCookieMessage = exports.openCookieMessage = function openCookieMessage() {
  return {
    type: _constants.OPEN_COOKIE_MESSAGE
  };
};

/***/ }),

/***/ "./template/state/modules/layout/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_VIEWPORT_CATEGORY = exports.UPDATE_VIEWPORT_CATEGORY = "update-viewport-category";
var SMALL_VIEWPORT = exports.SMALL_VIEWPORT = "small-viewport";
var MEDIUM_VIEWPORT = exports.MEDIUM_VIEWPORT = "medium-viewport";
var LARGE_VIEWPORT = exports.LARGE_VIEWPORT = "large-viewport";
var CLOSE_SIDE_PANEL = exports.CLOSE_SIDE_PANEL = "CLOSE_SIDE_PANEL";
var OPEN_SIDE_PANEL = exports.OPEN_SIDE_PANEL = "OPEN_SIDE_PANEL";
var SET_GENDER = exports.SET_GENDER = "SET_GENDER";
var MALE = exports.MALE = "men";
var FEMALE = exports.FEMALE = "women";
var DEFAULT = exports.DEFAULT = "default";
var SECURE = exports.SECURE = "secure";
var OPEN_COOKIE_MESSAGE = exports.OPEN_COOKIE_MESSAGE = "OPEN_COOKIE_MESSAGE";
var CLOSE_COOKIE_MESSAGE = exports.CLOSE_COOKIE_MESSAGE = "CLOSE_COOKIE_MESSAGE";

/***/ }),

/***/ "./template/state/modules/layout/helpers/bounceeffect.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BounceEffect = undefined;

var _clientConfig = __webpack_require__("./template/clientConfig.js");

var _clientConfig2 = _interopRequireDefault(_clientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BounceEffect = exports.BounceEffect = !_clientConfig2.default.isServer() ? __webpack_require__("../node_modules/inobounce/inobounce.js") : { enable: function enable() {}, disable: function disable() {} };

/***/ }),

/***/ "./template/state/modules/layout/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewportPropType = exports.genderPropType = exports.getPlatform = exports.getCurrentGender = exports.isCookieMessageOpen = exports.getViewport = exports.isSidePanelOpen = exports.hasGender = exports.isMale = exports.isFemale = exports.updateViewportCategory = exports.closeCookieMessage = exports.openCookieMessage = exports.closeSidePanel = exports.openSidePanel = exports.setGender = exports.SECURE = exports.DEFAULT = exports.LARGE_VIEWPORT = exports.MEDIUM_VIEWPORT = exports.SMALL_VIEWPORT = exports.FEMALE = exports.MALE = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__("./template/state/modules/layout/constants.js");

Object.defineProperty(exports, "MALE", {
  enumerable: true,
  get: function get() {
    return _constants.MALE;
  }
});
Object.defineProperty(exports, "FEMALE", {
  enumerable: true,
  get: function get() {
    return _constants.FEMALE;
  }
});
Object.defineProperty(exports, "SMALL_VIEWPORT", {
  enumerable: true,
  get: function get() {
    return _constants.SMALL_VIEWPORT;
  }
});
Object.defineProperty(exports, "MEDIUM_VIEWPORT", {
  enumerable: true,
  get: function get() {
    return _constants.MEDIUM_VIEWPORT;
  }
});
Object.defineProperty(exports, "LARGE_VIEWPORT", {
  enumerable: true,
  get: function get() {
    return _constants.LARGE_VIEWPORT;
  }
});
Object.defineProperty(exports, "DEFAULT", {
  enumerable: true,
  get: function get() {
    return _constants.DEFAULT;
  }
});
Object.defineProperty(exports, "SECURE", {
  enumerable: true,
  get: function get() {
    return _constants.SECURE;
  }
});

var _actions = __webpack_require__("./template/state/modules/layout/actions.js");

Object.defineProperty(exports, "setGender", {
  enumerable: true,
  get: function get() {
    return _actions.setGender;
  }
});
Object.defineProperty(exports, "openSidePanel", {
  enumerable: true,
  get: function get() {
    return _actions.openSidePanel;
  }
});
Object.defineProperty(exports, "closeSidePanel", {
  enumerable: true,
  get: function get() {
    return _actions.closeSidePanel;
  }
});
Object.defineProperty(exports, "openCookieMessage", {
  enumerable: true,
  get: function get() {
    return _actions.openCookieMessage;
  }
});
Object.defineProperty(exports, "closeCookieMessage", {
  enumerable: true,
  get: function get() {
    return _actions.closeCookieMessage;
  }
});
Object.defineProperty(exports, "updateViewportCategory", {
  enumerable: true,
  get: function get() {
    return _actions.updateViewportCategory;
  }
});

var _selectors = __webpack_require__("./template/state/modules/layout/selectors.js");

Object.defineProperty(exports, "isFemale", {
  enumerable: true,
  get: function get() {
    return _selectors.isFemale;
  }
});
Object.defineProperty(exports, "isMale", {
  enumerable: true,
  get: function get() {
    return _selectors.isMale;
  }
});
Object.defineProperty(exports, "hasGender", {
  enumerable: true,
  get: function get() {
    return _selectors.hasGender;
  }
});
Object.defineProperty(exports, "isSidePanelOpen", {
  enumerable: true,
  get: function get() {
    return _selectors.isSidePanelOpen;
  }
});
Object.defineProperty(exports, "getViewport", {
  enumerable: true,
  get: function get() {
    return _selectors.getViewport;
  }
});
Object.defineProperty(exports, "isCookieMessageOpen", {
  enumerable: true,
  get: function get() {
    return _selectors.isCookieMessageOpen;
  }
});
Object.defineProperty(exports, "getCurrentGender", {
  enumerable: true,
  get: function get() {
    return _selectors.getCurrentGender;
  }
});
Object.defineProperty(exports, "getPlatform", {
  enumerable: true,
  get: function get() {
    return _selectors.getPlatform;
  }
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bounceeffect = __webpack_require__("./template/state/modules/layout/helpers/bounceeffect.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var genderPropType = exports.genderPropType = _propTypes2.default.oneOf([_constants.MALE, _constants.FEMALE, _constants.DEFAULT]);
var viewportPropType = exports.viewportPropType = _propTypes2.default.oneOf([_constants.SMALL_VIEWPORT, _constants.MEDIUM_VIEWPORT, _constants.LARGE_VIEWPORT]);

var initialState = {
  viewportCategory: _constants.SMALL_VIEWPORT,
  isSidePanelOpen: false,
  isCookieMessageOpen: false,
  gender: _constants.DEFAULT,
  platform: "desktop"
};

var needsBounceEffect = function needsBounceEffect() {
  var testDiv = document.createElement("div");
  document.documentElement.appendChild(testDiv);
  testDiv.style.WebkitOverflowScrolling = "touch";
  var scrollSupport = "getComputedStyle" in window && window.getComputedStyle(testDiv)["-webkit-overflow-scrolling"] === "touch";
  document.documentElement.removeChild(testDiv);
  return scrollSupport;
};

_bounceeffect.BounceEffect.disable();

var validateViewport = function validateViewport(state, viewportCategory) {
  return [_constants.SMALL_VIEWPORT, _constants.MEDIUM_VIEWPORT, _constants.LARGE_VIEWPORT].indexOf(viewportCategory) !== -1 ? viewportCategory : state.viewportCategory;
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.UPDATE_VIEWPORT_CATEGORY:
      return (0, _extends3.default)({}, state, {
        viewportCategory: validateViewport(state, action.payload.viewportCategory)
      });
    case _constants.SET_GENDER:
      return (0, _extends3.default)({}, state, {
        gender: action.payload
      });
    case _constants.OPEN_SIDE_PANEL:
      document.body.classList.add("chrome-hide-overflow");
      if (needsBounceEffect()) {
        _bounceeffect.BounceEffect.enable();
      }
      return (0, _extends3.default)({}, state, {
        isSidePanelOpen: true
      });
    case _constants.CLOSE_SIDE_PANEL:
      document.body.classList.remove("chrome-hide-overflow");
      _bounceeffect.BounceEffect.disable();
      return (0, _extends3.default)({}, state, {
        isSidePanelOpen: false
      });

    case _constants.OPEN_COOKIE_MESSAGE:
      return (0, _extends3.default)({}, state, {
        isCookieMessageOpen: true
      });
    case _constants.CLOSE_COOKIE_MESSAGE:
      return (0, _extends3.default)({}, state, {
        isCookieMessageOpen: false
      });
  }

  return state;
};

/***/ }),

/***/ "./template/state/modules/layout/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlatform = exports.isCookieMessageOpen = exports.getCurrentGender = exports.isMale = exports.isFemale = exports.hasGender = exports.isSidePanelOpen = exports.getViewport = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _constants = __webpack_require__("./template/state/modules/layout/constants.js");

var getLayout = function getLayout(state) {
  return state.layout;
};

var getViewport = exports.getViewport = (0, _reselect.createSelector)(getLayout, function (layout) {
  return layout.viewportCategory;
});

var isSidePanelOpen = exports.isSidePanelOpen = (0, _reselect.createSelector)(getLayout, function (layout) {
  return layout.isSidePanelOpen;
});

var hasGender = exports.hasGender = (0, _reselect.createSelector)(getLayout, function (layout) {
  return layout.gender === _constants.FEMALE || layout.gender === _constants.MALE;
});

var isFemale = exports.isFemale = (0, _reselect.createSelector)(getLayout, function (layout) {
  return layout.gender === _constants.FEMALE;
});

var isMale = exports.isMale = (0, _reselect.createSelector)(getLayout, function (layout) {
  return layout.gender === _constants.MALE;
});

var getCurrentGender = exports.getCurrentGender = (0, _reselect.createSelector)(getLayout, function (layout) {
  return layout.gender;
});

var isCookieMessageOpen = exports.isCookieMessageOpen = (0, _reselect.createSelector)(getLayout, function (layout) {
  return layout.isCookieMessageOpen;
});

var getPlatform = exports.getPlatform = (0, _reselect.createSelector)(getLayout, function (layout) {
  return layout.platform;
});

/***/ }),

/***/ "./template/state/modules/navigation/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNavigationTree = exports.clearNavActiveItem = exports.setNavActiveItem = undefined;

var _constants = __webpack_require__("./template/state/modules/navigation/constants.js");

var setNavActiveItem = exports.setNavActiveItem = function setNavActiveItem(id) {
  return {
    type: _constants.SET_NAV_ACTIVE_ITEM,
    payload: id
  };
};

var clearNavActiveItem = exports.clearNavActiveItem = function clearNavActiveItem() {
  return {
    type: _constants.CLEAR_NAV_ACTIVE_ITEM
  };
};

var updateNavigationTree = exports.updateNavigationTree = function updateNavigationTree(navigationTree) {
  return {
    type: _constants.UPDATE_NAVIGATION_TREE,
    payload: navigationTree
  };
};

/***/ }),

/***/ "./template/state/modules/navigation/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WOMEN_FLOOR_ALIAS = exports.WOMEN_FLOOR_ALIAS = "WW";
var MEN_FLOOR_ALIAS = exports.MEN_FLOOR_ALIAS = "MW";
var SET_NAV_ACTIVE_ITEM = exports.SET_NAV_ACTIVE_ITEM = "SET_NAV_ACTIVE_ITEM";
var CLEAR_NAV_ACTIVE_ITEM = exports.CLEAR_NAV_ACTIVE_ITEM = "CLEAR_NAV_ACTIVE_ITEM";
var UPDATE_NAVIGATION_TREE = exports.UPDATE_NAVIGATION_TREE = "UPDATE_NAVIGATION_TREE";
var UL_ITEM_COUNT = exports.UL_ITEM_COUNT = 11;

/***/ }),

/***/ "./template/state/modules/navigation/helpers/mapNavigationTree.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapLargePrimaryNavigation = exports.mapSidePrimaryNavigationForViewport = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _orderBy = __webpack_require__("../node_modules/lodash/orderBy.js");

var _orderBy2 = _interopRequireDefault(_orderBy);

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sort = function sort(items, viewport) {
  return viewport === _layout.LARGE_VIEWPORT ? (0, _orderBy2.default)(items, ["largeScreenPriority"], ["desc"]) : items;
};

var shouldExcludeForViewport = function shouldExcludeForViewport(item, viewport) {
  return item.excludes.indexOf(viewport) !== -1;
};

var filterTreeByViewport = function filterTreeByViewport(tree, forViewport) {
  return sort(tree.reduce(function (filteredTree, item) {
    if (shouldExcludeForViewport(item, forViewport)) {
      return filteredTree;
    }
    filteredTree.push((0, _extends3.default)({}, item, {
      items: sort(filterTreeByViewport(item.items, forViewport), forViewport)
    }));
    return filteredTree;
  }, []), forViewport);
};

var mapSidePrimaryNavigationForViewport = exports.mapSidePrimaryNavigationForViewport = function mapSidePrimaryNavigationForViewport(tree, forViewport) {
  return filterTreeByViewport(tree, forViewport);
};

var mapLargePrimaryNavigation = exports.mapLargePrimaryNavigation = function mapLargePrimaryNavigation(tree) {
  return mapSidePrimaryNavigationForViewport(tree, _layout.LARGE_VIEWPORT).reduce(function (items, secondLevelItems) {
    return items.concat(secondLevelItems.items);
  }, []);
};

/***/ }),

/***/ "./template/state/modules/navigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavActiveItem = exports.footerNavigation = exports.femaleSidePrimaryNavigationItems = exports.maleSidePrimaryNavigationItems = exports.femaleLargePrimaryNavigationItems = exports.maleLargePrimaryNavigationItems = exports.UL_ITEM_COUNT = exports.updateNavigationTree = exports.clearNavActiveItem = exports.setNavActiveItem = exports.navigationPropType = exports.navigationItemPropType = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _actions = __webpack_require__("./template/state/modules/navigation/actions.js");

Object.defineProperty(exports, "setNavActiveItem", {
  enumerable: true,
  get: function get() {
    return _actions.setNavActiveItem;
  }
});
Object.defineProperty(exports, "clearNavActiveItem", {
  enumerable: true,
  get: function get() {
    return _actions.clearNavActiveItem;
  }
});
Object.defineProperty(exports, "updateNavigationTree", {
  enumerable: true,
  get: function get() {
    return _actions.updateNavigationTree;
  }
});

var _constants = __webpack_require__("./template/state/modules/navigation/constants.js");

Object.defineProperty(exports, "UL_ITEM_COUNT", {
  enumerable: true,
  get: function get() {
    return _constants.UL_ITEM_COUNT;
  }
});

var _selectors = __webpack_require__("./template/state/modules/navigation/selectors.js");

Object.defineProperty(exports, "maleLargePrimaryNavigationItems", {
  enumerable: true,
  get: function get() {
    return _selectors.maleLargePrimaryNavigationItems;
  }
});
Object.defineProperty(exports, "femaleLargePrimaryNavigationItems", {
  enumerable: true,
  get: function get() {
    return _selectors.femaleLargePrimaryNavigationItems;
  }
});
Object.defineProperty(exports, "maleSidePrimaryNavigationItems", {
  enumerable: true,
  get: function get() {
    return _selectors.maleSidePrimaryNavigationItems;
  }
});
Object.defineProperty(exports, "femaleSidePrimaryNavigationItems", {
  enumerable: true,
  get: function get() {
    return _selectors.femaleSidePrimaryNavigationItems;
  }
});
Object.defineProperty(exports, "footerNavigation", {
  enumerable: true,
  get: function get() {
    return _selectors.footerNavigation;
  }
});
Object.defineProperty(exports, "getNavActiveItem", {
  enumerable: true,
  get: function get() {
    return _selectors.getNavActiveItem;
  }
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navigationShape = {
  id: _propTypes2.default.string.isRequired,
  alias: _propTypes2.default.string,
  label: _propTypes2.default.string,
  linkType: _propTypes2.default.string,
  subtitle: _propTypes2.default.string,
  link: _propTypes2.default.string,
  excludes: _propTypes2.default.array.isRequired,
  largeScreenPriority: _propTypes2.default.number,
  smallAndMediumImageUrl: _propTypes2.default.string
};

var navigationItemPropType = exports.navigationItemPropType = _propTypes2.default.shape(navigationShape);

var navigationPropType = exports.navigationPropType = _propTypes2.default.shape((0, _extends3.default)({}, navigationShape, {
  items: _propTypes2.default.arrayOf(navigationItemPropType).isRequired
}));

var initialState = {};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _constants.SET_NAV_ACTIVE_ITEM:
      return (0, _extends3.default)({}, state, {
        activeNavItem: payload
      });

    case _constants.CLEAR_NAV_ACTIVE_ITEM:
      return (0, _extends3.default)({}, state, {
        activeNavItem: null
      });

    case _constants.UPDATE_NAVIGATION_TREE:
      return (0, _extends3.default)({}, state, {
        tree: payload.tree,
        footer: payload.footer || state.footer
      });
  }

  return state;
};

/***/ }),

/***/ "./template/state/modules/navigation/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerNavigation = exports.getNavActiveItem = exports.maleSidePrimaryNavigationItems = exports.femaleSidePrimaryNavigationItems = exports.maleLargePrimaryNavigationItems = exports.femaleLargePrimaryNavigationItems = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _mapNavigationTree = __webpack_require__("./template/state/modules/navigation/helpers/mapNavigationTree.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _constants = __webpack_require__("./template/state/modules/navigation/constants.js");

var selectFemaleNavigationTree = function selectFemaleNavigationTree(state) {
  var femaleNav = state.navigation.tree.find(function (item) {
    return item.alias === _constants.WOMEN_FLOOR_ALIAS;
  });
  if (femaleNav && femaleNav.items) {
    return femaleNav.items;
  }

  return [];
};

var selectMaleNavigationTree = function selectMaleNavigationTree(state) {
  var maleNav = state.navigation.tree.find(function (item) {
    return item.alias === _constants.MEN_FLOOR_ALIAS;
  });
  if (maleNav && maleNav.items) {
    return maleNav.items;
  }

  return [];
};

var selectNavActiveItem = function selectNavActiveItem(state) {
  return state.navigation.activeNavItem;
};
var selectFooterLinks = function selectFooterLinks(state) {
  return state.navigation.footer;
};

var femaleLargePrimaryNavigationItems = exports.femaleLargePrimaryNavigationItems = (0, _reselect.createSelector)(selectFemaleNavigationTree, _mapNavigationTree.mapLargePrimaryNavigation);

var maleLargePrimaryNavigationItems = exports.maleLargePrimaryNavigationItems = (0, _reselect.createSelector)(selectMaleNavigationTree, _mapNavigationTree.mapLargePrimaryNavigation);

var femaleSidePrimaryNavigationItems = exports.femaleSidePrimaryNavigationItems = (0, _reselect.createSelector)(selectFemaleNavigationTree, _layout.getViewport, _mapNavigationTree.mapSidePrimaryNavigationForViewport);

var maleSidePrimaryNavigationItems = exports.maleSidePrimaryNavigationItems = (0, _reselect.createSelector)(selectMaleNavigationTree, _layout.getViewport, _mapNavigationTree.mapSidePrimaryNavigationForViewport);

var getNavActiveItem = exports.getNavActiveItem = (0, _reselect.createSelector)(selectNavActiveItem, function (id) {
  return id;
});

var footerNavigation = exports.footerNavigation = (0, _reselect.createSelector)(selectFooterLinks, function (footer) {
  return footer;
});

/***/ }),

/***/ "./template/state/modules/regionalStore/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBrowseCurrency = exports.setKeyStoreDataversion = undefined;

var _constants = __webpack_require__("./template/state/modules/regionalStore/constants.js");

var setKeyStoreDataversion = exports.setKeyStoreDataversion = function setKeyStoreDataversion(keyStoreDataversion) {
  return {
    type: _constants.SET_KEY_STORE_DATA_VERSION,
    payload: keyStoreDataversion
  };
};

var setBrowseCurrency = exports.setBrowseCurrency = function setBrowseCurrency(currency) {
  return {
    type: _constants.SET_BROWSE_CURRENCY,
    payload: currency
  };
};

/***/ }),

/***/ "./template/state/modules/regionalStore/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_KEY_STORE_DATA_VERSION = exports.SET_KEY_STORE_DATA_VERSION = "SET_KEY_STORE_DATA_VERSION";
var SET_BROWSE_CURRENCY = exports.SET_BROWSE_CURRENCY = "SET_BROWSE_CURRENCY";
var KSDV_PROPS_OVERWRITE = exports.KSDV_PROPS_OVERWRITE = ["storeCode", "siteId", "currencies", "sizeSchemas", "defaultLanguage", "defaultSizeSchema", "defaultCurrency", "storeUrls"];
var SEARCH_PATH = exports.SEARCH_PATH = "search/";

/***/ }),

/***/ "./template/state/modules/regionalStore/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegionalStoreVariant = exports.isCorrectCountry = exports.getCurrencyId = exports.getCurrencies = exports.getSiteId = exports.getPaymentProviders = exports.getDefaultCountry = exports.getCurrency = exports.getDefaultCurrency = exports.getDefaultSizeSchema = exports.getKeyStoreDataversion = exports.getStoreCode = exports.getSecureStoreUrl = exports.getStoreUrlForMen = exports.getStoreUrlForWomen = exports.getSearchUrl = exports.getDefaultStoreUrl = exports.getDefaultLanguage = exports.getCountryFlag = exports.getCountryCode = exports.getCountryName = exports.getSocialLinks = exports.getStore = exports.setBrowseCurrency = exports.setKeyStoreDataversion = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _actions = __webpack_require__("./template/state/modules/regionalStore/actions.js");

Object.defineProperty(exports, "setKeyStoreDataversion", {
  enumerable: true,
  get: function get() {
    return _actions.setKeyStoreDataversion;
  }
});
Object.defineProperty(exports, "setBrowseCurrency", {
  enumerable: true,
  get: function get() {
    return _actions.setBrowseCurrency;
  }
});

var _selectors = __webpack_require__("./template/state/modules/regionalStore/selectors.js");

Object.defineProperty(exports, "getStore", {
  enumerable: true,
  get: function get() {
    return _selectors.getStore;
  }
});
Object.defineProperty(exports, "getSocialLinks", {
  enumerable: true,
  get: function get() {
    return _selectors.getSocialLinks;
  }
});
Object.defineProperty(exports, "getCountryName", {
  enumerable: true,
  get: function get() {
    return _selectors.getCountryName;
  }
});
Object.defineProperty(exports, "getCountryCode", {
  enumerable: true,
  get: function get() {
    return _selectors.getCountryCode;
  }
});
Object.defineProperty(exports, "getCountryFlag", {
  enumerable: true,
  get: function get() {
    return _selectors.getCountryFlag;
  }
});
Object.defineProperty(exports, "getDefaultLanguage", {
  enumerable: true,
  get: function get() {
    return _selectors.getDefaultLanguage;
  }
});
Object.defineProperty(exports, "getDefaultStoreUrl", {
  enumerable: true,
  get: function get() {
    return _selectors.getDefaultStoreUrl;
  }
});
Object.defineProperty(exports, "getSearchUrl", {
  enumerable: true,
  get: function get() {
    return _selectors.getSearchUrl;
  }
});
Object.defineProperty(exports, "getStoreUrlForWomen", {
  enumerable: true,
  get: function get() {
    return _selectors.getStoreUrlForWomen;
  }
});
Object.defineProperty(exports, "getStoreUrlForMen", {
  enumerable: true,
  get: function get() {
    return _selectors.getStoreUrlForMen;
  }
});
Object.defineProperty(exports, "getSecureStoreUrl", {
  enumerable: true,
  get: function get() {
    return _selectors.getSecureStoreUrl;
  }
});
Object.defineProperty(exports, "getStoreCode", {
  enumerable: true,
  get: function get() {
    return _selectors.getStoreCode;
  }
});
Object.defineProperty(exports, "getKeyStoreDataversion", {
  enumerable: true,
  get: function get() {
    return _selectors.getKeyStoreDataversion;
  }
});
Object.defineProperty(exports, "getDefaultSizeSchema", {
  enumerable: true,
  get: function get() {
    return _selectors.getDefaultSizeSchema;
  }
});
Object.defineProperty(exports, "getDefaultCurrency", {
  enumerable: true,
  get: function get() {
    return _selectors.getDefaultCurrency;
  }
});
Object.defineProperty(exports, "getCurrency", {
  enumerable: true,
  get: function get() {
    return _selectors.getCurrency;
  }
});
Object.defineProperty(exports, "getDefaultCountry", {
  enumerable: true,
  get: function get() {
    return _selectors.getDefaultCountry;
  }
});
Object.defineProperty(exports, "getPaymentProviders", {
  enumerable: true,
  get: function get() {
    return _selectors.getPaymentProviders;
  }
});
Object.defineProperty(exports, "getSiteId", {
  enumerable: true,
  get: function get() {
    return _selectors.getSiteId;
  }
});
Object.defineProperty(exports, "getCurrencies", {
  enumerable: true,
  get: function get() {
    return _selectors.getCurrencies;
  }
});
Object.defineProperty(exports, "getCurrencyId", {
  enumerable: true,
  get: function get() {
    return _selectors.getCurrencyId;
  }
});
Object.defineProperty(exports, "isCorrectCountry", {
  enumerable: true,
  get: function get() {
    return _selectors.isCorrectCountry;
  }
});

var _constants = __webpack_require__("./template/state/modules/regionalStore/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  storeUrls: {}
};

var ksdvOverrides = function ksdvOverrides(variants) {
  return (0, _keys2.default)(variants).reduce(function (overrides, key) {
    if (_constants.KSDV_PROPS_OVERWRITE.indexOf(key) !== -1) {
      overrides[key] = variants[key];
    }
    return overrides;
  }, {});
};

var getRegionalStoreVariant = exports.getRegionalStoreVariant = function getRegionalStoreVariant(state, keyStoreDataversion) {
  return state.variants && state.variants[keyStoreDataversion] && ksdvOverrides(state.variants[keyStoreDataversion]);
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var keyStoreDataversion = action.payload;
  switch (action.type) {
    case _constants.SET_KEY_STORE_DATA_VERSION:
      return (0, _extends3.default)({}, state, {
        keyStoreDataversion: keyStoreDataversion
      }, getRegionalStoreVariant(state, keyStoreDataversion));
    case _constants.SET_BROWSE_CURRENCY:
      return (0, _extends3.default)({}, state, {
        browseCurrency: action.payload
      });
  }
  return state;
};

/***/ }),

/***/ "./template/state/modules/regionalStore/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSiteId = exports.getPaymentProviders = exports.getDefaultCountry = exports.getCurrencyId = exports.getCurrencies = exports.getCurrency = exports.getDefaultCurrency = exports.getDefaultSizeSchema = exports.getKeyStoreDataversion = exports.getStoreCode = exports.getSecureStoreUrl = exports.getStoreUrlForMen = exports.getStoreUrlForWomen = exports.getSearchUrl = exports.getDefaultStoreUrl = exports.getDefaultLanguage = exports.getCountryFlag = exports.isCorrectCountry = exports.getCountryCode = exports.getCountryName = exports.getSocialLinks = exports.getStore = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _selectors = __webpack_require__("./template/state/modules/layout/selectors.js");

var _context = __webpack_require__("./client/context/index.js");

var _layout = __webpack_require__("./template/state/modules/layout/index.js");

var _constants = __webpack_require__("./template/state/modules/regionalStore/constants.js");

var _removeProtocolFromUrl = __webpack_require__("./template/helpers/removeProtocolFromUrl.js");

var _removeProtocolFromUrl2 = _interopRequireDefault(_removeProtocolFromUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStore = exports.getStore = function getStore(state) {
  return state.regionalStore;
};

var getSocialLinks = exports.getSocialLinks = (0, _reselect.createSelector)(getStore, _selectors.getCurrentGender, function (store, gender) {
  return store.socialLinks[gender];
});

var getCountryName = exports.getCountryName = (0, _reselect.createSelector)(getStore, function (store) {
  return store.countryName;
});

var getCountryCode = exports.getCountryCode = (0, _reselect.createSelector)(getStore, function (store) {
  return store.countryCode;
});

var isCorrectCountry = exports.isCorrectCountry = (0, _reselect.createSelector)(getStore, function (store) {
  var context = (0, _context.getContext)();
  var geoCountry = context && context.getGeoCountry();
  return geoCountry === store.countryCode;
});

var getCountryFlag = exports.getCountryFlag = (0, _reselect.createSelector)(getStore, function (store) {
  return store.countryFlag;
});

var getDefaultLanguage = exports.getDefaultLanguage = (0, _reselect.createSelector)(getStore, function (store) {
  return store.defaultLanguage;
});

var getDefaultStoreUrl = exports.getDefaultStoreUrl = (0, _reselect.createSelector)(getStore, function (store) {
  return store.storeUrls[_layout.DEFAULT];
});

var getSearchUrl = exports.getSearchUrl = (0, _reselect.createSelector)(getDefaultStoreUrl, function (url) {
  return (0, _removeProtocolFromUrl2.default)(url) + _constants.SEARCH_PATH;
});

var getStoreUrlForWomen = exports.getStoreUrlForWomen = (0, _reselect.createSelector)(getStore, function (store) {
  return store.storeUrls[_layout.FEMALE];
});

var getStoreUrlForMen = exports.getStoreUrlForMen = (0, _reselect.createSelector)(getStore, function (store) {
  return store.storeUrls[_layout.MALE];
});

var getSecureStoreUrl = exports.getSecureStoreUrl = (0, _reselect.createSelector)(getStore, function (store) {
  return store.storeUrls[_layout.SECURE];
});

var getStoreCode = exports.getStoreCode = (0, _reselect.createSelector)(getStore, function (store) {
  return store.storeCode;
});

var getKeyStoreDataversion = exports.getKeyStoreDataversion = (0, _reselect.createSelector)(getStore, function (store) {
  return store.keyStoreDataversion;
});

var getDefaultSizeSchema = exports.getDefaultSizeSchema = (0, _reselect.createSelector)(getStore, function (store) {
  return store.defaultSizeSchema;
});

var getDefaultCurrency = exports.getDefaultCurrency = (0, _reselect.createSelector)(getStore, function (store) {
  return store.defaultCurrency;
});

var getCurrency = exports.getCurrency = (0, _reselect.createSelector)(getStore, getDefaultCurrency, function (store, defaultCurrency) {
  return store.browseCurrency || defaultCurrency;
});

var getCurrencies = exports.getCurrencies = (0, _reselect.createSelector)(getStore, function (store) {
  return store.currencies;
});

var getCurrencyId = exports.getCurrencyId = (0, _reselect.createSelector)(getCurrency, getCurrencies, function (currencyCode, currencies) {
  return currencies.find(function (_ref) {
    var currency = _ref.currency;
    return currency === currencyCode;
  }).currencyId;
});

var getDefaultCountry = exports.getDefaultCountry = (0, _reselect.createSelector)(getStore, function (store) {
  return store.defaultCountry;
});

var getPaymentProviders = exports.getPaymentProviders = (0, _reselect.createSelector)(getStore, function (store) {
  return store.paymentProviders;
});

var getSiteId = exports.getSiteId = (0, _reselect.createSelector)(getStore, function (store) {
  return store.siteId;
});

/***/ }),

/***/ "./template/state/modules/savedItems/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSavedItemsFromSDK = undefined;

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _constants = __webpack_require__("./template/state/modules/savedItems/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import logger from "../../../../helpers/logger";

var sdkRequest = /* istanbul ignore next */function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // try {
            //   const { savedItemProducts } = await window.__sdk.savedItems.getSavedItems();
            //
            //   dispatch({ type: GET_SAVED_ITEMS, payload: savedItemProducts });
            // } catch (err) {
            //   logger.error(`Error while fetching saved items: ${err}`);
            //
            //   dispatch({ type: GET_SAVED_ITEMS, error: true, payload: err });
            // }
            dispatch({ type: _constants.GET_SAVED_ITEMS, payload: [] });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function sdkRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getSavedItemsFromSDK = /* istanbul ignore next */exports.getSavedItemsFromSDK = function getSavedItemsFromSDK() {
  return (/* istanbul ignore next */function (dispatch) {
      return new _promise2.default(function (resolve) {
        if (window.analyticsEventEmitter && (!window.__sdk || !window.__sdk.savedItems)) {
          window.analyticsEventEmitter.addListener("sdk-ready", function () {
            return resolve(sdkRequest(dispatch));
          });
        } else {
          resolve(sdkRequest(dispatch));
        }
      });
    }
  );
};

/***/ }),

/***/ "./template/state/modules/savedItems/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_SAVED_ITEMS = exports.GET_SAVED_ITEMS = "GET_SAVED_ITEMS";

/***/ }),

/***/ "./template/state/modules/savedItems/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSavedItemsFromSDK = exports.hasSavedItems = exports.getItems = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _selectors = __webpack_require__("./template/state/modules/savedItems/selectors.js");

Object.defineProperty(exports, "getItems", {
  enumerable: true,
  get: function get() {
    return _selectors.getItems;
  }
});
Object.defineProperty(exports, "hasSavedItems", {
  enumerable: true,
  get: function get() {
    return _selectors.hasSavedItems;
  }
});

var _actions = __webpack_require__("./template/state/modules/savedItems/actions.js");

Object.defineProperty(exports, "getSavedItemsFromSDK", {
  enumerable: true,
  get: function get() {
    return _actions.getSavedItemsFromSDK;
  }
});

var _constants = __webpack_require__("./template/state/modules/savedItems/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  items: []
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.GET_SAVED_ITEMS:
      return (0, _extends3.default)({}, state, { items: action.payload });
    default:
      return state;
  }
};

/***/ }),

/***/ "./template/state/modules/savedItems/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasSavedItems = exports.getItems = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var getSavedItems = function getSavedItems(state) {
  return state.savedItems;
};

var getItems = exports.getItems = (0, _reselect.createSelector)(getSavedItems, function (saved) {
  return saved.items;
});

var hasSavedItems = exports.hasSavedItems = (0, _reselect.createSelector)(getItems, function (items) {
  return items.length > 0;
});

/***/ }),

/***/ "./template/state/modules/search/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadSuggestions = exports.setSearchTerm = exports.openSearch = exports.closeSearch = exports.clearRecentSearches = exports.submitSearch = exports.receiveSuggestions = exports.requestSuggestions = undefined;

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _constants = __webpack_require__("./template/state/modules/search/constants.js");

var _selectors = __webpack_require__("./template/state/modules/search/selectors.js");

var _searchTermCleanser = __webpack_require__("./template/helpers/searchTermCleanser.js");

var _searchTermCleanser2 = _interopRequireDefault(_searchTermCleanser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestSuggestions = exports.requestSuggestions = function requestSuggestions(term) {
  return {
    type: _constants.REQUEST_SUGGESTIONS,
    payload: term
  };
};

var receiveSuggestions = exports.receiveSuggestions = function receiveSuggestions(term, suggestions) {
  return {
    type: _constants.RECEIVE_SUGGESTIONS,
    payload: suggestions,
    meta: { term: term }
  };
};

var submitSearch = exports.submitSearch = function submitSearch(term) {
  return {
    type: _constants.SUBMIT_SEARCH,
    payload: term
  };
};

var clearRecentSearches = exports.clearRecentSearches = function clearRecentSearches() {
  return { type: _constants.CLEAR_RECENT_SEARCHES };
};

var closeSearch = exports.closeSearch = function closeSearch() {
  return {
    type: _constants.CLOSE_SEARCH
  };
};

var openSearch = exports.openSearch = function openSearch() {
  return {
    type: _constants.OPEN_SEARCH
  };
};

var setSearchTerm = exports.setSearchTerm = function setSearchTerm(term) {
  return {
    type: _constants.SET_SEARCH_TERM,
    payload: (0, _searchTermCleanser2.default)(term)
  };
};

var loadSuggestions = exports.loadSuggestions = function loadSuggestions() {
  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState, _ref) {
      var api = _ref.api;
      var state, regionalStore, search, suggestions;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              regionalStore = state.regionalStore, search = state.search;

              if ((0, _selectors.termLongEnoughToSearch)(state)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", dispatch(receiveSuggestions(search.term, [])));

            case 4:

              dispatch(requestSuggestions(search.term));

              _context.prev = 5;
              _context.next = 8;
              return api.fetchSuggestions(regionalStore.siteId, regionalStore.defaultLanguage, search.term, regionalStore.countryCode);

            case 8:
              suggestions = _context.sent;


              dispatch(receiveSuggestions(search.term, parse(suggestions)));
              _context.next = 14;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[5, 12]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

function parse(responseJson) {
  return responseJson && responseJson.suggestionGroups && responseJson.suggestionGroups[0] && responseJson.suggestionGroups[0].suggestions || [];
}

/***/ }),

/***/ "./template/state/modules/search/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MINIMUM_SUGGESTIONS_CHARS = exports.MINIMUM_SUGGESTIONS_CHARS = 2;
var MAXIMUM_RECENT_SEARCHES = exports.MAXIMUM_RECENT_SEARCHES = 5;

var REQUEST_SUGGESTIONS = exports.REQUEST_SUGGESTIONS = "REQUEST_SUGGESTIONS";
var RECEIVE_SUGGESTIONS = exports.RECEIVE_SUGGESTIONS = "RECEIVE_SUGGESTIONS";
var SUBMIT_SEARCH = exports.SUBMIT_SEARCH = "SUBMIT_SEARCH";
var CLEAR_RECENT_SEARCHES = exports.CLEAR_RECENT_SEARCHES = "CLEAR_RECENT_SEARCHES";
var SET_SEARCH_TERM = exports.SET_SEARCH_TERM = "SET_SEARCH_TERM";
var CLOSE_SEARCH = exports.CLOSE_SEARCH = "CLOSE_SEARCH";
var OPEN_SEARCH = exports.OPEN_SEARCH = "OPEN_SEARCH";

/***/ }),

/***/ "./template/state/modules/search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSearchResultsPanelOpen = exports.getResultVisibility = exports.getSearchTerm = exports.getVisibility = exports.getSearchHistory = exports.getSearchSuggestions = exports.openSearch = exports.closeSearch = exports.setSearchTerm = exports.clearRecentSearches = exports.submitSearch = exports.loadSuggestions = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _actions = __webpack_require__("./template/state/modules/search/actions.js");

Object.defineProperty(exports, "loadSuggestions", {
  enumerable: true,
  get: function get() {
    return _actions.loadSuggestions;
  }
});
Object.defineProperty(exports, "submitSearch", {
  enumerable: true,
  get: function get() {
    return _actions.submitSearch;
  }
});
Object.defineProperty(exports, "clearRecentSearches", {
  enumerable: true,
  get: function get() {
    return _actions.clearRecentSearches;
  }
});
Object.defineProperty(exports, "setSearchTerm", {
  enumerable: true,
  get: function get() {
    return _actions.setSearchTerm;
  }
});
Object.defineProperty(exports, "closeSearch", {
  enumerable: true,
  get: function get() {
    return _actions.closeSearch;
  }
});
Object.defineProperty(exports, "openSearch", {
  enumerable: true,
  get: function get() {
    return _actions.openSearch;
  }
});

var _selectors = __webpack_require__("./template/state/modules/search/selectors.js");

Object.defineProperty(exports, "getSearchSuggestions", {
  enumerable: true,
  get: function get() {
    return _selectors.getSearchSuggestions;
  }
});
Object.defineProperty(exports, "getSearchHistory", {
  enumerable: true,
  get: function get() {
    return _selectors.getSearchHistory;
  }
});
Object.defineProperty(exports, "getVisibility", {
  enumerable: true,
  get: function get() {
    return _selectors.getVisibility;
  }
});
Object.defineProperty(exports, "getSearchTerm", {
  enumerable: true,
  get: function get() {
    return _selectors.getSearchTerm;
  }
});
Object.defineProperty(exports, "getResultVisibility", {
  enumerable: true,
  get: function get() {
    return _selectors.getResultVisibility;
  }
});
Object.defineProperty(exports, "isSearchResultsPanelOpen", {
  enumerable: true,
  get: function get() {
    return _selectors.isSearchResultsPanelOpen;
  }
});

var _constants = __webpack_require__("../node_modules/redux-persist/es/constants.js");

var _searchTermCleanser = __webpack_require__("./template/helpers/searchTermCleanser.js");

var _searchTermCleanser2 = _interopRequireDefault(_searchTermCleanser);

var _constants2 = __webpack_require__("./template/state/modules/search/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  recent: [],
  suggestions: [],
  term: "",
  isVisible: false
};

var addToSearchArray = function addToSearchArray(arr, newItem) {
  var item = (0, _searchTermCleanser2.default)(newItem);
  if (!item && !item.length) {
    return arr;
  }

  if (arr.length === _constants2.MAXIMUM_RECENT_SEARCHES) {
    arr.pop();
  }

  arr.unshift(item);

  return arr;
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === _constants2.SUBMIT_SEARCH) {
    if (state.recent.indexOf(action.payload) === -1) {
      return (0, _extends3.default)({}, state, {
        recent: addToSearchArray(state.recent, action.payload)
      });
    } else {
      return state;
    }
  }

  if (action.type === _constants2.SET_SEARCH_TERM) {
    return (0, _extends3.default)({}, state, {
      term: action.payload
    });
  }

  if (action.type === _constants2.RECEIVE_SUGGESTIONS) {
    if (state.term === action.meta.term) {
      return (0, _extends3.default)({}, state, {
        suggestions: action.meta.term.length < _constants2.MINIMUM_SUGGESTIONS_CHARS || action.payload.length > 0 ? action.payload : state.suggestions,
        isLoading: false
      });
    }

    return (0, _extends3.default)({}, state, {
      isLoading: false
    });
  }

  if (action.type === _constants.REHYDRATE && action.payload && action.payload.search) {
    return (0, _extends3.default)({}, state, { recent: action.payload.search.recent });
  }

  if (action.type === _constants2.CLOSE_SEARCH) {
    return (0, _extends3.default)({}, state, {
      isVisible: false
    });
  }

  if (action.type === _constants2.OPEN_SEARCH) {
    return (0, _extends3.default)({}, state, {
      isVisible: true
    });
  }

  if (action.type === _constants2.CLEAR_RECENT_SEARCHES) {
    return (0, _extends3.default)({}, state, { recent: [] });
  }

  if (action.type === _constants2.REQUEST_SUGGESTIONS) {
    return (0, _extends3.default)({}, state, { isLoading: true });
  }

  return state;
};

/***/ }),

/***/ "./template/state/modules/search/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSearchResultsPanelOpen = exports.getResultVisibility = exports.getLoadingStatus = exports.termLongEnoughToSearch = exports.getVisibility = exports.getSearchHistory = exports.getSearchTerm = exports.getSearchSuggestions = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _constants = __webpack_require__("./template/state/modules/search/constants.js");

var getSearch = function getSearch(state) {
  return state.search;
};

var hasHistoryOrSuggestions = function hasHistoryOrSuggestions(suggestions, history) {
  return suggestions.length > 0 || history.length > 0;
};

var getSearchSuggestions = exports.getSearchSuggestions = (0, _reselect.createSelector)(getSearch, function (search) {
  return search.suggestions;
});

var getSearchTerm = exports.getSearchTerm = (0, _reselect.createSelector)(getSearch, function (search) {
  return search.term;
});

var getSearchHistory = exports.getSearchHistory = (0, _reselect.createSelector)(getSearch, function (search) {
  return search.recent;
});

var getVisibility = exports.getVisibility = (0, _reselect.createSelector)(getSearch, function (search) {
  return search.isVisible || false;
});

var termLongEnoughToSearch = exports.termLongEnoughToSearch = (0, _reselect.createSelector)(getSearch, function (search) {
  return search.term.length >= _constants.MINIMUM_SUGGESTIONS_CHARS;
});

// needs to add loading icon
var getLoadingStatus = exports.getLoadingStatus = (0, _reselect.createSelector)(getSearch,
/* istanbul ignore next */function (search) {
  return search.isLoading;
});

var getResultVisibility = exports.getResultVisibility = (0, _reselect.createSelector)(getVisibility, getSearchHistory, getSearchSuggestions, function (isVisible, history, suggestions) {
  return isVisible && hasHistoryOrSuggestions(suggestions, history);
});

var isSearchResultsPanelOpen = exports.isSearchResultsPanelOpen = (0, _reselect.createSelector)(getSearchSuggestions, getSearchHistory, function (suggestions, history) {
  return hasHistoryOrSuggestions(suggestions, history);
});

/***/ }),

/***/ "./template/state/modules/user/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserPreferences = exports.setUserReconsentStatus = exports.setUserFetchingState = exports.setUserProfile = exports.setLoggedInState = exports.optOut = exports.optIn = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = __webpack_require__("../node_modules/babel-runtime/helpers/slicedToArray.js");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _constants = __webpack_require__("./template/state/modules/user/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACCEPTED_PREFERENCE_IDS = ["newness", "promos", "lifestyle", "partner"];

var formatPreferences = function formatPreferences(preferences, isOptOut) {
  return preferences.filter(function (_ref) {
    var id = _ref.preferenceId;
    return ACCEPTED_PREFERENCE_IDS.indexOf(id) !== -1;
  }).map(function (_ref2) {
    var customerChannels = _ref2.customerChannels,
        preferenceId = _ref2.preferenceId;
    return {
      customerChannels: isOptOut ? [] : customerChannels,
      preferenceId: preferenceId
    };
  });
};

var optIn = exports.optIn = function optIn() {
  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, _, _ref3) {
      var api = _ref3.api,
          identity = _ref3.identity;
      var userPreferences, userProfile, preferences, response;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              dispatch({ type: _constants.LOADING_OPT_IN });
              _context.next = 4;
              return identity.customer.preferences();

            case 4:
              userPreferences = _context.sent;
              _context.next = 7;
              return identity.customer.profile();

            case 7:
              userProfile = _context.sent;
              preferences = formatPreferences(userPreferences, false);
              _context.next = 11;
              return api.updatePreferences(userProfile.customerGuid, preferences);

            case 11:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              identity.customer.resetLocalCopy();
              dispatch({ type: _constants.SET_OPT_IN });
              _context.next = 18;
              break;

            case 17:
              throw new Error(response.statusText);

            case 18:
              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](0);

              dispatch({ type: _constants.SET_OPT_IN, error: true, payload: _context.t0 });

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 20]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var optOut = exports.optOut = function optOut() {
  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, _, _ref5) {
      var api = _ref5.api,
          identity = _ref5.identity;
      var userPreferences, userProfile, preferences, response;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              dispatch({ type: _constants.LOADING_OPT_OUT });
              _context2.next = 4;
              return identity.customer.preferences();

            case 4:
              userPreferences = _context2.sent;
              _context2.next = 7;
              return identity.customer.profile();

            case 7:
              userProfile = _context2.sent;
              preferences = formatPreferences(userPreferences, true);
              _context2.next = 11;
              return api.updatePreferences(userProfile.customerGuid, preferences);

            case 11:
              response = _context2.sent;

              if (!response.ok) {
                _context2.next = 17;
                break;
              }

              identity.customer.resetLocalCopy();
              dispatch({ type: _constants.SET_OPT_OUT });
              _context2.next = 18;
              break;

            case 17:
              throw new Error(response.statusText);

            case 18:
              _context2.next = 23;
              break;

            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](0);

              dispatch({ type: _constants.SET_OPT_OUT, error: true, payload: _context2.t0 });

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined, [[0, 20]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var setLoggedInState = exports.setLoggedInState = function setLoggedInState(loggedInState) {
  return {
    type: _constants.LOG_IN_USER,
    payload: loggedInState
  };
};

var setUserProfile = exports.setUserProfile = function setUserProfile(profile) {
  return {
    type: _constants.SET_USER_PROFILE,
    payload: profile
  };
};

var setUserFetchingState = exports.setUserFetchingState = function setUserFetchingState(status) {
  return {
    type: _constants.SET_USER_FETCHING_STATUS,
    payload: status
  };
};

var setUserReconsentStatus = exports.setUserReconsentStatus = function setUserReconsentStatus(status) {
  return {
    type: _constants.SET_USER_RECONSENT_STATUS,
    payload: status
  };
};

var setUserPreferences = exports.setUserPreferences = function setUserPreferences() {
  return function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState, _ref7) {
      var api = _ref7.api,
          identity = _ref7.identity;

      var serviceId, _getState, regionalStore, userPreferencesPromise, systemPreferencesPromise, _ref9, _ref10, userPreferences, systemPreferences, service, mergedPreferences;

      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              serviceId = "marketing";
              _getState = getState(), regionalStore = _getState.regionalStore;
              userPreferencesPromise = identity.customer.preferences();
              systemPreferencesPromise = api.fetchPreferences(regionalStore.countryCode, regionalStore.defaultLanguage);
              _context3.next = 7;
              return _promise2.default.all([userPreferencesPromise, systemPreferencesPromise]);

            case 7:
              _ref9 = _context3.sent;
              _ref10 = (0, _slicedToArray3.default)(_ref9, 2);
              userPreferences = _ref10[0];
              systemPreferences = _ref10[1];
              service = systemPreferences.services.find(function (service) {
                return service.serviceId == serviceId;
              });
              mergedPreferences = service.preferences.map(function (systemPreference) {
                var preference = userPreferences.find(function (userPreference) {
                  return userPreference.preferenceId == systemPreference.preferenceId;
                });

                return (0, _extends3.default)({}, systemPreference, preference);
              });


              service.preferences = mergedPreferences;

              return _context3.abrupt("return", dispatch({ type: _constants.SET_USER_PREFERENCES, payload: service }));

            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](0);

              dispatch({
                error: true,
                payload: _context3.t0,
                type: _constants.SET_USER_PREFERENCES
              });

              throw _context3.t0;

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[0, 17]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref8.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ "./template/state/modules/user/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FAILED = exports.FAILED = "FAILED";
var FETCHING = exports.FETCHING = "FETCHING";
var LOADING_OPT_IN = exports.LOADING_OPT_IN = "LOADING_OPT_IN";
var LOADING_OPT_OUT = exports.LOADING_OPT_OUT = "LOADING_OPT_OUT";
var LOG_IN_USER = exports.LOG_IN_USER = "LOG_IN_USER";
var SET_OPT_IN = exports.SET_OPT_IN = "SET_OPT_IN";
var SET_OPT_OUT = exports.SET_OPT_OUT = "SET_OPT_OUT";
var SET_USER_FETCHING_STATUS = exports.SET_USER_FETCHING_STATUS = "SET_USER_FETCHING_STATUS";
var SET_USER_PREFERENCES = exports.SET_USER_PREFERENCES = "SET_USER_PREFERENCES";
var SET_USER_PROFILE = exports.SET_USER_PROFILE = "SET_USER_PROFILE";
var SET_USER_RECONSENT_STATUS = exports.SET_USER_RECONSENT_STATUS = "SET_USER_RECONSENT_STATUS";
var SUCCESS = exports.SUCCESS = "SUCCESS";

/***/ }),

/***/ "./template/state/modules/user/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserReconsentStatus = exports.setUserProfile = exports.setUserPreferences = exports.setUserFetchingState = exports.setLoggedInState = exports.optOut = exports.optIn = exports.isLoggedIn = exports.getTermsUrlSegment = exports.getPrivacyUrlSegment = exports.getPreferences = exports.getIsReconsentRequired = exports.getIsRecognised = exports.getIsPremier = exports.getIsOptOutLoading = exports.getIsOptInLoading = exports.getIdentityHasResponded = exports.getHasReconsented = exports.getHasErrors = exports.getFirstName = exports.getCustomerId = exports.getCustomerGuid = exports.FETCHING = exports.FAILED = exports.SUCCESS = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__("./template/state/modules/user/constants.js");

Object.defineProperty(exports, "SUCCESS", {
  enumerable: true,
  get: function get() {
    return _constants.SUCCESS;
  }
});
Object.defineProperty(exports, "FAILED", {
  enumerable: true,
  get: function get() {
    return _constants.FAILED;
  }
});
Object.defineProperty(exports, "FETCHING", {
  enumerable: true,
  get: function get() {
    return _constants.FETCHING;
  }
});

var _selectors = __webpack_require__("./template/state/modules/user/selectors.js");

Object.defineProperty(exports, "getCustomerGuid", {
  enumerable: true,
  get: function get() {
    return _selectors.getCustomerGuid;
  }
});
Object.defineProperty(exports, "getCustomerId", {
  enumerable: true,
  get: function get() {
    return _selectors.getCustomerId;
  }
});
Object.defineProperty(exports, "getFirstName", {
  enumerable: true,
  get: function get() {
    return _selectors.getFirstName;
  }
});
Object.defineProperty(exports, "getHasErrors", {
  enumerable: true,
  get: function get() {
    return _selectors.getHasErrors;
  }
});
Object.defineProperty(exports, "getHasReconsented", {
  enumerable: true,
  get: function get() {
    return _selectors.getHasReconsented;
  }
});
Object.defineProperty(exports, "getIdentityHasResponded", {
  enumerable: true,
  get: function get() {
    return _selectors.getIdentityHasResponded;
  }
});
Object.defineProperty(exports, "getIsOptInLoading", {
  enumerable: true,
  get: function get() {
    return _selectors.getIsOptInLoading;
  }
});
Object.defineProperty(exports, "getIsOptOutLoading", {
  enumerable: true,
  get: function get() {
    return _selectors.getIsOptOutLoading;
  }
});
Object.defineProperty(exports, "getIsPremier", {
  enumerable: true,
  get: function get() {
    return _selectors.getIsPremier;
  }
});
Object.defineProperty(exports, "getIsRecognised", {
  enumerable: true,
  get: function get() {
    return _selectors.getIsRecognised;
  }
});
Object.defineProperty(exports, "getIsReconsentRequired", {
  enumerable: true,
  get: function get() {
    return _selectors.getIsReconsentRequired;
  }
});
Object.defineProperty(exports, "getPreferences", {
  enumerable: true,
  get: function get() {
    return _selectors.getPreferences;
  }
});
Object.defineProperty(exports, "getPrivacyUrlSegment", {
  enumerable: true,
  get: function get() {
    return _selectors.getPrivacyUrlSegment;
  }
});
Object.defineProperty(exports, "getTermsUrlSegment", {
  enumerable: true,
  get: function get() {
    return _selectors.getTermsUrlSegment;
  }
});
Object.defineProperty(exports, "isLoggedIn", {
  enumerable: true,
  get: function get() {
    return _selectors.isLoggedIn;
  }
});

var _actions = __webpack_require__("./template/state/modules/user/actions.js");

Object.defineProperty(exports, "optIn", {
  enumerable: true,
  get: function get() {
    return _actions.optIn;
  }
});
Object.defineProperty(exports, "optOut", {
  enumerable: true,
  get: function get() {
    return _actions.optOut;
  }
});
Object.defineProperty(exports, "setLoggedInState", {
  enumerable: true,
  get: function get() {
    return _actions.setLoggedInState;
  }
});
Object.defineProperty(exports, "setUserFetchingState", {
  enumerable: true,
  get: function get() {
    return _actions.setUserFetchingState;
  }
});
Object.defineProperty(exports, "setUserPreferences", {
  enumerable: true,
  get: function get() {
    return _actions.setUserPreferences;
  }
});
Object.defineProperty(exports, "setUserProfile", {
  enumerable: true,
  get: function get() {
    return _actions.setUserProfile;
  }
});
Object.defineProperty(exports, "setUserReconsentStatus", {
  enumerable: true,
  get: function get() {
    return _actions.setUserReconsentStatus;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  fetchingStatus: null,
  isLoggedIn: false,
  isReconsentRequired: false,
  preferences: [],
  profile: {}
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.LOADING_OPT_IN:
      return (0, _extends3.default)({}, state, {
        isOptInLoading: true
      });
    case _constants.LOADING_OPT_OUT:
      return (0, _extends3.default)({}, state, {
        isOptOutLoading: true
      });
    case _constants.LOG_IN_USER:
      return (0, _extends3.default)({}, state, {
        isLoggedIn: action.payload
      });
    case _constants.SET_USER_PROFILE:
      return (0, _extends3.default)({}, state, {
        profile: action.payload
      });
    case _constants.SET_USER_FETCHING_STATUS:
      return (0, _extends3.default)({}, state, {
        fetchingStatus: action.payload
      });
    case _constants.SET_USER_RECONSENT_STATUS:
      return (0, _extends3.default)({}, state, {
        isReconsentRequired: action.payload
      });
    case _constants.SET_USER_PREFERENCES:
      return (0, _extends3.default)({}, state, {
        preferences: action.payload.preferences,
        privacyUrlSegment: action.payload.privacyPolicyUrlSegment,
        termsUrlSegment: action.payload.termsConditionsUrlSegment
      });
    case _constants.SET_OPT_IN:
      return (0, _extends3.default)({}, state, {
        hasError: !!action.error,
        hasReconsented: action.error ? null : true,
        isOptInLoading: false,
        isReconsentRequired: !!action.error
      });
    case _constants.SET_OPT_OUT:
      return (0, _extends3.default)({}, state, {
        hasError: !!action.error,
        hasReconsented: action.error ? null : false,
        isOptOutLoading: false,
        isReconsentRequired: !!action.error
      });
    default:
      return state;
  }
};

/***/ }),

/***/ "./template/state/modules/user/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTermsUrlSegment = exports.getPrivacyUrlSegment = exports.getPreferences = exports.getIsPremier = exports.getIdentityHasResponded = exports.getIsReconsentRequired = exports.getHasReconsented = exports.getCustomerId = exports.getIsRecognised = exports.getCustomerGuid = exports.getIsOptOutLoading = exports.getIsOptInLoading = exports.getFirstName = exports.getHasErrors = exports.isLoggedIn = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _constants = __webpack_require__("./template/state/modules/user/constants.js");

var getUser = function getUser(state) {
  return state.user;
};

var isLoggedIn = exports.isLoggedIn = (0, _reselect.createSelector)(getUser, function (user) {
  return user.isLoggedIn;
});

var getHasErrors = exports.getHasErrors = (0, _reselect.createSelector)(getUser, function (user) {
  return user.hasError;
});

var getFirstName = exports.getFirstName = (0, _reselect.createSelector)(getUser, function (user) {
  return user.profile.firstName;
});

var getIsOptInLoading = exports.getIsOptInLoading = (0, _reselect.createSelector)(getUser, function (user) {
  return user.isOptInLoading;
});

var getIsOptOutLoading = exports.getIsOptOutLoading = (0, _reselect.createSelector)(getUser, function (user) {
  return user.isOptOutLoading;
});

var getCustomerGuid = exports.getCustomerGuid = (0, _reselect.createSelector)(getUser, function (user) {
  return user.profile.customerGuid;
});

var getIsRecognised = exports.getIsRecognised = (0, _reselect.createSelector)(getUser, function (user) {
  return user.profile.isRecognised;
});

var getCustomerId = exports.getCustomerId = (0, _reselect.createSelector)(getUser, function (user) {
  return user.profile.customerId;
});

var getHasReconsented = exports.getHasReconsented = (0, _reselect.createSelector)(getUser, function (user) {
  return user.hasReconsented;
});

var getIsReconsentRequired = exports.getIsReconsentRequired = (0, _reselect.createSelector)(getUser, function (user) {
  return user.isReconsentRequired;
});

var getIdentityHasResponded = exports.getIdentityHasResponded = (0, _reselect.createSelector)(getUser, function (user) {
  return [_constants.SUCCESS, _constants.FAILED].indexOf(user.fetchingStatus) !== -1;
});

var getIsPremier = exports.getIsPremier = (0, _reselect.createSelector)(getUser, function (user) {
  return !!(user && user.profile && user.profile.subscriptions);
});

var getPreferences = exports.getPreferences = (0, _reselect.createSelector)(getUser, function (user) {
  return user.preferences;
});

var getPrivacyUrlSegment = exports.getPrivacyUrlSegment = (0, _reselect.createSelector)(getUser, function (user) {
  return user.privacyUrlSegment;
});

var getTermsUrlSegment = exports.getTermsUrlSegment = (0, _reselect.createSelector)(getUser, function (user) {
  return user.termsUrlSegment;
});

/***/ }),

/***/ "./template/state/modules/version/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return state;
};

/***/ }),

/***/ "./template/state/modules/welcomeMat/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestWelcomeMat = undefined;

var _constants = __webpack_require__("./template/state/modules/welcomeMat/constants.js");

var requestWelcomeMat = exports.requestWelcomeMat = function requestWelcomeMat(platform) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;

    var _getState = getState(),
        regionalStore = _getState.regionalStore;

    var keyStoreDataversion = regionalStore.keyStoreDataversion,
        countryCode = regionalStore.countryCode;
    var fetchWelcomeMat = api.fetchWelcomeMat;

    fetchWelcomeMat(countryCode, platform, keyStoreDataversion).then(function (res) {
      dispatch({ type: _constants.RECEIVE_WELCOME_MAT, payload: res });
    });
  };
};

/***/ }),

/***/ "./template/state/modules/welcomeMat/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RECEIVE_WELCOME_MAT = exports.RECEIVE_WELCOME_MAT = "RECEIVE_WELCOME_MAT";

/***/ }),

/***/ "./template/state/modules/welcomeMat/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWelcomeText = exports.getPaymentOptions = exports.getValueHeader = exports.getValuePropositionMessages = exports.getWelcomeMatCountry = exports.getWelcomeMatRedirectUrl = exports.getWelcomeMessage = exports.requestWelcomeMat = undefined;

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _actions = __webpack_require__("./template/state/modules/welcomeMat/actions.js");

Object.defineProperty(exports, "requestWelcomeMat", {
  enumerable: true,
  get: function get() {
    return _actions.requestWelcomeMat;
  }
});

var _selectors = __webpack_require__("./template/state/modules/welcomeMat/selectors.js");

Object.defineProperty(exports, "getWelcomeMessage", {
  enumerable: true,
  get: function get() {
    return _selectors.getWelcomeMessage;
  }
});
Object.defineProperty(exports, "getWelcomeMatRedirectUrl", {
  enumerable: true,
  get: function get() {
    return _selectors.getWelcomeMatRedirectUrl;
  }
});
Object.defineProperty(exports, "getWelcomeMatCountry", {
  enumerable: true,
  get: function get() {
    return _selectors.getWelcomeMatCountry;
  }
});
Object.defineProperty(exports, "getValuePropositionMessages", {
  enumerable: true,
  get: function get() {
    return _selectors.getValuePropositionMessages;
  }
});
Object.defineProperty(exports, "getValueHeader", {
  enumerable: true,
  get: function get() {
    return _selectors.getValueHeader;
  }
});
Object.defineProperty(exports, "getPaymentOptions", {
  enumerable: true,
  get: function get() {
    return _selectors.getPaymentOptions;
  }
});
Object.defineProperty(exports, "getWelcomeText", {
  enumerable: true,
  get: function get() {
    return _selectors.getWelcomeText;
  }
});

var _constants = __webpack_require__("./template/state/modules/welcomeMat/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _constants.RECEIVE_WELCOME_MAT:
      return (0, _extends3.default)({}, state, action.payload.data);
    default:
      return state;
  }
};

/***/ }),

/***/ "./template/state/modules/welcomeMat/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWelcomeText = exports.getPaymentOptions = exports.getValueHeader = exports.getValuePropositionMessages = exports.getWelcomeMatCountry = exports.getWelcomeMatRedirectUrl = exports.getWelcomeMessage = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var getWelcomeMat = function getWelcomeMat(state) {
  return state.welcomeMat;
};

var getWelcomeMessage = exports.getWelcomeMessage = (0, _reselect.createSelector)(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.text;
});

var getWelcomeMatRedirectUrl = exports.getWelcomeMatRedirectUrl = (0, _reselect.createSelector)(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.redirectUrl;
});

var getWelcomeMatCountry = exports.getWelcomeMatCountry = (0, _reselect.createSelector)(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.country;
});

var getValuePropositionMessages = exports.getValuePropositionMessages = (0, _reselect.createSelector)(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.messages;
});

var getValueHeader = exports.getValueHeader = (0, _reselect.createSelector)(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.valueHeader;
});

var getPaymentOptions = exports.getPaymentOptions = (0, _reselect.createSelector)(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.paymentProviders;
});

var getWelcomeText = exports.getWelcomeText = (0, _reselect.createSelector)(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.welcome;
});

/***/ }),

/***/ "./template/state/modules/welcomeMessage/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestWelcomeMessage = undefined;

var _constants = __webpack_require__("./template/state/modules/welcomeMessage/constants.js");

var requestWelcomeMessage = exports.requestWelcomeMessage = function requestWelcomeMessage(platform) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;

    var _getState = getState(),
        regionalStore = _getState.regionalStore;

    var keyStoreDataversion = regionalStore.keyStoreDataversion,
        countryCode = regionalStore.countryCode;
    var fetchWelcomeMessage = api.fetchWelcomeMessage;

    fetchWelcomeMessage(countryCode, platform, keyStoreDataversion).then(function (res) {
      dispatch({ type: _constants.RECEIVE_WELCOME_MESSAGE, payload: res });
    });
  };
};

/***/ }),

/***/ "./template/state/modules/welcomeMessage/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RECEIVE_WELCOME_MESSAGE = exports.RECEIVE_WELCOME_MESSAGE = "RECEIVE_WELCOME_MESSAGE";

/***/ }),

/***/ "./template/state/modules/welcomeMessage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__("./template/state/modules/welcomeMessage/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _constants.RECEIVE_WELCOME_MESSAGE:
      return (0, _extends3.default)({}, state, action.payload);
    default:
      return state;
  }
};

/***/ }),

/***/ "./template/styles/fonts.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"web-fonts-base-path":"https\\://assets.asosservices.com/MasterLayout/WebFonts","web-fonts-futura-pt-book":"FTN45__W","web-fonts-futura-pt-heavy":"FTN75__W","web-fonts-futura-pt-oblique":"FTN46__W","web-fonts-futura-pt-extra-bold-oblique":"FTN96__W"};

/***/ }),

/***/ "./template/styles/global.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./template/styles/icons recursive ^\\.\\/.*\\.svg$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./a-list.svg": "./template/styles/icons/a-list.svg",
	"./a.svg": "./template/styles/icons/a.svg",
	"./account.svg": "./template/styles/icons/account.svg",
	"./accountFilled.svg": "./template/styles/icons/accountFilled.svg",
	"./accountUnfilled.svg": "./template/styles/icons/accountUnfilled.svg",
	"./alert.svg": "./template/styles/icons/alert.svg",
	"./backArrow.svg": "./template/styles/icons/backArrow.svg",
	"./bagFilled.svg": "./template/styles/icons/bagFilled.svg",
	"./bagUnfilled.svg": "./template/styles/icons/bagUnfilled.svg",
	"./bin.svg": "./template/styles/icons/bin.svg",
	"./burger.svg": "./template/styles/icons/burger.svg",
	"./chevron-right.svg": "./template/styles/icons/chevron-right.svg",
	"./close.svg": "./template/styles/icons/close.svg",
	"./communication-preferences.svg": "./template/styles/icons/communication-preferences.svg",
	"./emoji-content.svg": "./template/styles/icons/emoji-content.svg",
	"./emoji-happy.svg": "./template/styles/icons/emoji-happy.svg",
	"./heartFilled.svg": "./template/styles/icons/heartFilled.svg",
	"./heartFilledValentines.svg": "./template/styles/icons/heartFilledValentines.svg",
	"./heartPrideFilled.svg": "./template/styles/icons/heartPrideFilled.svg",
	"./heartUnfilled.svg": "./template/styles/icons/heartUnfilled.svg",
	"./heartUnfilledValentines.svg": "./template/styles/icons/heartUnfilledValentines.svg",
	"./icon-share-facebook-normal.svg": "./template/styles/icons/icon-share-facebook-normal.svg",
	"./icon-share-google-normal.svg": "./template/styles/icons/icon-share-google-normal.svg",
	"./icon-share-instagram-normal.svg": "./template/styles/icons/icon-share-instagram-normal.svg",
	"./icon-share-pinterest-normal.svg": "./template/styles/icons/icon-share-pinterest-normal.svg",
	"./icon-share-snapchat-normal.svg": "./template/styles/icons/icon-share-snapchat-normal.svg",
	"./icon-share-twitter-normal.svg": "./template/styles/icons/icon-share-twitter-normal.svg",
	"./icon-share-vk-normal.svg": "./template/styles/icons/icon-share-vk-normal.svg",
	"./icon-share-youtube-normal.svg": "./template/styles/icons/icon-share-youtube-normal.svg",
	"./minus.svg": "./template/styles/icons/minus.svg",
	"./notification-check-green.svg": "./template/styles/icons/notification-check-green.svg",
	"./notification-exclamation-orange.svg": "./template/styles/icons/notification-exclamation-orange.svg",
	"./notification-exclamation.svg": "./template/styles/icons/notification-exclamation.svg",
	"./notification.svg": "./template/styles/icons/notification.svg",
	"./orders.svg": "./template/styles/icons/orders.svg",
	"./plus.svg": "./template/styles/icons/plus.svg",
	"./returns.svg": "./template/styles/icons/returns.svg",
	"./search.svg": "./template/styles/icons/search.svg",
	"./selected.svg": "./template/styles/icons/selected.svg",
	"./sortdown.svg": "./template/styles/icons/sortdown.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./template/styles/icons recursive ^\\.\\/.*\\.svg$";

/***/ }),

/***/ "./template/styles/icons/a-list.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <path fill=\"#000\" fill-rule=\"evenodd\" d=\"M18.66 5c2.762 4.783 1.123 10.899-3.66 13.66C10.217 21.422 4.101 19.783 1.34 15-1.422 10.217.217 4.1 5 1.34 9.783-1.422 15.899.217 18.66 5zm-11.472.14l.48 3.975-3.316 2.31 3.954.74 1.155 3.831 1.964-3.518 4.03.058-2.741-2.916 1.336-3.795-3.658 1.717L7.188 5.14z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/a.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg width=\"24px\" height=\"25px\" viewBox=\"0 0 24 25\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"loading\" transform=\"translate(-50.000000, -45.000000)\" fill=\"#2D2D2D\">\r\n            <g id=\"a\" transform=\"translate(50.000000, 45.000000)\">\r\n                <g id=\"Shape\">\r\n                    <g id=\"Page-1\">\r\n                        <path d=\"M12.0943984,19.9996697 C8.55002376,19.9996697 5.30341587,17.2294005 5.30341587,12.2673911 C5.30341587,8.37309605 7.73686712,4.59960313 12.1172061,4.59960313 C14.0149939,4.59960313 18.825194,5.24545398 18.825194,12.2673911 C18.825194,19.3072597 13.8024392,19.9996697 12.0943984,19.9996697 L12.0943984,19.9996697 L12.0943984,19.9996697 Z M24,1.01517812 C24,0.795280538 23.818489,0.615650322 23.5980149,0.615650322 L19.3187266,0.615650322 C19.0979357,0.615650322 18.9170582,0.795280538 18.9170582,1.01517812 L18.9170582,2.1300809 C18.9170582,2.31757584 18.790349,2.38238114 18.636714,2.27353341 C17.1143023,1.17656219 14.8626788,0 12.1530014,0 C10.6305897,0 9.17628426,0.266142142 7.83094873,0.790561707 C6.48371258,1.31529586 5.2052162,2.11498064 4.03030462,3.16790941 C2.69225491,4.37593051 1.67446281,5.75351493 1.00733858,7.26070998 C0.33831371,8.76884878 0,10.4531573 0,12.2673911 C0,13.9605081 0.299984162,15.5466649 0.891082837,16.9818191 C1.48249828,18.4166587 2.38245077,19.7442236 3.56686553,20.9270775 C4.75159707,22.1108753 6.07570878,23.0102847 7.50245498,23.6007679 C8.92793412,24.1909365 10.4997624,24.4897959 12.1748588,24.4897959 C15.0559104,24.4897959 17.2172536,23.2720226 18.632596,22.1640408 C18.7890819,22.0466991 18.9170582,22.1099315 18.9170582,22.3040328 L18.9170582,23.4739886 C18.9170582,23.6935716 19.0979357,23.8732018 19.3187266,23.8732018 L23.5980149,23.8732018 C23.818489,23.8732018 24,23.6935716 24,23.4739886 L24,1.01517812 L24,1.01517812 Z\" id=\"Shape\"></path>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/account.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" focusable=\"false\">\r\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#2D2D2D\" stroke-width=\"2\" d=\"M15 6A5 5 0 1 1 5 6a5 5 0 0 1 10 0zm3.725 13H1.275c1.064-2.895 4.54-5 8.725-5 4.186 0 7.66 2.105 8.725 5z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/accountFilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" focusable=\"false\">\r\n  <path fill=\"#fff\" d=\"M16 6A6 6 0 1 1 4 6a6 6 0 0 1 12 0zm4 14H0c.553-4.006 4.819-7 10-7s9.447 2.994 10 7z\"></path>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/accountUnfilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" focusable=\"false\">\r\n  <path fill=\"#fff\" d=\"M14 6a4 4 0 1 0-8 0 4 4 0 0 0 8 0zm2 0A6 6 0 1 1 4 6a6 6 0 0 1 12 0zm-6 9c-3.068 0-5.67 1.223-7.035 3h14.07c-1.365-1.777-3.967-3-7.035-3zm10 5H0c.553-4.006 4.819-7 10-7s9.447 2.994 10 7z\"></path>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/alert.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <defs>\r\n        <filter id=\"a\" width=\"101.9%\" height=\"105.4%\" x=\"-.9%\" y=\"-1.9%\" filterUnits=\"objectBoundingBox\">\r\n            <feOffset dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"1\"/>\r\n            <feColorMatrix in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n    </defs>\r\n    <g fill=\"#2D2D2D\" fill-rule=\"evenodd\" filter=\"url(#a)\" transform=\"translate(-14 -18)\">\r\n        <path fill-rule=\"nonzero\" d=\"M25 35a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm0-16a9 9 0 1 0 0 18 9 9 0 0 0 0-18z\"/>\r\n        <path d=\"M24 27v6h2v-6h-2zm0-3c0 .548.452 1 1 1s1-.452 1-1-.452-1-1-1-1 .452-1 1z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/backArrow.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21\" height=\"15\" viewBox=\"0 0 21 15\">\r\n    <path d=\"M3.817 8.06h16.194v-2H3.817l4.646-4.646L7.05 0 0 7.049l.011.011L0 7.071l7.049 7.049 1.414-1.414L3.817 8.06z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/bagFilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\">\r\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M4.083 5a6.002 6.002 0 0 1 11.834 0H20v14.986L0 20V5h4.083zM14 5c0-1.001-1.06-3.274-4-3.274S6 4.006 6 5c0 0 8 .012 8 0z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/bagUnfilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\">\r\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M18 17.987V7H2v11l16-.013zM4.077 5A5.996 5.996 0 0 1 10 0c2.973 0 5.562 2.162 6.038 5H20v14.986L0 20V5h4.077zm9.902-.005C13.531 3.275 11.86 2 10 2 8.153 2 6.604 3.294 6.144 4.995c.92 0 7.654.03 7.835 0z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/bin.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"20\" viewBox=\"0 0 16 20\">\r\n    <path fill=\"#666\" fill-rule=\"evenodd\" d=\"M0 5h16v2H0V5zm14 3.07v9.27c0 1.47-1.15 2.66-2.574 2.66H4.574C3.153 20 2 18.797 2 17.34V8.07h12zM4 17.15c0 .462.363.85.803.85h6.394c.446 0 .803-.381.803-.85V8.1H4v9.05zM6 9h1v8H6V9zm3 0h1v8H9V9zM7 0h2c1.656 0 3 1.339 3 3v1.038H4V3c0-1.656 1.339-3 3-3zm3 3.999V3c0-.554-.446-1-1-1H7c-.554 0-1 .446-1 1v.999h4z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/burger.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 14\">\r\n    <g>\r\n        <path d=\"M0 0h18v2H0zM0 6h18v2H0zM0 12h18v2H0z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/chevron-right.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"44\" viewBox=\"0 0 44 44\">\r\n    <path fill=\"#2D2D2D\" fill-rule=\"evenodd\" d=\"M26.364 21.293l.707.707L20 29.071l-1.414-1.414L24.243 22l-5.657-5.657L20 14.93l6.364 6.364z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/close.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" focusable=\"false\">\r\n    <path d=\"M9.97 8.274L2.335.637.637 2.334 8.274 9.97.637 17.607l1.697 1.697 7.637-7.636 7.636 7.636 1.697-1.697-7.636-7.636 7.636-7.637L17.607.637 9.971 8.274z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/communication-preferences.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <g fill=\"#2D2D2D\" fill-rule=\"evenodd\">\r\n        <path fill-rule=\"nonzero\" d=\"M4.667 14h11.339c1.1 0 1.994-.9 1.994-2.009V4.01A2.003 2.003 0 0 0 16.006 2H3.994C2.894 2 2 2.9 2 4.009V16l2.667-2zm.666 2L0 20V4.009A4.002 4.002 0 0 1 3.994 0h12.012C18.215 0 20 1.8 20 4.009v7.982A4.002 4.002 0 0 1 16.006 16H5.333z\"/>\r\n        <path d=\"M6 8.333c-.552 0-1-.373-1-.833 0-.46.448-.833 1-.833S7 7.04 7 7.5c0 .46-.448.833-1 .833zm4 0c-.552 0-1-.373-1-.833 0-.46.448-.833 1-.833s1 .373 1 .833c0 .46-.448.833-1 .833zm4 0c-.552 0-1-.373-1-.833 0-.46.448-.833 1-.833s1 .373 1 .833c0 .46-.448.833-1 .833z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/emoji-content.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"88\" height=\"88\" viewBox=\"0 0 88 88\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#FFD95A\">\r\n            <path d=\"M29 0h30v88H29z\"/>\r\n            <path d=\"M18 6h52v76H18z\"/>\r\n            <path d=\"M12 12h64v64H12z\"/>\r\n            <path d=\"M6 18h76v52H6z\"/>\r\n            <path d=\"M0 30h88v28H0z\"/>\r\n            <g opacity=\".6\" style=\"mix-blend-mode:multiply\">\r\n                <path d=\"M29 0h30v88H29z\"/>\r\n                <path d=\"M18 6h52v76H18z\"/>\r\n                <path d=\"M12 12h64v64H12z\"/>\r\n                <path d=\"M6 18h76v52H6z\"/>\r\n                <path d=\"M0 30h88v28H0z\"/>\r\n            </g>\r\n        </g>\r\n        <path fill=\"#2D2D2D\" d=\"M22 29h6v6h-6zM60 29h6v6h-6zM16 35h6v6h-6zM54 35h6v6h-6zM28 35h6v6h-6zM66 35h6v6h-6zM29 55h6v6h-6zM53 55h6v6h-6z\"/>\r\n        <path fill=\"#D01345\" d=\"M59 49h12v6H59zM17 49h12v6H17z\" opacity=\".6\"/>\r\n        <path fill=\"#2D2D2D\" d=\"M35 61h18v6H35z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/emoji-happy.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"88\" height=\"88\" viewBox=\"0 0 88 88\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#FFD95A\">\r\n            <path d=\"M29 0h30v88H29z\"/>\r\n            <path d=\"M18 6h52v76H18z\"/>\r\n            <path d=\"M12 12h64v64H12z\"/>\r\n            <path d=\"M6 18h76v52H6z\"/>\r\n            <path d=\"M0 30h88v28H0z\"/>\r\n            <g opacity=\".6\" style=\"mix-blend-mode:multiply\">\r\n                <path d=\"M29 0h30v88H29z\"/>\r\n                <path d=\"M18 6h52v76H18z\"/>\r\n                <path d=\"M12 12h64v64H12z\"/>\r\n                <path d=\"M6 18h76v52H6z\"/>\r\n                <path d=\"M0 30h88v28H0z\"/>\r\n            </g>\r\n        </g>\r\n        <path fill=\"#2D2D2D\" d=\"M23 51h42v6H23zM29 57h30v6H29zM35 63h18v6H35zM24 37h6v6h-6zM58 37h6v6h-6zM24 31h6v6h-6zM58 31h6v6h-6z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartFilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\">\r\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M9.996 1.763l.203-.2A5.726 5.726 0 0 1 14.116 0c3.246-.004 5.88 2.725 5.884 6.097C20.01 13.845 10.014 18 10.014 18S.01 13.87 0 6.124C-.003 2.752 2.624.014 5.87.01A5.733 5.733 0 0 1 9.79 1.564l.205.199z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartFilledValentines.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"21\" viewBox=\"0 0 23 21\">\r\n    <g fill=\"none\" fill-rule=\"nonzero\">\r\n        <path fill=\"#FFF\" d=\"M10.996 2.763l.203-.2A5.726 5.726 0 0 1 15.116 1C18.362.996 20.996 3.725 21 7.097 21.01 14.845 11.014 19 11.014 19S1.01 14.87 1 7.124C.997 3.752 3.624 1.014 6.87 1.01a5.733 5.733 0 0 1 3.921 1.553l.205.199z\"/>\r\n        <path fill=\"#FFF\" d=\"M5 15.333V15h1v1h-.333l-.167.5-.5.5v3H4v-2l-1 1v2H2v-2H0v-1h2l1-1H1v-1h3l.5-.5.5-.167zM23 0h-4v1h2l-4.359 3.47.938 1.144L22 2v2h1z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartPrideFilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"20\" height=\"18\" viewBox=\"0 0 20 18\">\r\n    <defs>\r\n        <path id=\"a\" d=\"M9.966 3.105l.17-.166A4.772 4.772 0 0 1 13.4 1.636c2.705-.003 4.9 2.271 4.903 5.08.009 6.458-8.321 9.92-8.321 9.92S1.644 13.195 1.636 6.74C1.634 3.93 3.823 1.65 6.527 1.645A4.778 4.778 0 0 1 9.796 2.94l.17.165z\"/>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <mask id=\"b\" fill=\"#fff\">\r\n            <use xlink:href=\"#a\"/>\r\n        </mask>\r\n        <use fill=\"#FFF\" fill-rule=\"nonzero\" xlink:href=\"#a\"/>\r\n        <g mask=\"url(#b)\">\r\n            <path fill=\"#BD10E0\" d=\"M20 16H.364v-3H20z\"/>\r\n            <path fill=\"#0770CF\" d=\"M20 13H.364v-2H20z\"/>\r\n            <path fill=\"#00AA5B\" d=\"M20 11H.364V9H20z\"/>\r\n            <path fill=\"#F8E71C\" d=\"M20 9H.364V7H20z\"/>\r\n            <path fill=\"#F5A623\" d=\"M20 7H.364V5H20z\"/>\r\n            <path fill=\"#D0021B\" d=\"M20 5H.364V2H20z\"/>\r\n        </g>\r\n        <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M10.618 15.474a21.327 21.327 0 0 0 3.137-2.076c2.697-2.166 4.249-4.619 4.245-7.299-.003-2.284-1.757-4.101-3.881-4.099-1.016 0-1.97.417-2.69 1.158l-1.43 1.467-1.432-1.463a3.748 3.748 0 0 0-2.695-1.151C3.749 2.013 1.998 3.837 2 6.12c.003 2.677 1.559 5.123 4.256 7.281a21.32 21.32 0 0 0 3.756 2.39c.191-.096.394-.202.606-.318zM9.996 1.763l.203-.2A5.726 5.726 0 0 1 14.116 0c3.246-.004 5.88 2.725 5.884 6.097C20.01 13.845 10.014 18 10.014 18S.01 13.87 0 6.124C-.003 2.752 2.624.014 5.87.01A5.733 5.733 0 0 1 9.79 1.564l.205.199z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartUnfilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\">\r\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M10.618 15.474a21.327 21.327 0 0 0 3.137-2.076c2.697-2.166 4.249-4.619 4.245-7.299-.003-2.284-1.757-4.101-3.881-4.099-1.016 0-1.97.417-2.69 1.158l-1.43 1.467-1.432-1.463a3.748 3.748 0 0 0-2.695-1.151C3.749 2.013 1.998 3.837 2 6.12c.003 2.677 1.559 5.123 4.256 7.281a21.32 21.32 0 0 0 3.756 2.39c.191-.096.394-.202.606-.318zM9.996 1.763l.203-.2A5.726 5.726 0 0 1 14.116 0c3.246-.004 5.88 2.725 5.884 6.097C20.01 13.845 10.014 18 10.014 18S.01 13.87 0 6.124C-.003 2.752 2.624.014 5.87.01A5.733 5.733 0 0 1 9.79 1.564l.205.199z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartUnfilledValentines.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"21\" viewBox=\"0 0 23 21\">\r\n    <g fill=\"none\" fill-rule=\"nonzero\">\r\n        <path fill=\"#FFF\" d=\"M11.618 16.474a21.327 21.327 0 0 0 3.137-2.076c2.697-2.166 4.249-4.619 4.245-7.299-.003-2.284-1.757-4.101-3.881-4.099-1.016 0-1.97.417-2.69 1.158l-1.43 1.467-1.432-1.463a3.748 3.748 0 0 0-2.695-1.151C4.749 3.013 2.998 4.837 3 7.12c.003 2.677 1.559 5.123 4.256 7.281a21.32 21.32 0 0 0 3.756 2.39c.191-.096.394-.202.606-.318zm-.622-13.711l.203-.2A5.726 5.726 0 0 1 15.116 1C18.362.996 20.996 3.725 21 7.097 21.01 14.845 11.014 19 11.014 19S1.01 14.87 1 7.124C.997 3.752 3.624 1.014 6.87 1.01a5.733 5.733 0 0 1 3.921 1.553l.205.199z\"/>\r\n        <path fill=\"#FFF\" d=\"M5 15.333V15h1v1h-.333l-.167.5-.5.5v3H4v-2l-1 1v2H2v-2H0v-1h2l1-1H1v-1h3l.5-.5.5-.167zM23 0h-4v1h2l-4.359 3.47.938 1.144L22 2v2h1z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-facebook-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 0 30 30\">\r\n    <path fill=\"#3C5A99\" fill-rule=\"evenodd\" d=\"M15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm6.075-21.75H8.925c-.341 0-.675.334-.675.675v12.15c0 .341.333.675.675.675H15v-5.4h-1.35v-2.025H15v-1.35c.46-1.737 1.526-2.686 2.7-2.7 1.126.014 1.767.07 2.025 0V12.3h-1.35c-.646-.108-.81.294-1.35.675v1.35h2.7l-.675 2.025h-2.025v5.4h4.05c.341 0 .675-.334.675-.675V8.925c0-.341-.334-.675-.675-.675z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-google-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"41\" viewBox=\"0 0 40 41\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <circle cx=\"20\" cy=\"20\" r=\"20\" fill=\"#FFF\" stroke=\"#CCC\" stroke-width=\"2\"/>\r\n        <path fill=\"#FFF\" d=\"M17.192 11.502a9.2 9.2 0 0 0-5.184 4.539 9.057 9.057 0 0 0-.797 2.302 9.18 9.18 0 0 0 .792 5.916 9.23 9.23 0 0 0 2.484 3.054 9.115 9.115 0 0 0 3.324 1.677c1.525.408 3.148.399 4.682.05 1.387-.32 2.7-.984 3.748-1.948 1.107-1.018 1.898-2.356 2.316-3.797.458-1.569.517-3.246.232-4.859h-8.607v3.57h4.987a4.309 4.309 0 0 1-1.83 2.828 5.24 5.24 0 0 1-2.016.797 6.035 6.035 0 0 1-2.184-.005 5.416 5.416 0 0 1-2.036-.88 5.656 5.656 0 0 1-2.095-2.808 5.551 5.551 0 0 1 0-3.561 5.714 5.714 0 0 1 1.328-2.159 5.426 5.426 0 0 1 2.734-1.52 5.458 5.458 0 0 1 2.686.109c.737.22 1.416.63 1.972 1.16l1.682-1.682c.295-.3.605-.59.89-.9a8.92 8.92 0 0 0-2.946-1.824 9.233 9.233 0 0 0-6.162-.06z\"/>\r\n        <path fill=\"#EA4335\" d=\"M17.192 11.502a9.263 9.263 0 0 1 6.162.054A8.89 8.89 0 0 1 26.3 13.38c-.285.31-.595.6-.89.9l-1.682 1.682a4.982 4.982 0 0 0-1.972-1.16 5.4 5.4 0 0 0-2.686-.109 5.466 5.466 0 0 0-2.734 1.52 5.676 5.676 0 0 0-1.328 2.16c-.998-.778-1.997-1.55-3-2.327a9.191 9.191 0 0 1 5.184-4.544z\"/>\r\n        <path fill=\"#FBBC05\" d=\"M11.216 18.338a9.123 9.123 0 0 1 .797-2.302c.998.777 1.997 1.55 3 2.326a5.518 5.518 0 0 0 0 3.561c-.998.777-1.997 1.554-2.995 2.326a9.102 9.102 0 0 1-.802-5.911z\"/>\r\n        <path fill=\"#4285F4\" d=\"M20.182 18.431h8.607a10.82 10.82 0 0 1-.232 4.86c-.418 1.44-1.21 2.778-2.316 3.796l-2.907-2.257a4.309 4.309 0 0 0 1.83-2.828h-4.987c.005-1.19.005-2.38.005-3.57z\"/>\r\n        <path fill=\"#34A853\" d=\"M12.008 24.254c.999-.772 1.997-1.55 2.995-2.326a5.685 5.685 0 0 0 2.095 2.808 5.45 5.45 0 0 0 2.036.88c.718.148 1.461.128 2.184.005a5.24 5.24 0 0 0 2.016-.796l2.907 2.257c-1.048.969-2.36 1.628-3.748 1.948-1.534.349-3.157.359-4.682-.05a9.039 9.039 0 0 1-3.324-1.677 9.21 9.21 0 0 1-2.479-3.049z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-instagram-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 0 30 30\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path fill=\"#8433B7\" d=\"M15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm0-21.147c2.002 0 2.24.008 3.03.044.73.033 1.128.155 1.392.258.35.136.6.299.862.561.262.262.425.512.56.862.104.264.226.661.259 1.392.036.79.044 1.028.044 3.03s-.008 2.24-.044 3.03c-.033.73-.155 1.128-.258 1.392-.136.35-.299.6-.561.862a2.323 2.323 0 0 1-.862.56c-.264.104-.661.226-1.392.259-.79.036-1.028.044-3.03.044s-2.24-.008-3.03-.044c-.73-.033-1.128-.155-1.392-.258-.35-.136-.6-.299-.862-.561a2.323 2.323 0 0 1-.56-.862c-.104-.264-.226-.661-.259-1.392-.036-.79-.044-1.028-.044-3.03s.008-2.24.044-3.03c.033-.73.155-1.128.258-1.392.136-.35.299-.6.561-.862.262-.262.512-.425.862-.56.264-.104.661-.226 1.392-.259.79-.036 1.028-.044 3.03-.044zm0-1.35c-2.036 0-2.292.008-3.091.044-.798.037-1.343.164-1.82.349a3.675 3.675 0 0 0-1.328.865 3.675 3.675 0 0 0-.865 1.328c-.185.477-.312 1.022-.349 1.82-.036.8-.045 1.055-.045 3.091 0 2.036.009 2.292.045 3.091.037.798.164 1.343.349 1.82.192.493.448.911.865 1.328.417.417.835.673 1.328.865.477.185 1.022.312 1.82.349.8.036 1.055.045 3.091.045 2.036 0 2.292-.009 3.091-.045.798-.037 1.343-.164 1.82-.349a3.675 3.675 0 0 0 1.328-.865c.417-.417.673-.835.865-1.328.185-.477.312-1.022.349-1.82.036-.8.045-1.055.045-3.091 0-2.036-.009-2.292-.045-3.091-.037-.798-.164-1.343-.349-1.82a3.675 3.675 0 0 0-.865-1.328 3.675 3.675 0 0 0-1.328-.865c-.477-.185-1.022-.312-1.82-.349-.8-.036-1.055-.045-3.091-.045zm0 3.647a3.85 3.85 0 1 0 0 7.7 3.85 3.85 0 0 0 0-7.7zm0 6.35a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm4.902-6.502a.9.9 0 1 0-1.8 0 .9.9 0 0 0 1.8 0z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-pinterest-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"41\" viewBox=\"0 0 40 41\">\r\n    <path fill=\"#BD081C\" fill-rule=\"evenodd\" d=\"M0 20C0 8.954 8.952 0 20 0c11.046 0 20 8.952 20 20 0 11.046-8.952 20-20 20C8.954 40 0 31.048 0 20zm15.875 6.151c-.175.75.303 2.805.303 2.805s1.469-1.47 1.678-2.229c.12-.437.691-3.572.691-3.572.343.652 1.342 1.225 2.404 1.225 3.163 0 5.309-2.883 5.309-6.743 0-2.917-2.473-5.637-6.23-5.637-4.673 0-7.03 3.352-7.03 6.147 0 1.693.64 3.197 2.016 3.759.224.094.424.003.491-.245.045-.173.154-.61.2-.79.066-.247.042-.333-.14-.55-.397-.466-.649-1.071-.649-1.93 0-2.485 1.86-4.71 4.843-4.71 2.642 0 4.093 1.614 4.093 3.77 0 2.837-1.255 5.23-3.118 5.23-1.03 0-1.8-.85-1.554-1.894.296-1.246.869-2.593.869-3.492 0-.805-.433-1.477-1.327-1.477-1.052 0-1.897 1.089-1.897 2.547 0 .928.314 1.558.314 1.558s-1.077 5.432-1.266 6.228z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-snapchat-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path fill=\"#FFFC02\" d=\"M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20A20 20 0 0 0 20 0zm10 25.94c-.12.28-.66.68-2.54 1a.72.72 0 0 0-.3.65c0 .15-.07.31-.11.47a.25.25 0 0 1-.27.2 2.32 2.32 0 0 1-.42-.05 5.54 5.54 0 0 0-1.13-.12 5 5 0 0 0-.82.07c-.57.146-1.1.42-1.55.8A4.35 4.35 0 0 1 20.13 30h-.26a4.35 4.35 0 0 1-2.68-1.07 3.89 3.89 0 0 0-1.55-.8 5 5 0 0 0-.81-.07 5.51 5.51 0 0 0-1.13.13 2.45 2.45 0 0 1-.42.06A.26.26 0 0 1 13 28c0-.16-.08-.32-.11-.47a.75.75 0 0 0-.3-.65c-1.88-.29-2.42-.69-2.54-1a.37.37 0 0 1 0-.12.21.21 0 0 1 .18-.22c2.89-.48 4.18-3.47 4.24-3.6a1.13 1.13 0 0 0 .1-.94 2 2 0 0 0-1.27-.82l-.3-.05c-.85-.34-.93-.69-.89-.87a.81.81 0 0 1 .78-.52.54.54 0 0 1 .23 0c.31.16.651.252 1 .27a.84.84 0 0 0 .62-.2v-.62a10.35 10.35 0 0 1 .24-4.08A5.22 5.22 0 0 1 19.79 11h.4a5.23 5.23 0 0 1 4.86 3.17c.35 1.33.432 2.718.24 4.08V18.87a.82.82 0 0 0 .56.2 2.55 2.55 0 0 0 1-.27.72.72 0 0 1 .3-.06c.12 0 .24.024.35.07a.64.64 0 0 1 .48.53 1.06 1.06 0 0 1-.9.81l-.28.1a2 2 0 0 0-1.27.82 1.13 1.13 0 0 0 .1.94c.05.13 1.35 3.11 4.24 3.6a.21.21 0 0 1 .18.22.37.37 0 0 1-.05.11z\"/>\r\n        <path fill=\"#000\" fill-rule=\"nonzero\" d=\"M29.446 25.569a.297.297 0 0 0-.026.048l.026-.048zm-2.45-6.08a.393.393 0 0 0 .192-.079.334.334 0 0 0-.05-.003c-.007 0-.014.001.013-.012a3.19 3.19 0 0 1-.27.121l.116-.027zm-13.44 8.05c.435-.094.85-.141 1.277-.146.308.002.615.028.972.091.669.171 1.29.491 1.824.944a3.669 3.669 0 0 0 2.241.905h.246a3.685 3.685 0 0 0 2.313-.882 4.587 4.587 0 0 1 1.87-.948c.307-.052.618-.079.933-.08.423.002.844.046 1.259.133-.01-.457.207-.892.583-1.16l.274-.113c.589-.1 1.037-.207 1.36-.304-.98-.379-1.823-1.031-2.533-1.875-.579-.687-1.007-1.438-1.118-1.753a1.797 1.797 0 0 1-.159-1.494l.086-.169c.353-.505.868-.87 1.387-1.019.056-.016.112-.03.169-.04a3.232 3.232 0 0 1-.671.107 1.487 1.487 0 0 1-1.016-.362l-.23-.2v-.864l.007-.153a9.73 9.73 0 0 0-.193-3.724 4.566 4.566 0 0 0-4.247-2.766h-.405c-1.814-.013-3.462 1.053-4.16 2.613a9.926 9.926 0 0 0-.218 3.91v.926l-.232.2a1.493 1.493 0 0 1-1.09.36 3.137 3.137 0 0 1-1.27-.343l.305-.593-.142.651a.416.416 0 0 1-.107.015c-.061-.001-.117.036-.11-.001.019-.085 0-.162-.018-.185.018.023.048.05.09.08.038.027.086.057.146.088a2.692 2.692 0 0 0 .269.123L13 20.13l.11-.658.313.053a2.666 2.666 0 0 1 1.693 1.093l.086.169c.168.497.11 1.043-.127 1.432a8.177 8.177 0 0 1-1.306 1.995c-.693.777-1.504 1.374-2.444 1.72a5.455 5.455 0 0 1-1 .266.457.457 0 0 0 .39-.478l-.007.146a.297.297 0 0 0 .004-.055c-.001-.014-.222.009-.662.067l.622-.24c.022.058.223.17.653.295.321.093.77.194 1.367.286l.164.025.133.1a1.417 1.417 0 0 1 .568 1.193c0 .008-.223.005-.667-.009l.654-.13a6.498 6.498 0 0 0 .032.107c.066.215.09.327.09.47a.407.407 0 0 0-.423-.393 1.764 1.764 0 0 0 .313-.045zm14.27.013c0 .217-.025.324-.097.56a2.468 2.468 0 0 0-.03.1c-.101.451-.522.757-.937.714a2.984 2.984 0 0 1-.54-.064 4.531 4.531 0 0 0-1.647-.056 3.22 3.22 0 0 0-1.282.661 5.026 5.026 0 0 1-3.163 1.2h-.288a5.01 5.01 0 0 1-3.083-1.228 3.208 3.208 0 0 0-1.23-.652 4.312 4.312 0 0 0-.692-.06 4.83 4.83 0 0 0-.986.112 3.06 3.06 0 0 1-.52.076.927.927 0 0 1-.998-.915c0 .008-.005-.016-.03-.093a2.036 2.036 0 0 1-.067-.246l-.01-.165c-1.672-.284-2.538-.704-2.798-1.375l-.036-.133a1.037 1.037 0 0 1-.009-.27.872.872 0 0 1 .738-.836c1.03-.17 1.912-.725 2.653-1.556a6.856 6.856 0 0 0 1.123-1.727.463.463 0 0 0 .061-.303 1.322 1.322 0 0 0-.768-.458l-.3-.05-.138-.039c-.973-.39-1.439-.976-1.265-1.727a1.477 1.477 0 0 1 1.345-.949c.143-.02.289-.015.43.016l.163.058c.2.103.416.167.654.191a11.222 11.222 0 0 1 .291-4.497 5.885 5.885 0 0 1 5.42-3.508h.393c2.38-.024 4.542 1.386 5.512 3.667.372 1.417.46 2.893.262 4.25v.14c.207-.029.412-.094.626-.201.182-.08.38-.119.567-.116.208 0 .414.042.51.09.516.127.904.555.98 1.082l-.01.247c-.16.68-.711 1.194-1.395 1.309l-.312.104a1.333 1.333 0 0 0-.78.46c-.014.108.015.232.11.406.482 1.254 1.834 2.86 3.711 3.179a.877.877 0 0 1 .752.918l-.022.135c-.024.09-.06.175-.106.254-.295.597-1.157.998-2.762 1.295z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-twitter-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"41\" viewBox=\"0 0 40 41\">\r\n    <path fill=\"#1DA1F2\" fill-rule=\"evenodd\" d=\"M0 20C0 8.954 8.952 0 20 0c11.046 0 20 8.952 20 20 0 11.046-8.952 20-20 20C8.954 40 0 31.048 0 20zm30.14-6.126a6.926 6.926 0 0 1-2.14.63 3.973 3.973 0 0 0 1.641-2.21 7.48 7.48 0 0 1-2.368.973c-.677-.78-1.648-1.267-2.715-1.267-2.056 0-3.722 1.788-3.722 4 0 .31.033.616.094.905-3.087-.159-5.833-1.757-7.67-4.17a4.213 4.213 0 0 0-.501 2.009c0 1.383.656 2.615 1.656 3.322a3.527 3.527 0 0 1-1.686-.498v.055c0 1.934 1.283 3.547 2.985 3.92-.312.091-.642.133-.983.133-.24 0-.467-.017-.696-.072.472 1.595 1.847 2.753 3.475 2.777A7.116 7.116 0 0 1 12 26.036c1.646 1.139 3.599 1.803 5.705 1.803 6.845 0 10.59-6.094 10.59-11.377 0-.17-.004-.34-.013-.512a8.093 8.093 0 0 0 1.858-2.076z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-vk-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\">\r\n    <path fill=\"#507299\" fill-rule=\"evenodd\" d=\"M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm-1.257-12.059h1.434s.433-.048.655-.292c.203-.224.197-.644.197-.644s-.028-1.969.865-2.258c.88-.286 2.012 1.902 3.21 2.743.907.636 1.596.497 1.596.497l3.205-.046s1.676-.105.881-1.453c-.065-.11-.463-.997-2.383-2.82-2.01-1.907-1.74-1.598.68-4.897 1.475-2.01 2.064-3.236 1.88-3.762-.176-.5-1.26-.368-1.26-.368l-3.609.023s-.267-.037-.466.084c-.194.119-.318.396-.318.396s-.572 1.555-1.333 2.877c-1.607 2.79-2.25 2.938-2.512 2.764-.611-.404-.458-1.622-.458-2.487 0-2.704.4-3.832-.782-4.123-.392-.097-.68-.162-1.684-.172-1.288-.013-2.378.004-2.994.313-.411.206-.728.664-.535.69.239.033.779.15 1.065.548.37.514.357 1.67.357 1.67s.213 3.182-.496 3.577c-.487.272-1.154-.282-2.587-2.813-.734-1.297-1.288-2.73-1.288-2.73s-.106-.268-.297-.411c-.231-.174-.555-.229-.555-.229l-3.429.023s-.515.015-.703.244c-.169.203-.014.624-.014.624s2.685 6.423 5.724 9.66c2.789 2.967 5.954 2.772 5.954 2.772z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-youtube-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\">\r\n    <path fill=\"#CD201F\" fill-rule=\"evenodd\" d=\"M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm9.8-23.98s-.195-1.371-.795-1.976c-.76-.792-1.613-.796-2.004-.843C24.203 13 20.004 13 20.004 13h-.008s-4.198 0-6.997.201c-.391.047-1.243.05-2.004.843-.6.605-.795 1.976-.795 1.976s-.2 1.611-.2 3.222v1.51c0 1.61.2 3.221.2 3.221s.195 1.372.795 1.976c.76.793 1.76.768 2.205.85 1.6.154 6.8.201 6.8.201s4.203-.006 7.001-.208c.391-.046 1.244-.05 2.004-.843.6-.604.795-1.976.795-1.976s.2-1.61.2-3.22v-1.511c0-1.611-.2-3.222-.2-3.222zM18 23v-6l5 3.01L18 23z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/minus.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg width=\"10px\" height=\"1px\" viewBox=\"0 0 10 1\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g transform=\"translate(-332.000000, -387.000000)\" fill=\"#2D2D2D\">\r\n            <g transform=\"translate(-1.000000, 0.000000)\">\r\n                <g transform=\"translate(0.000000, 72.000000)\">\r\n                    <g transform=\"translate(0.000000, 220.000000)\">\r\n                        <rect x=\"333\" y=\"95\" width=\"10\" height=\"1\"></rect>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>"

/***/ }),

/***/ "./template/styles/icons/notification-check-green.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n    <g fill=\"#00AA5B\" fill-rule=\"evenodd\">\r\n        <path fill-rule=\"nonzero\" d=\"M9 16A7 7 0 1 1 9 2a7 7 0 0 1 0 14zM9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0z\"/>\r\n        <path d=\"M7.91 9.642L12.153 5.4l1.311 1.311-4.242 4.243-1.414 1.414L5.339 9.9l1.414-1.414L7.91 9.642z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/notification-exclamation-orange.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path stroke=\"#FFBC00\" stroke-width=\"2\" d=\"M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0z\"/>\r\n        <text fill=\"#FFBC00\" font-family=\"HelveticaNeue-Bold, Helvetica Neue\" font-size=\"12\" font-weight=\"bold\" transform=\"translate(0 1)\">\r\n            <tspan x=\"7.332\" y=\"12\">!</tspan>\r\n        </text>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/notification-exclamation.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path stroke=\"#262626\" stroke-width=\"2\" d=\"M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0z\"/>\r\n        <text fill=\"#262626\" font-family=\"HelveticaNeue-Bold, Helvetica Neue\" font-size=\"12\" font-weight=\"bold\" transform=\"translate(0 1)\">\r\n            <tspan x=\"7.332\" y=\"12\">!</tspan>\r\n        </text>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/notification.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n  <g fill=\"none\" fill-rule=\"evenodd\">\r\n    <path stroke-width=\"2\" d=\"M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0z\"/>\r\n    <text font-family=\"HelveticaNeue-Bold, Helvetica Neue\" font-size=\"12\" font-weight=\"bold\" transform=\"translate(0 1)\">\r\n      <tspan x=\"7.332\" y=\"12\">!</tspan>\r\n    </text>\r\n  </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/orders.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <g fill=\"#2D2D2D\" fill-rule=\"evenodd\">\r\n        <path fill-rule=\"nonzero\" d=\"M18 4.667L16 2H4L2 4.667V18h16V4.667zM0 4l3-4h14l3 4v16H0V4z\"/>\r\n        <path d=\"M0 4h20v2H0z\"/>\r\n        <path d=\"M9 1.111h2v4H9z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/plus.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"10px\" height=\"10px\" viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g transform=\"translate(-332.000000, -338.000000)\" fill=\"#2D2D2D\">\r\n            <g transform=\"translate(-1.000000, 0.000000)\">\r\n                <g transform=\"translate(0.000000, 72.000000)\">\r\n                    <g transform=\"translate(0.000000, 220.000000)\">\r\n                        <path d=\"M338.625,50.375 L338.625,46 L337.375,46 L337.375,50.375 L333,50.375 L333,51.625 L337.375,51.625 L337.375,56 L338.625,56 L338.625,51.625 L343,51.625 L343,50.375 L338.625,50.375 Z\"></path>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>"

/***/ }),

/***/ "./template/styles/icons/returns.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <path fill=\"#2D2D2D\" fill-rule=\"nonzero\" d=\"M9.7 13l1.8 1.5-1.436 1.5L6 12l4-4 1.5 1.5L9.7 11H20v9H0V3.605L3 0h14l3 3.605V9h-2V6H2v12h16v-5H9.7zM2.5 4H9V2H4L2.5 4zm15 0L16 2h-5v2h6.5z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/search.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"17\" viewBox=\"0 0 17 17\">\r\n    <path fill-rule=\"nonzero\" d=\"M7.65 15.3a7.65 7.65 0 1 1 5.997-2.9c-.01.012 3.183 3.297 3.183 3.297l-1.22 1.18s-3.144-3.283-3.154-3.275A7.618 7.618 0 0 1 7.65 15.3zm0-2a5.65 5.65 0 1 0 0-11.3 5.65 5.65 0 0 0 0 11.3z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/selected.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <circle cx=\"8\" cy=\"8\" r=\"7.68\" fill=\"#0770CF\"/>\r\n        <path fill=\"#FFF\" d=\"M6.404 9.222l3.879-3.878 1.199 1.199-3.88 3.878-1.292 1.293-2.257-2.257 1.293-1.292 1.058 1.057z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/sortdown.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M0 0h11.996v11.616H0z\"/>\r\n        <path fill=\"#2D2D2D\" d=\"M4.604 7.684l-.002.002 1.41 1.41.002-.002.007.006 1.41-1.41-.007-.006 2.83-2.83-1.41-1.41-2.83 2.83L3.19 3.449l-1.41 1.41 2.825 2.825z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./client/index.js");


/***/ }),

/***/ "dll-reference vendor":
/***/ (function(module, exports) {

module.exports = vendor;

/***/ })

/******/ });


// WEBPACK FOOTER //
// client.sitechrome.9c1f5d.js